webpackJsonp([22],{

/***/ "+3mA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+jjB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+jpl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[(_vm.rate && _vm.criteria && _vm.criteria.length)?_c('b-col',{attrs:{"cols":"12"}},[_c('b-tabs',{staticClass:"e-tabs witch-icon",attrs:{"nav-wrapper-class":"e-tabs__header","nav-class":"e-tabs__nav-tabs","content-class":"e-tabs__nav-item","no-fade":true},on:{"input":_vm.onChangeTab}},_vm._l((_vm.criteria),function(criterion,i){return _c('b-tab',{key:i,ref:"tabs",refInFor:true,attrs:{"title":criterion.criterion.title}},[_c('b-row',{staticClass:"e-view-rate"},[_c('b-col',{attrs:{"cols":"9"}},[_c('div',{staticClass:"eval",staticStyle:{"cursor":"auto"}},[_vm._v("\n                "+_vm._s(criterion.evaluate.toFixed(1))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("  \n                "+_vm._s(criterion.justification)+"\n              ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('em-asset-average-score',{attrs:{"score":_vm.rate.averageRate.toFixed(1)}},[_vm._v("Rater total score")]),_vm._v(" "),(_vm.oneOf(_vm.state, ['complete', 'moderating']))?_c('div',{staticClass:"rate-moderate",on:{"click":function($event){_vm.state = 'moderating'}}},[_c('span',[_vm._v("You score "),_c('i',{staticClass:"fas fa-pen"})]),_vm._v(" "),_c('span',[_c('star-rating',{staticClass:"stars",attrs:{"read-only":true,"padding":10,"inline":true,"show-rating":false,"increment":0.5,"star-size":15,"inactive-color":"#ffffff","active-color":"#1875f0","rounded-corners":true,"border-color":"#1875f0","border-width":2},model:{value:(_vm.eval),callback:function ($$v) {_vm.eval=$$v},expression:"eval"}})],1)]):_vm._e()],1)],1)],1)}),1),_vm._v(" "),_c('transition',{attrs:{"mode":"in-out","name":"fade"}},[(_vm.state === 'moderating')?_c('div',{staticClass:"e-moderation-rate"},[_c('star-rating',{staticClass:"stars",attrs:{"padding":10,"inline":true,"show-rating":false,"increment":0.5,"star-size":100,"inactive-color":"#ffffff","active-color":"#1875f0","rounded-corners":true,"border-color":"#1875f0","border-width":4},model:{value:(_vm.eval),callback:function ($$v) {_vm.eval=$$v},expression:"eval"}})],1):_vm._e()])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+vOg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__("4zFs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets__ = __webpack_require__("9NxA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coins__ = __webpack_require__("AYuQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orders__ = __webpack_require__("ftRK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rates__ = __webpack_require__("8bdi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forecasts__ = __webpack_require__("ivRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__moderation__ = __webpack_require__("oaKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui__ = __webpack_require__("7Az5");









/* harmony default export */ __webpack_exports__["a"] = ({
  Auth: __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */],
  Assets: __WEBPACK_IMPORTED_MODULE_1__assets__["a" /* default */],
  Coins: __WEBPACK_IMPORTED_MODULE_2__coins__["a" /* default */],
  Orders: __WEBPACK_IMPORTED_MODULE_3__orders__["a" /* default */],
  Rates: __WEBPACK_IMPORTED_MODULE_4__rates__["a" /* default */],
  Moderation: __WEBPACK_IMPORTED_MODULE_6__moderation__["a" /* default */],
  Ui: __WEBPACK_IMPORTED_MODULE_7__ui__["a" /* default */],
  Forecasts: __WEBPACK_IMPORTED_MODULE_5__forecasts__["a" /* default */]
});

/***/ }),

/***/ "+vqq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/5nz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/8TB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0BYS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_assets__ = __webpack_require__("SjBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services__ = __webpack_require__("+vOg");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-rate",
  props: {
    alias: String
  },
  watch: {
    alias: {
      handler: function handler(current) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
          var hasRate;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.resetCriteria();
                  _this.fetchAsset(current);

                  _context.next = 4;
                  return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* default */].Rates.getCurrentRateByAsset(current);

                case 4:
                  hasRate = _context.sent;


                  if (hasRate) {
                    _this.hasRate = hasRate;
                  } else {
                    _this.hasRate = null;
                  }

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      },

      immediate: true
    }
  },
  data: function data() {
    var steps = [{
      component: 'em-rate-step-select-criteria'
    }, {
      component: 'em-rate-step-write'
    }];

    return {
      currentStep: 0,
      title: '',
      isShow: true,
      hasRate: null,
      id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["a" /* createUid */])(),
      steps: steps
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    rateExist: function rateExist() {
      return !!this.hasRate;
    },
    asset: function asset() {
      return this.getAsset(this.alias);
    },
    stepObject: function stepObject() {
      return this.steps[this.currentStep];
    },
    componentProps: function componentProps() {
      return {
        assetId: this.alias,
        modalId: this.id
      };
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('assets', {
    getAsset: 'asset'
  }), {
    hint: function hint() {
      return {
        title: 'How the Rating Works',
        text: 'To create a reliable evaluation system, each asset is rated according to a predefined set of criteria. As a rater, you review the asset and provide your assessment for each criterion based on available information and your professional judgment. Your rating becomes part of the overall evaluation and will later be reviewed during the moderation process to ensure fairness and consistency. Honest and thoughtful ratings help build a trustworthy and transparent rating system for all participants.',
        buttonText: 'Got It'
      };
    },
    assetMeta: function assetMeta() {
      return [{
        title: 'Emixtier',
        value: this.asset.rate === 0 ? 'N/A' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_assets__["a" /* convertRateToEmixtier */])(this.asset.rate)
      }, {
        title: 'Total Score',
        value: this.asset.rate === 0 ? 'N/A' : this.asset.rate.toFixed(1)
      }, {
        title: 'Raters',
        value: this.asset.totalRaters
      }, {
        title: 'Moderators',
        value: this.asset.totalModeration
      }];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('assets', {
    fetchAsset: 'fetchAsset'
  }), {
    onClose: function onClose() {
      this.$router.go(-1);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['createModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('rate', ['resetCriteria']), {
    changeStep: function changeStep(step) {
      this.currentStep = step - 1;
    },
    onNextClick: function onNextClick() {
      this.stepObject.nextHandler();
    },
    onPreviewClick: function onPreviewClick() {
      this.stepObject.previewHandler();
    },
    show: function show() {
      this.isShow = true;
    }
  }),
  mounted: function mounted() {
    var modal = this.$refs.modal;
    var $app = this.$root.$el;

    $app.parentNode.appendChild(modal.$el);
  }
});

/***/ }),

/***/ "0NKQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.transition)?_c('transition',{attrs:{"name":_vm.transition,"mode":_vm.mode,"duration":_vm.duration,"enter-class":_vm.transitionClass(_vm.enterClass),"enter-active-class":_vm.transitionClass(_vm.enterActiveClass),"enter-to-class":_vm.transitionClass(_vm.enterToClass),"leave-class":_vm.transitionClass(_vm.leaveClass),"leave-active-class":_vm.transitionClass(_vm.leaveActiveClass),"leave-to-class":_vm.transitionClass(_vm.leaveToClass)},on:{"beforeEnter":function($event){return _vm.$emit("beforeEnter")},"enter":function($event){return _vm.$emit("enter")},"afterAnter":function($event){return _vm.$emit("afterEnter")},"enterCancelled":function($event){return _vm.$emit("enterCancelled")},"beforeLeave":function($event){return _vm.$emit("beforeLeave")},"leave":function($event){return _vm.$emit("leave")},"afterLeave":function($event){return _vm.$emit("afterLeave")},"leaveCancelled":function($event){return _vm.$emit("leaveCancelled")}}},[(_vm.waitsFor)?_c('span',[_vm._t("waiting"),_vm._v(" "),(_vm.message)?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e()],2):_c('div',[_vm._t("default")],2)]):_c('div',[(_vm.waitsFor)?_c('span',[_vm._t("waiting"),_vm._v(" "),(_vm.message)?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e()],2):_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0T5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__star_rating_vue__ = __webpack_require__("iSCs");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__star_rating_vue__["a" /* default */]);

/***/ }),

/***/ "1JMt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "20L/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"payment-step transfer-step"},[_c('transition',{attrs:{"name":"fade"}},[(!_vm.isLoading)?_c('div',[_c('b-col',{attrs:{"cols":"12 order-info-container"}},[_c('div',{staticClass:"f-box-title"},[_vm._v("\n          Order summary\n          "),_c('p',[_vm._v("Order Number: #"+_vm._s(_vm.paymentInfo.orderId)+" ")])]),_vm._v(" "),_c('table',{staticClass:"table-descktop"},[_c('tbody',[_c('tr',{staticClass:"with-border"},[_c('th',[_vm._v("Item/Details")]),_vm._v(" "),_c('th',[_vm._v("Price")])]),_vm._v(" "),_c('tr',{staticClass:"with-border"},[_c('td',[_vm._v("\n                "+_vm._s((_vm.orderData.amount / _vm.orderData.asset.price.value).toFixed(6))+" "+_vm._s(_vm.orderData.asset.name)+"\n                "),_c('p',{staticClass:"grey-text"},[_vm._v(_vm._s(_vm.orderData.asset.name)+" rate: "+_vm._s(_vm.orderData.asset.price.value.toFixed(2)))]),_vm._v(" "),_c('span',{staticClass:"grey-text"},[_vm._v("Not final.")])]),_vm._v(" "),_c('td',{staticClass:"text-to-top"},[_vm._v(_vm._s(parseFloat(_vm.orderData.amount).toFixed(2))+" "+_vm._s(_vm.currentOrder.moneyCurrency))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Service fee")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.paymentInfo.serviceFee)+" "+_vm._s(_vm.currentOrder.moneyCurrency))])]),_vm._v(" "),_c('tr',{staticClass:"with-border"},[_c('td',[_vm._v("Payment method fee")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.paymentInfo.paymentMethodFee)+" "+_vm._s(_vm.currentOrder.moneyCurrency))])]),_vm._v(" "),_c('tr',{staticClass:"with-border"},[_c('td',[_vm._v("\n                Transfer Funds\n              ")]),_vm._v(" "),_c('td',[_c('p',{staticClass:"tr-p"},[_vm._v("Please transfer us exactly\n                  "),_c('b',[_vm._v(_vm._s(_vm.finalTotal)+" "+_vm._s(_vm.currentOrder.moneyCurrency))]),_c('br'),_vm._v("\n                  using the following information:\n                ")]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("BENIFICIARY:  "+_vm._s(_vm.paymentInfo.beneficiary))]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("BANK NAME:  "+_vm._s(_vm.paymentInfo.name))]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("BANK ACCOUNT NUMBER: "+_vm._s(_vm.paymentInfo.accountNumber))]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("BANK ADDRESS: "+_vm._s(_vm.paymentInfo.address))]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("SWIFT: "+_vm._s(_vm.paymentInfo.swift))]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("IBAN: "+_vm._s(_vm.paymentInfo.iban))])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"payment-total o-number"},[_vm._v("PAYMENT TOTAL:")]),_vm._v(" "),_c('td',{staticClass:"o-number"},[_vm._v(_vm._s(_vm.finalTotal)+" "+_vm._s(_vm.currentOrder.moneyCurrency))])])])]),_vm._v(" "),_c('div',{staticClass:"table-mobile"},[_c('table',[_c('tbody',[_c('tr',{staticClass:"with-border"},[_c('th',[_vm._v("Order Number")]),_vm._v(" "),_c('th',[_vm._v("Item/Details")])]),_vm._v(" "),_c('tr',{staticClass:"with-border"},[_c('td',{staticClass:"o-number"},[_vm._v("#"+_vm._s(_vm.paymentInfo.orderId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.paymentInfo.item)+" "+_vm._s(_vm.paymentInfo.currencyToBuy)+"\n                  "),_c('br'),_vm._v("Not final.\n                ")])])]),_vm._v(" "),_c('tr',{staticClass:"with-border"},[_c('th',[_vm._v("Payment Method")]),_vm._v(" "),_c('th',[_vm._v("Price")])]),_vm._v(" "),_c('tr',{staticClass:"with-border"},[_c('td',[_vm._v(_vm._s(_vm.paymentInfo.price)+" "+_vm._s(_vm.currentOrder.moneyCurrency))])]),_vm._v(" "),_c('tr',{staticClass:"small-padding"},[_c('td',{},[_vm._v("Payment method fee")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.paymentInfo.paymentMethodFee)+" "+_vm._s(_vm.currentOrder.moneyCurrency))])]),_vm._v(" "),_c('tr',{staticClass:"with-border"},[_c('td',[_vm._v("Transfer Funds")]),_vm._v(" "),_c('td',[_c('p',{staticClass:"tr-p"},[_vm._v("Please transfer us exactly\n                  "),_c('b',[_vm._v(_vm._s(_vm.paymentInfo.finalPayment)+" "+_vm._s(_vm.currentOrder.moneyCurrency))]),_c('br'),_vm._v("\n                  using the following information:\n                ")]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("BENIFICIARY:  "+_vm._s(_vm.paymentInfo.beneficiary))]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("BANK NAME:  "+_vm._s(_vm.paymentInfo.name))]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("BANK ACCOUNT NUMBER: "+_vm._s(_vm.paymentInfo.accountNumber))]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("BANK ADDRESS: "+_vm._s(_vm.paymentInfo.address))]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("SWIFT: "+_vm._s(_vm.paymentInfo.swift))]),_vm._v(" "),_c('span',{staticClass:"bp font-14"},[_vm._v("IBAN: "+_vm._s(_vm.paymentInfo.iban))])])]),_vm._v(" "),_c('tr',{staticClass:"small-padding"},[_c('td',{staticClass:"o-number"},[_vm._v("Payment Total")]),_vm._v(" "),_c('td',{staticClass:"o-number"},[_vm._v(_vm._s(_vm.paymentInfo.finalPayment)+" "+_vm._s(_vm.currentOrder.moneyCurrency))])])])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('e-hint',{staticStyle:{"margin-top":"20px"},attrs:{"title":"IMPORTANT:"}},[_vm._v("\n          When creating the bank transfer, please add the Order Number as a comment to the transfer.\n          "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.sendToMail.apply(null, arguments)}}},[_vm._v("Send me these instructions to my email")])]),_vm._v(" "),_c('div',{staticClass:"modal-block-title"},[_vm._v("Your "+_vm._s(_vm.orderData.asset.name)+" wallet ID")]),_vm._v(" "),_c('div',{staticClass:"buy-wallet-id"},[_vm._v(_vm._s(_vm.orderData.walletId))])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"modal-block-title"},[_vm._v("Order Number: #"+_vm._s(_vm.paymentInfo.orderId))]),_vm._v(" "),_c('p',{staticClass:"p-info"},[_vm._v("\n          Once you have transfered the money, please keep the transfers reference number and confirm your bank transfer\n        ")]),_vm._v(" "),_c('e-button',{staticStyle:{"margin-left":"auto"},on:{"click":_vm.nextPage}},[_vm._v("I Have Sent Funds to Economix")])],1)],1):_vm._e()]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"payment-loading"},[_vm._v("\n    Loading ...\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2I1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps__ = __webpack_require__("iuW+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__step__ = __webpack_require__("tTnP");



/* harmony default export */ __webpack_exports__["a"] = ({
  Steps: __WEBPACK_IMPORTED_MODULE_0__steps__["a" /* default */], Step: __WEBPACK_IMPORTED_MODULE_1__step__["a" /* default */]
});

/***/ }),

/***/ "2ZPF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = oneOf;
function oneOf(value, validList) {
  for (var i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}

/***/ }),

/***/ "2hJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2uPa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3GME":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3ssj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-card"},[_c('div',{staticClass:"e-card__container"},[_c('b-tabs',{ref:"bTabs",attrs:{"nav-wrapper-class":"e-card__header","nav-class":"e-card__nav-tabs","content-class":"e-card__nav-item"}},[_vm._t("default")],2),_vm._v(" "),(_vm.controls)?_c('e-card-header',{ref:"tHeader",on:{"move":_vm.handleMove}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3tE5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "46VR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forecast__ = __webpack_require__("khtj");


/* harmony default export */ __webpack_exports__["a"] = ({
  Forecast: __WEBPACK_IMPORTED_MODULE_0__forecast__["a" /* default */]
});

/***/ }),

/***/ "4U4o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4bkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_emitter__ = __webpack_require__("QOex");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_emitter__["a" /* default */]],
  name: "e-step",
  props: ['label'],
  data: function data() {
    return {
      stepNumber: '',
      currentStatus: '',
      isVisible: false
    };
  },

  watch: {
    isVisible: {
      handler: function handler() {
        this.$emit('select', this);
      },

      immediate: true
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('click');
    }
  },
  mounted: function mounted() {
    this.dispatch('e-steps', 'append');
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('e-steps', 'remove');
  }
});

/***/ }),

/***/ "4icS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-card',{class:_vm.sizeClasses,on:{"toggleDrag":function($event){return _vm.$emit('toggleDrag')}}},[_c('b-tab',{attrs:{"title":"Activity & Rewards"}},[_c('eb-chat')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4oBp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepSentMoney_vue__ = __webpack_require__("FlY9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dd10eb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepSentMoney_vue__ = __webpack_require__("XVka");
function injectStyle (ssrContext) {
  __webpack_require__("rikD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepSentMoney_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dd10eb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepSentMoney_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4ywl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menuItem__ = __webpack_require__("U+ZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu__ = __webpack_require__("GO4B");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-submenu-item",
  components: { EMenuItem: __WEBPACK_IMPORTED_MODULE_0__menuItem__["a" /* default */], EMenu: __WEBPACK_IMPORTED_MODULE_1__menu__["a" /* default */] },
  props: ['uppercase', 'badge', 'icon', 'label', 'linkClass', 'parentOpen'],
  watch: {
    parentOpen: function parentOpen(v) {
      this.parentIsOpen = v;
    }
  },
  methods: {
    onClickItem: function onClickItem() {
      if (this.parentIsOpen) {
        this.isOpen = !this.isOpen;
      } else {
        this.isOpen = true;
        this.$emit('needOpen');
        console.log(123123);
      }
      this.$emit('click');
    }
  },
  data: function data() {
    return {
      isOpen: this.$props.open || false,
      parentIsOpen: true
    };
  },

  computed: {
    getImg: function getImg() {
      return __webpack_require__("UFRR")("./" + this.icon + ".svg");
    },
    menuItemClasses: function menuItemClasses() {
      return { 'is-open': this.isOpen && this.parentIsOpen, 'is-close': !this.isOpen || !this.parentIsOpen };
    }
  }
});

/***/ }),

/***/ "4zFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_http__ = __webpack_require__("vHCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__("QmSG");















var authUri = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].services.auth;
var ratingUri = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].services.rating;
var mobileUrl = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].services.mobile;
var AUTH_STUB_STORAGE_KEY = 'economix.auth.stub';

var defaultKycSteps = {
  step1: {
    firstName: '',
    middleName: '',
    lastName: '',
    gender: '',
    dateBirth: null
  },
  step2: {
    countryOfResidents: '',
    address: '',
    city: '',
    zip: '',
    phone: ''
  },
  step3: {
    idIssuingCountry: '',
    idNumber: '',
    idExpirationDate: null
  }
};

var defaultAuthStub = {
  user: {
    id: 1,
    name: 'Demo',
    surname: 'User',
    email: 'demo@economix.ai',
    kycStatus: 'Tier0',
    amountLimit: 15000,
    lastLoginDate: new Date().toISOString(),
    kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
      status: 'draft'
    }, defaultKycSteps)
  },
  kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultKycSteps)
};

var Auth = function () {
  function Auth() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Auth);

    this.useMock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["b" /* useMock */])('auth');
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Auth, [{
    key: 'getAuthStub',
    value: function getAuthStub() {
      if (typeof window === 'undefined' || !window.localStorage) {
        return {
          user: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.user, { kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.user.kyc) }),
          kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.kyc)
        };
      }

      try {
        var raw = window.localStorage.getItem(AUTH_STUB_STORAGE_KEY);
        if (!raw) {
          return {
            user: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.user, { kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.user.kyc) }),
            kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.kyc)
          };
        }

        var parsed = JSON.parse(raw);
        return {
          user: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.user, parsed.user || {}, {
            kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.user.kyc, parsed.user && parsed.user.kyc || {})
          }),
          kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.kyc, parsed.kyc || {})
        };
      } catch (e) {
        return {
          user: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.user, { kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.user.kyc) }),
          kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultAuthStub.kyc)
        };
      }
    }
  }, {
    key: 'setAuthStub',
    value: function setAuthStub(stub) {
      if (typeof window === 'undefined' || !window.localStorage) {
        return;
      }

      window.localStorage.setItem(AUTH_STUB_STORAGE_KEY, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(stub));
    }
  }, {
    key: 'updateAuthStub',
    value: function updateAuthStub(step, data) {
      var stub = this.getAuthStub();

      stub.kyc[step] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, stub.kyc[step], data);

      stub.user = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, stub.user, {
        name: stub.kyc.step1.firstName || stub.user.name,
        surname: stub.kyc.step1.lastName || stub.user.surname,
        kyc: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, stub.user.kyc, stub.kyc)
      });

      this.setAuthStub(stub);
      return stub;
    }
  }, {
    key: 'shouldUseStub',
    value: function shouldUseStub(error) {
      return this.useMock || !error || !error.response;
    }
  }, {
    key: 'login',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
        var _login = _ref2.login,
            password = _ref2.password,
            clientId = _ref2.clientId,
            clientSecret = _ref2.clientSecret;
        var secret, sign, params, headers, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                secret = "VmVyeVNlY3JldEtleTE=";
                sign = __WEBPACK_IMPORTED_MODULE_8_crypto_js__["HmacSHA1"](_login + password + clientId + clientSecret, secret);
                params = { username: _login, password: password };
                headers = {
                  'clientId': clientId,
                  'sign': sign
                };
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].post(authUri + '/api/v1/login', params, { headers: headers });

              case 6:
                data = _context.sent;
                return _context.abrupt('return', data.data);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function login(_x) {
        return _ref.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: 'refreshToken',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
        var clientId = _ref4.clientId,
            clientSecret = _ref4.clientSecret,
            _refreshToken = _ref4.refreshToken;
        var headers, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                headers = {
                  'clientId': clientId,
                  'refreshToken': _refreshToken
                };
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].get(authUri + '/api/v1/refreshtoken', { headers: headers });

              case 3:
                data = _context2.sent;


                console.log(data.data);

                return _context2.abrupt('return', data.data);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refreshToken(_x2) {
        return _ref3.apply(this, arguments);
      }

      return refreshToken;
    }()
  }, {
    key: 'fetchUserData',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this = this;

        var _ref7, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.useMock) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
                  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(resolve) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_helpers__["c" /* sleep */])(500);

                          case 2:
                            _context3.t0 = resolve;
                            _context3.next = 5;
                            return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "SYjz"));

                          case 5:
                            _context3.t1 = _context3.sent.default.user;
                            (0, _context3.t0)(_context3.t1);

                          case 7:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this);
                  }));

                  return function (_x3) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 2:
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].get(ratingUri + '/api/v1/user/info');

              case 4:
                _ref7 = _context4.sent;
                data = _ref7.data;
                return _context4.abrupt('return', data.data);

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchUserData() {
        return _ref5.apply(this, arguments);
      }

      return fetchUserData;
    }()
  }, {
    key: 'fetchModerationGroup',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(assetId, token) {
        var headers, _ref9, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                headers = {
                  'Authorization': token
                };
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].get(ratingUri + '/api/v1/user/moderation/group/current/' + assetId, { headers: headers });

              case 3:
                _ref9 = _context5.sent;
                data = _ref9.data;
                return _context5.abrupt('return', data.data);

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchModerationGroup(_x4, _x5) {
        return _ref8.apply(this, arguments);
      }

      return fetchModerationGroup;
    }()
  }, {
    key: 'fetchModeration',
    value: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(moderationId) {
        var _ref11, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].get(ratingUri + '/api/v1/user/moderation/' + moderationId);

              case 2:
                _ref11 = _context6.sent;
                data = _ref11.data;
                return _context6.abrupt('return', data.data);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetchModeration(_x6) {
        return _ref10.apply(this, arguments);
      }

      return fetchModeration;
    }()
  }, {
    key: 'getUserActivityList',
    value: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(filter) {
        var params, _ref13, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                params = {
                  limit: filter.limit || 10,
                  sort: filter.sort || null,
                  page: filter.page || 1
                };
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].get(ratingUri + '/api/v1/user/activity/list', { params: params });

              case 3:
                _ref13 = _context7.sent;
                data = _ref13.data;
                return _context7.abrupt('return', data);

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getUserActivityList(_x7) {
        return _ref12.apply(this, arguments);
      }

      return getUserActivityList;
    }()
  }, {
    key: 'changeUserData',
    value: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(userData) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].post(ratingUri + '/api/v1/user/info/change', userData);

              case 2:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function changeUserData(_x8) {
        return _ref14.apply(this, arguments);
      }

      return changeUserData;
    }()
  }, {
    key: 'saveKYCStep',
    value: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(_ref16) {
        var data = _ref16.data,
            step = _ref16.step;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].post(authUri + '/api/v1/user/kyc', data, { params: { step: 'step' + step } });

              case 3:
                _context9.next = 10;
                break;

              case 5:
                _context9.prev = 5;
                _context9.t0 = _context9['catch'](0);

                if (this.shouldUseStub(_context9.t0)) {
                  _context9.next = 9;
                  break;
                }

                throw _context9.t0;

              case 9:

                this.updateAuthStub('step' + step, data);

              case 10:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 5]]);
      }));

      function saveKYCStep(_x9) {
        return _ref15.apply(this, arguments);
      }

      return saveKYCStep;
    }()
  }, {
    key: 'getKYCStep',
    value: function () {
      var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10(step) {
        var _ref18, data, stub;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].get(authUri + '/api/v1/user/kyc', step !== null ? { params: { step: step } } : {});

              case 3:
                _ref18 = _context10.sent;
                data = _ref18.data;
                return _context10.abrupt('return', data);

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10['catch'](0);

                if (this.shouldUseStub(_context10.t0)) {
                  _context10.next = 12;
                  break;
                }

                throw _context10.t0;

              case 12:
                stub = this.getAuthStub();
                return _context10.abrupt('return', stub.kyc['step' + step] || {});

              case 14:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 8]]);
      }));

      function getKYCStep(_x10) {
        return _ref17.apply(this, arguments);
      }

      return getKYCStep;
    }()
  }, {
    key: 'getKYCUser',
    value: function () {
      var _ref19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var _ref20, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].get(authUri + '/api/v1/user');

              case 3:
                _ref20 = _context11.sent;
                data = _ref20.data;
                return _context11.abrupt('return', data);

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11['catch'](0);

                if (this.shouldUseStub(_context11.t0)) {
                  _context11.next = 12;
                  break;
                }

                throw _context11.t0;

              case 12:
                return _context11.abrupt('return', this.getAuthStub().user);

              case 13:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 8]]);
      }));

      function getKYCUser() {
        return _ref19.apply(this, arguments);
      }

      return getKYCUser;
    }()
  }, {
    key: 'sendVerifyCode',
    value: function () {
      var _ref21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12(phone, userId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_9__plugins_http__["a" /* default */].get(mobileUrl + '/api/v1/mobauth/verificationPhone', { params: { phone: phone, userId: userId } });

              case 1:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function sendVerifyCode(_x11, _x12) {
        return _ref21.apply(this, arguments);
      }

      return sendVerifyCode;
    }()
  }]);

  return Auth;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Auth());

/***/ }),

/***/ "5Y0+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listItem_vue__ = __webpack_require__("q0g7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae3e795_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listItem_vue__ = __webpack_require__("Fe2a");
function injectStyle (ssrContext) {
  __webpack_require__("hf0W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ae3e795"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae3e795_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5p87":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "5tLd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__star_vue__ = __webpack_require__("Zk2G");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { star: __WEBPACK_IMPORTED_MODULE_1__star_vue__["a" /* default */] },
  model: {
    prop: 'rating',
    event: 'rating-selected'
  },
  props: {
    increment: { type: Number, default: 1 },
    rating: { type: Number, default: 0 },
    roundStartRating: { type: Boolean, default: true },
    activeColor: { type: [String, Array], default: '#ffd055' },
    inactiveColor: { type: String, default: '#d8d8d8' },
    maxRating: { type: Number, default: 5 },
    starPoints: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    starSize: { type: Number, default: 50 },
    showRating: { type: Boolean, default: true },
    readOnly: { type: Boolean, default: false },
    textClass: { type: String, default: '' },
    inline: { type: Boolean, default: false },
    borderColor: { type: String, default: '#999' },
    activeBorderColor: { type: [String, Array], default: null },
    borderWidth: { type: Number, default: 0 },
    roundedCorners: { type: Boolean, default: false },
    padding: { type: Number, default: 0 },
    rtl: { type: Boolean, default: false },
    fixedPoints: { type: Number, default: null },
    glow: { type: Number, default: 0 },
    glowColor: { type: String, default: '#fff' },
    clearable: { type: Boolean, default: false },
    activeOnClick: { type: Boolean, default: false },
    animate: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      step: 0,
      fillLevel: [],
      currentRating: 0,
      selectedRating: 0,
      ratingSelected: false
    };
  },

  computed: {
    formattedRating: function formattedRating() {
      return this.fixedPoints === null ? this.currentRating : this.currentRating.toFixed(this.fixedPoints);
    },
    shouldRound: function shouldRound() {
      return this.ratingSelected || this.roundStartRating;
    },
    margin: function margin() {
      return this.padding + this.borderWidth;
    },
    activeColors: function activeColors() {
      if (Array.isArray(this.activeColor)) {
        return this.padColors(this.activeColor, this.maxRating, this.activeColor.slice(-1)[0]);
      }
      return new Array(this.maxRating).fill(this.activeColor);
    },
    currentActiveColor: function currentActiveColor() {
      if (!this.activeOnClick) {
        return this.currentRating > 0 ? this.activeColors[Math.ceil(this.currentRating) - 1] : this.inactiveColor;
      }
      return this.selectedRating > 0 ? this.activeColors[Math.ceil(this.selectedRating) - 1] : this.inactiveColor;
    },
    activeBorderColors: function activeBorderColors() {
      if (Array.isArray(this.activeBorderColor)) {
        return this.padColors(this.activeBorderColor, this.maxRating, this.activeBorderColor.slice(-1)[0]);
      }
      var borderColor = this.activeBorderColor ? this.activeBorderColor : this.borderColor;
      return new Array(this.maxRating).fill(borderColor);
    },
    currentActiveBorderColor: function currentActiveBorderColor() {
      if (!this.activeOnClick) {
        return this.currentRating > 0 ? this.activeBorderColors[Math.ceil(this.currentRating) - 1] : this.borderColor;
      }
      return this.selectedRating > 0 ? this.activeBorderColors[Math.ceil(this.selectedRating) - 1] : this.borderColor;
    }
  },
  watch: {
    rating: function rating(val) {
      this.currentRating = val;
      this.selectedRating = val;
      this.createStars(this.shouldRound);
    }
  },
  created: function created() {
    this.step = this.increment * 100;
    this.currentRating = this.rating;
    this.selectedRating = this.currentRating;
    this.createStars(this.roundStartRating);
  },

  methods: {
    setRating: function setRating(event, persist) {
      if (!this.readOnly) {
        var position = this.rtl ? (100 - event.position) / 100 : event.position / 100;
        this.currentRating = (event.id + position - 1).toFixed(2);
        this.currentRating = this.currentRating > this.maxRating ? this.maxRating : this.currentRating;
        if (persist) {
          this.createStars(true, true);
          if (this.clearable && this.currentRating === this.selectedRating) {
            this.selectedRating = 0;
          } else {
            this.selectedRating = this.currentRating;
          }
          this.$emit('rating-selected', this.selectedRating);
          this.ratingSelected = true;
        } else {
          this.createStars(true, !this.activeOnClick);
          this.$emit('current-rating', this.currentRating);
        }
      }
    },
    resetRating: function resetRating() {
      if (!this.readOnly) {
        this.currentRating = this.selectedRating;
        this.createStars(this.shouldRound);
      }
    },
    createStars: function createStars() {
      var round = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var applyFill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (round) {
        this.round();
      }
      for (var i = 0; i < this.maxRating; i += 1) {
        var level = 0;
        if (i < this.currentRating) {
          level = this.currentRating - i > 1 ? 100 : (this.currentRating - i) * 100;
        }
        if (applyFill) {
          this.fillLevel[i] = Math.round(level);
        }
      }
    },
    round: function round() {
      var inv = 1.0 / this.increment;
      this.currentRating = Math.min(this.maxRating, Math.ceil(this.currentRating * inv) / inv);
    },
    padColors: function padColors(array, minLength, fillValue) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new Array(minLength).fill(fillValue), array);
    }
  }
});

/***/ }),

/***/ "5xbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buyList__ = __webpack_require__("ejEv");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__buyList__["a" /* default */]);

/***/ }),

/***/ "5xew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("XItq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c4910e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("xt5r");
function injectStyle (ssrContext) {
  __webpack_require__("3tE5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41c4910e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41c4910e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6A3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6JhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_message_vue__ = __webpack_require__("dcti");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e6229c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_message_vue__ = __webpack_require__("OZJm");
function injectStyle (ssrContext) {
  __webpack_require__("P3UP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51e6229c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_message_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e6229c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6MG3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6NVj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");



var _this = this;



/* harmony default export */ __webpack_exports__["default"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['auth/isAuth']) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', next({
              name: 'dashboard'
            }));

          case 2:

            next();

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),

/***/ "6g1Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "6q2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-input",
  props: {
    value: [String, Number],
    label: String,
    type: String,
    placeholder: String,
    floating: Boolean
  },
  computed: {
    getPlaceholder: function getPlaceholder() {
      if (this.floating && !this.placeholder) {
        return ' ';
      }

      return this.placeholder;
    }
  }
});

/***/ }),

/***/ "6qc/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_card_card__ = __webpack_require__("tqXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_dynamicSize__ = __webpack_require__("KOBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_trading_card_vue__ = __webpack_require__("7NcE");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ec-kyc",
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_dynamicSize__["a" /* default */]],
  components: { ECard: __WEBPACK_IMPORTED_MODULE_3__elements_card_card__["a" /* default */], TCard: __WEBPACK_IMPORTED_MODULE_8__elements_trading_card_vue__["a" /* default */] },
  filters: {
    shortText: function shortText(value) {
      if (value.length > 25) {
        value = value.substring(0, 22) + '...';
      }

      return value;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])("settings", ["setShowKyc"]), {
    onSeeAllClick: function onSeeAllClick() {
      this.$router.push({ name: 'trading-buy' });
    },
    showKycModal: function showKycModal() {
      this.setShowKyc(true);
    }
  }),
  data: function data() {
    return {
      loading: true,
      kycUser: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])("coins", {
    getCoins: 'coins'
  }), {
    buttonText: function buttonText() {
      switch (this.kycUser.kycStatus) {
        case 'Tier0':
          return 'Up to 15K USD';
        case 'Tier1':
          return 'Up to 500K USD';
        case 'Tier2':
          return 'Up to 1M USD';
      }
    },
    tradingLimit: function tradingLimit() {
      return parseFloat(this.kycUser.amountLimit).toFixed(2);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_7__services__["a" /* default */].Auth.getKYCUser();

            case 3:
              _this.kycUser = _context.sent;

              _this.loading = false;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "6xR6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjQ2NjcgMC4wMjQ3MjM2TDIgMS43Mzg4MUMwLjg2NjY2NyAxLjkxNzA3IDAgMi42NTc1NiAwIDMuODkxN1YxMy45NDMxQzAgMTYgMCAxNiAyIDE2SDE0LjY0QzE1LjQyNjcgMTYgMTYgMTUuNDEwNCAxNiAxNC42MDEzVjUuMDU3MjhDMTYgNC4yNDgyMyAxNS40MjY3IDMuNjU4NTkgMTQuNjQgMy42NTg1OUgyLjM2QzEuNzg2NjcgMy42NTg1OSAxLjczMzMzIDMuMTkyMzUgMi4zNiAzLjEyMzc5TDE0IDEuODc1OTRWMS4yMDQwMUMxNCAwLjMyNjQwMiAxMy4yOCAtMC4xMTI0MDMgMTIuNDY2NyAwLjAyNDcyMzZaTTEzLjUwNjcgMTAuNzQ4QzEyLjg1MzMgMTAuNzQ4IDEyLjMzMzMgMTAuMjI3IDEyLjMzMzMgOS41NTUwNEMxMi4zMzMzIDguODgzMTIgMTIuODUzMyA4LjM0ODMyIDEzLjUwNjcgOC4zNDgzMkMxNC4xNiA4LjM0ODMyIDE0LjY2NjcgOC44ODMxMiAxNC42NjY3IDkuNTU1MDRDMTQuNjY2NyAxMC4yMjcgMTQuMTYgMTAuNzQ4IDEzLjUwNjcgMTAuNzQ4WiIgZmlsbD0iI0U0RUNGMyIvPgo8L3N2Zz4K"

/***/ }),

/***/ "7Az5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");







var Auth = function () {
  function Auth() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Auth);

    this.useMock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["b" /* useMock */])('ui');
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Auth, [{
    key: 'fetchDashboard',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(userId) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.useMock) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["c" /* sleep */])(500);

                          case 2:
                            _context.t0 = resolve;
                            _context.next = 5;
                            return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "SYjz"));

                          case 5:
                            _context.t1 = userId;
                            _context.t2 = _context.sent.getDashboard(_context.t1);
                            (0, _context.t0)(_context.t2);

                          case 8:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchDashboard(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchDashboard;
    }()
  }]);

  return Auth;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Auth());

/***/ }),

/***/ "7MJl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal-content-container"},[_c('b-row',{staticClass:"modal-row"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Search"},on:{"input":_vm.changeSearch},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.filteredCriteria.length === 0)?_c('e-button',{staticClass:"ml-2 new-criterion",attrs:{"color":"blue-light","type":"outlined","size":"smaller"},on:{"click":_vm.newCriterion}},[_c('b',[_vm._v("+")]),_vm._v(" Create new")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"modal-row"},[_c('b-col',{attrs:{"cols":"9"}},[_c('div',{staticClass:"modal-block-title"},[_vm._v("List of Criteria:")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('div',{staticClass:"d-flex flex-row align-items-center justify-content-end"},[_c('b-btn',{staticClass:"e-create-rate__reset",attrs:{"variant":"link","size":"sm"},on:{"click":_vm.resetCriteria}},[_vm._v("Reset all")])],1)])],1),_vm._v(" "),(_vm.filteredCriteria.length === 0)?_c('b-row',{staticClass:"modal-row select-criteria-list",class:{'is-loading': _vm.$wait.is('assets.searchCriteria')}},[_c('b-col',{key:"empty-data",staticClass:"align-items-center justify-content-center d-flex",attrs:{"cols":"12"}},[(_vm.search)?_c('h3',{staticClass:"criterion-item not-found"},[_vm._v("Not found similar to "),_c('b',[_vm._v("\""+_vm._s(this.search)+"\"")]),_vm._v(" criteria")]):_c('h3',{staticClass:"criterion-item not-found"},[_vm._v("No criteria yet")])])],1):_vm._e(),_vm._v(" "),(_vm.filteredCriteria.length !== 0)?_c('transition-group',{staticClass:"select-criteria-list",class:{'is-loading': _vm.$wait.is('assets.searchCriteria')},attrs:{"tag":"b-row","name":"fade","duration":100,"appear":""}},_vm._l((_vm.filteredCriteria),function(criterion){return _c('b-col',{key:criterion.id,staticClass:"criterion-item",attrs:{"cols":"4"}},[_c('e-button',{staticClass:"w-100 font-weight-bold",attrs:{"color":_vm.isSelectedCriterion(criterion.id) ? 'blue-light' : 'custom-color'},domProps:{"innerHTML":_vm._s(_vm.formattedCriterionTitle(criterion.id))},on:{"click":function($event){return _vm.toggleCriterion(criterion.id)}}})],1)}),1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('e-button',{attrs:{"type":"outlined"},on:{"click":function () { return this$1.$emit('closeModal'); }}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"d-flex ml-auto"},[_c('e-button',{attrs:{"disabled":_vm.nextBtnDisabled},on:{"click":_vm.onNextClick}},[_vm._v("Next")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7NcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__ = __webpack_require__("T4CU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d3ab9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__ = __webpack_require__("eK9d");
function injectStyle (ssrContext) {
  __webpack_require__("PLmV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d3ab9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Vdr":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./checkAuth.js": "LQnS",
	"./locale.js": "BoPI",
	"./onlyAuth.js": "BCG5",
	"./onlyGuest.js": "6NVj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7Vdr";

/***/ }),

/***/ "7c+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.asset.id,staticClass:"e-asset-card"},[_c('div',{staticClass:"e-asset-card__header"},[_c('div',{staticClass:"e-asset-card__header--left"},[_c('div',{staticClass:"e-asset-card__text eh-primary-text"},[_vm._v(_vm._s(_vm._f("shortText")(_vm.asset.name,10)))])]),_vm._v(" "),(!_vm.showDescribe)?_c('div',{staticClass:"e-asset-card__header--right"},[_c('hr',{staticClass:"e-divider e-divider--direction--vertical"}),_vm._v(" "),_c('div',{staticClass:"e-asset-card__text eh-secondary-text"},[_vm._v(_vm._s(_vm.asset.symbol))]),_vm._v(" "),_c('div',{staticClass:"e-asset-card__info",on:{"click":_vm.toggleDescribe}})]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.showDescribe)?_c('div',{key:"face"},[_c('div',{staticClass:"e-asset-card__content"},[_c('router-link',{staticClass:"e-asset-card__logo",attrs:{"to":{name:'asset', params: {id: _vm.asset.id}}}},[_c('img',{attrs:{"src":_vm.asset.logoPath,"width":"100%","height":"100%"}})]),_vm._v(" "),_c('div',{staticClass:"e-asset-card__meta"},[_c('div',{staticClass:"e-asset-card__meta-col"},[_c('b-btn',{ref:"popoverBtn",staticClass:"e-btn e-btn--outlined e-btn--color--gray-dark e-btn--size--small d-sm-flex d-xl-none"},[_vm._v("Learn More")]),_vm._v(" "),_c('b-popover',{staticClass:"e-popover",attrs:{"target":function () { return this$1.$refs.popoverBtn; },"placement":"top","triggers":"hover focus"}},[_c('ul',{staticClass:"ee-list eh-secondary-text"},[_c('li',[_c('p',{staticClass:"mr-2"},[_vm._v("Assets Vol:")]),_c('p',{staticClass:"ml-auto"},[_vm._v(_vm._s(_vm.asset.volume)+" USD ($)")])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"mr-2"},[_vm._v("Forecasted:")]),_c('p',{staticClass:"ml-auto"},[_vm._v(_vm._s(_vm.asset.totalForecasters)+" "),_c('span',{staticClass:"e-asset-card__forecasted-icon"})])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"mr-2"},[_vm._v("Added in portfolio:")]),_c('p',{staticClass:"ml-auto"},[_vm._v(_vm._s(_vm.asset.totalInPortfolio))])])])])],1),_vm._v(" "),_c('div',{staticClass:"e-asset-card__meta-col"},[(_vm.asset.change24)?_c('div',{staticClass:"badge e-badge e-asset-card__trend e-badge--size--large",class:_vm.asset.change24 >= 0 ? ' e-asset-card__trend--up' : ' e-asset-card__trend--down'},[_vm._v("\n                "+_vm._s(_vm.asset.change24 >= 0 ? '+' : '-')+" "+_vm._s(_vm.asset.change24.toFixed(2))+" %\n                "),_c('span',{staticClass:"e-asset-card__trend-icon"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"e-asset-card__info"},[_c('div',{staticClass:"e-asset-card__price"},[_vm._v(_vm._s(_vm.asset.price.value ? ((this.formatPrice(_vm.asset.price.value)) + " " + (_vm.asset.price.currency)) : 'N/A'))]),_vm._v(" "),_c('div',{staticClass:"e-asset-card__rate"},[_vm._v(_vm._s(_vm.asset.rate === 0 ? 'N/A' : _vm.asset.rate))])])],1),_vm._v(" "),_c('ul',{staticClass:"e-asset-card__list ee-list eh-secondary-text d-none d-xl-flex"},[_c('li',[_c('p',{staticClass:"mr-2"},[_vm._v("Assets Vol:")]),_c('p',{staticClass:"ml-auto"},[_vm._v(_vm._s(_vm.asset.volume)+" USD ($)")])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"mr-2"},[_vm._v("Forecasted:")]),_c('p',{staticClass:"ml-auto"},[_vm._v(_vm._s(_vm.asset.totalForecasters)+" "),_c('span',{staticClass:"e-asset-card__forecasted-icon"})])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"mr-2"},[_vm._v("Added in portfolio:")]),_c('p',{staticClass:"ml-auto"},[_vm._v(_vm._s(_vm.asset.totalInPortfolio))])])])]):_vm._e(),_vm._v(" "),(_vm.showDescribe)?_c('div',{key:"back",staticClass:"e-asset-card__describe eh-primary-text"},[_c('p',[_vm._v(_vm._s(_vm._f("shortText")(_vm.asset.description,240)))]),_vm._v(" "),_c('b-btn',{staticClass:"e-btn e-btn--outlined e-btn--color--gray-dark e-btn--size--small px-3",on:{"click":_vm.toggleDescribe}},[_vm._v("Back")])],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7iwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectCriteria_vue__ = __webpack_require__("s7Lj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79b3e52c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectCriteria_vue__ = __webpack_require__("7MJl");
function injectStyle (ssrContext) {
  __webpack_require__("YvDG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79b3e52c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectCriteria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79b3e52c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectCriteria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7rHV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lineChart_vue__ = __webpack_require__("vZaH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dce663f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lineChart_vue__ = __webpack_require__("ngrN");
function injectStyle (ssrContext) {
  __webpack_require__("a7Jc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0dce663f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lineChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dce663f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lineChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8HOo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__("C5Io");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__button__["a" /* default */]);

/***/ }),

/***/ "8I6K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8TID":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxOCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE4Ij4KICAgIDxwYXRoIGZpbGw9IiNFNEVDRjMiIGQ9Ik04IDBDNi42OTggMCA1LjYzOSAxLjA3NCA1LjYzOSAyLjM5NXYuNzIyaDEuMjJ2LS43MjJBMS4xNSAxLjE1IDAgMCAxIDggMS4yMzljLjYzIDAgMS4xNDEuNTE4IDEuMTQxIDEuMTU2di43MjJoMS4yMjF2LS43MjJDMTAuMzYxIDEuMDc1IDkuMzAxIDAgOCAwek05LjY3IDE1LjA5YzAgLjkyMS0uNzQgMS42NzEtMS42NSAxLjY3MWgtLjA0Yy0uOTEgMC0xLjY1LS43NS0xLjY1LTEuNjcySDUuMTFDNS4xMSAxNi42OTQgNi4zOTYgMTggNy45OCAxOGguMDRjMS41ODMgMCAyLjg3LTEuMzA2IDIuODctMi45MUg5LjY3eiIvPgogICAgPHBhdGggZmlsbD0iI0U0RUNGMyIgZD0iTTE1LjkwMyAxNC44NThsLTEuNzM1LTIuNzM3VjguNjA4YzAtMy40ODMtMi43NjctNi4zMTctNi4xNjgtNi4zMTctMy40MDEgMC02LjE2OCAyLjgzNC02LjE2OCA2LjMxN3YzLjUxM0wuMDk3IDE0Ljg1OGEuNjI2LjYyNiAwIDAgMC0uMDIyLjYzMS42MS42MSAwIDAgMCAuNTM2LjMyM2gxNC43NzhhLjYxLjYxIDAgMCAwIC41MzYtLjMyMi42MjYuNjI2IDAgMCAwLS4wMjItLjYzMnptLTE0LjE3NC0uMjg0bDEuMjI3LTEuOTM2YS42MjUuNjI1IDAgMCAwIC4wOTctLjMzNVY4LjYwOGMwLTIuOCAyLjIyLTUuMDc4IDQuOTQ3LTUuMDc4IDIuNzI4IDAgNC45NDcgMi4yNzggNC45NDcgNS4wNzh2My42OTVjMCAuMTE5LjAzMy4yMzUuMDk3LjMzNWwxLjIyNyAxLjkzNkgxLjcyOXoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "8bdi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_http__ = __webpack_require__("vHCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__("QmSG");









var uri = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].services.rating;

var Rates = function () {
  function Rates() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Rates);

    this.useMock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["b" /* useMock */])('rates');
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Rates, [{
    key: "fetchRates",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.useMock) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["c" /* sleep */])(200);

                          case 2:
                            _context.t0 = resolve;
                            _context.next = 5;
                            return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "eMHj"));

                          case 5:
                            _context.t1 = _context.sent;
                            (0, _context.t0)(_context.t1);

                          case 7:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchRates() {
        return _ref.apply(this, arguments);
      }

      return fetchRates;
    }()
  }, {
    key: "getRatesList",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(filter) {
        var params, _ref4, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {};

                params.limit = filter.limit || 25;
                params.page = filter.page || 1;

                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/user/rates", { params: params });

              case 5:
                _ref4 = _context3.sent;
                data = _ref4.data;
                return _context3.abrupt("return", data.data);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getRatesList(_x2) {
        return _ref3.apply(this, arguments);
      }

      return getRatesList;
    }()
  }, {
    key: "createRate",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(data) {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].post(uri + "/api/v1/rates", data);

              case 2:
                res = _context4.sent;
                return _context4.abrupt("return", res.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createRate(_x3) {
        return _ref5.apply(this, arguments);
      }

      return createRate;
    }()
  }, {
    key: "fetchRate",
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id, token) {
        var _ref7, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/rates/" + id);

              case 2:
                _ref7 = _context5.sent;
                data = _ref7.data;
                return _context5.abrupt("return", data.data);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchRate(_x4, _x5) {
        return _ref6.apply(this, arguments);
      }

      return fetchRate;
    }()
  }, {
    key: "getCurrentRateByAsset",
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(assetId) {
        var _ref9, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/user/rates/current/" + assetId);

              case 2:
                _ref9 = _context6.sent;
                data = _ref9.data;
                return _context6.abrupt("return", data.data);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getCurrentRateByAsset(_x6) {
        return _ref8.apply(this, arguments);
      }

      return getCurrentRateByAsset;
    }()
  }]);

  return Rates;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Rates());

/***/ }),

/***/ "8o/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assetsList__ = __webpack_require__("zhIy");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__assetsList__["a" /* default */]);

/***/ }),

/***/ "9+hP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xOC43NSAwSDIuMjVDMS4wMSAwIDAgMS4wMSAwIDIuMjV2MTYuNUMwIDE5Ljk5IDEuMDEgMjEgMi4yNSAyMWgxNi41YzEuMjQgMCAyLjI1LTEuMDEgMi4yNS0yLjI1VjIuMjVDMjEgMS4wMSAxOS45OSAwIDE4Ljc1IDB6TTIuMjUgMS41aDE2LjVhLjc1Ljc1IDAgMCAxIC43NS43NVY5aC0xOFYyLjI1YS43NS43NSAwIDAgMSAuNzUtLjc1em0xNi41IDE4SDIuMjVhLjc1Ljc1IDAgMCAxLS43NS0uNzVWMTAuNWgxOHY4LjI1YS43NS43NSAwIDAgMS0uNzUuNzV6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNOS43NSAxNC41aDcuNWEuNzUuNzUgMCAxIDAgMC0xLjVoLTcuNWEuNzUuNzUgMCAxIDAgMCAxLjV6TTkuNSAxNy41aDVjLjI3NiAwIC41LS4zMzUuNS0uNzVzLS4yMjQtLjc1LS41LS43NWgtNWMtLjI3NiAwLS41LjMzNS0uNS43NXMuMjI0Ljc1LjUuNzV6TTUuMjUgMTcuNWMxLjI0IDAgMi4yNS0xLjAxIDIuMjUtMi4yNVM2LjQ5IDEzIDUuMjUgMTMgMyAxNC4wMSAzIDE1LjI1czEuMDEgMi4yNSAyLjI1IDIuMjV6bTAtM2EuNzUuNzUgMCAxIDEtLjAwMiAxLjUwMi43NS43NSAwIDAgMSAuMDAyLTEuNTAyek0zLjc1IDZoNy41YS43NS43NSAwIDEgMCAwLTEuNWgtNy41YS43NS43NSAwIDEgMCAwIDEuNXpNMTUuNzUgNy41QzE2Ljk5IDcuNSAxOCA2LjQ5IDE4IDUuMjVTMTYuOTkgMyAxNS43NSAzIDEzLjUgNC4wMSAxMy41IDUuMjVzMS4wMSAyLjI1IDIuMjUgMi4yNXptMC0zYS43NS43NSAwIDEgMS0uMDAyIDEuNTAyLjc1Ljc1IDAgMCAxIC4wMDItMS41MDJ6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "9A88":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "9CXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "e-menu-header"
});

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9NxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_http__ = __webpack_require__("vHCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__("QmSG");









var uri = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].services.rating;

var Assets = function () {
  function Assets() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Assets);

    this.useMock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["b" /* useMock */])('assets');
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Assets, [{
    key: "fetchAssets",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(ids) {
        var _this = this;

        var params, _ref3, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.useMock) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["c" /* sleep */])(2000);

                          case 2:
                            _context.t0 = resolve;
                            _context.next = 5;
                            return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "2REp"));

                          case 5:
                            _context.t1 = ids;
                            _context.t2 = _context.sent.byIds(_context.t1);
                            (0, _context.t0)(_context.t2);

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 2:
                params = {
                  ids: ids
                };
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/assets/list", { params: params });

              case 5:
                _ref3 = _context2.sent;
                data = _ref3.data;
                return _context2.abrupt("return", data.data.items);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchAssets(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchAssets;
    }()
  }, {
    key: "fetchAsset",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var _ref5, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('fetchAsset', id);
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/assets/" + id + "/details");

              case 3:
                _ref5 = _context3.sent;
                data = _ref5.data;

                console.log('fetchAsset r', data);

                return _context3.abrupt("return", data.data);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchAsset(_x3) {
        return _ref4.apply(this, arguments);
      }

      return fetchAsset;
    }()
  }, {
    key: "fetchAllAssets",
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(withoutIds, token) {
        var _this2 = this;

        var _ref8, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.useMock) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["c" /* sleep */])(1000);

                          case 2:
                            _context4.t0 = resolve;
                            _context4.next = 5;
                            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "2REp"));

                          case 5:
                            _context4.t1 = withoutIds;
                            _context4.t2 = _context4.sent.getAllAssets(_context4.t1);
                            (0, _context4.t0)(_context4.t2);

                          case 8:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this2);
                  }));

                  return function (_x6) {
                    return _ref7.apply(this, arguments);
                  };
                }()));

              case 2:
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/assets");

              case 4:
                _ref8 = _context5.sent;
                data = _ref8.data;
                return _context5.abrupt("return", data.data);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchAllAssets(_x4, _x5) {
        return _ref6.apply(this, arguments);
      }

      return fetchAllAssets;
    }()
  }, {
    key: "fetchAssetsByFilter",
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(filter) {
        var params, _ref10, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                params = {};


                params.limit = filter.limit || 25;
                params.page = filter.page || 1;
                params.sort = filter.sort || '';
                params.type = filter.type || 'all';

                if (filter.sort) {
                  params.sort = filter.sort;
                }

                _context6.next = 8;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/assets/list", { params: params });

              case 8:
                _ref10 = _context6.sent;
                data = _ref10.data;
                return _context6.abrupt("return", data.data);

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetchAssetsByFilter(_x7) {
        return _ref9.apply(this, arguments);
      }

      return fetchAssetsByFilter;
    }()
  }, {
    key: "followToAsset",
    value: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(id) {
        var _ref12, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].post(uri + "/api/v1/assets/" + id + "/follow");

              case 2:
                _ref12 = _context7.sent;
                data = _ref12.data;

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function followToAsset(_x8) {
        return _ref11.apply(this, arguments);
      }

      return followToAsset;
    }()
  }, {
    key: "searchCriteria",
    value: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(search, token) {
        var params, _ref14, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                params = {
                  q: search
                };
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/search/criteria", { params: params });

              case 3:
                _ref14 = _context8.sent;
                data = _ref14.data;
                return _context8.abrupt("return", data.data);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function searchCriteria(_x9, _x10) {
        return _ref13.apply(this, arguments);
      }

      return searchCriteria;
    }()
  }, {
    key: "fetchAllCriteria",
    value: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _this3 = this;

        var _ref17, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!this.useMock) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(resolve) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.next = 2;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["c" /* sleep */])(1000);

                          case 2:
                            _context9.t0 = resolve;
                            _context9.next = 5;
                            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "2REp"));

                          case 5:
                            _context9.t1 = _context9.sent.getAllCriteria();
                            (0, _context9.t0)(_context9.t1);

                          case 7:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9, _this3);
                  }));

                  return function (_x11) {
                    return _ref16.apply(this, arguments);
                  };
                }()));

              case 2:
                _context10.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/criteria");

              case 4:
                _ref17 = _context10.sent;
                data = _ref17.data;
                return _context10.abrupt("return", data.data);

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function fetchAllCriteria() {
        return _ref15.apply(this, arguments);
      }

      return fetchAllCriteria;
    }()
  }, {
    key: "fetchCriterion",
    value: function () {
      var _ref18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(id, token) {
        var _ref19, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/criteria/" + id);

              case 2:
                _ref19 = _context11.sent;
                data = _ref19.data;

                console.log('cirririri fetchCriterion', uri + "/api/v1/criteria/" + id, data);

                return _context11.abrupt("return", data.data);

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function fetchCriterion(_x12, _x13) {
        return _ref18.apply(this, arguments);
      }

      return fetchCriterion;
    }()
  }, {
    key: "fetchSector",
    value: function () {
      var _ref20 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(id, token) {
        var _ref21, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/sectors/" + id);

              case 2:
                _ref21 = _context12.sent;
                data = _ref21.data;
                return _context12.abrupt("return", data.data);

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function fetchSector(_x14, _x15) {
        return _ref20.apply(this, arguments);
      }

      return fetchSector;
    }()
  }, {
    key: "fetchAllSectors",
    value: function () {
      var _ref22 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var _this4 = this;

        var _ref24, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!this.useMock) {
                  _context14.next = 2;
                  break;
                }

                return _context14.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref23 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(resolve) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                      while (1) {
                        switch (_context13.prev = _context13.next) {
                          case 0:
                            _context13.next = 2;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["c" /* sleep */])(1000);

                          case 2:
                            _context13.t0 = resolve;
                            _context13.next = 5;
                            return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "2REp"));

                          case 5:
                            _context13.t1 = _context13.sent.getAllSectors();
                            (0, _context13.t0)(_context13.t1);

                          case 7:
                          case "end":
                            return _context13.stop();
                        }
                      }
                    }, _callee13, _this4);
                  }));

                  return function (_x16) {
                    return _ref23.apply(this, arguments);
                  };
                }()));

              case 2:
                _context14.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(uri + "/api/v1/sectors");

              case 4:
                _ref24 = _context14.sent;
                data = _ref24.data;
                return _context14.abrupt("return", data.data);

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function fetchAllSectors() {
        return _ref22.apply(this, arguments);
      }

      return fetchAllSectors;
    }()
  }]);

  return Assets;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Assets());

/***/ }),

/***/ "9kTw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9x+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"mb-3",attrs:{"cols":"12"}},[_c('div',{staticClass:"e-create-rate__title"},[_vm._v("What is your rate:")])]),_vm._v(" "),_c('b-col',{staticClass:"mb-4",attrs:{"cols":"12"}},[_c('ul',{staticClass:"e-evaluation"},_vm._l((10),function(i){return _c('li',{key:i,staticClass:"e-evaluation__item",class:{'active': i === _vm.getCriterionEvaluation(_vm.criterionId)},on:{"click":function($event){return _vm.onChangeEval(i)}}},[_c('span',[_vm._v(_vm._s(i))])])}),0)]),_vm._v(" "),_c('b-col',{staticClass:"mb-3",attrs:{"cols":"12"}},[_c('div',{staticClass:"e-create-rate__title"},[_vm._v("Justification:")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('b-form-textarea',{staticClass:"h-100 mh-100",attrs:{"placeholder":"Write something about you rate","rows":5,"max-rows":8},model:{value:(_vm.justification),callback:function ($$v) {_vm.justification=$$v},expression:"justification"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('em-asset-average-score',{staticClass:"my-0",attrs:{"score":_vm.averageEvaluation.toFixed(1)}},[_vm._v("Your average score so far:")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9yQM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_card_card__ = __webpack_require__("tqXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_myAssets_myAssets__ = __webpack_require__("p4KC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_dynamicSize__ = __webpack_require__("KOBJ");
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ec-assets",
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_dynamicSize__["a" /* default */]],
  components: { EbMyAssets: __WEBPACK_IMPORTED_MODULE_1__widgets_myAssets_myAssets__["a" /* default */], ECard: __WEBPACK_IMPORTED_MODULE_0__elements_card_card__["a" /* default */] }
});

/***/ }),

/***/ "A9cn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__message__ = __webpack_require__("6JhI");
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-chat",
  components: { EChatMessage: __WEBPACK_IMPORTED_MODULE_0__message__["a" /* default */] },
  data: function data() {
    var subjects = [{ avatar: 'https://randomuser.me/api/portraits/men/10.jpg' }, { avatar: 'https://randomuser.me/api/portraits/men/11.jpg' }];

    return {
      messages: [{
        id: 1,
        subject: subjects[0],
        type: 'from',
        message: {
          text: 'You account is now varified. Feel free connect your wallet and start trading & rating',
          date: Date.now()
        }
      }, {
        id: 2,
        subject: subjects[1],
        type: 'to',
        message: {
          text: 'You completed your varification and waiting for an approval...',
          date: Date.now() - 1000 * 60 * 5
        }
      }, {
        id: 3,
        subject: subjects[1],
        type: 'to',
        message: {
          text: 'You rated IOTA for +25%',
          date: Date.now() - 1000 * 60 * 60
        }
      }, {
        id: 4,
        subject: subjects[0],
        type: 'from',
        message: {
          text: 'New bit by <span>@Fredric</span> for Wings',
          date: Date.now() - 1000 * 60 * 120
        }
      }, {
        id: 5,
        subject: subjects[0],
        type: 'from',
        message: {
          text: 'You account is now varified. Feel free connect your wallet and start trading & rating',
          date: Date.now() - 1000 * 60 * 24 * 60
        }
      }]
    };
  }
});

/***/ }),

/***/ "ABpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lockTokens__ = __webpack_require__("NKB3");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__lockTokens__["a" /* default */]);

/***/ }),

/***/ "ASOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assets_vue__ = __webpack_require__("9yQM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d46e6d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assets_vue__ = __webpack_require__("Hp1D");
function injectStyle (ssrContext) {
  __webpack_require__("PKqg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44d46e6d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44d46e6d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AYuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_http__ = __webpack_require__("vHCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__("QmSG");









var ratingUri = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].services.rating;

var Coins = function () {
  function Coins() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Coins);

    this.useMock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["b" /* useMock */])('coins');
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Coins, [{
    key: 'fetchTradingAssets',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(type) {
        var _this = this;

        var _ref3, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.useMock) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["c" /* sleep */])(200);

                          case 2:
                            _context.t0 = resolve;
                            _context.next = 5;
                            return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "Wdd2"));

                          case 5:
                            _context.t1 = _context.sent;
                            (0, _context.t0)(_context.t1);

                          case 7:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 2:
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(ratingUri + '/api/v1/trading/assets?type=' + type);

              case 4:
                _ref3 = _context2.sent;
                data = _ref3.data;
                return _context2.abrupt('return', data.data);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchTradingAssets(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchTradingAssets;
    }()
  }]);

  return Coins;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Coins());

/***/ }),

/***/ "Ab68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"size":"lg","modal-class":"e-modal buy-crypto-modal","hide-footer":true,"centered":""},on:{"show":_vm.onShow,"hide":_vm.close},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.asset)?[_c('template',{slot:"modal-header"},[_c('div',{staticClass:"title"},[_vm._v("\n        Buy "+_vm._s(_vm.asset.name)+"\n      ")])]),_vm._v(" "),[_c('em-buy-crypto-header'),_vm._v(" "),_c('div',{staticClass:"modal-divider"}),_vm._v(" "),_c('div',{staticClass:"modal-content-container"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('ul',{staticClass:"e-breadcrumb"},_vm._l((_vm.steps),function(step,i){return _c('li',{key:i,staticClass:"e-breadcrumb__item",class:{'e-breadcrumb--active': step.number < _vm.current, 'e-breadcrumb--current': step.number === _vm.current}},[_c('span',[_vm._v(_vm._s(step.label))])])}),0)])],1),_vm._v(" "),_c('b-row',[(!_vm.isFinished)?_c('b-col',{attrs:{"cols":"12"}},[(_vm.current === 1)?_c('step-payment-method',{on:{"nextPage":function () { return this$1.current = 2; }}}):_vm._e(),_vm._v(" "),(_vm.current === 2)?_c('step-wallet',{on:{"nextPage":function () { return this$1.current = 3; }}}):_vm._e(),_vm._v(" "),(_vm.current === 3)?_c('step-wiretransfer',{on:{"nextPage":function () { return this$1.current = 4; }}}):_vm._e(),_vm._v(" "),(_vm.current === 4)?_c('step-sent-money',{on:{"nextPage":function () { return this$1.isFinished = true; }}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('b-col',{attrs:{"cols":"12"}},[(_vm.isFinished)?_c('div',[_c('div',{staticClass:"success-message"},[_c('h3',[_vm._v("We will check the information and send you "+_vm._s(_vm.asset.name)+".")]),_vm._v(" "),_c('div',{staticClass:"img-container",staticStyle:{"margin":"20px auto"}},[_c('svg',{staticStyle:{"fill":"#0672f3"},attrs:{"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 465.2 465.2","xml:space":"preserve"}},[_c('g',[_c('g',{attrs:{"id":"Layer_2_16_"}},[_c('g',[_c('path',{attrs:{"d":"M279.591,423.714c-3.836,0.956-7.747,1.805-11.629,2.52c-10.148,1.887-16.857,11.647-14.98,21.804\n                              c0.927,4.997,3.765,9.159,7.618,11.876c3.971,2.795,9.025,4.057,14.175,3.099c4.623-0.858,9.282-1.867,13.854-3.008\n                              c10.021-2.494,16.126-12.646,13.626-22.662C299.761,427.318,289.618,421.218,279.591,423.714z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M417.887,173.047c1.31,3.948,3.811,7.171,6.97,9.398c4.684,3.299,10.813,4.409,16.662,2.475\n                              c9.806-3.256,15.119-13.83,11.875-23.631c-1.478-4.468-3.118-8.95-4.865-13.314c-3.836-9.59-14.714-14.259-24.309-10.423\n                              c-9.585,3.834-14.256,14.715-10.417,24.308C415.271,165.528,416.646,169.293,417.887,173.047z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M340.36,397.013c-3.299,2.178-6.704,4.286-10.134,6.261c-8.949,5.162-12.014,16.601-6.854,25.546\n                              c1.401,2.433,3.267,4.422,5.416,5.942c5.769,4.059,13.604,4.667,20.127,0.909c4.078-2.352,8.133-4.854,12.062-7.452\n                              c8.614-5.691,10.985-17.294,5.291-25.912C360.575,393.686,348.977,391.318,340.36,397.013z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M465.022,225.279c-0.407-10.322-9.101-18.356-19.426-17.953c-10.312,0.407-18.352,9.104-17.947,19.422\n                              c0.155,3.945,0.195,7.949,0.104,11.89c-0.145,6.473,3.021,12.243,7.941,15.711c2.931,2.064,6.488,3.313,10.345,3.401\n                              c10.322,0.229,18.876-7.958,19.105-18.285C465.247,234.756,465.208,229.985,465.022,225.279z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M414.835,347.816c-8.277-6.21-19.987-4.524-26.186,3.738c-2.374,3.164-4.874,6.289-7.434,9.298\n                              c-6.69,7.86-5.745,19.666,2.115,26.361c0.448,0.38,0.901,0.729,1.371,1.057c7.814,5.509,18.674,4.243,24.992-3.171\n                              c3.057-3.59,6.037-7.323,8.874-11.102C424.767,365.735,423.089,354.017,414.835,347.816z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M442.325,280.213c-9.855-3.09-20.35,2.396-23.438,12.251c-1.182,3.765-2.492,7.548-3.906,11.253\n                              c-3.105,8.156-0.13,17.13,6.69,21.939c1.251,0.879,2.629,1.624,4.126,2.19c9.649,3.682,20.454-1.159,24.132-10.812\n                              c1.679-4.405,3.237-8.906,4.646-13.382C457.66,293.795,452.178,283.303,442.325,280.213z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M197.999,426.402c-16.72-3.002-32.759-8.114-47.968-15.244c-0.18-0.094-0.341-0.201-0.53-0.287\n                              c-3.584-1.687-7.162-3.494-10.63-5.382c-0.012-0.014-0.034-0.023-0.053-0.031c-6.363-3.504-12.573-7.381-18.606-11.628\n                              C32.24,331.86,11.088,209.872,73.062,121.901c13.476-19.122,29.784-35.075,47.965-47.719c0.224-0.156,0.448-0.311,0.67-0.468\n                              c64.067-44.144,151.06-47.119,219.089-1.757l-14.611,21.111c-4.062,5.876-1.563,10.158,5.548,9.518l63.467-5.682\n                              c7.12-0.64,11.378-6.799,9.463-13.675L387.61,21.823c-1.908-6.884-6.793-7.708-10.859-1.833l-14.645,21.161\n                              C312.182,7.638,252.303-5.141,192.87,5.165c-5.986,1.036-11.888,2.304-17.709,3.78c-0.045,0.008-0.081,0.013-0.117,0.021\n                              c-0.225,0.055-0.453,0.128-0.672,0.189C123.122,22.316,78.407,52.207,46.5,94.855c-0.269,0.319-0.546,0.631-0.8,0.978\n                              c-1.061,1.429-2.114,2.891-3.145,4.353c-1.686,2.396-3.348,4.852-4.938,7.308c-0.199,0.296-0.351,0.597-0.525,0.896\n                              C10.762,149.191-1.938,196.361,0.24,244.383c0.005,0.158-0.004,0.317,0,0.479c0.211,4.691,0.583,9.447,1.088,14.129\n                              c0.027,0.302,0.094,0.588,0.145,0.89c0.522,4.708,1.177,9.427,1.998,14.145c8.344,48.138,31.052,91.455,65.079,125.16\n                              c0.079,0.079,0.161,0.165,0.241,0.247c0.028,0.031,0.059,0.047,0.086,0.076c9.142,9.017,19.086,17.357,29.793,24.898\n                              c28.02,19.744,59.221,32.795,92.729,38.808c10.167,1.827,19.879-4.941,21.703-15.103\n                              C214.925,437.943,208.163,428.223,197.999,426.402z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M221.124,83.198c-8.363,0-15.137,6.78-15.137,15.131v150.747l137.87,71.271c2.219,1.149,4.595,1.69,6.933,1.69\n                              c5.476,0,10.765-2.982,13.454-8.185c3.835-7.426,0.933-16.549-6.493-20.384l-121.507-62.818V98.329\n                              C236.243,89.978,229.477,83.198,221.124,83.198z"}})])])])])]),_vm._v(" "),_c('p',[_vm._v("Soon we will check your payment and send you "+_vm._s(_vm.asset.name)+". Estimated waiting time is 1 day.")]),_vm._v(" "),_c('p',[_vm._v("If not, contact technical support. You may need an order number, a check from the bank about the committed transaction and documents proving your identity.")])])]):_vm._e()])],1)],1)],1)]]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AbjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-asset-header"},[_c('b-row',[_c('div',{staticClass:"col-4 asset-info"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.asset.logoPath}}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h2',[_vm._v(_vm._s(_vm.asset.name))]),_vm._v(" "),_c('small',[_vm._v("("+_vm._s(_vm.asset.symbol)+")")])])]),_vm._v(" "),_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.isHintVisible && _vm.hint)?_c('b-col',{key:"hint"},[_c('e-hint',{attrs:{"title":_vm.hint.title || ''}},[_vm._v(_vm._s(_vm.hint.text || ''))]),_vm._v(" "),_c('e-button',{staticClass:"px-3 mt-2",attrs:{"color":"gray","type":"outlined","size":"smaller"},on:{"click":_vm.hideHint}},[_vm._v(_vm._s(_vm.hint.buttonText))])],1):_c('b-col',{key:"asset-data",attrs:{"cols":"7","offset":"1"}},[(_vm.meta)?_c('div',{staticClass:"asset-meta"},_vm._l((_vm.meta),function(item,k){return _c('div',{key:k,staticClass:"item"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.value))]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))])])}),0):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ak/v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_assest__ = __webpack_require__("2ZPF");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-moderation-view",
  props: {
    moderationId: {
      type: String
    }
  },
  data: function data() {
    return {
      eval$: 0,
      rate: null,
      moderation: null,
      criteria: null,
      showedCriteria: {},
      state$: 'view'
    };
  },

  watch: {
    moderationId: {
      handler: function handler(id) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (id) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt('return');

                case 2:

                  _this.rate = null;
                  _this.moderation = null;
                  _this.criteria = null;
                  _this.showedCriteria = {};

                  _context.next = 8;
                  return _this.fetchModerationItem(id);

                case 8:
                  _this.moderation = _this.getModeration(id);
                  console.log('mim', _this.moderation);

                  _this.eval = (_this.moderation.evaluate || 0) / 2;
                  _this.state = _this.eval > 0 ? 'complete' : 'view';

                  _context.next = 14;
                  return _this.fetchRate(_this.moderation.rate);

                case 14:
                  _this.rate = _this.getRate(_this.moderation.rate);
                  console.log('mi2m', _this.rate);

                  _context.next = 18;
                  return _this.fetchCriteria(_this.rate.criteria.map(function (c) {
                    return c.criterion;
                  }));

                case 18:
                  _this.criteria = _this.rate.criteria.map(function (c) {
                    return {
                      evaluate: c.evaluate,
                      justification: c.justification,
                      criterion: _this.getCriterion(c.criterion)
                    };
                  });

                case 19:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      },

      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('moderation', {
    fetchModerationItem: 'fetchModerationItem'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('rate', {
    fetchRate: 'fetchRate'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('assets', {
    fetchCriteria: 'fetchCriteria'
  }), {
    oneOf: function oneOf(value, data) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_assest__["a" /* oneOf */])(value, data);
    },
    onChangeTab: function onChangeTab(index) {
      if (!this.criteria || !this.criteria.length || !this.$refs.tabs || !this.$refs.tabs[index]) {
        return;
      }

      if (index !== undefined && index !== null) {
        // This is hack
        var silent = __WEBPACK_IMPORTED_MODULE_5_vue__["default"].silent;
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].silent = false;
        this.$refs.tabs[index].titleItemClass = 'is-showed';
        this.showedCriteria[index] = true;
        __WEBPACK_IMPORTED_MODULE_5_vue__["default"].silent = silent;

        if (this.allCriteriaShowed()) {
          this.state = this.eval > 0 ? 'complete' : 'ready';
        }
      }
    },
    allCriteriaShowed: function allCriteriaShowed() {
      if (!this.criteria || !this.criteria.length) {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.showedCriteria).length === this.criteria.length && _.every(this.showedCriteria, function (s) {
        return s === true;
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('rate', {
    getRate: 'rate',
    criterionEval: 'getCriterionEvaluation',
    criterionJustification: 'getCriterionJustification',
    averageEvaluation: 'getAverageEvaluation'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('moderation', {
    getModeration: 'moderation'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('assets', {
    getCriterion: 'criterion'
  }), {
    eval: {
      get: function get() {
        return this.eval$ || 0;
      },
      set: function set(val) {
        this.eval$ = val;
        this.$emit('changeEval', val);
        this.$store.commit('moderation/updateModerationEval', { id: this.moderationId, evaluate: val });
      }
    },
    state: {
      get: function get() {
        return this.state$;
      },
      set: function set(state) {
        this.state$ = state;
        this.$emit('changeState', state);
      }
    },
    classesForCriteria: function classesForCriteria() {
      var _this2 = this;

      return function (index) {
        var showed = _this2.showedCriteria[index] && _this2.showedCriteria[index] === true;
        // console.log(showed);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'is-showed', showed);
      };
    }
    // criteriaEval(id) {
    //   return () => {
    //     this.rate.criteria.
    //   }
    // }

  })
});

/***/ }),

/***/ "B0LN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_store__ = __webpack_require__("EBaU");






var state = {
  rates: {},
  currentCreateRate: {
    criteria: [],
    locked: 0
  },
  currentCreateRateCriteria: []
};

// getters
var getters = {
  rate: function rate(state) {
    return function (id) {
      return state.rates[id];
    };
  },
  getCurrentCreateRate: function getCurrentCreateRate(state) {
    return state.currentCreateRate;
  },
  getCurrentCreateRateCriteria: function getCurrentCreateRateCriteria(state) {
    return state.currentCreateRateCriteria;
  },
  getCriterionEvaluation: function getCriterionEvaluation(state) {
    return function (id) {
      return state.currentCreateRate.criteria[id].evaluation;
    };
  },
  getCriterionJustification: function getCriterionJustification(state) {
    return function (id) {
      return state.currentCreateRate.criteria[id].justification;
    };
  },
  getAverageEvaluation: function getAverageEvaluation(state, getters) {
    return state.currentCreateRateCriteria.reduce(function (p, c) {
      return p + getters.getCriterionEvaluation(c);
    }, 0) / getters.getCurrentCreateRateCriteria.length;
  },
  isSelectedCriterion: function isSelectedCriterion(state) {
    return function (id) {
      return state.currentCreateRateCriteria.includes(id);
    };
  }
};

// actions
var actions = {
  fetchRate: function fetchRate(_ref, id) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch,
        rootGetters = _ref.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.rates[id]) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].Rates.fetchRate(id, rootGetters['auth/token']);

            case 4:
              data = _context.sent;
              _context.next = 7;
              return dispatch('pushRate', data);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  pushRate: function pushRate(_ref2, rate) {
    var _this2 = this;

    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch,
        rootGetters = _ref2.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _splitIdsCollection, criteriaIds, criteriaObjects, assembledCriteria;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // console.log(rate);

              _splitIdsCollection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_store__["a" /* splitIdsCollection */])(rate.criteria.map(function (c) {
                return c.criterion;
              })), criteriaIds = _splitIdsCollection.ids, criteriaObjects = _splitIdsCollection.objects;
              _context2.next = 3;
              return dispatch('assets/pushCriteria', criteriaObjects, { root: true });

            case 3:

              // assemble true collection of criteria
              assembledCriteria = [];


              rate.criteria.forEach(function (c) {
                if (criteriaIds.includes(c.criterion)) {
                  assembledCriteria.push(c);
                } else if (criteriaObjects.includes(c.criterion)) {
                  assembledCriteria.push({
                    criterion: c.criterion.id,
                    popularity: c.popularity
                  });
                }
              });

              rate.criteria = assembledCriteria;

              commit('addRate', { id: rate.id, rate: rate });

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  addCriterion: function addCriterion(_ref3, title) {
    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;
  },
  toggleCriterion: function toggleCriterion(_ref4, id) {
    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;

    commit('toggleCriterion', id);
  },
  resetCriteria: function resetCriteria(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch;

    commit('resetCriteria');
  },
  changeEvaluation: function changeEvaluation(_ref6, _ref7) {
    var commit = _ref6.commit,
        state = _ref6.state,
        dispatch = _ref6.dispatch;
    var id = _ref7.id,
        evaluation = _ref7.evaluation;

    commit('changeEvaluation', { id: id, evaluation: evaluation });
  },
  changeJustification: function changeJustification(_ref8, _ref9) {
    var commit = _ref8.commit,
        state = _ref8.state,
        dispatch = _ref8.dispatch;
    var id = _ref9.id,
        justification = _ref9.justification;

    commit('changeJustification', { id: id, justification: justification });
  }
};

// mutations
var mutations = {
  toggleCriterion: function toggleCriterion(state, id) {
    if (state.currentCreateRateCriteria.includes(id)) {
      state.currentCreateRateCriteria.splice(state.currentCreateRateCriteria.indexOf(id), 1);
      state.currentCreateRate.criteria.splice(id, 1);
    } else {
      state.currentCreateRateCriteria.push(id);
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.currentCreateRate.criteria, id, {
        evaluation: 5,
        justification: ''
      });
    }
  },
  resetCriteria: function resetCriteria(state) {
    state.currentCreateRateCriteria = [];
    state.currentCreateRate = {
      criteria: [],
      locked: 0
    };
  },
  changeEvaluation: function changeEvaluation(state, _ref10) {
    var id = _ref10.id,
        evaluation = _ref10.evaluation;

    state.currentCreateRate.criteria[id].evaluation = evaluation;
  },
  changeJustification: function changeJustification(state, _ref11) {
    var id = _ref11.id,
        justification = _ref11.justification;

    state.currentCreateRate.criteria[id].justification = justification;
  },
  addRate: function addRate(state, _ref12) {
    var rate = _ref12.rate,
        id = _ref12.id;

    state.rates[id] = rate;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "BCG5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");



var _this = this;



/* harmony default export */ __webpack_exports__["default"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['auth/isAuth']) {
              _context.next = 10;
              break;
            }

            // return next({
            //   name: 'signin',
            //   query: {
            //     redirect: to.fullPath,
            //   },
            // });

            window.location.href =  true ? 'https://economix.ai/login' : 'https://economix.ai/login'; //'http://localhost:8082/login'
            return _context.abrupt('return');

          case 6:
            _context.next = 10;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](3);

          case 10:

            next();

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[3, 8]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),

/***/ "BFVg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "step-already-exists",
  props: ['prediction'],
  filters: {
    formatPrice: function formatPrice(price) {
      price = parseFloat(price);
      if (price <= 10) {
        return price.toFixed(6);
      } else if (price <= 50) {
        return price.toFixed(4);
      }

      return price.toFixed(2);
    }
  },
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])('forecast', {
    setLockedTokens: 'setLockedTokens',
    setAcceptedRules: 'setAcceptedRules'
  }), {
    close: function close() {
      this.$emit('closeModal');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('forecast', {
    lockedTokens: 'lockedTokens',
    acceptedRules: 'acceptedRules',
    forecastData: 'forecastModalData'
  }), {
    asset: function asset() {
      return this.forecastData !== null ? this.forecastData.asset : null;
    }
  })
});

/***/ }),

/***/ "BJ8h":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMEM0LjAwOTA5IDAgMCA0LjAwOTA5IDAgOUMwIDEzLjk5MDkgNC4wMDkwOSAxOCA5IDE4QzEzLjk5MDkgMTggMTggMTMuOTkwOSAxOCA5QzE4IDQuMDA5MDkgMTMuOTkwOSAwIDkgMFpNMTMuOTA5MSA5LjQwOTA5QzEzLjkwOTEgOS42NTQ1NSAxMy43NDU1IDkuODE4MTggMTMuNSA5LjgxODE4SDEwLjAyMjdDOS45IDkuODE4MTggOS44MTgxOCA5LjkgOS44MTgxOCAxMC4wMjI3VjEzLjVDOS44MTgxOCAxMy43NDU1IDkuNjU0NTUgMTMuOTA5MSA5LjQwOTA5IDEzLjkwOTFIOC41OTA5MUM4LjM0NTQ1IDEzLjkwOTEgOC4xODE4MiAxMy43NDU1IDguMTgxODIgMTMuNVYxMC4wMjI3QzguMTgxODIgOS45IDguMSA5LjgxODE4IDcuOTc3MjcgOS44MTgxOEg0LjVDNC4yNTQ1NSA5LjgxODE4IDQuMDkwOTEgOS42NTQ1NSA0LjA5MDkxIDkuNDA5MDlWOC41OTA5MUM0LjA5MDkxIDguMzQ1NDUgNC4yNTQ1NSA4LjE4MTgyIDQuNSA4LjE4MTgySDcuOTc3MjdDOC4xIDguMTgxODIgOC4xODE4MiA4LjEgOC4xODE4MiA3Ljk3NzI3VjQuNUM4LjE4MTgyIDQuMjU0NTUgOC4zNDU0NSA0LjA5MDkxIDguNTkwOTEgNC4wOTA5MUg5LjQwOTA5QzkuNjU0NTUgNC4wOTA5MSA5LjgxODE4IDQuMjU0NTUgOS44MTgxOCA0LjVWNy45NzcyN0M5LjgxODE4IDguMSA5LjkgOC4xODE4MiAxMC4wMjI3IDguMTgxODJIMTMuNUMxMy43NDU1IDguMTgxODIgMTMuOTA5MSA4LjM0NTQ1IDEzLjkwOTEgOC41OTA5MVY5LjQwOTA5WiIgZmlsbD0iI0U0RUNGMyIvPgo8L3N2Zz4K"

/***/ }),

/***/ "Bk8q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BoPI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");



var _this = this;


// import { loadMessages } from '~/plugins/i18n'

/* harmony default export */ __webpack_exports__["default"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // await loadMessages(store.getters['lang/locale'])

            next();

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),

/***/ "C5Io":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__ = __webpack_require__("wphm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e427af1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__("uB6o");
function injectStyle (ssrContext) {
  __webpack_require__("2uPa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e427af1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e427af1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CEt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{ref:"mySwiper",staticClass:"e-assets-slider__wrapper",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.myAssets),function(asset){return (!_vm.$wait.is('assets.fetchAssets'))?_c('transition-group',{key:asset.id,staticClass:"e-assets-slider__item",attrs:{"name":"fade","tag":"swiper-slide"}},[_c('e-asset-card',{key:asset,staticClass:"e-assets-slider__container",attrs:{"asset":_vm.getAsset(asset)}})],1):_vm._e()}),_vm._v(" "),_vm._l((3),function(key){return (_vm.$wait.is('assets.fetchAssets'))?_c('transition-group',{key:("assets-mock-" + key),staticClass:"e-assets-slider__item",attrs:{"name":"fade","tag":"swiper-slide"}},[_c('div',{key:("assets-mock-" + key),staticClass:"e-asset-card"},[_c('div',{staticClass:"e-asset-card__header"},[_c('div',{staticClass:"e-asset-card__header--left"},[_c('div',{staticClass:"e-asset-card__text eh-primary-text"},[_c('span',{staticClass:"e-mock e-mock__text float-right"})])]),_vm._v(" "),_c('div',{staticClass:"e-asset-card__header--right"},[_c('div',{staticClass:"e-asset-card__text eh-secondary-text"},[_c('span',{staticClass:"e-mock e-mock__text"})])])]),_vm._v(" "),_c('div',{staticClass:"e-asset-card__content"},[_c('div',{staticClass:"e-asset-card__logo e-avatar e-mock"}),_vm._v(" "),_c('p',{staticClass:"e-asset-card__forecast e-mock e-mock__text e-mock--size--small"})]),_vm._v(" "),_c('ul',{staticClass:"e-asset-card__list ee-list eh-secondary-text d-none d-xl-flex"},[_c('li',[_c('span',{staticClass:"e-mock e-mock__text e-mock--size--small"})]),_vm._v(" "),_c('li',[_c('span',{staticClass:"e-mock e-mock__text e-mock--size--small"})]),_vm._v(" "),_c('li',[_c('span',{staticClass:"e-mock e-mock__text e-mock--size--small"})]),_vm._v(" "),_c('li',[_c('span',{staticClass:"e-mock e-mock__text e-mock--size--small"})]),_vm._v(" "),_c('li',[_c('span',{staticClass:"e-mock e-mock__text e-mock--size--small"})])])])]):_vm._e()}),_vm._v(" "),(_vm.myAssets.length <= 3)?_c('swiper-slide',{staticClass:"e-assets-slider__item"},[_c('div',{staticClass:"e-asset-card"},[_c('div',{staticClass:"e-asset-card__preview"},[_c('p',[_vm._v("Add new Asset in your Watchlist")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"e-assets-slider__button e-assets-slider__button--prev swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"e-assets-slider__button e-assets-slider__button--next swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CGR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");




var state = {
  orders: [],
  currentOrder: {},
  paymentInfo: {},
  isShowBuyModal: false,
  buyModalData: null
};

// getters
var getters = {
  orders: function orders(state, getters, root) {
    return state.orders;
  },
  currentOrder: function currentOrder(state, getters, root) {
    return state.currentOrder;
  },
  paymentInfo: function paymentInfo(state, getters, root) {
    return state.paymentInfo;
  },
  isShowBuyModal: function isShowBuyModal(state) {
    return state.isShowBuyModal;
  },
  buyModalData: function buyModalData(state) {
    return state.buyModalData;
  }
};

// actions
var actions = {
  fetchOrders: function fetchOrders(_ref) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data, orders;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].Orders.fetchOrders();

            case 2:
              data = _context.sent;
              orders = data.default.map(function (e) {
                e.small = true;return e;
              });

              commit('updateOrders', orders);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  createOrder: function createOrder(_ref2, order) {
    var _this2 = this;

    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].Orders.createOrder(order);

            case 2:
              data = _context2.sent;

              commit('buyOrder', data);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getPaymentInfo: function getPaymentInfo(_ref3) {
    var _this3 = this;

    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log("getPaymentInfo");
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].Orders.paymentInfo(state.currentOrder.orderId);

            case 3:
              data = _context3.sent;

              // let pinfo = data
              commit('setPaymentInfo', data);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
};

// mutations
var mutations = {
  updateOrders: function updateOrders(state, data) {
    state.orders = [].concat(data);
  },
  buyOrder: function buyOrder(state, data) {
    state.currentOrder = data;
  },
  setPaymentInfo: function setPaymentInfo(state, data) {
    state.paymentInfo = data;
  },
  setShowBuyModal: function setShowBuyModal(state, status) {
    state.isShowBuyModal = status;
  },
  setBuyModalData: function setBuyModalData(state, data) {
    state.buyModalData = data;
  },
  setWalletId: function setWalletId(state, walletId) {
    state.buyModalData.walletId = walletId;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "CZdj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjMzOTUgMTAuNDEyMUg5LjgzNDlWMTEuMDU3OEM5LjgzNDkgMTEuNDE0NSA5LjU3MjExIDExLjcwMzYgOS4yNDc3NyAxMS43MDM2SDYuNzUyNEM2LjQyODA1IDExLjcwMzYgNi4xNjUyNCAxMS40MTQzIDYuMTY1MjQgMTEuMDU3OFYxMC40MTIxSDAuNjYwNjQ1VjE3Ljk5OTZIMTUuMzM5NlYxMC40MTIxSDE1LjMzOTVaIiBmaWxsPSIjRTRFQ0YzIi8+CjxwYXRoIGQ9Ik0wIDQuMTE2NThWOS4xMjExMkg2LjE2NTExVjguNDc1MzZDNi4xNjUxMSA4LjExODY1IDYuNDI3OTQgNy44Mjk2MiA2Ljc1MjI2IDcuODI5NjJIOS4yNDc3NEM5LjU3MjA5IDcuODI5NjIgOS44MzQ4NyA4LjExODY1IDkuODM0ODcgOC40NzUzNlY5LjEyMTEySDE2VjQuMTE2NThDMTYgMy43NTk4OCAxNS43MzcyIDMuNDcwODUgMTUuNDEyOCAzLjQ3MDg1SDExLjI3M0MxMS40MjQyIDMuMzM3ODEgMTEuNTIzIDMuMTM1MzcgMTEuNTIzIDIuOTA1ODJDMTEuNTIzIDEuMjc2MzEgOS45NzU1NyAwIDguMDAwMDggMEM2LjAyNDU5IDAgNC40NzcxNiAxLjI3NjMxIDQuNDc3MTYgMi45MDU3OUM0LjQ3NzE2IDMuMTM1MzcgNC41NzYwMSAzLjMzNzc4IDQuNzI3MjQgMy40NzA4MkgwLjU4NzE1M0MwLjI2Mjk0MyAzLjQ3MDg1IDAgMy43NjAwMyAwIDQuMTE2NThaTTUuNzk4MTggMi45MDU3OUM1Ljc5ODE4IDIuMTMxODEgNi44MjcyIDEuNDUyODEgOC4wMDAwOCAxLjQ1MjgxQzkuMTcyOTYgMS40NTI4MSAxMC4yMDIgMi4xMzE4MSAxMC4yMDIgMi45MDU3OUMxMC4yMDIgMy4xMzUzNyAxMC4zMDA4IDMuMzM3NzggMTAuNDUyMSAzLjQ3MDgySDUuNTQ4MTNDNS42OTk0NyAzLjMzNzgxIDUuNzk4MTggMy4xMzU1MiA1Ljc5ODE4IDIuOTA1NzlaIiBmaWxsPSIjRTRFQ0YzIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cookies_js__ = __webpack_require__("wFBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cookies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_cookies_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_store__ = __webpack_require__("EBaU");







var clientId = 'Z3JlZWRpc2dvb2QK';
var clientSecret = 'VerySecretKey1';

var state = {
  user: {
    name: null,
    surname: null,
    balance: 0,
    myAssets: [],
    notificationCount: 0,
    firstUse: false
  },
  token: null,
  refreshToken: null,
  expiresIn: null,
  refreshTimer: null
};

// getters
var getters = {
  isAuth: function isAuth(state, getters, root) {
    return state.token !== null;
  },
  check: function check(state, getters) {
    return true;
  },
  token: function token(state, getters) {
    return state.token;
  },
  fullname: function fullname(state) {
    return state.user.name + ' ' + state.user.surname;
  },
  myAssets: function myAssets(state, getters, rState, rGetters) {
    // return rGetters['assets/getByIds'](state.user.myAssetsIds);
    return state.user.myAssets;
  },
  balance: function balance(state) {
    return state.user.balance;
  },
  isFirstUse: function isFirstUse(s) {
    return s.user.firstUse;
  }
};

// actions
var actions = {
  login: function login(_ref, _ref2) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;
    var login = _ref2.login,
        password = _ref2.password,
        remember = _ref2.remember;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch('wait/start', 'auth.login', { root: true });

              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__services__["a" /* default */].Auth.login({ login: login, password: password, clientId: clientId, clientSecret: clientSecret });

            case 4:
              data = _context.sent;


              commit('setToken', data.accessToken);
              commit('setRefreshToken', data.refreshToken);
              commit('setExpiresToken', data.accessToken.expires_in);

              if (remember) {
                __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.set('accessToken', data.accessToken);
                __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.set('refreshToken', data.refreshToken);
                __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.set('expiresToken', data.accessToken.expires_in);
              }
              _context.next = 13;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](1);

            case 13:

              dispatch('wait/end', 'auth.login', { root: true });

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 11]]);
    }))();
  },
  logout: function logout(_ref3) {
    var _this2 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit('setToken', null);
              commit('setRefreshToken', null);
              commit('setExpiresToken', null);

              __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.expire('accessToken');
              __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.expire('refreshToken');
              __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.expire('expiresToken');

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  updateAuthSession: function updateAuthSession(_ref4) {
    var _this3 = this;

    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        state = _ref4.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__services__["a" /* default */].Auth.refreshToken({ refreshToken: state.refreshToken, clientId: clientId, clientSecret: clientSecret });

            case 2:
              data = _context3.sent;


              commit('setToken', data.accessToken);
              commit('setRefreshToken', data.refreshToken);
              commit('setExpiresToken', data.expires_in);

              __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.set('accessToken', data.accessToken);
              __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.set('refreshToken', data.refreshToken);
              __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.set('expiresToken', data.expires_in);

            case 9:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  updateRefreshTimer: function updateRefreshTimer(_ref5) {
    var _this4 = this;

    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var time, timerFn;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              time = state.expiresIn - Date.now() / 1000;

              console.log(state.expiresIn * 1000);
              console.log(Date.now());
              console.log(state.expiresIn * 1000 - Date.now());
              console.log(time);
              console.log(time / 1000 + ' ms');
              console.log(time / 1000 / 60 + ' s');
              console.log(time / 1000 / 60 / 60 + ' min');

              timerFn = function () {
                var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return dispatch('updateAuthSession');

                        case 2:
                          dispatch('updateRefreshTimer');

                        case 3:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this4);
                }));

                return function timerFn() {
                  return _ref6.apply(this, arguments);
                };
              }();

              // commit('setRefreshTimer', setTimeout(timerFn, time - 2000));


            case 9:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this4);
    }))();
  },
  updateUserData: function updateUserData(_ref7) {
    var _this5 = this;

    var commit = _ref7.commit,
        state = _ref7.state,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var data, _splitIdsCollection, assetsIds, assetsObjects;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch('wait/start', 'auth.fetchUserData', { root: true });
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__services__["a" /* default */].Auth.fetchUserData(state.token);

            case 3:
              data = _context6.sent;
              _splitIdsCollection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_store__["a" /* splitIdsCollection */])(data.myAssets), assetsIds = _splitIdsCollection.ids, assetsObjects = _splitIdsCollection.objects;

              if (!(assetsObjects.length > 0)) {
                _context6.next = 8;
                break;
              }

              _context6.next = 8;
              return dispatch('assets/pushAssets', assetsObjects, { root: true });

            case 8:
              if (!(assetsIds.length > 0)) {
                _context6.next = 11;
                break;
              }

              _context6.next = 11;
              return dispatch('assets/fetchAssets', assetsIds, { root: true });

            case 11:

              delete data.myAssets;

              commit('updateUserData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
                myAssets: assetsIds.concat(assetsObjects.map(function (a) {
                  return a.id;
                }))
              }));

              dispatch('wait/end', 'auth.fetchUserData', { root: true });

            case 14:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this5);
    }))();
  },
  changeFirstUse: function changeFirstUse(_ref8, value) {
    var _this6 = this;

    var commit = _ref8.commit,
        state = _ref8.state,
        dispatch = _ref8.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__services__["a" /* default */].Auth.changeUserData({ firstUse: value });

              commit('updateUserData', {
                firstUse: value
              });

            case 2:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this6);
    }))();
  }
};

// mutations
var mutations = {
  setToken: function setToken(state, token) {
    state.token = token;
  },
  setRefreshToken: function setRefreshToken(state, token) {
    state.refreshToken = token;
  },
  setExpiresToken: function setExpiresToken(state, expiresIn) {
    state.expiresIn = parseInt(expiresIn);
  },
  setRefreshTimer: function setRefreshTimer(state, timer) {
    if (state.refreshTimer) {
      clearTimeout(state.refreshTimer);
    }

    state.refreshTimer = timer;
  },
  updateUserData: function updateUserData(state, mergeData) {
    state.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.user, mergeData);
  },
  decrementNotificationCount: function decrementNotificationCount(state) {
    state.user.notificationCount--;
  },
  followAssets: function followAssets(state, _ref9) {
    var id = _ref9.id,
        status = _ref9.status;

    if (status === true) {
      state.user.myAssets.push(id);
    } else {
      if (state.user.myAssets.indexOf(id) !== null) {
        state.user.myAssets.splice(state.user.myAssets.indexOf(id), 1);
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "D8Ss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading)?_c('div',{staticClass:"modal-content-container"},[(_vm.availableModeration)?_c('e-steps',{attrs:{"current":_vm.currentStep},on:{"changeStep":_vm.onChangeStep}},[_c('e-step',{attrs:{"label":"Lock Tokens & Accept the rules"}},[_c('e-lock-tokens',{model:{value:(_vm.lockedModel),callback:function ($$v) {_vm.lockedModel=$$v},expression:"lockedModel"}})],1),_vm._v(" "),_vm._l((_vm.numberOfModeration),function(moderationNumber){return _c('e-step',{key:moderationNumber,attrs:{"label":("Moderation # " + moderationNumber)}},[(_vm.moderationGroup)?_c('e-moderation-view',{ref:"moderation",refInFor:true,attrs:{"moderationId":_vm.moderationGroup.moderation[moderationNumber - 1]},on:{"changeState":_vm.onChangeState,"changeEval":_vm.onChangeEval}}):_vm._e()],1)})],2):_c('div',[_c('div',{staticClass:"not-available-message",staticStyle:{"position":"relative","margin":"0","padding-top":"0"}},[_c('h3',[_vm._v("No rates available now.")]),_vm._v(" "),_c('div',{staticClass:"img-container",staticStyle:{"margin":"20px auto"}},[_c('svg',{staticStyle:{"fill":"#0672f3"},attrs:{"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 465.2 465.2","xml:space":"preserve"}},[_c('g',[_c('g',{attrs:{"id":"Layer_2_16_"}},[_c('g',[_c('path',{attrs:{"d":"M279.591,423.714c-3.836,0.956-7.747,1.805-11.629,2.52c-10.148,1.887-16.857,11.647-14.98,21.804\n                    c0.927,4.997,3.765,9.159,7.618,11.876c3.971,2.795,9.025,4.057,14.175,3.099c4.623-0.858,9.282-1.867,13.854-3.008\n                    c10.021-2.494,16.126-12.646,13.626-22.662C299.761,427.318,289.618,421.218,279.591,423.714z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M417.887,173.047c1.31,3.948,3.811,7.171,6.97,9.398c4.684,3.299,10.813,4.409,16.662,2.475\n                    c9.806-3.256,15.119-13.83,11.875-23.631c-1.478-4.468-3.118-8.95-4.865-13.314c-3.836-9.59-14.714-14.259-24.309-10.423\n                    c-9.585,3.834-14.256,14.715-10.417,24.308C415.271,165.528,416.646,169.293,417.887,173.047z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M340.36,397.013c-3.299,2.178-6.704,4.286-10.134,6.261c-8.949,5.162-12.014,16.601-6.854,25.546\n                    c1.401,2.433,3.267,4.422,5.416,5.942c5.769,4.059,13.604,4.667,20.127,0.909c4.078-2.352,8.133-4.854,12.062-7.452\n                    c8.614-5.691,10.985-17.294,5.291-25.912C360.575,393.686,348.977,391.318,340.36,397.013z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M465.022,225.279c-0.407-10.322-9.101-18.356-19.426-17.953c-10.312,0.407-18.352,9.104-17.947,19.422\n                    c0.155,3.945,0.195,7.949,0.104,11.89c-0.145,6.473,3.021,12.243,7.941,15.711c2.931,2.064,6.488,3.313,10.345,3.401\n                    c10.322,0.229,18.876-7.958,19.105-18.285C465.247,234.756,465.208,229.985,465.022,225.279z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M414.835,347.816c-8.277-6.21-19.987-4.524-26.186,3.738c-2.374,3.164-4.874,6.289-7.434,9.298\n                    c-6.69,7.86-5.745,19.666,2.115,26.361c0.448,0.38,0.901,0.729,1.371,1.057c7.814,5.509,18.674,4.243,24.992-3.171\n                    c3.057-3.59,6.037-7.323,8.874-11.102C424.767,365.735,423.089,354.017,414.835,347.816z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M442.325,280.213c-9.855-3.09-20.35,2.396-23.438,12.251c-1.182,3.765-2.492,7.548-3.906,11.253\n                    c-3.105,8.156-0.13,17.13,6.69,21.939c1.251,0.879,2.629,1.624,4.126,2.19c9.649,3.682,20.454-1.159,24.132-10.812\n                    c1.679-4.405,3.237-8.906,4.646-13.382C457.66,293.795,452.178,283.303,442.325,280.213z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M197.999,426.402c-16.72-3.002-32.759-8.114-47.968-15.244c-0.18-0.094-0.341-0.201-0.53-0.287\n                    c-3.584-1.687-7.162-3.494-10.63-5.382c-0.012-0.014-0.034-0.023-0.053-0.031c-6.363-3.504-12.573-7.381-18.606-11.628\n                    C32.24,331.86,11.088,209.872,73.062,121.901c13.476-19.122,29.784-35.075,47.965-47.719c0.224-0.156,0.448-0.311,0.67-0.468\n                    c64.067-44.144,151.06-47.119,219.089-1.757l-14.611,21.111c-4.062,5.876-1.563,10.158,5.548,9.518l63.467-5.682\n                    c7.12-0.64,11.378-6.799,9.463-13.675L387.61,21.823c-1.908-6.884-6.793-7.708-10.859-1.833l-14.645,21.161\n                    C312.182,7.638,252.303-5.141,192.87,5.165c-5.986,1.036-11.888,2.304-17.709,3.78c-0.045,0.008-0.081,0.013-0.117,0.021\n                    c-0.225,0.055-0.453,0.128-0.672,0.189C123.122,22.316,78.407,52.207,46.5,94.855c-0.269,0.319-0.546,0.631-0.8,0.978\n                    c-1.061,1.429-2.114,2.891-3.145,4.353c-1.686,2.396-3.348,4.852-4.938,7.308c-0.199,0.296-0.351,0.597-0.525,0.896\n                    C10.762,149.191-1.938,196.361,0.24,244.383c0.005,0.158-0.004,0.317,0,0.479c0.211,4.691,0.583,9.447,1.088,14.129\n                    c0.027,0.302,0.094,0.588,0.145,0.89c0.522,4.708,1.177,9.427,1.998,14.145c8.344,48.138,31.052,91.455,65.079,125.16\n                    c0.079,0.079,0.161,0.165,0.241,0.247c0.028,0.031,0.059,0.047,0.086,0.076c9.142,9.017,19.086,17.357,29.793,24.898\n                    c28.02,19.744,59.221,32.795,92.729,38.808c10.167,1.827,19.879-4.941,21.703-15.103\n                    C214.925,437.943,208.163,428.223,197.999,426.402z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M221.124,83.198c-8.363,0-15.137,6.78-15.137,15.131v150.747l137.87,71.271c2.219,1.149,4.595,1.69,6.933,1.69\n                    c5.476,0,10.765-2.982,13.454-8.185c3.835-7.426,0.933-16.549-6.493-20.384l-121.507-62.818V98.329\n                    C236.243,89.978,229.477,83.198,221.124,83.198z"}})])])])])]),_vm._v(" "),_c('p',[_vm._v("There are currently no rates available, try again later.")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.isFinished)?_c('div',{staticClass:"success-message"},[_c('div',{staticClass:"img-container"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 512 512"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 512 512","xml:space":"preserve"}},[_c('path',{staticStyle:{"fill":"#0672f3"},attrs:{"d":"M496.396,61.776c20.807,20.807,20.807,54.664,0,75.471L248.82,384.822\n              c-6.895,6.895-15.951,10.342-25.007,10.342c-9.056,0-18.112-3.447-25.007-10.342l-120.34-120.34\n              c-20.807-20.807-20.807-54.664,0-75.471s54.664-20.807,75.471,0l69.876,69.862L420.925,61.776\n              c10.41-10.397,24.063-15.609,37.742-15.609C472.319,46.167,485.999,51.379,496.396,61.776z M477.052,117.904\n              c10.137-10.15,10.137-26.648,0-36.785c-10.137-10.137-26.648-10.137-36.785,0L241.16,280.227\n              c-4.637,4.637-10.793,7.182-17.346,7.182c-6.553,0-12.708-2.544-17.332-7.182l-71.887-71.873\n              c-5.075-5.075-11.724-7.606-18.386-7.606c-6.662,0-13.324,2.531-18.399,7.606c-10.137,10.137-10.137,26.634,0,36.785l120.34,120.34\n              c3.119,3.119,8.208,3.119,11.327,0L477.052,117.904z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#D2E3FB"},attrs:{"d":"M477.052,81.119c10.137,10.137,10.137,26.634,0,36.785L229.477,365.479\n              c-3.119,3.119-8.208,3.119-11.327,0L97.81,245.139c-10.137-10.15-10.137-26.648,0-36.785c5.075-5.075,11.737-7.606,18.399-7.606\n              c6.662,0,13.31,2.531,18.386,7.606l71.887,71.873c4.624,4.637,10.78,7.182,17.332,7.182s12.708-2.544,17.346-7.182L440.268,81.119\n              C450.404,70.982,466.916,70.982,477.052,81.119z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#0672f3"},attrs:{"d":"M449.72,239.845c0.383,5.308,0.575,10.739,0.575,16.156c0,124.143-100.997,225.141-225.141,225.141\n              S0,380.144,0,256S101.011,30.86,225.154,30.86c49.165,0,95.867,15.568,135.046,45.006c6.046,4.542,7.264,13.119,2.722,19.152\n              c-4.542,6.046-13.119,7.264-19.152,2.722c-34.418-25.855-75.43-39.521-118.617-39.521C116.086,58.219,27.359,146.946,27.359,256\n              s88.727,197.781,197.795,197.781c109.055,0,197.781-88.727,197.781-197.781c0-4.761-0.178-9.535-0.506-14.186\n              c-0.547-7.538,5.13-14.09,12.654-14.637C442.634,226.644,449.173,232.307,449.72,239.845z"}})])]),_vm._v(" "),_c('h3',[_vm._v("Your moderation has been saved.")]),_vm._v(" "),_c('p',[_vm._v("Soon your moderation will be taken into account in the overall assessment of \""+_vm._s(_vm.asset.name)+"\"\" asset.")])]):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(!_vm.isFinished)?_c('e-button',{attrs:{"type":"outlined"},on:{"click":function () { return this$1.$emit('closeModal'); }}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.availableModeration || _vm.isFinished)?_c('div',{staticClass:"d-flex ml-auto"},[(!_vm.isFinished && _vm.currentStep !== 1)?_c('e-button',{staticStyle:{"margin-right":"30px"},on:{"click":_vm.onPreviewClick}},[_vm._v("Preview")]):_vm._e(),_vm._v(" "),(!_vm.isFinished)?_c('e-button',{attrs:{"disabled":_vm.nextButtonDisabled},on:{"click":_vm.onNextClick}},[_vm._v(_vm._s(_vm.nextButtonText))]):_vm._e(),_vm._v(" "),(_vm.isFinished)?_c('e-button',{on:{"click":function () { return this$1.$emit('closeModal'); }}},[_vm._v("Ok")]):_vm._e()],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DcsS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("w/TU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_click_outside__ = __webpack_require__("dDoS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-draggable",
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_2_vue_click_outside___default.a
  },
  components: { draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a },
  props: {
    target: {
      type: Array,
      required: true
    }
  },
  computed: {
    components: {
      get: function get() {
        // const minRows = Math.ceil(this.components.reduce((p, c) => p + c.sizes.large.min, 0) / 12);
        var rows = [];

        var temp = 0;
        var tempI = 0;

        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(this.rootTarget, 'position').forEach(function (c) {
          if (temp + c.sizes.large.min <= 12) {
            if (!rows[tempI]) {
              rows[tempI] = [];
            }
          } else {
            tempI++;
            temp = 0;
            if (!rows[tempI]) {
              rows[tempI] = [];
            }
          }
          temp += c.sizes.large.min;
          rows[tempI].push({
            id: c.id,
            component: c.component,
            position: c.position,
            size: c.sizes.large.min,
            diff: c.sizes.large.max - c.sizes.large.min,
            sizes: c.sizes
          });
        });

        rows.forEach(function (row) {
          var diff = 12 - row.reduce(function (p, c) {
            return p + c.size;
          }, 0);

          if (diff !== 0) {
            (function () {
              var sorted = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(row, 'diff');
              // let flag = true;

              while (diff !== 0 && sorted.some(function (e) {
                return e.diff > 0;
              })) {
                sorted.forEach(function (c, i) {
                  if (c.diff !== 0) {
                    sorted[i].size++;
                    sorted[i].diff--;
                    diff--;
                  }
                });
              }
            })();
          }
        });

        // this.rowsState = rows;
        // console.log(_.flatten(rows));
        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flatten(rows);
      },
      set: function set(v) {
        var newPositions = v.map(function (c, i) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, c, {
            position: i + 1
          });
        });

        this.$emit('change', newPositions);
        // this.rootTarget = newPositions;
      }
    },
    options: function options() {
      return {
        group: 'sample',
        animation: 150,
        forceFallback: true,
        // draggable: '.e-draggable__target',
        // draggable: '.e-draggable__item',
        // handle: 'e-draggable__item',
        disabled: !this.canDrag
        // disabled: false,
      };
    }
  },
  methods: {
    move: function move(evt) {
      return evt.draggedContext.element.id === this.dragId;
    },
    hide: function hide() {
      this.canDrag = false;
    },
    toggleDrag: function toggleDrag(id) {
      // console.log(this.$refs.dragItems[i]);
      // this.$refs.dragItems[i]
      this.dragId = id;
      this.canDrag = !this.canDrag;
    }
  },
  watch: {
    'target': {
      handler: function handler(current, old) {
        this.rootTarget = current;
      }
    }
  },
  data: function data() {
    return {
      canDrag: false,
      rootTarget: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.target, true),
      dragId: null
      // components: _.clone(this.target, true),
      // rowsState: [],
    };
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "DhXM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E+vL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiNFNEVDRjMiIGQ9Ik0xNS42NTIgOC42NGMtLjE2OC0uMDUxLS4zNjctLjE5LS41NzYtLjQwMi0uMTc0LS4xNzYtLjM0LS40LS41MS0uNjgzLS45MzgtMS41NjktMS45MzktMi4zMjEtMi45NzctMi4yMzItLjI0LjAyLS40NjMuMDg3LS42NzQuMTgzQTEzLjE4IDEzLjE4IDAgMCAwIDEwLjY2MyA1QzkuNTM4IDIuODc2IDguMzI4IDEuODU0IDcuMDY3IDEuOTY3Yy0yLjMzMi4yMDgtMy43MTggNC4yMTYtMy44OSA0Ljc0LS42MTQgMS41ODUtMS42MjUgMi4wNTItMi4yIDIuMTlWLjQ5NkEuNDkzLjQ5MyAwIDAgMCAuNDkgMCAuNDkzLjQ5MyAwIDAgMCAwIC40OTZ2MTUuMDA4YzAgLjI3NC4yMTkuNDk2LjQ4OS40OTZoMTQuNzg2Yy4yNyAwIC40ODktLjIyMi40ODktLjQ5NmEuNDkyLjQ5MiAwIDAgMC0uNDktLjQ5NkgzLjE0YzIuMDE0LTEuMjczIDUuMzcyLTMuNzI0IDYuNTc1LTYuNTU3LjExNC0uMjkuNDA3LS44NzcuODAyLTEuMzY0LjAzNi4wOTQuMDcxLjE4Ny4xMDYuMjg0LjM0OC45OS45OTUgMi44MDMgMS40MTEgMy44MS4yODUuNjkuNzQ4IDEuMjQ1IDEuMzQgMS42MDUuNDE1LjI1Mi44MzUuMzggMS4yNC4zOC4yNDUgMCAuNDg1LS4wNDcuNzE2LS4xMzlhLjQ5OS40OTkgMCAwIDAgLjI3NS0uNjQzLjQ4Ni40ODYgMCAwIDAtLjYzMy0uMjhjLS4zMjguMTMtLjY5Ni4wNzQtMS4wOTUtLjE2OWEyLjM5MyAyLjM5MyAwIDAgMS0uOTQyLTEuMTM3Yy0uNDA3LS45ODYtMS4wNDctMi43OC0xLjM5Mi0zLjc2YTE3LjEgMTcuMSAwIDAgMC0uMjM0LS42MjVjLjExNy0uMDU0LjIzOC0uMDkuMzYyLS4xMDEuNzk0LS4wNyAxLjU1OC45MTkgMi4wNiAxLjc1OC4yMTEuMzUyLjQyNS42MzcuNjU1Ljg3LjMyNy4zMzIuNjU5LjU1Ljk4Ni42NWEuNDg3LjQ4NyAwIDAgMCAuNjA4LS4zMzIuNDk3LjQ5NyAwIDAgMC0uMzI3LS42MTh6bS02Ljg0LS41N2MtMS40ODEgMy40ODctNi44NzcgNi41MzQtNy42MTUgNi45MzhoLS4yMnYtNS4xYy43NjItLjEyOSAyLjI3Mi0uNjYyIDMuMTE1LTIuODVhLjcxNy43MTcgMCAwIDAgLjAxLS4wMjZjLjM1NC0xLjA5IDEuNTk0LTMuOTQ4IDMuMDUtNC4wNzYgMS4wNDMtLjA5MyAyLjAxNSAxLjMxNiAyLjY1IDIuNTE0LjEwMy4xOTYuMjAxLjQuMjk3LjYwOS0uNzc5Ljc1Ni0xLjIyMiAxLjgyNC0xLjI4OCAxLjk5MXoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "E2OI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E9JO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_card_card__ = __webpack_require__("tqXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_myAssets_myAssets__ = __webpack_require__("p4KC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_dynamicSize__ = __webpack_require__("KOBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_assets__ = __webpack_require__("SjBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services__ = __webpack_require__("+vOg");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var COLORS = {
  crypto: 'green',
  ico: 'lime-green',
  stock: 'blue',
  ipo: 'cyan',
  startup: 'violet'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ec-assets-list",
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_dynamicSize__["a" /* default */]],
  components: { ECard: __WEBPACK_IMPORTED_MODULE_4__elements_card_card__["a" /* default */] },
  filters: {
    shortText: function shortText(value) {
      if (value.length > 25) {
        value = value.substring(0, 22) + '...';
      }

      return value;
    }
  },
  data: function data() {
    return {
      currentAssetId: null,
      assets: [],
      assetsStock: [],
      isLoaded: false,
      assetsListTableFields: ['project', 'sector', 'rates', 'rate', 'actions']
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('assets', {
    fetchAssetsByFilter: 'fetchAssetsByFilter',
    fetchCriteria: 'fetchCriteria',
    fetchSectors: 'fetchSectors'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('ui', {
    'addToDashboard': 'addToDashboard'
  }), {
    rowClicked: function rowClicked(item, i, e) {
      this.$router.push({ name: 'asset', params: { id: item.id } });
    },
    convertRate: function convertRate(rate) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_assets__["a" /* convertRateToEmixtier */])(rate);
    },
    onSeeAllClick: function onSeeAllClick(type) {
      this.$router.push('/assets/list?type=' + type);
    },
    onRateClick: function onRateClick(asset, e) {
      e.stopPropagation();
      this.$router.push({ name: 'create-rate', params: { alias: asset.id } });
    },
    onModerateClick: function onModerateClick(asset, e) {
      e.stopPropagation();
      this.$router.push({ name: 'create-moderate', params: { alias: asset.id } });
    },
    loadAssets: function loadAssets(type) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var filter, paginator, sectorsToFetch, criteriaToFetch, assets;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filter = {
                  populate: ['criteria', 'sectors'],
                  limit: 5,
                  type: type
                };
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__services__["a" /* default */].Assets.fetchAssetsByFilter(filter);

              case 3:
                paginator = _context.sent;
                sectorsToFetch = [];
                criteriaToFetch = [];
                assets = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.toArray(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.mapValues(paginator.items, function (asset) {
                  sectorsToFetch = sectorsToFetch.concat(asset.sectors);
                  criteriaToFetch = criteriaToFetch.concat(asset.criteria.map(function (c) {
                    return c.criterion;
                  }));
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                    _rowVariant: 'row table-row--border-left'
                  }, asset);
                }));
                _context.next = 9;
                return _this.fetchCriteria(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.uniq(criteriaToFetch));

              case 9:
                _context.next = 11;
                return _this.fetchSectors(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.uniq(sectorsToFetch));

              case 11:
                return _context.abrupt('return', assets);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])("settings", ["menuIsOpen"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('assets', {
    getAssetsByFilter: 'assetsByFilter',
    getCriterion: 'criterion',
    getCriteria: 'criteria',
    getSector: 'sector'
  }), {
    flattenSector: function flattenSector() {
      var _this2 = this;

      return function (sectors, item) {
        return sectors.map(function (s) {
          return _this2.getSector(s).title;
        }).join(', ');
      };
    }
  }),
  beforeMount: function beforeMount() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var pr;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoaded = false;

              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this3.loadAssets('crypto'), _this3.loadAssets('stock')]);

            case 3:
              pr = _context2.sent;


              _this3.assets = pr[0];
              _this3.assetsStock = pr[1];
              _this3.isLoaded = true;

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),

/***/ "EBaU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export likeId */
/* harmony export (immutable) */ __webpack_exports__["a"] = splitIdsCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');

function likeId(id) {
  if (id == null) return false;

  if (typeof id === 'number') {
    return true;
  }

  if (typeof id === 'string') {
    return id.length === 12 || id.length === 24 && checkForHexRegExp.test(id);
  }

  return false;
}

function splitIdsCollection(collection) {
  var ids = [];
  var objects = [];

  if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(collection)) {
    collection.forEach(function (item) {
      if (likeId(item)) {
        ids.push(item);
      } else {
        objects.push(item);
      }
    });
  }

  return { ids: ids, objects: objects };
}

/***/ }),

/***/ "FFyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__("x25R");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__events__["a" /* default */]);

/***/ }),

/***/ "Fe2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-line-chart-list__item",class:[_vm.element.__color ? ("e-line-chart-list__item--color--" + (_vm.element.__color)) : ''],on:{"click":_vm.onClick}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('b',{staticClass:"e-line-chart-list__asset"},[_vm._v(_vm._s(_vm.element.asset))]),_vm._v(" "),_c('small',{staticClass:"e-line-chart-list__currency eh-secondary-text"},[_vm._v("BTC")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-avatar size-30 e-line-chart-list__avatar"},[_c('img',{attrs:{"src":__webpack_require__("UEml")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FlY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "step-sent-money",
  components: {},
  data: function data() {
    return {
      wallet: null,
      amount: 0,
      card: "0000 0000 0000 0000"
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])("settings", ["setPaymentState"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])("orders", ["setWalletId"]), {
    nextPage: function nextPage() {
      this.$emit('nextPage');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])("orders", {
    orderData: 'buyModalData'
  }), {
    disabledButton: function disabledButton() {
      return this.amount <= 0;
    }
  })
});

/***/ }),

/***/ "G2NB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_averageScore_vue__ = __webpack_require__("Lglm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73a190be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_averageScore_vue__ = __webpack_require__("H7eb");
function injectStyle (ssrContext) {
  __webpack_require__("HBGa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73a190be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_averageScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73a190be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_averageScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GEoW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"size":"xl","modal-class":"e-modal e-modal-moderation","hide-footer":true,"centered":""},on:{"hide":_vm.onClose},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[(!_vm.$wait.is(("assets." + _vm.alias + ".fetch")))?[_c('template',{slot:"modal-header"},[_c('div',{staticClass:"title"},[_vm._v("\n        Moderating\n      ")])]),_vm._v(" "),(_vm.asset)?[_c('div',{staticClass:"modal-content-container"},[_c('em-modal-asset-header',{attrs:{"asset":_vm.asset,"hint":_vm.hint,"meta":_vm.assetMeta,"type":"moderate"}})],1),_vm._v(" "),_c('div',{staticClass:"modal-divider"}),_vm._v(" "),_c('em-moderate-steps',{attrs:{"asset":_vm.asset},on:{"closeModal":function () { return this$1.$refs.modal.hide(); }}})]:_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GO4B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__ = __webpack_require__("wkPx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e75bc1d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__ = __webpack_require__("VEOp");
function injectStyle (ssrContext) {
  __webpack_require__("J/pi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e75bc1d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e75bc1d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gwys":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H7eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"average-score"},[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.score))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HBGa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HRjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"e-input has-float-label"},[_c('input',_vm._b({staticClass:"e-input__control form-control",attrs:{"type":_vm.type,"placeholder":_vm.getPlaceholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span',{staticClass:"e-input__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HVL6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjk5OTUgOUMxMi41NTIgOSAxMyA4LjU1MjUgMTMgOFYxQzEzIDAuNDQ3NSAxMi41NTIgMCAxMS45OTk1IDBIMC45OTk1QzAuNDQ3IDAgMCAwLjQ0NzUgMCAxVjEzTDMuOTk5NSA5SDExLjk5OTVaIiBmaWxsPSIjRTRFQ0YzIi8+CjxwYXRoIGQ9Ik0xNC45OTk1IDJIMTRWMTBINC45OTk1MUwyLjk5OTUxIDEySDEyLjc5OTVMMTYgMTZWM0MxNiAyLjQ0NzUgMTYgMiAxNC45OTk1IDJaIiBmaWxsPSIjRTRFQ0YzIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "HZmZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HolZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_templateString__ = __webpack_require__("TcSE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-topbar",
  props: {
    mobileMenuOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['fullname', 'isAuth']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('settings', ['pageTitle']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["e" /* mapState */])('auth', {
    user: function user(state) {
      return state.user;
    }
  }), {
    computedStyle: function computedStyle() {
      return {
        paddingLeft: this.menuIsOpen ? '230px' : '110px'
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('auth', ['updateUserData', 'logout']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])('auth', {
    decrementNotificationCount: 'decrementNotificationCount'
  }), {
    goTo: function goTo(name) {
      this.$router.push({ name: name });
    },
    handleLogout: function handleLogout() {
      this.logout();
      // this.$router.push({name: 'signin'});
      window.location.href =  true ? 'https://economix.ai/login' : 'http://localhost:8082/login';
      return;
    },
    updateActivityList: function updateActivityList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* default */].Auth.getUserActivityList({ limit: 5, sort: '-createdAt' });

              case 3:
                _ref = _context.sent;
                data = _ref.data;


                _this.activity = data.items.map(function (item) {
                  if (item.showed === false) {
                    _this.decrementNotificationCount();
                  }

                  var params = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.mapValues(item.message.params, function (value, key) {
                    if (key === 'date' && (typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object') {
                      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(value.date).format(value.format);
                    }

                    return value;
                  });

                  return {
                    id: item._id,
                    message: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_templateString__["a" /* default */])(item.message.template)(params),
                    image: item.message.image,
                    showed: item.showed,
                    date: item.createdAt
                  };
                });

                _this.loading = false;

                _this.$nextTick(function () {
                  var dropdown = _this.$refs.notifyDropdown.$el.childNodes[2];
                  _this.calculatedOffset = dropdown.clientWidth / 2 - 37;
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    formattedDate: function formattedDate(date) {
      return this.$moment(date).fromNow();
    }
  }),
  data: function data() {
    return {
      menuIsOpen: true,
      activity: [],
      loading: true,
      calculatedOffset: 0
    };
  },
  created: function created() {
    this.updateUserData();
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    this.$root.$on('ex::sidebar::toggleMenu', function (o) {
      _this2.menuIsOpen = o;
    });
  }
});

/***/ }),

/***/ "Hp1D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-card',{class:_vm.sizeClasses,attrs:{"data-v-step":"3"},on:{"toggleDrag":function($event){return _vm.$emit('toggleDrag')}}},[_c('b-tab',{staticClass:"e-assets-slider",attrs:{"title":"My Assets"}},[_c('eb-my-assets')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"My Events (Soon)","disabled":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hw/g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input__ = __webpack_require__("xD3O");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__input__["a" /* default */]);

/***/ }),

/***/ "IQYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_steps_vue__ = __webpack_require__("Upue");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01345e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_steps_vue__ = __webpack_require__("D8Ss");
function injectStyle (ssrContext) {
  __webpack_require__("1JMt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01345e32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01345e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_ui__ = __webpack_require__("XZap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_assets__ = __webpack_require__("gZor");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_settings__ = __webpack_require__("THyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_coins__ = __webpack_require__("iOlq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_rate__ = __webpack_require__("B0LN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_orders__ = __webpack_require__("CGR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_rates__ = __webpack_require__("dTcm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_moderation__ = __webpack_require__("kr3L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_forecast__ = __webpack_require__("fMnW");













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    rate: __WEBPACK_IMPORTED_MODULE_7__modules_rate__["a" /* default */],
    ui: __WEBPACK_IMPORTED_MODULE_3__modules_ui__["a" /* default */],
    assets: __WEBPACK_IMPORTED_MODULE_4__modules_assets__["a" /* default */],
    settings: __WEBPACK_IMPORTED_MODULE_5__modules_settings__["a" /* default */],
    coins: __WEBPACK_IMPORTED_MODULE_6__modules_coins__["a" /* default */],
    orders: __WEBPACK_IMPORTED_MODULE_8__modules_orders__["a" /* default */],
    rates: __WEBPACK_IMPORTED_MODULE_9__modules_rates__["a" /* default */],
    moderation: __WEBPACK_IMPORTED_MODULE_10__modules_moderation__["a" /* default */],
    forecast: __WEBPACK_IMPORTED_MODULE_11__modules_forecast__["a" /* default */]
  },
  strict: debug
}));

/***/ }),

/***/ "In1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "step-wallet",
  components: {},
  data: function data() {
    return {
      wallet: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])("settings", ["setPaymentState"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])("orders", ["setWalletId"]), {
    nextPage: function nextPage() {
      this.setWalletId(this.wallet);
      this.$emit('nextPage');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])("orders", {
    orderData: 'buyModalData'
  }), {
    isWalidAddress: function isWalidAddress() {
      return !(this.wallet !== null && this.wallet !== '');
    },
    total: function total() {
      return (this.orderData.amount / this.orderData.asset.price.value).toFixed(6);
    }
  })
});

/***/ }),

/***/ "IvEH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J/pi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J0Jw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__activity__ = __webpack_require__("sfUl");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__activity__["a" /* default */]);

/***/ }),

/***/ "J79C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JDmK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-asset-card",
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  filters: {
    shortText: function shortText(value, len) {
      if (value.length > len) {
        value = value.substring(0, len - 3) + '...';
      }

      return value;
    },
    formatPrice: function formatPrice(price) {
      price = parseFloat(price);
      if (price <= 10) {
        return price.toFixed(6);
      } else if (price <= 50) {
        return price.toFixed(4);
      }

      return price.toFixed(2);
    }
  },
  computed: {},
  data: function data() {
    return {
      showDescribe: false
    };
  },

  methods: {
    toggleDescribe: function toggleDescribe() {
      this.showDescribe = !this.showDescribe;
    },
    formatPrice: function formatPrice(price) {
      price = parseFloat(price);
      if (price <= 10) {
        return price.toFixed(4);
      } else if (price <= 50) {
        return price.toFixed(3);
      }

      return price.toFixed(2);
    },
    forecastPrediction: function forecastPrediction(period) {
      // return this.asset.forecastPredictions.find(p => p.period === period).value / this.asset.price.value * 100 - 100
      return 4.85;
    }
  }
});

/***/ }),

/***/ "JpXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-card',{staticClass:"buy-list-wizard",class:_vm.sizeClasses,attrs:{"data-v-step":"7"},on:{"toggleDrag":function($event){return _vm.$emit('toggleDrag')}}},[_c('b-tab',{staticClass:"e-card__content",attrs:{"title":"Buy Crypto"}},[_c('div',{staticClass:"trading-list"},[_c('transition',{attrs:{"name":"fade"}},[(!_vm.isLoading)?_c('b-table',{key:"table",staticClass:"e-table e-table--bg--white e-table--padding--small",attrs:{"responsive":"","hover":"","fields":_vm.currenciesListFields,"items":_vm.currenciesList},scopedSlots:_vm._u([{key:"HEAD_currency",fn:function(data){return [_vm._v("\n            Currencies\n          ")]}},{key:"HEAD_price",fn:function(data){return [_vm._v("\n            Rate\n          ")]}},{key:"HEAD_rate",fn:function(data){return [_vm._v("\n            Score\n          ")]}},{key:"HEAD_emixtier",fn:function(data){return [_vm._v("\n            Emixtier\n          ")]}},{key:"HEAD_actions",fn:function(data){return undefined}},{key:"currency",fn:function(data){return [_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"e-avatar size-30 mr-4"},[_c('img',{attrs:{"src":data.item.logoPath}})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('b',[_vm._v(_vm._s(data.item.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.item.symbol))])])])]}},{key:"price",fn:function(data){return [_c('b',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("formatPrice")(data.item.price.value))+" USD")])]}},{key:"rate",fn:function(data){return [_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(data.item.rate === 0 ? 'N/A' : data.item.rate))])]}},{key:"emixtier",fn:function(data){return [_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(data.item.rate === 0 ? 'N/A' : _vm.convertRate(data.item.rate)))])]}},{key:"actions",fn:function(data){return [_c('div',{staticClass:"d-flex flex-row justify-content-end"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-right":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buyAmount[data.index]),expression:"buyAmount[data.index]"}],staticClass:"tc-amount",class:{ active: _vm.buyAmount[data.index] > 0 },attrs:{"type":"text","value":"0"},domProps:{"value":(_vm.buyAmount[data.index])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.buyAmount, data.index, $event.target.value)},function($event){_vm.buyAmount[data.index] = $event.target.value != '' ? $event.target.value : 0}]}}),_vm._v(" "),_c('div',{staticClass:"fg-amount-name"},[_vm._v("USD")])]),_vm._v(" "),_c('e-button',{attrs:{"color":"blue-light","size":"small","shadow":false,"disabled":_vm.buyAmount[data.index] === 0},on:{"click":function($event){return _vm.buyCurrency(data.index)}}},[_vm._v("Buy")])],1)]}}],null,false,1018365632)}):_vm._e()],1)],1),_vm._v(" "),_c('button',{staticClass:"e-btn see-all",on:{"click":function($event){return _vm.onSeeAllClick()}}},[_vm._v("See All Coins")])]),_vm._v(" "),_c('b-tab',{staticClass:"e-card__content",attrs:{"title":"Buy Stock (Soon)","disabled":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jsz5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE5IDIwIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik05LjA0OCAwYTIuNjY5IDIuNjY5IDAgMCAwLTIuNjcxIDIuNjZ2LjgwM2gxLjM4MXYtLjgwMmMwLS43MDkuNTc5LTEuMjg1IDEuMjktMS4yODUuNzEgMCAxLjI5LjU3NiAxLjI5IDEuMjg1di44MDJoMS4zOHYtLjgwMkEyLjY2OSAyLjY2OSAwIDAgMCA5LjA0OCAwek0xMC45MzUgMTYuNzY2YTEuODY0IDEuODY0IDAgMCAxLTEuODY0IDEuODU4aC0uMDQ2YTEuODY0IDEuODY0IDAgMCAxLTEuODY1LTEuODU4SDUuNzc5QTMuMjQ0IDMuMjQ0IDAgMCAwIDkuMDI1IDIwaC4wNDZjMS43OSAwIDMuMjQ2LTEuNDUgMy4yNDYtMy4yMzRoLTEuMzgyeiIvPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE3Ljk4NiAxNi41MDlsLTEuOTYzLTMuMDQxVjkuNTY0YzAtMy44Ny0zLjEyOS03LjAxOC02Ljk3NS03LjAxOC0zLjg0NyAwLTYuOTc2IDMuMTQ4LTYuOTc2IDcuMDE4djMuOTA0TC4xMSAxNi41MDhhLjY4Ni42ODYgMCAwIDAtLjAyNi43MDNjLjEyMi4yMi4zNTQuMzU4LjYwNy4zNThoMTYuNzE0YS42OS42OSAwIDAgMCAuNjA2LS4zNTguNjg1LjY4NSAwIDAgMC0uMDI1LS43MDJ6bS0xNi4wMy0uMzE2bDEuMzg3LTIuMTUxYy4wNzItLjExLjExLS4yNC4xMS0uMzcyVjkuNTY0YzAtMy4xMSAyLjUxLTUuNjQyIDUuNTk1LTUuNjQyczUuNTk0IDIuNTMxIDUuNTk0IDUuNjQydjQuMTA2YzAgLjEzMi4wMzguMjYuMTEuMzcybDEuMzg3IDIuMTUxSDEuOTU2eiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "K6NR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-menu-item",
  props: {
    badge: {
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' || typeof value === 'string';
      }
    },
    route: {
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' || typeof value === 'string';
      }
    },
    icon: String,
    label: String,
    linkClass: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClickItem: function onClickItem() {
      this.$emit('click');
    }
  },
  computed: {
    getImg: function getImg() {
      return __webpack_require__("UFRR")("./" + this.icon + '.svg');
    },
    linkClasses: function linkClasses() {
      var classes = {
        'disabled': this.disabled
      };

      if (this.$props.linkClass) {
        classes[this.$props.linkClass] = true;
      }

      return classes;
    }
  }
});

/***/ }),

/***/ "K7k7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepWallet_vue__ = __webpack_require__("In1z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_009fc354_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepWallet_vue__ = __webpack_require__("ig+Z");
function injectStyle (ssrContext) {
  __webpack_require__("nO1W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepWallet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_009fc354_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepWallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KAhp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"size":"xl","modal-class":"e-modal","hide-footer":true,"centered":""},on:{"show":_vm.onShow,"hide":_vm.Close},model:{value:(_vm.showKyc),callback:function ($$v) {_vm.showKyc=$$v},expression:"showKyc"}},[[_c('template',{slot:"modal-header"},[(_vm.stage === 1)?_c('div',{staticClass:"title"},[_vm._v("Up to $ 15,000 — Verification")]):_vm._e(),_vm._v(" "),(_vm.stage === 2)?_c('div',{staticClass:"title"},[_vm._v("Up to $ 50,000 — Verification")]):_vm._e(),_vm._v(" "),(_vm.stage === 3)?_c('div',{staticClass:"title"},[_vm._v("Up to $ 1M — Verification")]):_vm._e(),_vm._v(" "),(_vm.stage === 4)?_c('div',{staticClass:"title"},[_vm._v("Let's Extend Your Spending Limit")]):_vm._e()]),_vm._v(" "),[_c('div',{staticClass:"vm-modal"},[(_vm.stage === 1)?_c('div',{staticClass:"vm-steps"},[_c('div',{staticClass:"vm-step",class:{active:_vm.step === 1, done:_vm.step > 1},on:{"click":function($event){return _vm.devClick(1)}}},[_c('div',{staticClass:"step-number"},[_vm._v("Step 1\n                "),_c('img',{staticClass:"done-icon",attrs:{"src":"/static/kyc/check mark.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"step-name"},[_vm._v(" Personal Details ")])]),_vm._v(" "),_c('div',{staticClass:"vm-step",class:{active:_vm.step === 2, done:_vm.step > 2},on:{"click":function($event){return _vm.devClick(2)}}},[_c('div',{staticClass:"step-number"},[_vm._v("Step 2\n                "),_c('img',{staticClass:"done-icon",attrs:{"src":"/static/kyc/check mark.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"step-name"},[_vm._v(" Contact Details ")])]),_vm._v(" "),_c('div',{staticClass:"vm-step",class:{active:_vm.step === 3, done:_vm.step > 3},on:{"click":function($event){return _vm.devClick(3)}}},[_c('div',{staticClass:"step-number"},[_vm._v("Step 3\n                "),_c('img',{staticClass:"done-icon",attrs:{"src":"/static/kyc/check mark.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"step-name"},[_vm._v(" ID Details ")])]),_vm._v(" "),_c('div',{staticClass:"vm-step",class:{active:_vm.step === 4, done:_vm.step > 4},on:{"click":function($event){return _vm.devClick(4)}}},[_c('div',{staticClass:"step-number"},[_vm._v("Step 4\n                "),_c('img',{staticClass:"done-icon",attrs:{"src":"/static/kyc/check mark.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"step-name"},[_vm._v(" Uploading Documents ")])]),_vm._v(" "),_c('div',{staticClass:"vm-step",class:{active:_vm.step === 5, done:_vm.step > 5},on:{"click":function($event){return _vm.devClick(5)}}},[_c('div',{staticClass:"step-number"},[_vm._v("Step 5\n                "),_c('img',{staticClass:"done-icon",attrs:{"src":"/static/kyc/check mark.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"step-name"},[_vm._v(" Selfie Verification ")])]),_vm._v(" "),_c('div',{staticClass:"vm-step",class:{active:_vm.step === 6, done:_vm.step > 6},on:{"click":function($event){return _vm.devClick(6)}}},[_c('div',{staticClass:"step-number"},[_vm._v("Step 6\n                "),_c('img',{staticClass:"done-icon",attrs:{"src":"/static/kyc/check mark.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"step-name"},[_vm._v(" Phone Verification ")])]),_vm._v(" "),_c('div',{staticClass:"vm-step",class:{active:_vm.step === 7},on:{"click":function($event){return _vm.devClick(7)}}},[_c('div',{staticClass:"step-number"},[_vm._v("Step 7")]),_vm._v(" "),_c('div',{staticClass:"step-name"},[_vm._v(" Done ")])])]):_vm._e(),_vm._v(" "),(_vm.stage === 2)?_c('div',{staticClass:"vm-steps"},[_c('div',{staticClass:"vm-step",class:{active:_vm.step === 1, done:_vm.step > 1},on:{"click":function($event){return _vm.devClick(1)}}},[_c('div',{staticClass:"step-number"},[_vm._v("Step 1\n                "),_c('img',{staticClass:"done-icon",attrs:{"src":"/static/kyc/check mark.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"step-name"},[_vm._v(" Uploading a Secondary ID ")])]),_vm._v(" "),_c('div',{staticClass:"vm-step",class:{active:_vm.step === 2, done:_vm.step > 2},on:{"click":function($event){return _vm.devClick(2)}}},[_c('div',{staticClass:"step-number"},[_vm._v("Step 2\n                "),_c('img',{staticClass:"done-icon",attrs:{"src":"/static/kyc/check mark.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"step-name"},[_vm._v(" Uploading a Utility Bill ")])]),_vm._v(" "),_c('div',{staticClass:"vm-step",class:{active:_vm.step === 3, done:_vm.step > 3},on:{"click":function($event){return _vm.devClick(3)}}},[_c('div',{staticClass:"step-number"},[_vm._v("Step 3\n                "),_c('img',{staticClass:"done-icon",attrs:{"src":"/static/kyc/check mark.svg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"step-name"},[_vm._v(" Done ")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 1 || _vm.stage!==1)),expression:"!(step !== 1 || stage!==1)"}],staticClass:"vm-content"},[_c('div',{staticClass:"vm-title"},[_vm._v("Personal Details")]),_vm._v(" "),_c('div',{staticClass:"vm-subtitle"},[_vm._v("Please enter your personal details and then click next")]),_vm._v(" "),_c('div',{staticClass:"vm-notice"},[_c('span',{staticClass:"notice"},[_vm._v(" Notice: ")]),_vm._v(" Adding your detail help us to confirm that you're\n              really\n              you and avoid ID theift for your personal security and fraud")]),_vm._v(" "),_c('div',{staticClass:"vm-form"},[_c('div',{staticClass:"vmf-flexrow"},[_c('div',{staticClass:"input-field"},[_c('e-input',{attrs:{"type":"text","label":"First Name *","floating":""},model:{value:(_vm.kycData.step1.firstName),callback:function ($$v) {_vm.$set(_vm.kycData.step1, "firstName", $$v)},expression:"kycData.step1.firstName"}})],1),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('e-input',{attrs:{"type":"text","label":"Middle Name","floating":""},model:{value:(_vm.kycData.step1.middleName),callback:function ($$v) {_vm.$set(_vm.kycData.step1, "middleName", $$v)},expression:"kycData.step1.middleName"}})],1),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('e-input',{attrs:{"type":"text","label":"Last Name *","floating":""},model:{value:(_vm.kycData.step1.lastName),callback:function ($$v) {_vm.$set(_vm.kycData.step1, "lastName", $$v)},expression:"kycData.step1.lastName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"vmf-flexrow mt-10"},[_c('div',{staticClass:"select-box"},_vm._l((_vm.genderList),function(gender){return _c('div',{staticClass:"select-item",class:{selected: _vm.kycData.step1.gender === gender},on:{"click":function($event){return _vm.selectGender(gender)}}},[_vm._v(_vm._s(gender))])}),0),_vm._v(" "),_c('div',{staticClass:"vmf-comment"},[_vm._v("We are welcome anyone though for the verification process we need the Gender that\n                  is\n                  shown in your personal ID")])]),_vm._v(" "),_c('div',{staticClass:"vmf-flexrow vm-date"},[_c('div',{staticClass:"input-field"},[_c('e-input',{attrs:{"type":"date","label":"Date of birth *","floating":""},model:{value:(_vm.kycData.step1.dateBirth),callback:function ($$v) {_vm.$set(_vm.kycData.step1, "dateBirth", $$v)},expression:"kycData.step1.dateBirth"}})],1),_vm._v(" "),_c('div',{staticClass:"vmf-comment"},[_vm._v("Example: 18 December 1990; 18/12/1990; 18-12-1990")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 2 || _vm.stage!==1)),expression:"!(step !== 2 || stage!==1)"}],staticClass:"vm-content"},[_c('div',{staticClass:"vm-title"},[_vm._v("Contact Details")]),_vm._v(" "),_c('div',{staticClass:"vm-subtitle"},[_vm._v("Please enter your contact details")]),_vm._v(" "),_c('div',{staticClass:"vm-form"},[_c('div',{staticClass:"vm-select"},[_c('span',{staticClass:"txt-u"},[_vm._v("Country of residence *")]),_vm._v(" "),_c('span',{staticClass:"txt-p"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.kycData.step2.countryOfResidents),expression:"kycData.step2.countryOfResidents"}],staticClass:"e-select-box",attrs:{"placeholder":"Please select your country","name":"countryOfResidents"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.kycData.step2, "countryOfResidents", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.countries),function(country){return _c('option',{domProps:{"value":country.name}},[_vm._v(_vm._s(country.name))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"input-field longer"},[_c('e-input',{attrs:{"type":"address","label":"Street name and Number *","floating":""},model:{value:(_vm.kycData.step2.address),callback:function ($$v) {_vm.$set(_vm.kycData.step2, "address", $$v)},expression:"kycData.step2.address"}})],1),_vm._v(" "),_c('div',{staticClass:"vmf-flexrow"},[_c('div',{staticClass:"input-field"},[_c('e-input',{attrs:{"type":"text","label":"City *","floating":""},model:{value:(_vm.kycData.step2.city),callback:function ($$v) {_vm.$set(_vm.kycData.step2, "city", $$v)},expression:"kycData.step2.city"}})],1),_vm._v(" "),_c('div',{staticClass:"input-field"},[_c('e-input',{attrs:{"type":"text","label":"ZIP code *","floating":""},model:{value:(_vm.kycData.step2.zip),callback:function ($$v) {_vm.$set(_vm.kycData.step2, "zip", $$v)},expression:"kycData.step2.zip"}})],1)]),_vm._v(" "),_c('div',{staticClass:"vmf-flexrow mt-10"},[_c('div',{staticClass:"input-field"},[_c('e-input',{attrs:{"type":"tel","label":"Phone *","floating":""},model:{value:(_vm.kycData.step2.phone),callback:function ($$v) {_vm.$set(_vm.kycData.step2, "phone", $$v)},expression:"kycData.step2.phone"}})],1),_vm._v(" "),_c('div',{staticClass:"vmf-comment"},[_vm._v("This number will help you to varify you in case of lost/forger credenatials")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 3 || _vm.stage!==1)),expression:"!(step !== 3 || stage!==1)"}],staticClass:"vm-content"},[_c('div',{staticClass:"vm-title"},[_vm._v("ID Details")]),_vm._v(" "),_c('div',{staticClass:"vm-subtitle"},[_vm._v("Please enter your ID details")]),_vm._v(" "),_c('div',{staticClass:"vm-form"},[_c('div',{staticClass:"vm-select"},[_c('span',{staticClass:"txt-u"},[_vm._v("ID Issuing country *")]),_vm._v(" "),_c('span',{staticClass:"txt-p"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.kycData.step3.idIssuingCountry),expression:"kycData.step3.idIssuingCountry"}],staticClass:"e-select-box",attrs:{"placeholder":"Please select your country","name":"countryOfResidents"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.kycData.step3, "idIssuingCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.countries),function(country){return _c('option',{domProps:{"value":country.name}},[_vm._v(_vm._s(country.name)+"\n                      ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"input-field longer"},[_c('e-input',{attrs:{"type":"number","label":"ID Number *","floating":""},model:{value:(_vm.kycData.step3.idNumber),callback:function ($$v) {_vm.$set(_vm.kycData.step3, "idNumber", $$v)},expression:"kycData.step3.idNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"vmf-flexrow vm-date"},[_c('div',{staticClass:"input-field"},[_c('e-input',{attrs:{"type":"date","label":"ID experation date *","floating":""},model:{value:(_vm.kycData.step3.idExpirationDate),callback:function ($$v) {_vm.$set(_vm.kycData.step3, "idExpirationDate", $$v)},expression:"kycData.step3.idExpirationDate"}})],1),_vm._v(" "),_c('div',{staticClass:"vmf-comment"},[_vm._v("Example: 18 December 1990; 18/12/1990; 18-12-1990")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 4 || _vm.stage!==1)),expression:"!(step !== 4 || stage!==1)"}],staticClass:"vm-content"},[_c('div',{staticClass:"vm-title"},[_vm._v("Uploading Documents")]),_vm._v(" "),_c('div',{staticClass:"vm-subtitle"},[_vm._v("Now you need to upload a documents")]),_vm._v(" "),_c('div',{staticClass:"vm-notice"},[_c('span',{staticClass:"notice"},[_vm._v(" Notice: ")]),_vm._v(" A valid government issues ID: International\n              Passport\n              (npn-US), Driver Licencese or National ID.")]),_vm._v(" "),_c('div',{staticClass:"vm-photos-form"},[_c('div',{staticClass:"upload-photo",class:{'non-border':_vm.kycData.photos.kycF != ''}},[(_vm.kycData.photos.kycF != '')?_c('div',{staticClass:"upload-img"},[_c('img',{attrs:{"src":_vm.kycData.photos.kycF,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"upload-label"},[_vm._v("KYC Front Side")]),_vm._v(" "),_c('img',{staticClass:"up-info",attrs:{"src":"/static/kyc/info.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"up-photo",attrs:{"src":"/static/kyc/photo.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"upload-plus",attrs:{"src":"/static/kyc/plus(load).svg"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.kycData.photos.kycF !== ''),expression:"kycData.photos.kycF !== ''"}],staticClass:"upload-close",attrs:{"src":"/static/kyc/close.svg"},on:{"click":function($event){_vm.kycData.photos.kycF = ''}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"frontSideFile","required":"","readonly":true,"accept":_vm.permitedFiles},on:{"change":function($event){return _vm.readUrl('kycF', $event)}}}),_vm._v(" "),_c('div',{staticClass:"upload-sublabel"},[_vm._v("Choose a file here")])]),_vm._v(" "),_c('div',{staticClass:"upload-photo",class:{'non-border':_vm.kycData.photos.kycB != ''}},[(_vm.kycData.photos.kycB != '')?_c('div',{staticClass:"upload-img"},[_c('img',{attrs:{"src":_vm.kycData.photos.kycB,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"upload-label"},[_vm._v("KYC Back Side")]),_vm._v(" "),_c('img',{staticClass:"up-info",attrs:{"src":"/static/kyc/info.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"up-photo",attrs:{"src":"/static/kyc/photo.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"upload-plus",attrs:{"src":"/static/kyc/plus(load).svg"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.kycData.photos.kycB !== ''),expression:"kycData.photos.kycB !== ''"}],staticClass:"upload-close",attrs:{"src":"/static/kyc/close.svg"},on:{"click":function($event){_vm.kycData.photos.kycB = ''}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"backSideFile","required":"","readonly":true,"accept":_vm.permitedFiles},on:{"change":function($event){return _vm.readUrl('kycB', $event)}}}),_vm._v(" "),_c('div',{staticClass:"upload-sublabel"},[_vm._v("Choose a file here")])])]),_vm._v(" "),_c('div',{staticClass:"vmf-comment full-comment"},[_vm._v("Make sure that you scanning all of your ID including its borders and all\n              the information\n              is clearable and readable and unhidden")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 5 || _vm.stage!==1)),expression:"!(step !== 5 || stage!==1)"}],staticClass:"vm-content"},[_c('div',{staticClass:"vm-title"},[_vm._v("Selfie Verification")]),_vm._v(" "),_c('div',{staticClass:"vm-subtitle"},[_vm._v("A real time verification")]),_vm._v(" "),_c('div',{staticClass:"vm-notice"},[_c('span',{staticClass:"notice"},[_vm._v(" Notice: ")]),_vm._v("You need to make a selfie with yor're holding\n              both:\n              Your ID and Paper note with “Economix\" and today's date on it.")]),_vm._v(" "),_c('div',{staticClass:"vm-photos-form"},[_c('div',{staticClass:"upload-photo",class:{'non-border':_vm.kycData.photos.selfie != ''}},[(_vm.kycData.photos.selfie != '')?_c('div',{staticClass:"upload-img"},[_c('img',{attrs:{"src":_vm.kycData.photos.selfie,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"upload-label"},[_vm._v("Selfie")]),_vm._v(" "),_c('img',{staticClass:"up-info",attrs:{"src":"/static/kyc/info.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"up-photo",attrs:{"src":"/static/kyc/photo.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"upload-plus",attrs:{"src":"/static/kyc/plus(load).svg"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.kycData.photos.selfie !== ''),expression:"kycData.photos.selfie !== ''"}],staticClass:"upload-close",attrs:{"src":"/static/kyc/close.svg"},on:{"click":function($event){_vm.kycData.photos.selfie = ''}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"frontSideFile","required":"","readonly":true,"accept":_vm.permitedFiles},on:{"change":function($event){return _vm.readUrl('selfie', $event)}}}),_vm._v(" "),_c('div',{staticClass:"upload-sublabel"},[_vm._v("Choose a file here")])]),_vm._v(" "),_c('div',{staticClass:"upload-photo solid-border"},[_c('div',{staticClass:"upload-img"},[_c('img',{attrs:{"src":"/static/kyc/selfie.png","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"vmf-comment full-comment example-photo-text"},[_vm._v("Please use this example for how making a good selfie")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 6 || _vm.stage!==1)),expression:"!(step !== 6 || stage!==1)"}],staticClass:"vm-content"},[_c('div',{staticClass:"vm-title"},[_vm._v("Phone Verification")]),_vm._v(" "),_c('div',{staticClass:"vm-form"},[_c('div',{staticClass:"intput-btn",staticStyle:{"align-items":"center"}},[_c('div',{staticClass:"input-field"},[_c('e-input',{attrs:{"type":"tel","label":"Phone","floating":"","autofocus":""},model:{value:(_vm.kycData.step2.phone),callback:function ($$v) {_vm.$set(_vm.kycData.step2, "phone", $$v)},expression:"kycData.step2.phone"}})],1),_vm._v(" "),_c('e-button',{attrs:{"size":"small","disabled":(_vm.sendSMSstage >= 1 && _vm.smsTimer > 0)  || _vm.smsBlocked},on:{"click":_vm.sendSMS}},[_vm._v("Send SMS")]),_vm._v(" "),_c('div',{staticClass:"vmf-error"},[_vm._v(_vm._s(_vm.smsError))])],1),_vm._v(" "),_c('div',{staticClass:"vmf-numbers"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.kycData.phonecode.n1),expression:"kycData.phonecode.n1"}],ref:"verifyCode1",staticClass:"phone-code",attrs:{"type":"number","min":"0","max":"9","placeholder":"-","id":"firstNumber"},domProps:{"value":(_vm.kycData.phonecode.n1)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.kycData.phonecode, "n1", $event.target.value)},function($event){return _vm.numInput(1, $event)}]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.kycData.phonecode.n2),expression:"kycData.phonecode.n2"}],ref:"verifyCode2",staticClass:"phone-code",attrs:{"type":"number","min":"0","max":"9","placeholder":"-"},domProps:{"value":(_vm.kycData.phonecode.n2)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.kycData.phonecode, "n2", $event.target.value)},function($event){return _vm.numInput(2, $event)}]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.kycData.phonecode.n3),expression:"kycData.phonecode.n3"}],ref:"verifyCode3",staticClass:"phone-code",attrs:{"type":"number","min":"0","max":"9","placeholder":"-"},domProps:{"value":(_vm.kycData.phonecode.n3)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.kycData.phonecode, "n3", $event.target.value)},function($event){return _vm.numInput(3, $event)}]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.kycData.phonecode.n4),expression:"kycData.phonecode.n4"}],ref:"verifyCode4",staticClass:"phone-code",attrs:{"type":"number","min":"0","max":"9","placeholder":"-"},domProps:{"value":(_vm.kycData.phonecode.n4)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.kycData.phonecode, "n4", $event.target.value)},function($event){return _vm.numInput(4, $event)}]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.kycData.phonecode.n5),expression:"kycData.phonecode.n5"}],ref:"verifyCode5",staticClass:"phone-code",attrs:{"type":"number","min":"0","max":"9","placeholder":"-"},domProps:{"value":(_vm.kycData.phonecode.n5)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.kycData.phonecode, "n5", $event.target.value)},function($event){return _vm.numInput(5, $event)}]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.kycData.phonecode.n6),expression:"kycData.phonecode.n6"}],ref:"verifyCode6",staticClass:"phone-code",attrs:{"type":"number","min":"0","max":"9","placeholder":"-"},domProps:{"value":(_vm.kycData.phonecode.n6)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.kycData.phonecode, "n6", $event.target.value)},function($event){return _vm.numInput(6, $event)}]}})]),_vm._v(" "),_c('div',{staticClass:"vm-notice mt-15",class:{invissible:_vm.sendSMSstage < 1 || _vm.smsBlocked}},[_vm._v(" If SMS does not arrive\n                within\n                "+_vm._s(_vm.smsTimer)+" seconds, we will "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.smsTimer > 0),expression:"!smsTimer > 0"}],on:{"click":function($event){return _vm.sendSMS()}}},[_vm._v("send it again")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.smsTimer <= 0),expression:"!smsTimer <= 0"}]},[_vm._v("send\n                  it again")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 7 || _vm.stage!==1)),expression:"!(step !== 7 || stage!==1)"}],staticClass:"vm-content"},[_c('div',{staticClass:"finish-content"},[_c('img',{staticStyle:{"width":"217px","height":"290px"},attrs:{"src":"/static/kyc/finish.svg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"f-text-box"},[_c('div',{staticClass:"f-title"},[_vm._v("Thank you "+_vm._s(_vm.kycData.step1.firstName)+"!")]),_vm._v(" "),_c('div',{staticClass:"f-text"},[_vm._v("You have successfully completed your verification process and should expect to hear\n                  from us shortly. Once your details are verified you will be able to spent up to $15,000.")]),_vm._v(" "),_c('div',{staticClass:"vmf-comment"},[_vm._v("\n                  * You can extend your spending limit right now to up to $50,000, with only 2 more steps!\n                  "),_c('br'),_c('br'),_vm._v("\n                  * You don’t have to do it right now, you can always get back to it later.")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 1 || _vm.stage!==2)),expression:"!(step !== 1 || stage!==2)"}],staticClass:"vm-content"},[_c('div',{staticClass:"vm-title"},[_vm._v("Uploading a Secondary ID")]),_vm._v(" "),_c('div',{staticClass:"vm-subtitle"},[_vm._v("We need this step to ensure your true identity")]),_vm._v(" "),_c('div',{staticClass:"vm-notice"},[_c('span',{staticClass:"notice"},[_vm._v(" Notice: ")]),_vm._v(" Please upload a valid government issued ID, such\n              as international passport or driving license")]),_vm._v(" "),_c('div',{staticClass:"vm-photos-form"},[_c('div',{staticClass:"upload-photo",class:{'non-border':_vm.kycData.photos.kyc2F != ''}},[(_vm.kycData.photos.kyc2F != '')?_c('div',{staticClass:"upload-img"},[_c('img',{attrs:{"src":_vm.kycData.photos.kyc2F,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"upload-label"},[_vm._v("Front Side")]),_vm._v(" "),_c('img',{staticClass:"up-info",attrs:{"src":"/static/kyc/info.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"up-photo",attrs:{"src":"/static/kyc/photo.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"upload-plus",attrs:{"src":"/static/kyc/plus(load).svg"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.kycData.photos.kyc2F !== ''),expression:"kycData.photos.kyc2F !== ''"}],staticClass:"upload-close",attrs:{"src":"/static/kyc/close.svg"},on:{"click":function($event){_vm.kycData.photos.kyc2F = ''}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"frontSideFile2","required":"","readonly":true,"accept":_vm.permitedFiles},on:{"change":function($event){return _vm.readUrl('kyc2F', $event)}}}),_vm._v(" "),_c('div',{staticClass:"upload-sublabel"},[_vm._v("Choose a file here")])]),_vm._v(" "),_c('div',{staticClass:"upload-photo",class:{'non-border':_vm.kycData.photos.kyc2B != ''}},[(_vm.kycData.photos.kyc2B != '')?_c('div',{staticClass:"upload-img"},[_c('img',{attrs:{"src":_vm.kycData.photos.kyc2B,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"upload-label"},[_vm._v("Back Side")]),_vm._v(" "),_c('img',{staticClass:"up-info",attrs:{"src":"/static/kyc/info.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"up-photo",attrs:{"src":"/static/kyc/photo.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"upload-plus",attrs:{"src":"/static/kyc/plus(load).svg"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.kycData.photos.kyc2B !== ''),expression:"kycData.photos.kyc2B !== ''"}],staticClass:"upload-close",attrs:{"src":"/static/kyc/close.svg"},on:{"click":function($event){_vm.kycData.photos.kyc2B = ''}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"backSideFile2","required":"","readonly":true,"accept":_vm.permitedFiles},on:{"change":function($event){return _vm.readUrl('kyc2B', $event)}}}),_vm._v(" "),_c('div',{staticClass:"upload-sublabel"},[_vm._v("Choose a file here")])])]),_vm._v(" "),_c('div',{staticClass:"vmf-comment full-comment"},[_vm._v("In darker font color so they can actually see it: Make sure your photo is\n              clearly readable and all its information and borders are clearly visible")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 2 || _vm.stage!==2)),expression:"!(step !== 2 || stage!==2)"}],staticClass:"vm-content"},[_c('div',{staticClass:"vm-title"},[_vm._v("Uploading a Utility Bill")]),_vm._v(" "),_c('div',{staticClass:"vm-subtitle"},[_vm._v("This step will help us identify your address")]),_vm._v(" "),_c('div',{staticClass:"vm-notice"},[_c('span',{staticClass:"notice"},[_vm._v(" Notice: ")]),_vm._v("You can upload any of the following documents:\n              electricity, water, gas, property tax, bank statement or credit card statement")]),_vm._v(" "),_c('div',{staticClass:"vm-photos-form"},[_c('div',{staticClass:"upload-photo",class:{'non-border':_vm.kycData.photos.bill != ''}},[(_vm.kycData.photos.bill != '')?_c('div',{staticClass:"upload-img"},[_c('img',{attrs:{"src":_vm.kycData.photos.bill,"alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"upload-label"},[_vm._v("Utility Bill")]),_vm._v(" "),_c('img',{staticClass:"up-info",attrs:{"src":"/static/kyc/info.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"up-photo",attrs:{"src":"/static/kyc/photo.svg","alt":""}}),_vm._v(" "),_c('img',{staticClass:"upload-plus",attrs:{"src":"/static/kyc/plus(load).svg"}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.kycData.photos.bill !== ''),expression:"kycData.photos.bill !== ''"}],staticClass:"upload-close",attrs:{"src":"/static/kyc/close.svg"},on:{"click":function($event){_vm.kycData.photos.bill = ''}}}),_vm._v(" "),_c('input',{attrs:{"type":"file","name":"billSideFile2","required":"","readonly":true,"accept":_vm.permitedFiles},on:{"change":function($event){return _vm.readUrl('bill', $event)}}}),_vm._v(" "),_c('div',{staticClass:"upload-sublabel"},[_vm._v("Choose a file here")])]),_vm._v(" "),_c('div',{staticClass:"upload-photo solid-border"},[_c('div',{staticClass:"upload-img"},[_c('img',{attrs:{"src":"static/kyc/bill.jpg","alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"vmf-comment full-comment example-photo-text"},[_vm._v("Make sure you "),_c('b',[_vm._v("scan all borders")]),_vm._v(" and the bill is\n              "),_c('b',[_vm._v("clearly readable")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 3 || _vm.stage!==2)),expression:"!(step !== 3 || stage!==2)"}],staticClass:"vm-content"},[_c('div',{staticClass:"finish-content"},[_c('img',{attrs:{"src":"/static/kyc/finish.svg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"f-text-box"},[_c('div',{staticClass:"f-title"},[_vm._v("Thank you "+_vm._s(_vm.kycData.step1.firstName)+"!")]),_vm._v(" "),_c('div',{staticClass:"f-text"},[_vm._v("You have seccessfully completed your secondary verification process and should now\n                  expect to hear from us. Once your information is verified you'll be able to spent up to $50,000.")]),_vm._v(" "),_c('div',{staticClass:"vmf-comment"},[_vm._v("\n                  * You can extend your spending limit right now to up to $1,000,000.\n                  "),_c('br'),_c('br'),_vm._v("\n                  * You don't have to do it right now, you can always get back to it later.\n                ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 1 || _vm.stage!==3)),expression:"!(step !== 1 || stage!==3)"}],staticClass:"vm-content"},[_c('div',{staticClass:"finish-content"},[_c('img',{attrs:{"src":"/static/kyc/finish.svg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"f-text-box"},[_c('div',{staticClass:"f-title"},[_vm._v("Thank you "+_vm._s(_vm.kycData.step1.firstName)+"!")]),_vm._v(" "),_c('div',{staticClass:"f-text"},[_vm._v("You Completed your verification process. Now its time to be patient untill we'll send\n                  you a proper documents to fill for investing up to\n                  $ 1M.")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.step !== 1 || _vm.stage!==4)),expression:"!(step !== 1 || stage!==4)"}],staticClass:"vm-content"},[_c('div',{staticClass:"finish-content"},[_c('img',{staticStyle:{"width":"220px","height":"220px"},attrs:{"src":"/static/kyc/stairs.svg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"f-text-box"},[_c('div',{staticClass:"f-title"},[_vm._v("Hi "+_vm._s(_vm.kycData.step1.firstName)+"!")]),_vm._v(" "),_c('div',{staticClass:"f-text"},[_vm._v("You have reached your spending limit\n                  "),_c('br'),_vm._v("\n                  In order to extend you spending limit to up $50,000, there are 2 more verification steps to complete and\n                  you're good to go!\n\n                ")]),_vm._v(" "),_c('div',{staticClass:"vmf-comment"},[_vm._v("\n                  * You can extend your spending limit right now to up to $1,000,000.\n                  "),_c('br'),_c('br'),_vm._v("\n                  * You don't have to do it right now, you can always get back to it later.\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"vm-buttons"},[_c('div',{staticClass:"vmb-line"},[(_vm.checkValid())?_c('div',{staticClass:"vmbl-done"},[_vm._v("Good Job "+_vm._s(_vm.kycData.step1.firstName)+", Click Next to Continue")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"vmb-btnsbox"},[((_vm.step!==7 && _vm.stage===1) || (_vm.step !==3 && _vm.stage===2))?_c('e-button',{attrs:{"type":"outlined"},on:{"click":function($event){return _vm.Close()}}},[_vm._v("Close")]):_vm._e(),_vm._v(" "),(_vm.stage===4)?_c('e-button',{staticStyle:{"min-width":"auto","white-space":"nowrap"},attrs:{"type":"outlined"},on:{"click":function($event){return _vm.Close()}}},[_vm._v("I Will Do It Later")]):_vm._e(),_vm._v(" "),(_vm.stage===1 && _vm.step===7)?_c('e-button',{staticStyle:{"min-width":"auto","white-space":"nowrap"},attrs:{"type":"outlined"},on:{"click":function($event){_vm.stage = 2; _vm.step = 1;}}},[_vm._v("Extend Your Spending Limit")]):_vm._e(),_vm._v(" "),(_vm.stage===2 && _vm.step===3)?_c('e-button',{staticStyle:{"min-width":"auto","white-space":"nowrap"},attrs:{"type":"outlined"},on:{"click":function($event){_vm.stage = 3; _vm.step = 1;}}},[_vm._v("Extend Your Spending Limit")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vmf-flexrow",class:{'flex-right': (_vm.step===7 && _vm.stage===1) || _vm.stage===3}},[(_vm.step===1 && _vm.stage===1)?_c('div',{staticClass:"vmf-comment btn-comment"},[_vm._v("There are 4 more steps ahead\n                  approximately 5 minutes to finish\n                ")]):_vm._e(),_vm._v(" "),(_vm.step===2 && _vm.stage===1)?_c('div',{staticClass:"vmf-comment btn-comment"},[_vm._v("There are 3 more steps ahead\n                  approximately 4 minutes to finish\n                ")]):_vm._e(),_vm._v(" "),(_vm.step===3 && _vm.stage===1)?_c('div',{staticClass:"vmf-comment btn-comment"},[_vm._v("There are 2 more step ahead approximately\n                  2 minutes to finish\n                ")]):_vm._e(),_vm._v(" "),(_vm.step===4 && _vm.stage===1)?_c('div',{staticClass:"vmf-comment btn-comment"},[_vm._v("There is 1 more step ahead approximately\n                  1 minute to finish\n                ")]):_vm._e(),_vm._v(" "),(_vm.step===5 && _vm.stage===1)?_c('div',{staticClass:"vmf-comment btn-comment"},[_vm._v("You are almost done approximately 1\n                  minute to finish\n                ")]):_vm._e(),_vm._v(" "),(_vm.step===1 && _vm.stage===2)?_c('div',{staticClass:"vmf-comment btn-comment"},[_vm._v("You are almost done approximately 2\n                  minute to finish\n                ")]):_vm._e(),_vm._v(" "),(_vm.step===2 && _vm.stage===2)?_c('div',{staticClass:"vmf-comment btn-comment"},[_vm._v("You are almost done approximately 1\n                  minute to finish\n                ")]):_vm._e(),_vm._v(" "),(_vm.stage === 1 || _vm.stage === 2)?_c('e-button',{attrs:{"disabled":!_vm.checkValid()},on:{"click":function($event){return _vm.nextStep()}}},[_vm._v("\n                  "+_vm._s((_vm.step === 7 && _vm.stage === 1 ) || (_vm.step === 3 && _vm.stage === 2) ? "Finish" : "Next")+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.stage === 4)?_c('e-button',{on:{"click":function($event){_vm.stage = 2; _vm.step = 1;}}},[_vm._v("Extend My Spending Limit")]):_vm._e(),_vm._v(" "),(_vm.stage === 3)?_c('e-button',{on:{"click":function($event){return _vm.Close()}}},[_vm._v("Finish")]):_vm._e()],1)],1)])])]]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KExZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


var prefix = 'e-badge';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-badge",
  props: {
    color: {
      type: String,
      default: 'white'
    }
  },
  computed: {
    classes: function classes() {
      return [prefix, prefix + '-color-' + this.color];
    }
  }
});

/***/ }),

/***/ "KFdj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__performance__ = __webpack_require__("mb2O");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__performance__["a" /* default */]);

/***/ }),

/***/ "KOBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mixin = {
  props: {
    size: Number
  },
  computed: {
    sizeClasses: function sizeClasses() {
      return ['col-12', 'col-sm-' + this.size];
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mixin);

/***/ }),

/***/ "KS/K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KWv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "tUnb")).then(function (m) {
    return m.default || m;
  });
};
var TradingBuy = function TradingBuy() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "IeaG")).then(function (m) {
    return m.default || m;
  });
};
var AssetsList = function AssetsList() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "g1a3")).then(function (m) {
    return m.default || m;
  });
};
var ForecastList = function ForecastList() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "GzKD")).then(function (m) {
    return m.default || m;
  });
};
var Orders = function Orders() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "v6kf")).then(function (m) {
    return m.default || m;
  });
};
var Rates = function Rates() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "K1ie")).then(function (m) {
    return m.default || m;
  });
};
var Activity = function Activity() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "gr3c")).then(function (m) {
    return m.default || m;
  });
};
var Account = function Account() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "zSEb")).then(function (m) {
    return m.default || m;
  });
};
var Auth = function Auth() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "0D7F")).then(function (m) {
    return m.default || m;
  });
};
var Asset = function Asset() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "tKcw")).then(function (m) {
    return m.default || m;
  });
};
var SignUp = function SignUp() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "l7i4")).then(function (m) {
    return m.default || m;
  });
};
var SignIn = function SignIn() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "xWuv")).then(function (m) {
    return m.default || m;
  });
};
var Forgot = function Forgot() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "3gEl")).then(function (m) {
    return m.default || m;
  });
};
var Payment = function Payment() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "mJXS")).then(function (m) {
    return m.default || m;
  });
};
var Emixtier = function Emixtier() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "dlPh")).then(function (m) {
    return m.default || m;
  });
};
var Contacts = function Contacts() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "CMSj")).then(function (m) {
    return m.default || m;
  });
};

var ModerateModal = function ModerateModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "LYHe")).then(function (m) {
    return m.default || m;
  });
};
var RateModal = function RateModal() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "QO7f")).then(function (m) {
    return m.default || m;
  });
};

var routes = [{ path: '/trading/buy', component: TradingBuy, name: 'trading-buy' }, { path: '/orders', component: Orders, name: 'orders' }, { path: '/about/emixtier', component: Emixtier, name: 'about-emixtier' }, { path: '/rates', component: Rates, name: 'rates' }, { path: '/activity', component: Activity, name: 'activity' }, { path: '/account', component: Account, name: 'account' }, { path: '/contacts', component: Contacts, name: 'contacts' }, { path: '/asset/:id', component: Asset, name: 'asset', props: true }, {
  path: '/forecast/list',
  component: ForecastList,
  name: 'forecast-list',
  props: function props(route) {
    return {
      filter: {
        page: route.query.page || 1,
        type: route.query.type || 'all'
      }
    };
  }
}, {
  path: '/assets/list',
  component: AssetsList,
  name: 'assets-list',
  props: function props(route) {
    return {
      filter: {
        page: route.query.page || 1,
        type: route.query.type || 'all'
      }
    };
  },
  children: [{
    path: '/asset/:alias/moderate',
    alias: '/assets/moderate/:alias',
    props: { default: false, modal: true },
    name: 'create-moderate',
    components: {
      modal: ModerateModal
    }
  }, {
    path: '/asset/:alias/rate',
    alias: '/assets/rate/:alias',
    props: { default: false, modal: true },
    name: 'create-rate',
    components: {
      modal: RateModal
    }
  }]
}, { path: '/dashboard', component: Dashboard, name: 'dashboard' }, { path: '/payment', component: Payment, name: 'payment' }, {
  path: '/auth',
  component: Auth,
  children: [{
    path: 'signup',
    component: SignUp,
    name: 'signup'
  }, {
    path: 'forgot',
    component: Forgot,
    name: 'forgot-password'
  }, {
    path: '/',
    component: SignIn,
    name: 'signin'
  }]
}, { path: '/*', redirect: 'dashboard' }];

// router.beforeResolve((to, from, next) => {
//   if(to.matched.length > 0) {
//     const title = to.matched[0].components.default.pageTitle;
//     if(title) {
//       store.dispatch('settings/setPageTitle', title);
//     }
//   }
//   next();
// });

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "KnVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assetCard_vue__ = __webpack_require__("JDmK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b17db8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assetCard_vue__ = __webpack_require__("7c+F");
function injectStyle (ssrContext) {
  __webpack_require__("hi96")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01b17db8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assetCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b17db8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assetCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LJeQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LQnS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");



var _this = this;



/* harmony default export */ __webpack_exports__["default"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['auth/check'] && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters['auth/token'])) {
              _context.next = 8;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('auth/updateUserData');

          case 4:
            _context.next = 8;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context['catch'](1);

          case 8:

            next();

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 6]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),

/***/ "LYHe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moderate_vue__ = __webpack_require__("wWok");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_248fcc98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moderate_vue__ = __webpack_require__("GEoW");
function injectStyle (ssrContext) {
  __webpack_require__("rPjM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-248fcc98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moderate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_248fcc98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moderate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Lglm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-asset-average-score",
  props: {
    score: {
      required: true
    }
  }
});

/***/ }),

/***/ "LmS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"size":"xxl","modal-class":"e-modal forecast-modal","hide-footer":true,"centered":""},on:{"hidden":_vm.onAfterClose,"show":_vm.onShow,"hide":_vm.close},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.asset)?[_c('template',{slot:"modal-header"},[_c('div',{staticClass:"title"},[_vm._v("\n        Forecast "+_vm._s(_vm.asset.name)+"\n      ")])]),_vm._v(" "),[_c('em-forecast-header',{attrs:{"hint":_vm.hint}}),_vm._v(" "),_c('div',{staticClass:"modal-divider"}),_vm._v(" "),_c('div',{staticClass:"modal-content-container"},[_c('b-row',[(!_vm.isLoading)?_c('b-col',{attrs:{"cols":"12"}},[_c('transition',{attrs:{"duration":200,"name":"fade","mode":"out-in"}},[(_vm.current === 1)?_c('step-create-forecast',{key:"step1",on:{"nextPage":function () { return this$1.current = 2; },"closeModal":_vm.close}}):_vm._e(),_vm._v(" "),(_vm.current === 2)?_c('step-lock-tokens',{key:"step2",on:{"nextPage":_vm.sendPrediction,"previewPage":function () { return this$1.current = 1; },"closeModal":_vm.close}}):_vm._e(),_vm._v(" "),(_vm.current === 3)?_c('step-finish-message',{key:"step3",on:{"closeModal":_vm.close}}):_vm._e(),_vm._v(" "),(_vm.current === 4)?_c('step-already-exists',{key:"step4",attrs:{"prediction":_vm.prediction},on:{"closeModal":_vm.close}}):_vm._e()],1)],1):_vm._e()],1)],1)]]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lzff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forecast-step"},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('div',{staticClass:"modal-block-title"},[_vm._v("Asset Metrics:")]),_vm._v(" "),_c('ul',{staticClass:"asset-metrics"},[_c('li',[_c('span',[_vm._v("Type of Oracle:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.forecastData.forecast.oracle))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Current Price:")]),_vm._v(" "),_c('span',[_vm._v("$ "+_vm._s(_vm._f("formatPrice")(_vm.asset.price.value)))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Volume:")]),_vm._v(" "),_c('span',[_vm._v("$ 81.76M")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Marcet Cap.:")]),_vm._v(" "),_c('span',[_vm._v("$ 2.26B")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Evaluation Date:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("formatForecastDate")(_vm.forecastData.forecast.forecastDate)))])])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('div',{staticClass:"wrapp"},[_c('div',{staticClass:"modal-block-title"},[_vm._v("Your Evaluation is:")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"p-input"},[_c('div',{staticClass:"label"},[_vm._v("Change in %")]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valuePercent),expression:"valuePercent"}],attrs:{"type":"number","min":"-100"},domProps:{"value":(_vm.valuePercent)},on:{"change":_vm.onPercentChange,"input":function($event){if($event.target.composing){ return; }_vm.valuePercent=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"p-input"},[_c('div',{staticClass:"label"},[_vm._v("Value after your evaluation")]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueAbs),expression:"valueAbs"}],attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.valueAbs)},on:{"change":_vm.onAbsChange,"input":function($event){if($event.target.composing){ return; }_vm.valueAbs=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"p-input-suffix"},[_vm._v("USD")])])])]),_vm._v(" "),_c('div',{staticClass:"result-change",class:{ up: _vm.changeValue > 0, down: _vm.changeValue < 0 }},[_c('div',{staticClass:"label"},[_vm._v("Change is:")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.changeValue))]),_vm._v(" "),_c('div',{staticClass:"suffix"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 40 40"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 40 40","xml:space":"preserve"}},[_c('path',{staticClass:"st0",attrs:{"d":"M36.9,0H12.2c-0.8,0-1.6,0.3-2.2,0.9C9.5,1.5,9.2,2.2,9.2,3.1c0,0.8,0.3,1.6,0.9,2.2l8.5,8.5L0.5,31.8\n                C0.2,32.1,0,32.5,0,32.9c0,0.4,0.2,0.8,0.5,1.1L6,39.5C6.3,39.8,6.7,40,7.1,40c0.4,0,0.8-0.2,1.1-0.5l18.1-18.1l8.5,8.5\n                c0.6,0.6,1.3,0.9,2.2,0.9c0.8,0,1.6-0.3,2.2-0.9c0.6-0.6,0.9-1.3,0.9-2.2V3.1c0-0.8-0.3-1.6-0.9-2.2C38.5,0.3,37.8,0,36.9,0z"}})])])])])])],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('e-button',{attrs:{"type":"outlined"},on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"d-flex ml-auto"},[_c('e-button',{attrs:{"disabled":_vm.isDisabledNext},on:{"click":_vm.next}},[_vm._v("Set")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M4KK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chart__ = __webpack_require__("TY8e");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__chart__["a" /* default */]);

/***/ }),

/***/ "M7es":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24c0373a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("rq66");
function injectStyle (ssrContext) {
  __webpack_require__("gxY3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24c0373a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MEQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-card',{class:_vm.sizeClasses,on:{"toggleDrag":function($event){return _vm.$emit('toggleDrag')}}},[_c('b-tab',{attrs:{"title":"Rating Performance VS Crowd"}},[_c('eb-line-chart')],1),_vm._v(" "),_c('b-tab',{staticClass:"e-card__content",attrs:{"title":"Portfolio Returns Crows / Your"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MfZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_v_wait_vue__ = __webpack_require__("Nfsp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_16c05e07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_v_wait_vue__ = __webpack_require__("0NKQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_v_wait_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_16c05e07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_v_wait_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mijz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_highcharts__ = __webpack_require__("ajw3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment__ = __webpack_require__("8AgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_wait_src_vue_wait_js__ = __webpack_require__("lCCX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_grid_layout__ = __webpack_require__("SFAN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_grid_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_grid_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vendor_vue_star_rating__ = __webpack_require__("0T5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_tour__ = __webpack_require__("pvO8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_tour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_tour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_theme_scss__ = __webpack_require__("aeD6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue2_animate_dist_vue2_animate_min_css__ = __webpack_require__("6A3X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue2_animate_dist_vue2_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue2_animate_dist_vue2_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__App__ = __webpack_require__("M93x");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






















var BootstrapVue = __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["default"] || __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__;
var VueAwesomeSwiper = __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__["default"] || __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__;
var VueHighcharts = __WEBPACK_IMPORTED_MODULE_6_vue_highcharts__["default"] || __WEBPACK_IMPORTED_MODULE_6_vue_highcharts__;
var VueMoment = __WEBPACK_IMPORTED_MODULE_7_vue_moment__["default"] || __WEBPACK_IMPORTED_MODULE_7_vue_moment__;
var VueGridLayout = __WEBPACK_IMPORTED_MODULE_10_vue_grid_layout__["default"] || __WEBPACK_IMPORTED_MODULE_10_vue_grid_layout__;
var VueTour = __WEBPACK_IMPORTED_MODULE_12_vue_tour__["default"] || __WEBPACK_IMPORTED_MODULE_12_vue_tour__;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('star-rating', __WEBPACK_IMPORTED_MODULE_11__vendor_vue_star_rating__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(VueHighcharts);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(VueAwesomeSwiper);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(BootstrapVue);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_wait_src_vue_wait_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(VueMoment);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(VueGridLayout);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__components__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(VueTour);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  wait: new __WEBPACK_IMPORTED_MODULE_8_vue_wait_src_vue_wait_js__["a" /* default */]({
    useVuex: true, // Uses Vuex to manage wait state
    vuexModuleName: 'wait', // Vuex module name
    registerComponent: true, // Registers `v-wait` component
    componentName: 'v-wait', // <v-wait> component name, you can set `my-loader` etc.
    registerDirective: true, // Registers `v-wait` directive
    directiveName: 'wait' // <span v-wait /> directive name, you can set `my-loader` etc.

  })
}, __WEBPACK_IMPORTED_MODULE_18__App__["a" /* default */]));

/***/ }),

/***/ "NKB3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lockTokens_vue__ = __webpack_require__("xnnc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a32956c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lockTokens_vue__ = __webpack_require__("UzX3");
function injectStyle (ssrContext) {
  __webpack_require__("J79C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a32956c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lockTokens_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a32956c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lockTokens_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NS6T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lineChart__ = __webpack_require__("7rHV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listItem__ = __webpack_require__("5Y0+");



/* harmony default export */ __webpack_exports__["a"] = ({
  LineChart: __WEBPACK_IMPORTED_MODULE_0__lineChart__["a" /* default */],
  ListItem: __WEBPACK_IMPORTED_MODULE_1__listItem__["a" /* default */]
});

/***/ }),

/***/ "NXt2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Neyk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_dynamicSize__ = __webpack_require__("KOBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_assets__ = __webpack_require__("SjBe");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var COLORS = {
  crypto: 'green',
  ico: 'lime-green',
  stock: 'blue',
  ipo: 'cyan',
  startup: 'violet'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ec-buy-list",
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_dynamicSize__["a" /* default */]],
  filters: {
    formatPrice: function formatPrice(price) {
      price = parseFloat(price);
      if (price <= 10) {
        return price.toFixed(6);
      } else if (price <= 50) {
        return price.toFixed(4);
      }

      return price.toFixed(2);
    }
  },
  data: function data() {
    return {
      isLoading: true,
      currenciesList: [],
      buyAmount: [],
      currenciesListFields: ['currency', 'price', 'rate', 'emixtier', 'actions']
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('orders', ['createOrder']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])('orders', ['setShowBuyModal', 'setBuyModalData']), {
    convertRate: function convertRate(rate) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_assets__["a" /* convertRateToEmixtier */])(rate);
    },
    buyCurrency: function buyCurrency(index) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var asset;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                asset = _this.currenciesList[index];

                _this.setBuyModalData({ asset: asset, amount: _this.buyAmount[index], currency: 'USD' });
                _this.setShowBuyModal(true);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onSeeAllClick: function onSeeAllClick() {
      this.$router.push({ name: 'trading-buy' });
    }
  }),
  computed: {
    maxAmount: function maxAmount() {
      return 5000;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.isLoading = true;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* default */].Coins.fetchTradingAssets('crypto');

            case 3:
              _this2.currenciesList = _context2.sent.slice(0, 5);


              _this2.buyAmount = _this2.currenciesList.map(function (i) {
                return 0;
              });

              _this2.isLoading = false;

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ "Nfsp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    visible: Boolean,
    for: [String, Array],
    message: String,
    transition: String,
    duration: Number,
    mode: {
      type: String,
      default: 'out-in'
    },
    enterClass: {
      type: String,
      default: 'enter'
    },
    enterActiveClass: {
      type: String,
      default: 'enter-active'
    },
    enterToClass: {
      type: String,
      default: 'enter-to'
    },
    leaveClass: {
      type: String,
      default: 'leave'
    },
    leaveActiveClass: {
      type: String,
      default: 'leave-active'
    },
    leaveToClass: {
      type: String,
      default: 'leave-to'
    }
  },
  methods: {
    transitionClass: function transitionClass(className) {
      return this.transition + '-' + className;
    }
  },
  computed: {
    waitsFor: function waitsFor() {
      if (this.visible) {
        return this.visible;
      }
      if (this.for) {
        return this.__$waitInstance.is(this.for);
      }
      return this.__$waitInstance.any;
    }
  }
});

/***/ }),

/***/ "O6tT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "step-payment-method",
  components: {},
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])("orders", ["getPaymentInfo"]), {
    nextPage: function nextPage(type) {
      this.$emit('nextPage', type);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])("orders", {
    orderData: 'buyModalData'
  }), {
    total: function total() {
      return (this.orderData.amount / this.orderData.asset.price.value).toFixed(6);
    }
  }),
  mounted: function mounted() {
    // this.fetchCoins();
  }
});

/***/ }),

/***/ "OXYJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OZJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.id,staticClass:"e-chat__item",class:("e-chat__item--" + _vm.type)},[_c('div',{staticClass:"e-chat__message"},[_c('div',{staticClass:"e-chat__text",domProps:{"innerHTML":_vm._s(_vm.message.text)}}),_vm._v(" "),_c('div',{staticClass:"e-avatar size-24 e-chat__avatar"},[_c('img',{attrs:{"src":_vm.subject.avatar}})])]),_vm._v(" "),_c('div',{staticClass:"e-chat__time"},[_vm._v(_vm._s(_vm.formattedDate))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Obzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chat__ = __webpack_require__("m+09");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__chat__["a" /* default */]);

/***/ }),

/***/ "Ofui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-topbar"},[_c('ul',{staticClass:"list-items"},[_c('li',{staticClass:"item mobile-menu-toggle"},[_c('button',{staticClass:"mobile-menu-button",attrs:{"type":"button","aria-expanded":_vm.mobileMenuOpen ? 'true' : 'false',"aria-label":"Toggle menu"},on:{"click":function($event){return _vm.$emit('toggleMobileMenu')}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"item go-back"},[_c('e-button',{attrs:{"type":"link"},on:{"click":function($event){return _vm.$router.back()}}},[_c('img',{attrs:{"src":"/static/icons/topbar-arrow-left.svg"}})])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.pageTitle)?_c('li',{staticClass:"item page-title"},[_c('a',{staticClass:"link",attrs:{"href":"#"}},[_vm._v("\n          "+_vm._s(_vm.pageTitle)+"\n        ")])]):_vm._e()])],1),_vm._v(" "),_c('ul',{staticClass:"list-items align-right"},[_c('li',{staticClass:"item notifications-item",attrs:{"data-v-step":"2"}},[_c('b-dropdown',{ref:"notifyDropdown",staticClass:"e-dropdown notify-dropdown",class:{'notify-dropdown-loading': _vm.loading},attrs:{"offset":_vm.calculatedOffset,"right":"","toggle-class":"e-dropdown__toggle","menu-class":"e-dropdown__menu e-dropdown__menu--center"},on:{"show":_vm.updateActivityList}},[_c('template',{staticClass:"link",slot:"button-content"},[_c('img',{attrs:{"src":__webpack_require__("aWB/")}}),_vm._v(" "),(_vm.user.notificationCount > 0)?_c('e-badge',{attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.user.notificationCount))]):_vm._e()],1),_vm._v(" "),_vm._l((_vm.activity),function(item){return _c('b-dropdown-item',{key:item.id,staticClass:"e-dropdown__item notify-dropdown-item",on:{"click":function($event){return _vm.goTo('activity')}}},[_c('div',{staticClass:"activity-image"},[_c('img',{attrs:{"src":item.image}})]),_vm._v(" "),_c('div',{staticClass:"activity-content"},[_c('h3',[_vm._v(_vm._s(item.message))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formattedDate(item.date)))])])])}),_vm._v(" "),_c('b-dropdown-item',{staticClass:"e-dropdown__item notify-dropdown-item notify-button",on:{"click":function($event){return _vm.goTo('activity')}}},[_c('span',[_vm._v("See all")])])],2)],1),_vm._v(" "),_c('li',{staticClass:"item balance-item",attrs:{"data-v-step":"1"}},[_c('a',{staticClass:"link",attrs:{"href":"#"}},[_c('div',{staticClass:"link-content"},[_vm._v("\n          Balance: "),_c('span',{staticClass:"eh-text-blue-light font-weight-bold"},[_vm._v(_vm._s(_vm.user.balance || 0)+" EMiX")])])])]),_vm._v(" "),_c('li',{staticClass:"item user-item"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('b-dropdown',{key:"user-data",staticClass:"e-dropdown e-topbar__dropdown",attrs:{"offset":-40,"right":"","toggle-class":"e-dropdown__toggle e-topbar__dropdown-toggle","menu-class":"e-dropdown__menu e-dropdown__menu--top e-topbar__dropdown-menu"}},[(!_vm.$wait.is('auth.fetchUserData'))?_c('template',{slot:"button-content"},[(_vm.isAuth)?[_c('div',{staticClass:"e-avatar"},[_c('img',{attrs:{"src":'https://randomuser.me/api/portraits/men/34.jpg'}})]),_vm._v(" "),_c('div',{staticClass:"e-topbar__text"},[_c('div',{staticClass:"e-topbar__username"},[_vm._v(_vm._s(_vm.fullname))]),_vm._v(" "),_c('small',{staticClass:"eh-secondary-text"},[_vm._v("24 th")])])]:[_c('e-button',{attrs:{"type":"link"}},[_vm._v("Login")])]],2):_c('template',{slot:"button-content"},[_c('div',{staticClass:"e-avatar fake"}),_vm._v(" "),_c('div',{staticClass:"e-topbar__text"},[_c('div',{staticClass:"e-topbar__username e-mock e-mock__text"}),_vm._v(" "),_c('small',{staticClass:"eh-secondary-text e-mock e-mock__text e-mock--size--small"})])]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"e-dropdown__item",on:{"click":function($event){return _vm.goTo('account')}}},[_vm._v("Account")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"e-dropdown__item",on:{"click":_vm.handleLogout}},[_vm._v("Logout")])],2)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ozyv":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiNFNEVDRjMiIGQ9Ik0xNC4yODYgMEgxLjcxNEMuNzcgMCAwIC43NyAwIDEuNzE0djEyLjU3MkMwIDE1LjIzLjc3IDE2IDEuNzE0IDE2aDEyLjU3MkMxNS4yMyAxNiAxNiAxNS4yMyAxNiAxNC4yODZWMS43MTRDMTYgLjc3IDE1LjIzIDAgMTQuMjg2IDB6TTEuNzE0IDEuMTQzaDEyLjU3MmMuMzE1IDAgLjU3MS4yNTYuNTcxLjU3MXY1LjE0M0gxLjE0M1YxLjcxNGMwLS4zMTUuMjU2LS41NzEuNTcxLS41NzF6bTEyLjU3MiAxMy43MTRIMS43MTRhLjU3Mi41NzIgMCAwIDEtLjU3MS0uNTcxVjhoMTMuNzE0djYuMjg2YS41NzIuNTcyIDAgMCAxLS41NzEuNTcxeiIvPgogICAgPHBhdGggZmlsbD0iI0U0RUNGMyIgZD0iTTcuNDI5IDExLjA0OGg1LjcxNGEuNTcxLjU3MSAwIDEgMCAwLTEuMTQzSDcuNDI5YS41NzEuNTcxIDAgMSAwIDAgMS4xNDN6TTcuMjM4IDEzLjMzM2gzLjgxYy4yMSAwIC4zOC0uMjU1LjM4LS41NzEgMC0uMzE2LS4xNy0uNTcyLS4zOC0uNTcyaC0zLjgxYy0uMjEgMC0uMzguMjU2LS4zOC41NzIgMCAuMzE2LjE3LjU3MS4zOC41NzF6TTQgMTMuMzMzYy45NDUgMCAxLjcxNC0uNzY5IDEuNzE0LTEuNzE0UzQuOTQ1IDkuOTA1IDQgOS45MDVzLTEuNzE0Ljc2OS0xLjcxNCAxLjcxNC43NjkgMS43MTQgMS43MTQgMS43MTR6bTAtMi4yODVhLjU3Mi41NzIgMCAxIDEtLjAwMSAxLjE0NEEuNTcyLjU3MiAwIDAgMSA0IDExLjA0OHpNMi44NTcgNC41NzFoNS43MTRhLjU3MS41NzEgMCAxIDAgMC0xLjE0MkgyLjg1N2EuNTcxLjU3MSAwIDEgMCAwIDEuMTQyek0xMiA1LjcxNGMuOTQ1IDAgMS43MTQtLjc2OSAxLjcxNC0xLjcxNFMxMi45NDUgMi4yODYgMTIgMi4yODYgMTAuMjg2IDMuMDU1IDEwLjI4NiA0IDExLjA1NSA1LjcxNCAxMiA1LjcxNHptMC0yLjI4NWEuNTcyLjU3MiAwIDEgMS0uMDAxIDEuMTQ0QS41NzIuNTcyIDAgMCAxIDEyIDMuNDI5eiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "P3UP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P7vv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu-item"},[(!_vm.route)?_c('a',{staticClass:"item-link",class:_vm.linkClasses,attrs:{"href":"#"},on:{"click":_vm.onClickItem}},[_c('div',{staticClass:"item-prepend"},[_vm._t("prepend",function(){return [(_vm.icon)?_c('img',{staticClass:"item-icon",attrs:{"src":_vm.getImg}}):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._t("default",function(){return [_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")]})],2),_vm._v(" "),_c('div',{staticClass:"item-append"},[_vm._t("append",function(){return [(_vm.badge !== undefined)?_c('span',{staticClass:"e-badge",class:_vm.badge.class || []},[_vm._v(_vm._s(_vm.badge.value || _vm.badge))]):_vm._e()]})],2)]):_vm._e(),_vm._v(" "),(_vm.route)?_c('router-link',{staticClass:"item-link",class:_vm.linkClasses,attrs:{"to":typeof _vm.route === 'string' ? {name: _vm.route} : _vm.route,"active-class":"active"},on:{"click":_vm.onClickItem}},[_c('div',{staticClass:"item-prepend"},[_vm._t("prepend",function(){return [(_vm.icon)?_c('img',{staticClass:"item-icon",attrs:{"src":_vm.getImg}}):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.label))])]})],2),_vm._v(" "),_c('div',{staticClass:"item-append"},[_vm._t("append",function(){return [(_vm.badge !== undefined)?_c('span',{staticClass:"e-badge",class:_vm.badge.class || []},[_vm._v(_vm._s(_vm.badge.value || _vm.badge))]):_vm._e()]})],2)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PKqg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PLmV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "POuU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-card',{staticClass:"assets-list-wizard",class:_vm.sizeClasses,attrs:{"data-v-step":"4"},on:{"toggleDrag":function($event){return _vm.$emit('toggleDrag')}}},[_c('b-tab',{staticClass:"e-card__content",attrs:{"title":"Crypto"}},[(!_vm.$wait.is('assets.fetchSectors') && _vm.isLoaded)?_c('b-table',{staticClass:"e-table e-table--bg--white e-table--padding--small",attrs:{"responsive":"","hover":"","fields":_vm.assetsListTableFields,"items":_vm.assets},on:{"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"HEAD_project",fn:function(data){return [_vm._v("\n        Projects\n      ")]}},{key:"HEAD_sector",fn:function(data){return [_vm._v("\n        Sector\n      ")]}},{key:"HEAD_rates",fn:function(data){return [_vm._v("\n        Rates\n      ")]}},{key:"HEAD_rate",fn:function(data){return [_vm._v("\n        Score\n      ")]}},{key:"HEAD_actions",fn:function(data){return [_vm._v("\n        Actions\n      ")]}},{key:"project",fn:function(data){return [_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"e-avatar size-30 mr-4"},[_c('img',{attrs:{"src":data.item.logoPath}})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('b',[_vm._v(_vm._s(data.item.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.item.symbol))])])])]}},{key:"sector",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("shortText")(_vm.flattenSector(data.item.sectors, data.item)))+"\n      ")]}},{key:"rates",fn:function(data){return [_c('b',[_vm._v(_vm._s(data.item.totalRaters))]),_vm._v(" / "+_vm._s(data.item.totalModerations || 0)+"\n      ")]}},{key:"rate",fn:function(data){return [_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(data.item.rate === 0 ? 'N/A' : data.item.rate)+" "+_vm._s(data.item.rate === 0 ? '' : ("(" + (_vm.convertRate(data.item.rate)) + ")")))])]}},{key:"actions",fn:function(data){return [_c('div',{staticClass:"d-flex flex-row"},[_c('e-button',{staticClass:"px-3",attrs:{"type":"outlined","color":"blue-light","size":"smaller","data-v-step":data.index === 0 ? 5 : null},on:{"click":function (e) { return _vm.onRateClick(data.item, e); }}},[_vm._v("Rate")]),_vm._v(" "),_c('e-button',{staticClass:"ml-3 px-3",attrs:{"type":"outlined","color":"blue-light","size":"smaller","data-v-step":data.index === 0 ? 6 : null},on:{"click":function (e) { return _vm.onModerateClick(data.item, e); }}},[_vm._v("Moderate")])],1)]}}],null,false,2397611317)}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"e-btn see-all",on:{"click":function($event){return _vm.onSeeAllClick('crypto')}}},[_vm._v("See All")])],1),_vm._v(" "),_c('b-tab',{staticClass:"e-card__content",attrs:{"title":"Stock"}},[(!_vm.$wait.is('assets.fetchSectors') && _vm.isLoaded)?_c('b-table',{staticClass:"e-table e-table--bg--white e-table--padding--small",attrs:{"responsive":"","hover":"","fields":_vm.assetsListTableFields,"items":_vm.assetsStock},on:{"row-clicked":_vm.rowClicked},scopedSlots:_vm._u([{key:"HEAD_project",fn:function(data){return [_vm._v("\n        Projects\n      ")]}},{key:"HEAD_sector",fn:function(data){return [_vm._v("\n        Sector\n      ")]}},{key:"HEAD_rates",fn:function(data){return [_vm._v("\n        Rates\n      ")]}},{key:"HEAD_rate",fn:function(data){return [_vm._v("\n        Score\n      ")]}},{key:"HEAD_actions",fn:function(data){return [_vm._v("\n        Actions\n      ")]}},{key:"project",fn:function(data){return [_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"e-avatar size-30 mr-4"},[_c('img',{attrs:{"src":data.item.logoPath}})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('b',[_vm._v(_vm._s(data.item.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(data.item.symbol))])])])]}},{key:"sector",fn:function(data){return [_vm._v("\n        "+_vm._s(_vm._f("shortText")(_vm.flattenSector(data.item.sectors, data.item)))+"\n      ")]}},{key:"rates",fn:function(data){return [_c('b',[_vm._v(_vm._s(data.item.totalRaters))]),_vm._v(" / "+_vm._s(data.item.totalModerations || 0)+"\n      ")]}},{key:"rate",fn:function(data){return [_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(data.item.rate === 0 ? 'N/A' : data.item.rate)+" "+_vm._s(data.item.rate === 0 ? '' : ("(" + (_vm.convertRate(data.item.rate)) + ")")))])]}},{key:"actions",fn:function(data){return [_c('div',{staticClass:"d-flex flex-row"},[_c('e-button',{staticClass:"px-3",attrs:{"type":"outlined","color":"blue-light","size":"smaller","data-v-step":data.index === 0 ? 5 : null},on:{"click":function (e) { return _vm.onRateClick(data.item, e); }}},[_vm._v("Rate")]),_vm._v(" "),_c('e-button',{staticClass:"ml-3 px-3",attrs:{"type":"outlined","color":"blue-light","size":"smaller","data-v-step":data.index === 0 ? 6 : null},on:{"click":function (e) { return _vm.onModerateClick(data.item, e); }}},[_vm._v("Moderate")])],1)]}}],null,false,2397611317)}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"e-btn see-all",on:{"click":function($event){return _vm.onSeeAllClick('stock')}}},[_vm._v("See All")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PPHu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_chat_chat__ = __webpack_require__("m+09");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_card_card__ = __webpack_require__("tqXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_dynamicSize__ = __webpack_require__("KOBJ");
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ec-chat",
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_dynamicSize__["a" /* default */]],
  components: { ECard: __WEBPACK_IMPORTED_MODULE_1__elements_card_card__["a" /* default */], EbChat: __WEBPACK_IMPORTED_MODULE_0__widgets_chat_chat__["a" /* default */] }
});

/***/ }),

/***/ "PV91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moderate__ = __webpack_require__("LYHe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__steps__ = __webpack_require__("IQYR");



/* harmony default export */ __webpack_exports__["a"] = ({
  Moderate: __WEBPACK_IMPORTED_MODULE_0__moderate__["default"], Steps: __WEBPACK_IMPORTED_MODULE_1__steps__["a" /* default */]
});

/***/ }),

/***/ "PnJR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__evaluation__ = __webpack_require__("R3zG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__finish__ = __webpack_require__("kLh0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services__ = __webpack_require__("+vOg");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-rate-step-write",
  components: { EmRateFinish: __WEBPACK_IMPORTED_MODULE_5__finish__["a" /* default */], EmRateEvaluation: __WEBPACK_IMPORTED_MODULE_4__evaluation__["a" /* default */] },
  props: {
    assetId: String,
    modalId: String
  },
  watch: {
    assetId: {
      handler: function handler(current) {
        this.asset = this.getAsset(current);
        this.changeTitle();
      },

      immediate: true
    }
  },
  data: function data() {
    return {
      currentStep: 1,
      lockedTokens: 0,
      acceptRules: false,
      isFinished: false,
      asset: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('rate', {
    changeEvaluation: 'changeEvaluation'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('assets', {
    getCriterion: 'criterion'
  }), {
    onEditCriterion: function onEditCriterion(step) {
      this.currentStep = step;
    },
    changeStep: function changeStep(step) {
      this.$emit('changeStep', step);
    },
    onNextClick: function onNextClick() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.currentStep - _this.criteria.length === 2)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__services__["a" /* default */].Rates.createRate({
                  assetId: _this.assetId,
                  lockedTokens: _this.lockedModel.locked,
                  criteria: _this.getCurrentCreateRateCriteria.map(function (id) {
                    var criterion = _this.getCriterion(id);
                    var criterionId = criterion && criterion.id != null ? criterion.id : id;
                    var isNew = typeof criterionId === 'string' && criterionId.indexOf('new_') === 0;

                    var c = {
                      evaluate: _this.getCriterionEvaluation(id),
                      justification: _this.getCriterionJustification(id)
                    };

                    if (isNew) {
                      c.title = criterion.title;
                    } else {
                      c.id = criterionId;
                    }

                    return c;
                  })
                });

              case 3:

                _this.isFinished = true;

                // this.$emit('closeModal');
                return _context.abrupt("return");

              case 5:

                _this.currentStep++;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onPreviewClick: function onPreviewClick() {
      if (this.currentStep === 1) {
        this.$emit('previewStep');
      } else {
        this.currentStep--;
      }
    },
    changeTitle: function changeTitle() {
      this.$emit('changeTitle', "Rate " + this.asset.name);
    },
    closeModal: function closeModal() {
      this.$emit('closeModal');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('rate', ['getCurrentCreateRateCriteria', 'getCriterionEvaluation', 'getCriterionJustification']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('assets', {
    getAsset: 'asset',
    getCriterion: 'criterion'
  }), {

    lockedModel: {
      get: function get() {
        return {
          locked: this.lockedTokens,
          rules: this.acceptRules,
          disabled: false
        };
      },
      set: function set(value) {
        this.lockedTokens = value.locked;
        this.acceptRules = value.rules;
      }
    },

    nextBtnDisabled: function nextBtnDisabled() {
      if (this.currentStep <= this.criteria.length) {
        return this.getCriterionJustification(this.criteria[this.currentStep - 1].id).length === 0;
      }

      if (this.currentStep === this.criteria.length + 1) {
        return !(this.lockedTokens > 0 && this.acceptRules);
      }
    },
    criteria: function criteria() {
      var _this2 = this;

      return this.getCurrentCreateRateCriteria.map(function (id) {
        return _this2.getCriterion(id);
      });
    },
    breadcrumb: function breadcrumb() {
      var _this3 = this;

      var criteria = this.criteria;

      return criteria.map(function (c, i) {
        return {
          value: c.title,
          active: _this3.currentStep > i + 1,
          current: _this3.currentStep === i + 1
        };
      }).concat([{
        value: 'Lock tokens',
        active: this.currentStep > criteria.length + 1,
        current: this.currentStep === criteria.length + 1
      }, {
        value: 'Finish',
        active: this.currentStep > criteria.length + 2,
        current: this.currentStep === criteria.length + 2
      }]);
    }
  })
});

/***/ }),

/***/ "PyWm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function debounce(fn) {
  var waiting = void 0;
  return function () {
    if (waiting) return;
    waiting = true;
    var context = this,
        args = arguments;
    var later = function later() {
      waiting = false;
      fn.apply(context, args);
    };
    this.$nextTick(later);
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-steps",
  props: ['current'],
  data: function data() {
    return {
      stepsComponents: []
    };
  },

  computed: {
    steps: function steps() {
      return this.stepsComponents.map(function (c, i) {
        return {
          label: c.label,
          number: i + 1
        };
      });
    }
  },
  watch: {
    current: {
      handler: function handler(val) {
        this.updateChildProps(true);
        this.$emit('changeStep', val);
      },

      immediate: true
    }
  },
  methods: {
    updateChildProps: function updateChildProps(isInit) {
      var _this = this;

      this.stepsComponents = this.$children;
      this.$children.forEach(function (child, index) {
        child.stepNumber = index + 1;

        if (!(isInit && child.currentStatus)) {
          if (index == _this.current) {
            if (_this.status != 'error') {
              child.currentStatus = 'process';
            }
          } else if (index < _this.current) {
            child.currentStatus = 'finish';
          } else {
            child.currentStatus = 'wait';
          }
        }
        if (child.currentStatus != 'error' && index != 0) {
          _this.$children[index - 1].nextError = false;
        }

        child.isVisible = index + 1 === _this.current;
      });
    },
    updateCurrent: function updateCurrent(isInit) {
      if (this.current < 0 || this.current >= this.$children.length) {
        return;
      }

      // this.$children[this.current].isVisible = true;

      // if (isInit) {
      //   const current_status = this.$children[this.current].currentStatus;
      //   if (!current_status) {
      //     this.$children[this.current].currentStatus = this.status;
      //   }
      // } else {
      //   this.$children[this.current].currentStatus = this.status;
      // }
    },
    debouncedAppendRemove: function debouncedAppendRemove() {
      return debounce(function () {
        this.updateSteps();
      });
    },
    updateSteps: function updateSteps() {
      this.updateChildProps(true);
      this.updateCurrent(true);
    }
  },
  mounted: function mounted() {
    this.updateSteps();
    this.$on('append', this.debouncedAppendRemove());
    this.$on('remove', this.debouncedAppendRemove());
  }
});

/***/ }),

/***/ "Q49I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__topbar__ = __webpack_require__("hm1K");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__topbar__["a" /* default */]);

/***/ }),

/***/ "QERB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-card',{staticClass:"kyc-wizard",class:_vm.sizeClasses,attrs:{"data-v-step":"8"},on:{"toggleDrag":function($event){return _vm.$emit('toggleDrag')}}},[(!_vm.loading)?_c('b-tab',{staticClass:"e-card__content",attrs:{"title":"KYC Status"}},[_c('p',[_vm._v("The KYC procedure is a simple online process of identification. Participants will need to provide a high-quality image of a passport or government-issued ID.")]),_vm._v(" "),_c('p',[_vm._v("Complete your KYC verification and start buying crypto with us!")]),_vm._v(" "),_c('e-button',{on:{"click":_vm.showKycModal}},[_vm._v(_vm._s(_vm.buttonText))]),_vm._v(" "),_c('p',{staticClass:"limit"},[_vm._v("Current trading limit: "),_c('b',[_vm._v("$"+_vm._s(_vm.tradingLimit))])]),_vm._v(" "),_c('e-hint',{attrs:{"title":"Note:"}},[_vm._v("\n      Economix is implementing the KYC procedure to address concerns from specific countries regulators. Our team also believes that it symbolizes better business practice and it is beneficial to all parties!\n    ")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QO7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rate_vue__ = __webpack_require__("0BYS");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10ce5ab6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rate_vue__ = __webpack_require__("xryl");
function injectStyle (ssrContext) {
  __webpack_require__("oZ5M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10ce5ab6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10ce5ab6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QOex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.name;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
});

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  mock: {
    auth: false,
    assets: false,
    coins: false,
    orders: true,
    rates: true,
    ui: true,
    moderation: true
  },
  services: {

    // Route auth through the app worker in production so stubbed API responses stay same-origin.
    auth:  true ? 'https://app.economix.ai' : 'http://localhost:3006',
    // rating: 'https://app.economix.ai',
    rating:  true ? 'https://app.economix.ai' : 'http://localhost:3008',
    // order: 'https://app.economix.ai',
    order:  true ? 'https://orders.economix.ai' : 'http://localhost:3013',
    mobile:  true ? 'https://mobile.economix.ai' : 'http://localhost:3005'
  }
});

/***/ }),

/***/ "R06g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"payment-step"},[_c('b-col',{staticClass:"select-block",attrs:{"cols":"6"}},[_c('div',{staticClass:"payment-title"},[_vm._v("Wire / Bank Transfer")]),_vm._v(" "),_c('p',[_vm._v("\n      You will be billed and must be paid through a bank. By specifying the order number in the comments. After payment within a short time, the amount of "+_vm._s(_vm.total)+" "+_vm._s(_vm.orderData.asset.symbol)+" will be transferred to the address you specified to receive "+_vm._s(_vm.orderData.asset.name)+"\n    ")]),_vm._v(" "),_c('e-button',{on:{"click":function($event){return _vm.nextPage('transfer')}}},[_vm._v("Choose")])],1),_vm._v(" "),_c('b-col',{staticClass:"select-block",attrs:{"cols":"6"}},[_c('div',{staticClass:"payment-title"},[_vm._v("Credit or Debit Card (Soon)")]),_vm._v(" "),_c('p',[_vm._v("Simple and fast payment without additional confirmation using a credit or debit card. Cryptocurrency comes immediately after payment.")]),_vm._v(" "),_c('p',[_vm._v("Will be available soon!")]),_vm._v(" "),_c('e-button',{attrs:{"disabled":""}},[_vm._v("Choose")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R3zG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_evaluation_vue__ = __webpack_require__("hYU/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0992fda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_evaluation_vue__ = __webpack_require__("9x+c");
function injectStyle (ssrContext) {
  __webpack_require__("2hJb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0992fda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_evaluation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0992fda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_evaluation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R6Jc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_card_card__ = __webpack_require__("tqXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_dynamicSize__ = __webpack_require__("KOBJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ec-chart",
  components: { ECard: __WEBPACK_IMPORTED_MODULE_0__elements_card_card__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_dynamicSize__["a" /* default */]],
  computed: {
    options: function options() {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          height: '100%'
          // width: '100%',
        },
        tooltip: {
          useHTML: true,
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
          shadow: true,
          formatter: function formatter() {
            var render = void 0;

            render = '<div class="e-pie-chart__tooltip">' + '<div class="e-pie-chart__logo e-avatar size-30">' + '<img src="/static/assets/bitcoin.svg">' + '</div>' + '<div class="e-pie-chart__info">' + ('<div class="e-pie-chart__asset">' + this.key + '</div>') + ('<div class="e-pie-chart__value">' + this.y + '%</div>') + '</div>' + '</div>';

            return render;
          }
        },
        title: {
          text: '<span>2 340</span><br/>Contribution <br/>Pts.',
          useHTML: false,
          align: 'center',
          verticalAlign: 'middle',
          y: -15
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            size: '100%',
            // colors: ['#00c2ff', '#ff5656', '#ffab48', '#6248ff', '#ff48ab', '#00e3ba'],
            colors: ['#0e3d60', '#0e4b6e', '#0e648c', '#116091', '#1472ad', '#1490cb'],
            dataLabels: {
              enabled: true,
              useHTML: true,
              format: '{point.y}%',
              distance: -30,
              inside: true,
              className: 'pie-chart-label'
            }
          }
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'Share',
          innerSize: '48%',
          data: [{ name: 'Bitcoin', y: 36 }, { name: 'Litecoin', y: 27 }, { name: 'Ethereum', y: 14 }, { name: 'Bitcoin Cash', y: 9 }, { name: 'Lisk', y: 4 }, { name: 'Other', y: 10 }]
        }]
      };
    },
    optionsLine: function optionsLine() {
      return {
        chart: {
          type: 'line',
          scrollablePlotArea: {
            minWidth: 700,
            scrollPositionX: -1
          },
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        tooltip: {
          shared: true
        },
        xAxis: {
          gridLineWidth: 0,
          lineWidth: 0,
          tickWidth: 0,
          categories: ['13.07', '14.07', '15.07', '16.07', '17.07', '18.07', '19.07', '20.07', '21.07', '22.07', '23.07', '24.07', '25.07', '26.07', '27.07'],
          tickmarkPlacement: 'on',
          title: {
            text: ''
          }
        },
        yAxis: {
          gridLineWidth: 0,
          title: {
            text: ''
          }
        },
        colors: ['#00c2ff', '#ff5656', '#ffab48', '#6248ff', '#ff48ab', '#00e3ba'],
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false
            }
          }
        },
        series: [{
          name: 'Bitcoin',
          marker: {
            enabled: false
          },
          data: [7.0, 6.9, 9.5, 14.5, 18.4, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6, 10, 10, 10, 10, 11],
          type: "spline"
        }, {
          name: 'Ethereum',
          marker: {
            enabled: false
          },
          data: [3.9, 4.2, 5.7, 8.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 6.6, 4.8, 3, 5, 6, 7, 8],
          type: "spline"
        }]
      };
    }
  },
  methods: {
    reflow: function reflow() {
      var chart = this.$refs.piChart.chart;

      this.$nextTick(function () {
        chart.reflow();
      });
    }
  },
  beforeCreate: function beforeCreate() {
    this.$root.$on('ex::sidebar::toggleMenu', this.reflow);
  }
});

/***/ }),

/***/ "RcyS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ru/V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S0zI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basic_vue__ = __webpack_require__("eEWW");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_477dda72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basic_vue__ = __webpack_require__("YRNT");
function injectStyle (ssrContext) {
  __webpack_require__("/8TB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_477dda72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SSdR":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./basic.vue": "S0zI",
	"./clear.vue": "bKF4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SSdR";

/***/ }),

/***/ "SZfz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
		name: "e-hint",
		props: {
				title: String
		}
});

/***/ }),

/***/ "SjBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = convertRateToEmixtier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



function convertRateToEmixtier(rate) {
  var scale = {
    'AAA': function AAA(v) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.inRange(v, 9.5, 10);
    },
    'AA': function AA(v) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.inRange(v, 8.5, 9.5);
    },
    'A': function A(v) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.inRange(v, 7.5, 8.5);
    },
    'BBB': function BBB(v) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.inRange(v, 6.5, 7.5);
    },
    'BB': function BB(v) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.inRange(v, 5.5, 6.5);
    },
    'B': function B(v) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.inRange(v, 4.5, 5.5);
    },
    'CCC': function CCC(v) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.inRange(v, 3.5, 4.5);
    },
    'CC': function CC(v) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.inRange(v, 2.5, 3.5);
    },
    'C': function C(v) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.inRange(v, 1.5, 2.5);
    },
    'SM': function SM(v) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.inRange(v, 0, 1.5);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(scale).reverse().find(function (e) {
    return scale[e](rate);
  });
}

/***/ }),

/***/ "T4CU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "t-card",
  props: ["coin"],
  data: function data() {
    return {
      amount: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])("coins", ["smallAllCoins"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])("orders", ["createOrder"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    expandCoin: function expandCoin(coin) {
      this.smallAllCoins(this.coin, this.small);
    },
    checkActiveAmount: function checkActiveAmount() {},
    getMaxForTier: function getMaxForTier() {
      return 5000;
    },
    buyOrder: function buyOrder(coin) {
      console.log("createOrder");
      this.createOrder({ coin: this.coin, currency: "USD" });
    }
  }, "checkActiveAmount", function checkActiveAmount(coin) {})),
  computed: {
    slideWidth: function slideWidth() {
      return "calc(" + this.amount / (this.getMaxForTier() / 100) + "% - " + 22 / this.getMaxForTier() * this.amount + "px)";
    },
    computeResult: function computeResult() {
      return this.amount / this.coin.price.value;
    },
    currentPrice: function currentPrice() {
      return this.coin.price.value.toFixed(2);
    },
    getImage: function getImage() {
      return this.logoPath;
    }
  }
});

/***/ }),

/***/ "THyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  menuIsOpen: true,
  pageTitle: '',
  paymentState: "",
  isShowKyc: false
};

// getters
var getters = {
  menuIsOpen: function menuIsOpen(state, getters, root) {
    return state.menuIsOpen;
  },
  pageTitle: function pageTitle(state, getters, root) {
    return state.pageTitle;
  },
  paymentState: function paymentState(state, getters, root) {
    return state.paymentState;
  },
  isShowKyc: function isShowKyc(s) {
    return s.isShowKyc;
  }
};

// actions
var actions = {
  toggleMenu: function toggleMenu(_ref, data) {
    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;

    commit('toggleMenu', data);
  },
  setPageTitle: function setPageTitle(_ref2, title) {
    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;

    commit('setPageTitle', title);
  },
  setPaymentState: function setPaymentState(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;

    commit('setPaymentState', data);
  }
};

// mutations
var mutations = {
  toggleMenu: function toggleMenu(state, flag) {
    state.menuIsOpen = flag;
  },
  setPageTitle: function setPageTitle(state, title) {
    state.pageTitle = title;
  },
  setPaymentState: function setPaymentState(state, statename) {
    state.paymentState = statename;
  },
  setShowKyc: function setShowKyc(state, v) {
    state.isShowKyc = v;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "TIZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-finish"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-tabs',{staticClass:"e-tabs",attrs:{"nav-wrapper-class":"e-tabs__header","nav-class":"e-tabs__nav-tabs","content-class":"e-tabs__nav-item"}},_vm._l((_vm.criteria),function(criterion,i){return _c('b-tab',{key:criterion.id,attrs:{"title":((_vm.criterionEval(criterion.id).toFixed(1)) + "  |  " + (criterion.title))}},[_c('b-row',{staticClass:"e-view-rate"},[_c('b-col',{attrs:{"cols":"9"}},[_c('div',{staticClass:"eval",on:{"click":function($event){return _vm.onEditClick(i)}}},[_vm._v("\n                "+_vm._s(_vm.criterionEval(criterion.id).toFixed(1))+"\n                "),_c('div',{staticClass:"edit"},[_c('i',{staticClass:"fas fa-pen"})])]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n                "+_vm._s(_vm.criterionJustification(criterion.id))+"\n              ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('em-asset-average-score',{attrs:{"score":_vm.averageEvaluation.toFixed(1)}},[_vm._v("Average score of you rating")])],1)],1)],1)}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TKeN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hint_vue__ = __webpack_require__("SZfz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e6fd49_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hint_vue__ = __webpack_require__("vMY6");
function injectStyle (ssrContext) {
  __webpack_require__("M7es")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48e6fd49"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e6fd49_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TY8e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__ = __webpack_require__("R6Jc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2a1f248_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__ = __webpack_require__("wE/A");
function injectStyle (ssrContext) {
  __webpack_require__("KS/K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2a1f248_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TcSE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var generateTemplateString = function () {
  var cache = {};

  function generateTemplate(template) {
    var fn = cache[template];

    if (!fn) {
      // Replace ${expressions} (etc) with ${map.expressions}.

      var sanitized = template.replace(/\$\{([\s]*[^;\s\{]+[\s]*)\}/g, function (_, match) {
        return '${map.' + match.trim() + '}';
      })
      // Afterwards, replace anything that's not ${map.expressions}' (etc) with a blank string.
      .replace(/(\$\{(?!map\.)[^}]+\})/g, '');

      fn = Function('map', 'return `' + sanitized + '`');
    }

    return fn;
  }

  return generateTemplate;
}();

/* harmony default export */ __webpack_exports__["a"] = (generateTemplateString);

/***/ }),

/***/ "TdRy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__("r+CK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b4111a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__("beVx");
function injectStyle (ssrContext) {
  __webpack_require__("E2OI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40b4111a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b4111a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TzeR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepWiretransfer_vue__ = __webpack_require__("cJmQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c9b1fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepWiretransfer_vue__ = __webpack_require__("20L/");
function injectStyle (ssrContext) {
  __webpack_require__("f87H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepWiretransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c9b1fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepWiretransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U+ZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menuItem_vue__ = __webpack_require__("K6NR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655ecafa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menuItem_vue__ = __webpack_require__("P7vv");
function injectStyle (ssrContext) {
  __webpack_require__("Bk8q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-655ecafa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_655ecafa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UEml":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "UFRR":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./account.svg": "eluC",
	"./activity-white.svg": "9+hP",
	"./activity.svg": "5p87",
	"./arrow-left.svg": "tqch",
	"./bell-white.svg": "Jsz5",
	"./bell.svg": "aWB/",
	"./buy.svg": "BJ8h",
	"./community.svg": "HVL6",
	"./dashboard.svg": "sm9Y",
	"./forecast.svg": "9A88",
	"./help.svg": "ijvn",
	"./information.svg": "Yuu7",
	"./live-feed.svg": "Ozyv",
	"./notification.svg": "8TID",
	"./portfolio.svg": "CZdj",
	"./prediction.svg": "E+vL",
	"./rate.svg": "muIl",
	"./sell.svg": "YKaf",
	"./settings.svg": "6g1Y",
	"./support.svg": "jVvO",
	"./trading.svg": "dJjF",
	"./wallet.svg": "6xR6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";

/***/ }),

/***/ "UHz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepFinishMessage_vue__ = __webpack_require__("dpC9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66457107_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepFinishMessage_vue__ = __webpack_require__("qfd7");
function injectStyle (ssrContext) {
  __webpack_require__("3GME")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepFinishMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66457107_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepFinishMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Upue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_moderationView_view__ = __webpack_require__("WryN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-moderate-steps",
  components: { EModerationView: __WEBPACK_IMPORTED_MODULE_6__elements_moderationView_view__["a" /* default */] },
  props: {
    asset: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      localLockedModel: {
        locked: 0,
        rules: false,
        disabled: false
      },
      numberOfModeration: 0,
      moderationGroup: null,
      currentStep: 1,
      nextButtonDisabled: false,
      nextButtonText: 'Next',
      isLoading: true,
      availableModeration: false,
      isFinished: false
    };
  },

  watch: {
    asset: {
      handler: function handler(asset) {
        console.log('handlers', asset);
        if (asset) {
          this.onChangeAsset(asset);
        }
      },

      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('moderation', {
    fetchModerationGroup: 'fetchModerationGroupByAsset',
    fetchModerationGroupsByFilter: 'fetchModerationGroupsByFilter',
    loadNewModeration: 'loadNewModeration'
  }), {
    getNumberOfModeration: function getNumberOfModeration(asset) {
      var moderationGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var assetModerators = Number(asset && asset.totalModeration);
      var normalizedAssetModerators = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_finite___default()(assetModerators) ? Math.max(0, Math.floor(assetModerators)) : 0;
      var currentModerationCount = Array.isArray(moderationGroup && moderationGroup.moderation) ? moderationGroup.moderation.length : 0;

      return Math.max(normalizedAssetModerators, currentModerationCount);
    },
    buildModerationPayload: function buildModerationPayload() {
      var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var userId = this.user && this.user.id ? this.user.id : undefined;
      var assetId = this.asset ? this.asset.id : undefined;
      var groupId = this.moderationGroup ? this.moderationGroup.id : undefined;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
        user_id: userId,
        asset_id: assetId,
        locked_tokens: this.lockedModel.locked,
        moderation_group_id: groupId,
        moderation: Array.isArray(this.moderationGroup && this.moderationGroup.moderation) ? this.moderationGroup.moderation.map(function (item) {
          return {
            id: item && item.id ? item.id : item,
            moderation_group_id: groupId,
            status: 'draft'
          };
        }) : []
      }, extra);
    },
    getModerationGroupStatus: function getModerationGroupStatus(moderationGroup) {
      if (!moderationGroup) {
        return null;
      }

      if (moderationGroup.status !== undefined && moderationGroup.status !== null) {
        return moderationGroup.status;
      }

      if (moderationGroup.state !== undefined && moderationGroup.state !== null) {
        return moderationGroup.state;
      }

      return null;
    },
    applyModerationGroupState: function applyModerationGroupState(asset, moderationGroup) {
      var hasModerationGroup = moderationGroup && (typeof moderationGroup === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(moderationGroup)) === 'object' && Array.isArray(moderationGroup.moderation);
      var groupStatus = this.getModerationGroupStatus(moderationGroup);

      this.asset = asset;
      this.moderationGroup = hasModerationGroup ? moderationGroup : null;
      this.numberOfModeration = this.getNumberOfModeration(asset, this.moderationGroup);

      if (hasModerationGroup && groupStatus === 'published') {
        this.availableModeration = false;
        this.isFinished = true;
        this.currentStep = 1;
        this.nextButtonText = 'Next';
        this.nextButtonDisabled = false;
        return;
      }

      this.isFinished = false;
      this.availableModeration = hasModerationGroup ? true : this.availableModeration;
      this.currentStep = hasModerationGroup ? moderationGroup.moderation.length + 1 : 1;
    },
    onChangeAsset: function onChangeAsset(asset) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var moderationGroup, hasModerationGroup;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                console.log('ooo onChangeAsset', asset);
                _this.isLoading = true;
                _this.isFinished = false;

                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_7__services__["a" /* default */].Moderation.fetchCurrentModerationGroup(asset.id);

              case 6:
                moderationGroup = _context.sent;

                console.log('moderationGroup', moderationGroup);
                hasModerationGroup = moderationGroup && (typeof moderationGroup === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(moderationGroup)) === 'object' && Array.isArray(moderationGroup.moderation);

                if (hasModerationGroup) {
                  _context.next = 14;
                  break;
                }

                moderationGroup = null;
                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_7__services__["a" /* default */].Moderation.moderationIsAvailable(asset.id);

              case 13:
                _this.availableModeration = _context.sent;

              case 14:

                _this.applyModerationGroupState(asset, moderationGroup);
                _this.isLoading = false;
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](0);

                console.log('ex', _context.t0);
                _this.isLoading = false;

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 18]]);
      }))();
    },
    onChangeEval: function onChangeEval(rate) {
      this.nextButtonDisabled = !(rate > 0);
    },
    onNextClick: function onNextClick() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var computedModerationGroup, currentModerationGroup, viewComponent, moderation;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('nextnext', _this2.currentStep);

                if (!(_this2.currentStep === 1)) {
                  _context2.next = 26;
                  break;
                }

                if (_this2.moderationGroup) {
                  _context2.next = 21;
                  break;
                }

                _this2.isLoading = true;
                _context2.prev = 4;
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_7__services__["a" /* default */].Moderation.createModeration(_this2.buildModerationPayload({
                  status: 'draft'
                }));

              case 7:
                computedModerationGroup = _context2.sent;


                computedModerationGroup.moderation = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(computedModerationGroup.moderation, function (m) {
                  return m.id;
                });
                _this2.applyModerationGroupState(_this2.asset, computedModerationGroup);
                _context2.next = 18;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](4);
                _context2.next = 16;
                return __WEBPACK_IMPORTED_MODULE_7__services__["a" /* default */].Moderation.fetchCurrentModerationGroup(_this2.asset.id);

              case 16:
                currentModerationGroup = _context2.sent;

                _this2.applyModerationGroupState(_this2.asset, currentModerationGroup);

              case 18:
                _context2.prev = 18;

                _this2.isLoading = false;
                return _context2.finish(18);

              case 21:
                if (!_this2.isFinished) {
                  _context2.next = 23;
                  break;
                }

                return _context2.abrupt("return");

              case 23:
                _this2.currentStep += 1;
                _context2.next = 47;
                break;

              case 26:
                viewComponent = _this2.$refs.moderation[_this2.currentStep - 2];
                _context2.t1 = viewComponent.state;
                _context2.next = _context2.t1 === 'moderating' ? 30 : _context2.t1 === 'complete' ? 30 : _context2.t1 === 'ready' ? 44 : _context2.t1 === 'view' ? 46 : 47;
                break;

              case 30:
                if (!(viewComponent.eval > 0)) {
                  _context2.next = 43;
                  break;
                }

                viewComponent.state = 'complete';

                // Если это крайняя модерация то загружаем с сервера новую

                if (!(_this2.currentStep - 1 === _this2.moderationGroup.moderation.length)) {
                  _context2.next = 42;
                  break;
                }

                _context2.next = 35;
                return __WEBPACK_IMPORTED_MODULE_7__services__["a" /* default */].Moderation.fetchNextModeration(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this2.buildModerationPayload({
                  moderation_id: viewComponent.moderationId,
                  rating_id: viewComponent.moderation && viewComponent.moderation.rate,
                  evaluate: viewComponent.eval,
                  status: 'published'
                })));

              case 35:
                moderation = _context2.sent;

                if (!(moderation.currentState === 'published')) {
                  _context2.next = 39;
                  break;
                }

                _this2.isFinished = true;
                return _context2.abrupt("return");

              case 39:

                if (moderation.next) {
                  _this2.moderationGroup.moderation.push(moderation.next.id);
                  _this2.currentStep += 1;
                }
                _context2.next = 43;
                break;

              case 42:
                // иначе сохраняем изменения

                _this2.currentStep += 1;

              case 43:
                return _context2.abrupt("break", 47);

              case 44:
                viewComponent.state = 'moderating';
                return _context2.abrupt("break", 47);

              case 46:
                return _context2.abrupt("break", 47);

              case 47:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 12, 18, 21]]);
      }))();
    },
    onPreviewClick: function onPreviewClick() {
      if (this.currentStep > 1) {
        var viewComponent = this.$refs.moderation[this.currentStep - 2];
        switch (viewComponent.state) {
          case 'moderating':
            if (viewComponent.eval > 0) {
              viewComponent.state = 'complete';
            } else {
              viewComponent.state = 'ready';
            }
            break;
          default:
            {
              this.currentStep -= 1;
            }
        }
      }
    },
    onChangeStep: function onChangeStep(step) {
      var _this3 = this;

      console.log('onChangeStep', step);
      if (step === 1) {
        this.nextButtonText = 'Next';
        // this.nextButtonDisabled = !(this.lockedModel.rules && this.lockedModel.locked > 0);
        return;
      }

      if (step > 1) {
        this.$nextTick(function () {
          console.log('ss000', _this3.$refs, _this3.$refs.moderation);
          var moderationRefs = _this3.$refs.moderation;
          var viewComponent = Array.isArray(moderationRefs) ? moderationRefs[0] : null;
          console.log('ss0100', viewComponent);

          if (!viewComponent) return;

          switch (viewComponent.state) {
            case 'moderating':
              _this3.nextButtonText = 'Send';
              _this3.nextButtonDisabled = !viewComponent.allCriteriaShowed();
              break;
            case 'ready':
              if (step === _this3.numberOfModeration + 1) {
                _this3.nextButtonText = 'Complete!';
                _this3.nextButtonDisabled = false;
              } else {
                _this3.nextButtonText = 'Next';
                _this3.nextButtonDisabled = false;
              }
              break;
            case 'view':
              _this3.nextButtonText = 'Moderate Now';
              _this3.nextButtonDisabled = !viewComponent.allCriteriaShowed();
              break;
          }
        });
      }
    },
    onChangeState: function onChangeState(state) {
      var viewComponent = this.$refs.moderation[this.currentStep - 2];
      switch (state) {
        case 'moderating':
          this.nextButtonText = 'Send';
          this.nextButtonDisabled = true;
          break;
        case 'ready':
          this.nextButtonText = 'Moderate Now';
          this.nextButtonDisabled = false;
          break;
        case 'view':
          this.nextButtonText = 'Moderate Now';
          this.nextButtonDisabled = true;
          break;
        case 'complete':
          this.nextButtonText = 'Next';
          this.nextButtonDisabled = false;
          break;
      }
      // this.nextButtonDisabled = !viewComponent.allCriteriaShowed();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["e" /* mapState */])('auth', {
    user: function user(state) {
      return state.user;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('moderation', {
    getModerationGroup: 'moderationGroupByAsset'
  }), {
    lockedModel: {
      get: function get() {
        if (this.moderationGroup) {
          return {
            locked: this.moderationGroup.lockedTokens,
            rules: true,
            disabled: true
          };
        }

        return this.localLockedModel;
      },
      set: function set(value) {
        this.localLockedModel = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, value, { disabled: false });
      }
    }
  }),
  created: function created() {}
});

/***/ }),

/***/ "UzX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"e-lock-tokens"},[_c('b-col',{attrs:{"cols":"4"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-center mb-3 mt-2 eh-text-small eh-text-gray-dark"},[_c('span',[_c('i',{staticClass:"far fa-credit-card mr-1"}),_vm._v("Max. 15,000 EMiX")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Balance: "),_c('a',{staticClass:"font-weight-bold pl-1",attrs:{"href":"#"},on:{"click":_vm.onBalanceClick}},[_vm._v(_vm._s(_vm.balance)+" EMiX")])])]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"number","min":"0","max":_vm.balance,"disabled":_vm.value.disabled},model:{value:(_vm.lockValue),callback:function ($$v) {_vm.lockValue=$$v},expression:"lockValue"}}),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center mt-3 eh-text-small eh-text-gray-dark"},[_c('span',{staticClass:"text-uppercase font-weight-bold"},[_c('i',{staticClass:"fas fa-lock mr-1"}),_vm._v("Locked for 1 week")])]),_vm._v(" "),_c('e-hint',{staticClass:"lock-tokens-hint",attrs:{"title":"Notice"}},[_vm._v("Please be informed that the tokens you choose to lock will be locked for a 1 Week (AKA 7 Days) After one week you'r token will return to you ewallet and after that you'll be inform if you were rewarded on you moderation or not.")])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"7","offset":"1"}},[_c('div',{staticClass:"modal-block-title"},[_vm._v("Read and Accept the Rules")]),_vm._v(" "),_c('div',{staticClass:"rules"},[_c('div',{staticClass:"rules-wrapper"},[_c('p',[_vm._v("\n      By participating in moderation, you agree to review submitted ratings honestly and responsibly. Your role is to help ensure that evaluations follow the defined criteria and represent fair assessments of the asset. Moderators should carefully review each submission before approving or rejecting it.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Moderators must avoid conflicts of interest and must not attempt to manipulate ratings for personal benefit. Any suspicious activity, spam submissions, or attempts to influence the rating system unfairly should be rejected or reported through the moderation process.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Tokens locked for moderation represent your commitment to the process. They remain locked for the moderation period and are returned after it ends. Depending on the final consensus and quality of moderation, participants may receive rewards for accurate and responsible moderation.\n    ")])])]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"mt-4 legacy-checkbox",attrs:{"value":true,"unchecked-value":false,"disabled":_vm.value.disabled},model:{value:(_vm.acceptRules),callback:function ($$v) {_vm.acceptRules=$$v},expression:"acceptRules"}},[_vm._v("\n        I accept the rules\n      ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V7/o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-activity",
  props: {
    items: {
      type: Array,
      default: []
    }
  },
  computed: {
    computedStyle: function computedStyle() {
      return {
        height: (5 - this.items.length) * 66 + 'px',
        opacity: 0.5
      };
    }
  },
  methods: {
    formattedDate: function formattedDate(date) {
      return this.$moment(date).fromNow();
    }
  }
});

/***/ }),

/***/ "VEOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"e-menu"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VFFB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assetCard__ = __webpack_require__("jNXZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card__ = __webpack_require__("hHqd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chat__ = __webpack_require__("ta6T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__draggable__ = __webpack_require__("czb9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidebar__ = __webpack_require__("y6H5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__topbar__ = __webpack_require__("Q49I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__input__ = __webpack_require__("Hw/g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__steps__ = __webpack_require__("2I1G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__moderationView__ = __webpack_require__("aplL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hint__ = __webpack_require__("pqK0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__button__ = __webpack_require__("8HOo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lockTokens__ = __webpack_require__("ABpt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__badge__ = __webpack_require__("vwpd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__activity__ = __webpack_require__("J0Jw");















/* harmony default export */ __webpack_exports__["a"] = ({
  ExAssetCard: __WEBPACK_IMPORTED_MODULE_0__assetCard__["a" /* default */],
  ExCard: __WEBPACK_IMPORTED_MODULE_1__card__["a" /* default */],
  ExChat: __WEBPACK_IMPORTED_MODULE_2__chat__["a" /* default */],
  ExDraggable: __WEBPACK_IMPORTED_MODULE_3__draggable__["a" /* default */],
  ExSidebar: __WEBPACK_IMPORTED_MODULE_4__sidebar__["a" /* default */],
  ExTopbar: __WEBPACK_IMPORTED_MODULE_5__topbar__["a" /* default */],
  ExInput: __WEBPACK_IMPORTED_MODULE_6__input__["a" /* default */],
  ExSteps: __WEBPACK_IMPORTED_MODULE_7__steps__["a" /* default */],
  ExModerationView: __WEBPACK_IMPORTED_MODULE_8__moderationView__["a" /* default */],
  ExHint: __WEBPACK_IMPORTED_MODULE_9__hint__["a" /* default */],
  ExButton: __WEBPACK_IMPORTED_MODULE_10__button__["a" /* default */],
  ExLockTokens: __WEBPACK_IMPORTED_MODULE_11__lockTokens__["a" /* default */],
  ExBadge: __WEBPACK_IMPORTED_MODULE_12__badge__["a" /* default */],
  ExActivity: __WEBPACK_IMPORTED_MODULE_13__activity__["a" /* default */]
});

/***/ }),

/***/ "VLrv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VMNc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-chat__wrapper"},_vm._l((_vm.messages),function(message){return _c('e-chat-message',{key:message.id,attrs:{"subject":message.subject,"type":message.type,"id":message.id,"message":message.message}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W/5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__myAssets__ = __webpack_require__("p4KC");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__myAssets__["a" /* default */]);

/***/ }),

/***/ "Wmd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_card_card__ = __webpack_require__("tqXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_dynamicSize__ = __webpack_require__("KOBJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ec-events",
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_dynamicSize__["a" /* default */]],
  components: { ECard: __WEBPACK_IMPORTED_MODULE_0__elements_card_card__["a" /* default */] },
  data: function data() {
    return {
      forecastTableFields: [{
        key: 'index',
        label: '№'
      }, {
        label: 'Coin',
        key: 'preview'
      }, {
        key: 'forecasted'
      }, {
        key: 'actual',
        label: 'Actual price',
        formatter: function formatter(value) {
          return value + " USD";
        }
      }, {
        key: 'accuracy',
        label: 'Accuracy percentile',
        formatter: function formatter(value) {
          return value + "%";
        }
      }, {
        key: 'actions',
        label: ''
      }],
      forecastTableItems: [{
        crowd: 10000,
        asset: 'bitcoin',
        your: 12300,
        actual: 11300,
        accuracy: 68
      }, {
        crowd: 10000,
        asset: 'bitcoin',
        your: 12300,
        actual: 11300,
        accuracy: 68
      }, {
        crowd: 10000,
        asset: 'bitcoin',
        your: 12300,
        actual: 11300,
        accuracy: 68
      }]
    };
  }
});

/***/ }),

/***/ "WryN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_view_vue__ = __webpack_require__("Ak/v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06771876_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_view_vue__ = __webpack_require__("+jpl");
function injectStyle (ssrContext) {
  __webpack_require__("+3mA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06771876"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_view_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06771876_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XEzv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-wait',{attrs:{"for":"loadMessages"}},[_c('template',{slot:"waiting"},[_c('p',{staticClass:"eh-secondary-text text-center mt-3"},[_vm._v("\n      Loading messages ...\n    ")])]),_vm._v(" "),_c('div',{staticClass:"e-chat"},[_c('e-chat')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XItq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cookies_js__ = __webpack_require__("wFBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cookies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_cookies_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-forecast-header",
  props: {
    hint: Object,
    type: String
  },
  filters: {
    formatForecastDate: function formatForecastDate(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('DD MMM. YYYY');
    },
    formatPrice: function formatPrice(price) {
      price = parseFloat(price);
      if (price <= 10) {
        return price.toFixed(6);
      } else if (price <= 50) {
        return price.toFixed(4);
      }

      return price.toFixed(2);
    }
  },
  data: function data() {
    return {
      isHintVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('forecast', {
    forecastData: 'forecastModalData'
  }), {
    asset: function asset() {
      return this.forecastData !== null ? this.forecastData.asset : null;
    },
    evalPrice: function evalPrice() {
      return this.forecastData.asset.change24 / 100 * this.asset.price.value + this.asset.price.value;
    },
    coloredClass: function coloredClass() {
      return {
        'color-red': this.forecastData.asset.change24 < 0,
        'color-green': this.forecastData.asset.change24 >= 0
      };
    }
  }),
  methods: {
    hideHint: function hideHint() {
      this.isHintVisible = false;
      __WEBPACK_IMPORTED_MODULE_3_cookies_js___default.a.set('hintDisabled_' + this.type, true);
    }
  },
  created: function created() {
    var hintDisabled = __WEBPACK_IMPORTED_MODULE_3_cookies_js___default.a.get('hintDisabled_' + this.type);
    this.isHintVisible = !hintDisabled;
  }
});

/***/ }),

/***/ "XL7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal-content-container"},[_c('b-row',[_c('b-col',{staticClass:"mb-3",attrs:{"cols":"12"}},[_c('ul',{staticClass:"e-breadcrumb"},[_vm._l((_vm.breadcrumb),function(item,i){return _c('li',{key:i,staticClass:"e-breadcrumb__item",class:{'e-breadcrumb--active': item.active, 'e-breadcrumb--current': item.current}},[_c('span',[_vm._v(_vm._s(i + 1)+". "+_vm._s(item.value))])])}),_vm._v(" "),_c('li',{staticClass:"e-breadcrumb__item e-create-rate__edit ml-auto"},[_c('b-btn',{staticClass:"e-create-rate__reset",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){return _vm.changeStep(1)}}},[_c('i',{staticClass:"fas fa-pen mr-2"}),_vm._v("Edit criteria\n            ")])],1)],2)])],1),_vm._v(" "),_vm._l((_vm.criteria),function(criterion,i){return (_vm.currentStep === i + 1)?_c('em-rate-evaluation',{key:criterion.id,attrs:{"criterionId":criterion.id}}):_vm._e()}),_vm._v(" "),_c('e-lock-tokens',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStep - _vm.criteria.length === 1),expression:"currentStep - criteria.length === 1"}],model:{value:(_vm.lockedModel),callback:function ($$v) {_vm.lockedModel=$$v},expression:"lockedModel"}}),_vm._v(" "),_c('em-rate-finish',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStep - _vm.criteria.length === 2),expression:"currentStep - criteria.length === 2"}],attrs:{"criteria":_vm.criteria},on:{"editCriterion":_vm.onEditCriterion}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.isFinished)?_c('div',{staticClass:"success-message"},[_c('div',{staticClass:"img-container"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 512 512"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 512 512","xml:space":"preserve"}},[_c('path',{staticStyle:{"fill":"#0672f3"},attrs:{"d":"M496.396,61.776c20.807,20.807,20.807,54.664,0,75.471L248.82,384.822\n              c-6.895,6.895-15.951,10.342-25.007,10.342c-9.056,0-18.112-3.447-25.007-10.342l-120.34-120.34\n              c-20.807-20.807-20.807-54.664,0-75.471s54.664-20.807,75.471,0l69.876,69.862L420.925,61.776\n              c10.41-10.397,24.063-15.609,37.742-15.609C472.319,46.167,485.999,51.379,496.396,61.776z M477.052,117.904\n              c10.137-10.15,10.137-26.648,0-36.785c-10.137-10.137-26.648-10.137-36.785,0L241.16,280.227\n              c-4.637,4.637-10.793,7.182-17.346,7.182c-6.553,0-12.708-2.544-17.332-7.182l-71.887-71.873\n              c-5.075-5.075-11.724-7.606-18.386-7.606c-6.662,0-13.324,2.531-18.399,7.606c-10.137,10.137-10.137,26.634,0,36.785l120.34,120.34\n              c3.119,3.119,8.208,3.119,11.327,0L477.052,117.904z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#D2E3FB"},attrs:{"d":"M477.052,81.119c10.137,10.137,10.137,26.634,0,36.785L229.477,365.479\n              c-3.119,3.119-8.208,3.119-11.327,0L97.81,245.139c-10.137-10.15-10.137-26.648,0-36.785c5.075-5.075,11.737-7.606,18.399-7.606\n              c6.662,0,13.31,2.531,18.386,7.606l71.887,71.873c4.624,4.637,10.78,7.182,17.332,7.182s12.708-2.544,17.346-7.182L440.268,81.119\n              C450.404,70.982,466.916,70.982,477.052,81.119z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#0672f3"},attrs:{"d":"M449.72,239.845c0.383,5.308,0.575,10.739,0.575,16.156c0,124.143-100.997,225.141-225.141,225.141\n              S0,380.144,0,256S101.011,30.86,225.154,30.86c49.165,0,95.867,15.568,135.046,45.006c6.046,4.542,7.264,13.119,2.722,19.152\n              c-4.542,6.046-13.119,7.264-19.152,2.722c-34.418-25.855-75.43-39.521-118.617-39.521C116.086,58.219,27.359,146.946,27.359,256\n              s88.727,197.781,197.795,197.781c109.055,0,197.781-88.727,197.781-197.781c0-4.761-0.178-9.535-0.506-14.186\n              c-0.547-7.538,5.13-14.09,12.654-14.637C442.634,226.644,449.173,232.307,449.72,239.845z"}})])]),_vm._v(" "),_c('h3',[_vm._v("Your rate has been saved.")]),_vm._v(" "),_c('p',[_vm._v("Soon your rate will be taken into account in the overall assessment of \""+_vm._s(_vm.asset.name)+"\"\" asset.")])]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(!_vm.isFinished)?_c('e-button',{attrs:{"type":"outlined"},on:{"click":_vm.closeModal}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex ml-auto"},[(!_vm.isFinished)?_c('e-button',{staticStyle:{"margin-right":"30px"},on:{"click":_vm.onPreviewClick}},[_vm._v("Preview")]):_vm._e(),_vm._v(" "),(!_vm.isFinished)?_c('e-button',{attrs:{"disabled":_vm.nextBtnDisabled},on:{"click":_vm.onNextClick}},[_vm._v(_vm._s(_vm.currentStep - _vm.criteria.length === 2 ? 'Submit rating' : 'Next'))]):_vm._e(),_vm._v(" "),(_vm.isFinished)?_c('e-button',{on:{"click":_vm.closeModal}},[_vm._v("OK")]):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XUI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets__ = __webpack_require__("rLRw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart__ = __webpack_require__("M4KK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chat__ = __webpack_require__("uA6i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events__ = __webpack_require__("FFyC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__performance__ = __webpack_require__("KFdj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assetsList__ = __webpack_require__("8o/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__buyList__ = __webpack_require__("5xbH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__kyc__ = __webpack_require__("xqBF");









/* harmony default export */ __webpack_exports__["a"] = ({
  EcAssets: __WEBPACK_IMPORTED_MODULE_0__assets__["a" /* default */],
  EcChart: __WEBPACK_IMPORTED_MODULE_1__chart__["a" /* default */],
  EcChat: __WEBPACK_IMPORTED_MODULE_2__chat__["a" /* default */],
  EcEvents: __WEBPACK_IMPORTED_MODULE_3__events__["a" /* default */],
  EcPerformance: __WEBPACK_IMPORTED_MODULE_4__performance__["a" /* default */],
  EcAssetsList: __WEBPACK_IMPORTED_MODULE_5__assetsList__["a" /* default */],
  EcBuyList: __WEBPACK_IMPORTED_MODULE_6__buyList__["a" /* default */],
  EcKYC: __WEBPACK_IMPORTED_MODULE_7__kyc__["a" /* default */]
});

/***/ }),

/***/ "XVka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"payment-step"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"modal-block-title",staticStyle:{"font-weight":"500"}},[_vm._v("I Have Sent Funds to Economix")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('e-input',{attrs:{"type":"number","step":"0.1","min":"0","floating":"","label":"Amount Sent"},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}}),_vm._v(" "),_c('e-input',{attrs:{"type":"text","floating":"","label":"Transfer Refference Number [optional]"},model:{value:(_vm.card),callback:function ($$v) {_vm.card=$$v},expression:"card"}}),_vm._v(" "),_c('e-input',{attrs:{"type":"text","floating":"","label":"Refference Document [optional]"}}),_vm._v(" "),_c('e-hint',{attrs:{"title":"REMINDER:"}},[_vm._v("Final "+_vm._s(_vm.orderData.asset.symbol)+" amount you will receive will be according BTC rate at the time your payment is received at our bank")])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"line"},[_c('p',[_vm._v("By clicking the button above I agree and approve the "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return (function () {}).apply(null, arguments)}}},[_vm._v("Terms Of Use.")])]),_vm._v(" "),_c('e-button',{attrs:{"disabled":_vm.disabledButton},on:{"click":_vm.nextPage}},[_vm._v("Confirm")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XZap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__("+vOg");





var state = {
  modals: {},
  modalsId: [],
  dashboard: [],
  dashboardIsLoaded: false
};

// getters
var getters = {
  getModal: function getModal(state, getters, rState, rGetters) {
    return function (id) {
      return state.modals[id];
    };
  },
  dashboard: function dashboard(state, getters) {
    return state.dashboard;
  },
  dashboardIsLoaded: function dashboardIsLoaded(state, getters) {
    return state.dashboardIsLoaded;
  }
};

// actions
var actions = {
  createModal: function createModal(_ref, id) {
    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;

    commit('createModal', id);
  },
  fetchDashboard: function fetchDashboard(_ref2) {
    var _this = this;

    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch('wait/start', 'ui.fetchDashboard', { root: true });
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__services__["a" /* default */].Ui.fetchDashboard(1);

            case 3:
              data = _context.sent;

              commit('updateDashboard', data);
              commit('updateDashboardStatus', true);
              dispatch('wait/end', 'ui.fetchDashboard', { root: true });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  updateDashboard: function updateDashboard(_ref3, newDashboard) {
    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;

    commit('updateDashboard', newDashboard);
  },
  addToDashboard: function addToDashboard(_ref4, panel) {
    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;

    if (!state.dashboard.find(function (c) {
      return panel.id === c.id;
    })) {
      panel.position = state.dashboard.length + 1;
      commit('addToDashboard', panel);
    }
  }
};

// mutations
var mutations = {
  createModal: function createModal(state, id) {
    state.modals[id] = {
      id: id
    };

    state.modalsId.push(id);
  },
  updateModal: function updateModal(state, _ref5) {
    var id = _ref5.id;

    state.modals[id] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.modals[id].data);
  },
  updateDashboard: function updateDashboard(state, dashboard) {
    state.dashboard = dashboard;
  },
  updateDashboardStatus: function updateDashboardStatus(state, status) {
    state.dashboardIsLoaded = status;
  },
  addToDashboard: function addToDashboard(state, panel) {
    state.dashboard.push(panel);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "YFh7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_write_vue__ = __webpack_require__("PnJR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_198b6e8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_write_vue__ = __webpack_require__("XL7M");
function injectStyle (ssrContext) {
  __webpack_require__("shPy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-198b6e8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_write_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_198b6e8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_write_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YKaf":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC4zIj4KPHBhdGggZD0iTTkgMEM0LjAyOTQ4IDAgMCA0LjAyOTQ4IDAgOUMwIDEzLjk3MDUgNC4wMjk0OCAxOCA5IDE4QzEzLjk3MDUgMTggMTggMTMuOTcwNSAxOCA5QzE4IDQuMDI5NDggMTMuOTcwNSAwIDkgMFpNMTIuMjgxMyAxMC4ySDUuNzE4NzdDNS4wNTYwNyAxMC4yIDQuNTE4NzcgOS42NjI3IDQuNTE4NzcgOUM0LjUxODc3IDguMzM3MjYgNS4wNTYwNyA3Ljc5OTk3IDUuNzE4NzcgNy43OTk5N0gxMi4yODEzQzEyLjk0MzkgNy43OTk5NyAxMy40ODEzIDguMzM3MjYgMTMuNDgxMyA5QzEzLjQ4MTMgOS42NjI3IDEyLjk0MzkgMTAuMiAxMi4yODEzIDEwLjJaIiBmaWxsPSIjRTRFQ0YzIi8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "YRNT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-layout",class:{'is-mobile-menu-open': _vm.mobileMenuOpen}},[_c('e-sidebar',{attrs:{"state":_vm.menuState,"mobile-open":_vm.mobileMenuOpen},on:{"changeState":_vm.changeState,"closeMobile":_vm.closeMobileMenu}}),_vm._v(" "),_c('div',{staticClass:"e-container"},[_c('e-topbar',{attrs:{"mobile-menu-open":_vm.mobileMenuOpen},on:{"toggleMobileMenu":_vm.toggleMobileMenu}}),_vm._v(" "),_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__);








/**
 * Global router guard.
 *
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
var beforeEach = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var components, middleware;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return resolveComponents(router.getMatchedComponents(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, to)));

          case 2:
            components = _context.sent;

            if (!(components.length === 0)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return', next());

          case 5:

            // Start the loading bar.
            if (components[components.length - 1].loading !== false) {}
            // router.app.$nextTick(() => router.app.$loading.start())


            // Get the middleware for all the matched components.
            middleware = getMiddleware(components);

            // Call each middleware.

            callMiddleware(middleware, to, from, function () {
              // Set the application layout only if "next()" was called with no args.
              if (arguments.length === 0) {
                router.app.setLayout(components[0].layout || '');
              }

              next.apply(undefined, arguments);
            });

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function beforeEach(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Global after hook.
 *
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */


var afterEach = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return router.app.$nextTick();

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function afterEach(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Call each middleware.
 *
 * @param {Array} middleware
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */








__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_router__["a" /* default */]);

// The middleware for every page of the application.
var globalMiddleware = ['locale', 'checkAuth'];

// Load middleware modules dynamically.
var routeMiddleware = resolveMiddleware(__webpack_require__("7Vdr"));

var router = createRouter();

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */], router);

/* harmony default export */ __webpack_exports__["a"] = (router);

/**
 * Create a new router instance.
 *
 * @return {Router}
 */
function createRouter() {
  var router = new __WEBPACK_IMPORTED_MODULE_10_vue_router__["a" /* default */]({
    scrollBehavior: scrollBehavior,
    mode: 'history',
    routes: __WEBPACK_IMPORTED_MODULE_9__routes__["a" /* default */]
  });

  router.beforeEach(beforeEach);
  router.afterEach(afterEach);

  return router;
}function callMiddleware(middleware, to, from, next) {
  var stack = middleware.reverse();

  var _next = function _next() {
    // Stop if "_next" was called with an argument or the stack is empty.
    if (arguments.length > 0 || stack.length === 0) {
      if (arguments.length > 0) {
        // router.app.$loading.finish()
      }

      return next.apply(undefined, arguments);
    }

    var middleware = stack.pop();

    if (typeof middleware === 'function') {
      middleware(to, from, _next);
    } else if (routeMiddleware[middleware]) {
      routeMiddleware[middleware](to, from, _next);
    } else {
      throw Error('Undefined middleware [' + middleware + ']');
    }
  };

  _next();
}

/**
 * Resolve async components.
 *
 * @param  {Array} components
 * @return {Array}
 */
function resolveComponents(components) {
  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(components.map(function (component) {
    return typeof component === 'function' ? component() : component;
  }));
}

/**
 * Merge the the global middleware with the components middleware.
 *
 * @param  {Array} components
 * @return {Array}
 */
function getMiddleware(components) {
  var middleware = [].concat(globalMiddleware);

  components.filter(function (c) {
    return c.middleware;
  }).forEach(function (component) {
    if (Array.isArray(component.middleware)) {
      middleware.push.apply(middleware, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(component.middleware));
    } else {
      middleware.push(component.middleware);
    }
  });

  return middleware;
}

/**
 * Scroll Behavior
 *
 * @link https://router.vuejs.org/en/advanced/scroll-behavior.html
 *
 * @param  {Route} to
 * @param  {Route} from
 * @param  {Object|undefined} savedPosition
 * @return {Object}
 */
function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  }

  if (to.hash) {
    return { selector: to.hash };
  }

  var _router$getMatchedCom = router.getMatchedComponents(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, to)).slice(-1),
      _router$getMatchedCom2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_router$getMatchedCom, 1),
      component = _router$getMatchedCom2[0];

  if (component && component.scrollToTop === false) {
    return {};
  }

  return { x: 0, y: 0 };
}

/**
 * @param  {Object} requireContext
 * @return {Object}
 */
function resolveMiddleware(requireContext) {
  return requireContext.keys().map(function (file) {
    return [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)];
  }).reduce(function (guards, _ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        name = _ref4[0],
        guard = _ref4[1];

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, guards, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, name, guard.default));
  }, {});
}

/***/ }),

/***/ "YdSO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_chat_chat__ = __webpack_require__("d4YC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helpers__ = __webpack_require__("c/9r");


//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "eb-chat",
  components: { EChat: __WEBPACK_IMPORTED_MODULE_2__elements_chat_chat__["a" /* default */] },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$wait.start('loadMessages');
              _context.next = 3;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_helpers__["c" /* sleep */])(1500);

            case 3:
              _this.$wait.end('loadMessages');

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "Yuu7":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiNFNEVDRjMiIGQ9Ik04IDBDMy41ODkgMCAwIDMuNTg5IDAgOHMzLjU4OSA4IDggOGM0LjQxIDAgOC0zLjU4OSA4LThzLTMuNTktOC04LTh6bTAgMTQuOTVBNi45NTkgNi45NTkgMCAwIDEgMS4wNSA4IDYuOTU4IDYuOTU4IDAgMCAxIDggMS4wNSA2Ljk1OSA2Ljk1OSAwIDAgMSAxNC45NSA4IDYuOTU5IDYuOTU5IDAgMCAxIDggMTQuOTV6Ii8+CiAgICA8cGF0aCBmaWxsPSIjRTRFQ0YzIiBkPSJNNy44NTIgNS4wMzlhLjcuNyAwIDEgMCAwLTEuNC43LjcgMCAwIDAgMCAxLjR6TTguOTY0IDExLjE4M2gtLjQ0di01QS41MjUuNTI1IDAgMCAwIDggNS42NThoLS45NjNhLjUyNS41MjUgMCAwIDAgMCAxLjA1aC40Mzl2NC40NzVoLS40NGEuNTI1LjUyNSAwIDAgMCAwIDEuMDVoMS45MjhhLjUyNS41MjUgMCAxIDAgMC0xLjA1eiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "YvDG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQmX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZjWu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zk2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_star_vue__ = __webpack_require__("zrHh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014628e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_star_vue__ = __webpack_require__("gqU1");
function injectStyle (ssrContext) {
  __webpack_require__("qvWD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-014628e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_star_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014628e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_star_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZsjQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepAlreadyExists_vue__ = __webpack_require__("BFVg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e8ebca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepAlreadyExists_vue__ = __webpack_require__("urWd");
function injectStyle (ssrContext) {
  __webpack_require__("+jjB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepAlreadyExists_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e8ebca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepAlreadyExists_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a7Jc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aWB/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE5IDIwIj4KICAgIDxwYXRoIGZpbGw9IiMwRTNENjAiIGQ9Ik05LjA0OCAwYTIuNjY5IDIuNjY5IDAgMCAwLTIuNjcxIDIuNjZ2LjgwM2gxLjM4MXYtLjgwMmMwLS43MDkuNTc5LTEuMjg1IDEuMjktMS4yODUuNzEgMCAxLjI5LjU3NiAxLjI5IDEuMjg1di44MDJoMS4zOHYtLjgwMkEyLjY2OSAyLjY2OSAwIDAgMCA5LjA0OCAwek0xMC45MzUgMTYuNzY2YTEuODY0IDEuODY0IDAgMCAxLTEuODY0IDEuODU4aC0uMDQ2YTEuODY0IDEuODY0IDAgMCAxLTEuODY1LTEuODU4SDUuNzc5QTMuMjQ0IDMuMjQ0IDAgMCAwIDkuMDI1IDIwaC4wNDZjMS43OSAwIDMuMjQ2LTEuNDUgMy4yNDYtMy4yMzRoLTEuMzgyeiIvPgogICAgPHBhdGggZmlsbD0iIzBFM0Q2MCIgZD0iTTE3Ljk4NiAxNi41MDlsLTEuOTYzLTMuMDQxVjkuNTY0YzAtMy44Ny0zLjEyOS03LjAxOC02Ljk3NS03LjAxOC0zLjg0NyAwLTYuOTc2IDMuMTQ4LTYuOTc2IDcuMDE4djMuOTA0TC4xMSAxNi41MDhhLjY4Ni42ODYgMCAwIDAtLjAyNi43MDNjLjEyMi4yMi4zNTQuMzU4LjYwNy4zNThoMTYuNzE0YS42OS42OSAwIDAgMCAuNjA2LS4zNTguNjg1LjY4NSAwIDAgMC0uMDI1LS43MDJ6bS0xNi4wMy0uMzE2bDEuMzg3LTIuMTUxYy4wNzItLjExLjExLS4yNC4xMS0uMzcyVjkuNTY0YzAtMy4xMSAyLjUxLTUuNjQyIDUuNTk1LTUuNjQyczUuNTk0IDIuNTMxIDUuNTk0IDUuNjQydjQuMTA2YzAgLjEzMi4wMzguMjYxLjExLjM3MmwxLjM4NyAyLjE1MUgxLjk1NnoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "aeD6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aplL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view__ = __webpack_require__("WryN");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__view__["a" /* default */]);

/***/ }),

/***/ "b/x4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardHeader__ = __webpack_require__("njrz");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-card",
  components: { ECardHeader: __WEBPACK_IMPORTED_MODULE_0__cardHeader__["a" /* default */] },
  props: {
    controls: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleMove: function handleMove(v) {
      this.$emit('toggleDrag');
    }
  },

  mounted: function mounted() {
    if (this.controls) {
      var tHeader = this.$refs.tHeader;
      var $header = this.$refs.bTabs.$el.querySelector('.e-card__header');

      $header.appendChild(tHeader.$el);
    }
  }
});

/***/ }),

/***/ "b8yz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets__ = __webpack_require__("psvm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cards__ = __webpack_require__("XUI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements__ = __webpack_require__("VFFB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals__ = __webpack_require__("mtPT");






var Components = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__widgets__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__elements__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modals__["a" /* default */]);

Components.install = function (Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  registry(Vue, Components);
};

function registry(Vue, components) {
  for (var componentName in components) {
    var component = components[componentName];
    if (component && componentName !== 'install') {
      if (component.name === undefined) {
        registry(Vue, component);
      } else {
        Vue.component(component.name, component);
      }
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (Components);

/***/ }),

/***/ "bKBf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bKF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clear_vue__ = __webpack_require__("fuTg");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e162988_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clear_vue__ = __webpack_require__("eDAf");
function injectStyle (ssrContext) {
  __webpack_require__("bKBf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clear_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e162988_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clear_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "beVx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-sidebar",class:_vm.classes},[_c('button',{staticClass:"sidebar-overlay",attrs:{"aria-label":"Close menu"},on:{"click":_vm.closeMobile}}),_vm._v(" "),_c('div',{staticClass:"sidebar-container"},[_c('div',{staticClass:"topline"},[_c('a',{attrs:{"href":"#"}},[_c('svg',{staticClass:"logo open",staticStyle:{"enable-background":"new 0 0 275 76"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 275 76","xml:space":"preserve"}},[_c('g',[_c('path',{staticClass:"st0",attrs:{"d":"M93.7,27.4c-6.1,0-10.5,4.6-10.5,10.4v0.1c0,6.2,4.6,10.3,11.1,10.3c4.1,0,7-1.6,9-4l-4-3.2\n              c-1.5,1.4-2.9,2-4.6,2c-2.3,0-3.9-1.1-4.5-3.3h13.9c0-0.5,0-1,0-1.4C104.2,32.5,100.9,27.4,93.7,27.4z M90.1,36.2\n              c0.4-2.2,1.7-3.6,3.6-3.6c2,0,3.3,1.4,3.6,3.6H90.1z M118,42.3c-2.5,0-4.1-1.9-4.1-4.5v-0.1c0-2.4,1.7-4.4,4.1-4.4\n              c1.8,0,2.9,0.8,3.9,2.1l4.9-3.5c-1.8-2.7-4.6-4.4-8.9-4.4c-6.6,0-11.1,4.7-11.1,10.3v0.1c0,5.6,4.6,10.3,10.9,10.3\n              c4.6,0,7.3-1.8,9.2-4.6l-4.9-3.4C120.8,41.6,119.7,42.3,118,42.3z M139.8,27.4c-6.7,0-11.5,4.7-11.5,10.4v0.1\n              c0,5.6,4.8,10.3,11.4,10.3c6.7,0,11.5-4.7,11.5-10.4v-0.1C151.3,32.1,146.5,27.4,139.8,27.4z M144.2,37.9c0,2.4-1.7,4.4-4.3,4.4\n              c-2.6,0-4.4-2.1-4.4-4.5v-0.1c0-2.4,1.7-4.4,4.3-4.4C142.3,33.3,144.2,35.4,144.2,37.9L144.2,37.9z M168.3,27.4\n              c-3,0-4.9,1.6-6.2,3.2v-2.8h-7.3v19.8h7.3V37c0-2.2,1.3-3.3,3.1-3.3c1.7,0,2.9,1.2,2.9,3.3v10.7h7.3v-13\n              C175.4,30.2,172.7,27.4,168.3,27.4z M190.3,27.4c-6.7,0-11.5,4.7-11.5,10.4v0.1c0,5.6,4.8,10.3,11.4,10.3\n              c6.7,0,11.5-4.7,11.5-10.4v-0.1C201.7,32.1,196.9,27.4,190.3,27.4z M194.6,37.9c0,2.4-1.7,4.4-4.3,4.4c-2.6,0-4.4-2.1-4.4-4.5\n              v-0.1c0-2.4,1.7-4.4,4.3-4.4C192.7,33.3,194.6,35.4,194.6,37.9L194.6,37.9z M231.6,27.4c-3,0-5.1,1.2-6.9,3.2\n              c-1.1-2.1-3.2-3.2-6-3.2c-2.9,0-4.8,1.5-6.2,3.2v-2.7h-7.3v19.8h7.3V36.9c0-2.2,1.2-3.3,3-3.3c1.7,0,2.8,1.1,2.8,3.3v10.8h7.3\n              V36.9c0-2.2,1.3-3.3,3-3.3c1.7,0,2.8,1.1,2.8,3.3v10.8h7.3v-13C238.7,30.1,236,27.4,231.6,27.4z M243.3,47.7h7.3V27.9h-7.3V47.7z\n              M268,37.7l6.8-9.8h-7.7l-3.1,4.9l-3.1-4.9h-7.9l6.9,9.8l-7,10h7.7l3.3-5.1l3.2,5.1h7.8L268,37.7z M247.1,24.8\n              c1.8,0,3.3-1.4,3.3-3.2c0-1.8-1.5-3.2-3.3-3.2c-1.8,0-3.3,1.4-3.3,3.2C243.7,23.4,245.2,24.8,247.1,24.8z M38.4,0\n              C17.2,0,0,17,0,38c0,21,17.2,38,38.4,38c21.1,0,38.4-17,38.4-38C76.7,17,59.5,0,38.4,0z M38.4,72.5C19.2,72.5,3.6,57,3.6,38\n              S19.2,3.6,38.4,3.6C57.5,3.6,73.1,19,73.1,38S57.5,72.5,38.4,72.5z M26.3,51.9c-3.9,0-7,3.1-7,6.9c0,3.8,3.1,6.9,7,6.9\n              c3.9,0,7-3.1,7-6.9C33.2,55,30.1,51.9,26.3,51.9z M62.6,31.1c-3.9,0-7,3.1-7,6.9c0,3.8,3.1,6.9,7,6.9c3.9,0,7-3.1,7-6.9\n              C69.6,34.2,66.5,31.1,62.6,31.1z M26.3,24.1c3.9,0,7-3.1,7-6.9c0-3.8-3.1-6.9-7-6.9c-3.9,0-7,3.1-7,6.9\n              C19.3,21,22.4,24.1,26.3,24.1z M38.4,7.1c-2.3,0-4.5,0.2-6.7,0.7c3.3,1.9,5.5,5.4,5.5,9.4c0,1.6-0.4,3.1-1,4.4\n              c0.7-0.1,1.4-0.1,2.1-0.1c6.9,0,12.9,4.2,15.4,10.2c2-2.7,5.2-4.5,8.9-4.5c2,0,3.9,0.6,5.5,1.5C64.1,16.1,52.3,7.1,38.4,7.1z\n              M53.7,44.4c-2.5,6-8.5,10.2-15.4,10.2c-0.7,0-1.4-0.1-2.1-0.1c0.6,1.4,1,2.9,1,4.5c0,4-2.2,7.5-5.5,9.4c2.1,0.5,4.4,0.7,6.6,0.7\n              c14,0,25.8-9.1,29.8-21.6c-1.6,0.9-3.5,1.5-5.5,1.5C58.9,48.9,55.7,47.1,53.7,44.4z M25.1,48c-2.2-2.8-3.5-6.3-3.5-10\n              c0-3.8,1.3-7.2,3.4-10c-5.5-0.6-9.8-5.2-9.8-10.8c0,0,0,0,0-0.1C10.2,22.6,7.1,30,7.1,38c0,8,3.1,15.3,8.2,20.8c0,0,0,0,0,0\n              C15.3,53.2,19.6,48.6,25.1,48z","fill":"#ffffff"}})])]),_vm._v(" "),_c('svg',{staticClass:"logo close",staticStyle:{"enable-background":"new 0 0 35 35"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 35 35","xml:space":"preserve"}},[_c('g',{attrs:{"fill":"#ffffff"}},[_c('path',{staticClass:"st0",attrs:{"d":"M17.5,33.4c-8.7,0-15.9-7.1-15.9-15.9S8.8,1.6,17.5,1.6c8.7,0,15.9,7.1,15.9,15.9S26.2,33.4,17.5,33.4 M17.5,0\n              C7.9,0,0,7.9,0,17.5S7.9,35,17.5,35C27.1,35,35,27.1,35,17.5S27.1,0,17.5,0"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M12,23.9c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2C15.2,25.3,13.7,23.9,12,23.9"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M28.6,14.3c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2\n              C31.8,15.7,30.3,14.3,28.6,14.3"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M12,4.7c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2C15.2,6.2,13.7,4.7,12,4.7"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M17.5,3.2c-1,0-2.1,0.1-3,0.3C16,4.4,17,6.1,17,7.9c0,0.7-0.2,1.4-0.4,2c0.3,0,0.6-0.1,1-0.1\n              c3.2,0,5.9,1.9,7,4.7c0.9-1.3,2.4-2.1,4-2.1c0.9,0,1.8,0.3,2.5,0.7C29.3,7.4,23.9,3.2,17.5,3.2"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M24.5,20.4c-1.1,2.7-3.9,4.7-7,4.7c-0.3,0-0.6,0-1-0.1c0.3,0.6,0.4,1.3,0.4,2.1c0,1.9-1,3.5-2.5,4.3\n              c1,0.2,2,0.3,3,0.3c6.4,0,11.8-4.2,13.6-9.9c-0.7,0.4-1.6,0.7-2.5,0.7C26.9,22.5,25.4,21.7,24.5,20.4"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M7,7.9c-2.3,2.5-3.7,5.9-3.7,9.6c0,3.7,1.4,7.1,3.7,9.6c0,0,0,0,0,0c0-2.6,2-4.7,4.5-5c-1-1.3-1.6-2.9-1.6-4.6\n              c0-1.7,0.6-3.3,1.6-4.6C8.9,12.6,7,10.5,7,7.9C7,7.9,7,7.9,7,7.9"}})])])]),_vm._v(" "),_c('button',{staticClass:"toggle-menu",on:{"click":_vm.toggleMenu}})]),_vm._v(" "),_c('e-menu',{staticClass:"sidebar-menu"},[_c('e-menu-header',[_vm._v("Personal Area")]),_vm._v(" "),_c('e-menu-item',{attrs:{"label":"Dashboard","route":"dashboard","icon":"dashboard"}}),_vm._v(" "),_c('e-menu-item',{attrs:{"label":"Activity","icon":"activity","route":"activity"}}),_vm._v(" "),_c('e-menu-item',{attrs:{"label":"Community (Soon)","icon":"community","disabled":""}}),_vm._v(" "),_c('e-menu-item',{attrs:{"label":"Wallet (Soon)","icon":"wallet","disabled":""}}),_vm._v(" "),_c('e-menu-header',[_vm._v("Prediction")]),_vm._v(" "),_c('e-menu-item',{attrs:{"icon":"rate","label":"Rate","route":"assets-list"}}),_vm._v(" "),_c('e-menu-item',{attrs:{"icon":"forecast","label":"Forecast","route":"forecast-list"}}),_vm._v(" "),_c('e-menu-item',{attrs:{"icon":"portfolio","label":"Portfolio (Soon)","disabled":""}}),_vm._v(" "),_c('e-menu-header',[_vm._v("Trading")]),_vm._v(" "),_c('e-menu-item',{attrs:{"label":"Buy","icon":"buy","route":"trading-buy"}}),_vm._v(" "),_c('e-menu-item',{attrs:{"label":"Sell (Soon)","icon":"sell","disabled":""}}),_vm._v(" "),_c('e-menu-header',[_vm._v("Settings")]),_vm._v(" "),_c('e-menu-item',{attrs:{"label":"Account","icon":"account","route":"account"}}),_vm._v(" "),_c('e-menu-item',{attrs:{"label":"Help","route":"contacts","icon":"help"}})],1),_vm._v(" "),_vm._m(0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-footer"},[_c('p',{staticClass:"copyright"},[_vm._v("Copyright © 2018-2026 ECONOMIX "),_c('br'),_c('a',{attrs:{"href":"#"}},[_vm._v("Terms of use")]),_vm._v(" / "),_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy Policy")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "btDd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c/9r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = useMock;
/* harmony export (immutable) */ __webpack_exports__["c"] = sleep;
/* harmony export (immutable) */ __webpack_exports__["a"] = createUid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");




function useMock(name) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */], 'mock.' + name, false);
}

function sleep(time) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    return setTimeout(resolve, time);
  });
}

function createUid() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

/***/ }),

/***/ "c5w6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("sZL0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bb8368c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("r7bF");
function injectStyle (ssrContext) {
  __webpack_require__("8I6K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8bb8368c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bb8368c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cFPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);










/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({
  name: 'em-kyc',
  mounted: function mounted() {},
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({
      countries: [],
      genderList: ['Male', 'Female'],
      permitedFiles: ['.jpg', '.jpeg', '.png', '.gif', '.pdf'],
      stage: 1,
      step: 1,
      kycData: {
        step1: {
          firstName: '',
          middleName: '',
          lastName: '',
          gender: '',
          dateBirth: '01/01/1900'
        },
        step2: {
          countryOfResidents: '',
          address: '',
          city: '',
          zip: '',
          phone: ''
        },
        step3: {
          idIssuingCountry: '',
          idNumber: '',
          idExpirationDate: '01/01/1900'
        },
        photos: {
          kycF: '',
          kycB: '',
          selfie: '',
          kyc2F: '',
          kyc2B: '',
          bill: ''
        },
        phonecode: {
          n1: '',
          n2: '',
          n3: '',
          n4: '',
          n5: '',
          n6: '',
          focused: 1
        },
        phone: ''
      },

      sendSMSstage: 0,
      smsTimer: 60,
      smsChecked: false,
      smsError: '',
      smsBlocked: false
    }, 'countries', [{ "name": "Afghanistan", "code": "AF" }, { "name": "Åland Islands", "code": "AX" }, { "name": "Albania", "code": "AL" }, { "name": "Algeria", "code": "DZ" }, { "name": "American Samoa", "code": "AS" }, { "name": "AndorrA", "code": "AD" }, { "name": "Angola", "code": "AO" }, { "name": "Anguilla", "code": "AI" }, { "name": "Antarctica", "code": "AQ" }, { "name": "Antigua and Barbuda", "code": "AG" }, { "name": "Argentina", "code": "AR" }, { "name": "Armenia", "code": "AM" }, { "name": "Aruba", "code": "AW" }, { "name": "Australia", "code": "AU" }, { "name": "Austria", "code": "AT" }, { "name": "Azerbaijan", "code": "AZ" }, { "name": "Bahamas", "code": "BS" }, { "name": "Bahrain", "code": "BH" }, { "name": "Bangladesh", "code": "BD" }, { "name": "Barbados", "code": "BB" }, { "name": "Belarus", "code": "BY" }, { "name": "Belgium", "code": "BE" }, { "name": "Belize", "code": "BZ" }, { "name": "Benin", "code": "BJ" }, { "name": "Bermuda", "code": "BM" }, { "name": "Bhutan", "code": "BT" }, { "name": "Bolivia", "code": "BO" }, { "name": "Bosnia and Herzegovina", "code": "BA" }, { "name": "Botswana", "code": "BW" }, { "name": "Bouvet Island", "code": "BV" }, { "name": "Brazil", "code": "BR" }, { "name": "British Indian Ocean Territory", "code": "IO" }, { "name": "Brunei Darussalam", "code": "BN" }, { "name": "Bulgaria", "code": "BG" }, { "name": "Burkina Faso", "code": "BF" }, { "name": "Burundi", "code": "BI" }, { "name": "Cambodia", "code": "KH" }, { "name": "Cameroon", "code": "CM" }, { "name": "Canada", "code": "CA" }, { "name": "Cape Verde", "code": "CV" }, { "name": "Cayman Islands", "code": "KY" }, { "name": "Central African Republic", "code": "CF" }, { "name": "Chad", "code": "TD" }, { "name": "Chile", "code": "CL" }, { "name": "China", "code": "CN" }, { "name": "Christmas Island", "code": "CX" }, { "name": "Cocos (Keeling) Islands", "code": "CC" }, { "name": "Colombia", "code": "CO" }, { "name": "Comoros", "code": "KM" }, { "name": "Congo", "code": "CG" }, { "name": "Congo, The Democratic Republic of the", "code": "CD" }, { "name": "Cook Islands", "code": "CK" }, { "name": "Costa Rica", "code": "CR" }, { "name": "Cote DIvoire", "code": "CI" }, { "name": "Croatia", "code": "HR" }, { "name": "Cuba", "code": "CU" }, { "name": "Cyprus", "code": "CY" }, { "name": "Czech Republic", "code": "CZ" }, { "name": "Denmark", "code": "DK" }, { "name": "Djibouti", "code": "DJ" }, { "name": "Dominica", "code": "DM" }, { "name": "Dominican Republic", "code": "DO" }, { "name": "Ecuador", "code": "EC" }, { "name": "Egypt", "code": "EG" }, { "name": "El Salvador", "code": "SV" }, { "name": "Equatorial Guinea", "code": "GQ" }, { "name": "Eritrea", "code": "ER" }, { "name": "Estonia", "code": "EE" }, { "name": "Ethiopia", "code": "ET" }, { "name": "Falkland Islands (Malvinas)", "code": "FK" }, { "name": "Faroe Islands", "code": "FO" }, { "name": "Fiji", "code": "FJ" }, { "name": "Finland", "code": "FI" }, { "name": "France", "code": "FR" }, { "name": "French Guiana", "code": "GF" }, { "name": "French Polynesia", "code": "PF" }, { "name": "French Southern Territories", "code": "TF" }, { "name": "Gabon", "code": "GA" }, { "name": "Gambia", "code": "GM" }, { "name": "Georgia", "code": "GE" }, { "name": "Germany", "code": "DE" }, { "name": "Ghana", "code": "GH" }, { "name": "Gibraltar", "code": "GI" }, { "name": "Greece", "code": "GR" }, { "name": "Greenland", "code": "GL" }, { "name": "Grenada", "code": "GD" }, { "name": "Guadeloupe", "code": "GP" }, { "name": "Guam", "code": "GU" }, { "name": "Guatemala", "code": "GT" }, { "name": "Guernsey", "code": "GG" }, { "name": "Guinea", "code": "GN" }, { "name": "Guinea-Bissau", "code": "GW" }, { "name": "Guyana", "code": "GY" }, { "name": "Haiti", "code": "HT" }, { "name": "Heard Island and Mcdonald Islands", "code": "HM" }, { "name": "Holy See (Vatican City State)", "code": "VA" }, { "name": "Honduras", "code": "HN" }, { "name": "Hong Kong", "code": "HK" }, { "name": "Hungary", "code": "HU" }, { "name": "Iceland", "code": "IS" }, { "name": "India", "code": "IN" }, { "name": "Indonesia", "code": "ID" }, { "name": "Iran, Islamic Republic Of", "code": "IR" }, { "name": "Iraq", "code": "IQ" }, { "name": "Ireland", "code": "IE" }, { "name": "Isle of Man", "code": "IM" }, { "name": "Israel", "code": "IL" }, { "name": "Italy", "code": "IT" }, { "name": "Jamaica", "code": "JM" }, { "name": "Japan", "code": "JP" }, { "name": "Jersey", "code": "JE" }, { "name": "Jordan", "code": "JO" }, { "name": "Kazakhstan", "code": "KZ" }, { "name": "Kenya", "code": "KE" }, { "name": "Kiribati", "code": "KI" }, { "name": "Korea, Democratic People Republic of", "code": "KP" }, { "name": "Korea, Republic of", "code": "KR" }, { "name": "Kuwait", "code": "KW" }, { "name": "Kyrgyzstan", "code": "KG" }, { "name": "Lao People Democratic Republic", "code": "LA" }, { "name": "Latvia", "code": "LV" }, { "name": "Lebanon", "code": "LB" }, { "name": "Lesotho", "code": "LS" }, { "name": "Liberia", "code": "LR" }, { "name": "Libyan Arab Jamahiriya", "code": "LY" }, { "name": "Liechtenstein", "code": "LI" }, { "name": "Lithuania", "code": "LT" }, { "name": "Luxembourg", "code": "LU" }, { "name": "Macao", "code": "MO" }, { "name": "Macedonia, The Former Yugoslav Republic of", "code": "MK" }, { "name": "Madagascar", "code": "MG" }, { "name": "Malawi", "code": "MW" }, { "name": "Malaysia", "code": "MY" }, { "name": "Maldives", "code": "MV" }, { "name": "Mali", "code": "ML" }, { "name": "Malta", "code": "MT" }, { "name": "Marshall Islands", "code": "MH" }, { "name": "Martinique", "code": "MQ" }, { "name": "Mauritania", "code": "MR" }, { "name": "Mauritius", "code": "MU" }, { "name": "Mayotte", "code": "YT" }, { "name": "Mexico", "code": "MX" }, { "name": "Micronesia, Federated States of", "code": "FM" }, { "name": "Moldova, Republic of", "code": "MD" }, { "name": "Monaco", "code": "MC" }, { "name": "Mongolia", "code": "MN" }, { "name": "Montserrat", "code": "MS" }, { "name": "Morocco", "code": "MA" }, { "name": "Mozambique", "code": "MZ" }, { "name": "Myanmar", "code": "MM" }, { "name": "Namibia", "code": "NA" }, { "name": "Nauru", "code": "NR" }, { "name": "Nepal", "code": "NP" }, { "name": "Netherlands", "code": "NL" }, { "name": "Netherlands Antilles", "code": "AN" }, { "name": "New Caledonia", "code": "NC" }, { "name": "New Zealand", "code": "NZ" }, { "name": "Nicaragua", "code": "NI" }, { "name": "Niger", "code": "NE" }, { "name": "Nigeria", "code": "NG" }, { "name": "Niue", "code": "NU" }, { "name": "Norfolk Island", "code": "NF" }, { "name": "Northern Mariana Islands", "code": "MP" }, { "name": "Norway", "code": "NO" }, { "name": "Oman", "code": "OM" }, { "name": "Pakistan", "code": "PK" }, { "name": "Palau", "code": "PW" }, { "name": "Palestinian Territory, Occupied", "code": "PS" }, { "name": "Panama", "code": "PA" }, { "name": "Papua New Guinea", "code": "PG" }, { "name": "Paraguay", "code": "PY" }, { "name": "Peru", "code": "PE" }, { "name": "Philippines", "code": "PH" }, { "name": "Pitcairn", "code": "PN" }, { "name": "Poland", "code": "PL" }, { "name": "Portugal", "code": "PT" }, { "name": "Puerto Rico", "code": "PR" }, { "name": "Qatar", "code": "QA" }, { "name": "Reunion", "code": "RE" }, { "name": "Romania", "code": "RO" }, { "name": "Russian Federation", "code": "RU" }, { "name": "RWANDA", "code": "RW" }, { "name": "Saint Helena", "code": "SH" }, { "name": "Saint Kitts and Nevis", "code": "KN" }, { "name": "Saint Lucia", "code": "LC" }, { "name": "Saint Pierre and Miquelon", "code": "PM" }, { "name": "Saint Vincent and the Grenadines", "code": "VC" }, { "name": "Samoa", "code": "WS" }, { "name": "San Marino", "code": "SM" }, { "name": "Sao Tome and Principe", "code": "ST" }, { "name": "Saudi Arabia", "code": "SA" }, { "name": "Senegal", "code": "SN" }, { "name": "Serbia and Montenegro", "code": "CS" }, { "name": "Seychelles", "code": "SC" }, { "name": "Sierra Leone", "code": "SL" }, { "name": "Singapore", "code": "SG" }, { "name": "Slovakia", "code": "SK" }, { "name": "Slovenia", "code": "SI" }, { "name": "Solomon Islands", "code": "SB" }, { "name": "Somalia", "code": "SO" }, { "name": "South Africa", "code": "ZA" }, { "name": "South Georgia and the South Sandwich Islands", "code": "GS" }, { "name": "Spain", "code": "ES" }, { "name": "Sri Lanka", "code": "LK" }, { "name": "Sudan", "code": "SD" }, { "name": "Svalbard and Jan Mayen", "code": "SJ" }, { "name": "Swaziland", "code": "SZ" }, { "name": "Sweden", "code": "SE" }, { "name": "Switzerland", "code": "CH" }, { "name": "Syrian Arab Republic", "code": "SY" }, { "name": "Taiwan, Province of China", "code": "TW" }, { "name": "Tajikistan", "code": "TJ" }, { "name": "Tanzania, United Republic of", "code": "TZ" }, { "name": "Thailand", "code": "TH" }, { "name": "Timor-Leste", "code": "TL" }, { "name": "Togo", "code": "TG" }, { "name": "Tokelau", "code": "TK" }, { "name": "Tonga", "code": "TO" }, { "name": "Trinidad and Tobago", "code": "TT" }, { "name": "Tunisia", "code": "TN" }, { "name": "Turkey", "code": "TR" }, { "name": "Turkmenistan", "code": "TM" }, { "name": "Turks and Caicos Islands", "code": "TC" }, { "name": "Tuvalu", "code": "TV" }, { "name": "Uganda", "code": "UG" }, { "name": "Ukraine", "code": "UA" }, { "name": "United Arab Emirates", "code": "AE" }, { "name": "United Kingdom", "code": "GB" }, { "name": "United States", "code": "US" }, { "name": "United States Minor Outlying Islands", "code": "UM" }, { "name": "Uruguay", "code": "UY" }, { "name": "Uzbekistan", "code": "UZ" }, { "name": "Vanuatu", "code": "VU" }, { "name": "Venezuela", "code": "VE" }, { "name": "Viet Nam", "code": "VN" }, { "name": "Virgin Islands, British", "code": "VG" }, { "name": "Virgin Islands, U.S.", "code": "VI" }, { "name": "Wallis and Futuna", "code": "WF" }, { "name": "Western Sahara", "code": "EH" }, { "name": "Yemen", "code": "YE" }, { "name": "Zambia", "code": "ZM" }, { "name": "Zimbabwe", "code": "ZW" }]);
  },

  watch: {
    step: {
      immediate: true,
      handler: function handler(step) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          var stepData, dates;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(step <= 3)) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 3;
                  return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* default */].Auth.getKYCStep(step);

                case 3:
                  stepData = _context.sent;
                  dates = ['dateBirth', 'idExpirationDate'];


                  dates.forEach(function (d) {
                    if (stepData[d] !== null) {
                      stepData[d] = __WEBPACK_IMPORTED_MODULE_6_moment___default()(stepData[d]).format('YYYY-MM-DD');
                    }
                  });

                  _this.kycData['step' + step] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.kycData['step' + step], stepData);

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])('settings', ['setShowKyc']), {
    devClick: function devClick(i) {
      this.step = i;
    },
    selectGender: function selectGender(gender) {
      this.kycData.step1.gender = gender;
    },
    sendSMS: function sendSMS() {
      __WEBPACK_IMPORTED_MODULE_5__services__["a" /* default */].Auth.sendVerifyCode(this.kycData.step2.phone, this.token);
    },
    Close: function Close() {
      this.showKyc = false;
    },
    checkValid: function checkValid() {
      return true;
    },
    readUrl: function readUrl(type, e) {
      var file = e.target.files[0];
      if (file) this.kycData.photos[type] = URL.createObjectURL(file);
    },
    numInput: function numInput(i, e) {
      if (parseInt(i) < 6) {
        this.$refs['verifyCode' + (parseInt(i) + 1)].focus();
      }
    },
    nextStep: function nextStep() {
      switch (this.stage) {
        case 1:
          {
            if (this.step < 7) {

              if (this.step <= 3) {
                __WEBPACK_IMPORTED_MODULE_5__services__["a" /* default */].Auth.saveKYCStep({
                  data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.kycData['step' + this.step]),
                  step: this.step
                });
              }

              this.step++;

              return;
            }

            return this.Close();
          }
        case 2:
          {
            if (this.step < 3) this.step++;else this.Close();
            break;
          }
      }
    },
    onShow: function onShow() {
      var modal = this.$refs.modal;
      var $app = this.$root.$el;

      $app.parentNode.appendChild(modal.$el);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('settings', {
    'isShowKyc': 'isShowKyc'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', {
    'token': 'token'
  }), {
    showKyc: {
      get: function get() {
        return this.isShowKyc;
      },
      set: function set(v) {
        this.setShowKyc(v);
      }
    }
  }),
  created: function created() {}
}, 'mounted', function mounted() {}));

/***/ }),

/***/ "cJmQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "step-wiretransfer",
  components: {},
  data: function data() {
    return {
      // paymentInfo: {},
      // currentOrder: {}
      isLoading: true
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])("settings", ["setPaymentState"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])("orders", ["getPaymentInfo", "createOrder"]), {
    orderPrice: function orderPrice() {
      return 50;
    },
    nextPage: function nextPage() {
      this.$emit('nextPage');
    },
    sendToMail: function sendToMail() {}
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])("orders", {
    currentOrder: "currentOrder",
    paymentInfo: "paymentInfo",
    orderData: 'buyModalData'
  }), {
    currency_name: function currency_name() {
      if (this.upd) return "Bitcoin";
      return "Bitcоin";
    },
    finalTotal: function finalTotal() {
      return parseFloat(this.orderData.amount) + parseFloat(this.paymentInfo.paymentMethodFee) + parseFloat(this.paymentInfo.serviceFee);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.isLoading = true;
              console.log(_this.orderData);
              _context.next = 4;
              return _this.createOrder({
                coin: {
                  amount: _this.orderData.amount,
                  symbol: _this.orderData.asset.symbol
                },
                currency: _this.orderData.currency
              });

            case 4:
              _context.next = 6;
              return _this.getPaymentInfo();

            case 6:
              console.log(_this.paymentInfo);
              _this.isLoading = false;
              // setInterval(() => { this.upd = !this.upd; }, 200)

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "cUJM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buy_vue__ = __webpack_require__("hqb6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_818b9030_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_buy_vue__ = __webpack_require__("Ab68");
function injectStyle (ssrContext) {
  __webpack_require__("Ru/V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-818b9030"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_818b9030_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_buy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "czb9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__draggable__ = __webpack_require__("s5DG");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__draggable__["a" /* default */]);

/***/ }),

/***/ "d4YC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chat_vue__ = __webpack_require__("A9cn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632b8efa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chat_vue__ = __webpack_require__("VMNc");
function injectStyle (ssrContext) {
  __webpack_require__("OXYJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-632b8efa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632b8efa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dJjF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICAgIDxwYXRoIGZpbGw9IiNFNEVDRjMiIGQ9Ik0yLjUwOSAxMS43MzdsOC45OC03Ljg5SDguNDZjLS4zNTYtLjAyMi0uNjMzLS4yODctLjYzMy0uNjIzYS42NC42NCAwIDAgMSAuNjIyLS42MzFoNC43MWMuMzczLjAyNS42NS4zMTguNjI3LjcxNUwxMy4yIDhjLS4wNzYuNDc5LS41MDguNTcxLS42ODQuNTZhLjY0NC42NDQgMCAwIDEtLjUzNy0uNzA4bC40MDQtMy4wOTYtOS4wMDkgNy45MTVjLS4yNTguMjI2LS42NzkuMjE2LS45MS0uMDQ2YS42MjYuNjI2IDAgMCAxIC4wNDUtLjg4OHpNNy4yMSAxNy42NDhsLjU4Ny00LjY5MmEuNjM3LjYzNyAwIDAgMSAuNzA2LS41MzVjLjMzMy4wNDMuNTguMzc1LjUzOC43MDhsLS4zOTcgMy4wNSA4Ljk4OC03Ljg5N2EuNjI3LjYyNyAwIDAgMSAuODgyLjA3Yy4yMy4yNjIuMjEyLjY1OS0uMDQ0Ljg4M0w5LjQ4NCAxNy4xM2wzLjA3NS0uMDAxYy4zNTUuMDIzLjYzMy4yODguNjMzLjYyNC0uMDIuNTI2LS40NjYuNjItLjYyMi42MzFsLTQuNzI4LS4wMjJjLS40MjktLjAyNy0uNjU3LS4yOTItLjYzMi0uNzE0eiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "dTcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");




var state = {
  rates: []
};

// getters
var getters = {
  rates: function rates(state, getters, root) {
    return state.rates;
  }
};

// actions
var actions = {
  fetchRates: function fetchRates(_ref) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data, rates;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].Rates.fetchRates();

            case 2:
              data = _context.sent;
              rates = data.default.map(function (e) {
                e.small = true;return e;
              });

              commit('updateRates', rates);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

// mutations
var mutations = {
  updateRates: function updateRates(state, data) {
    state.rates = [].concat(data);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "dX5N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subMenuItem_vue__ = __webpack_require__("4ywl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665c286a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subMenuItem_vue__ = __webpack_require__("uH6x");
function injectStyle (ssrContext) {
  __webpack_require__("j1/8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-665c286a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subMenuItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665c286a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subMenuItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dcti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-chat-message",
  props: {
    type: {
      type: String,
      default: 'from'
    },
    subject: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedDate: function formattedDate() {
      return this.$moment(this.message.date).fromNow();
    }
  }
});

/***/ }),

/***/ "djKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header__ = __webpack_require__("5xew");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stepCreateForecast_vue__ = __webpack_require__("kHJ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stepLockTokens_vue__ = __webpack_require__("ljbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stepFinishMessage_vue__ = __webpack_require__("UHz2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__stepAlreadyExists_vue__ = __webpack_require__("ZsjQ");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-forecast",
  components: { EmForecastHeader: __WEBPACK_IMPORTED_MODULE_4__header__["a" /* default */], StepCreateForecast: __WEBPACK_IMPORTED_MODULE_6__stepCreateForecast_vue__["a" /* default */], StepLockTokens: __WEBPACK_IMPORTED_MODULE_7__stepLockTokens_vue__["a" /* default */], StepFinishMessage: __WEBPACK_IMPORTED_MODULE_8__stepFinishMessage_vue__["a" /* default */], StepAlreadyExists: __WEBPACK_IMPORTED_MODULE_9__stepAlreadyExists_vue__["a" /* default */] },
  data: function data() {
    return {
      isLoading: true,
      current: 1,
      prediction: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('forecast', {
    isShowForecastModal: 'isShowForecastModal',
    forecastData: 'forecastModalData',
    lockedTokens: 'lockedTokens',
    forecastPrediction: 'forecastPrediction'
  }), {
    asset: function asset() {
      return this.forecastData !== null ? this.forecastData.asset : null;
    },
    hint: function hint() {
      return {
        title: 'How forecast is working',
        text: 'Ten years ago a crack commando until was sent to prison by a military count for a crime they didn\'t commit. These men promptly escaped from a maximum security stockade to the Los Angeles underground. Today, still wanted by the goverment, they survive as soldiers of fortune. If you have a problem and no one else can help, and if you can find them, maybe you can hire the A-team.',
        buttonText: 'Got It'
      };
    },

    show: {
      get: function get() {
        return this.isShowForecastModal;
      },
      set: function set(v) {
        this.setShowForecastModal(v);
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])('forecast', ['setShowForecastModal', 'clearForecastModalData']), {
    close: function close() {
      this.show = false;
    },
    onAfterClose: function onAfterClose() {
      this.clearForecastModalData();
    },
    sendPrediction: function sendPrediction() {
      __WEBPACK_IMPORTED_MODULE_5__services__["a" /* default */].Forecasts.sendPrediction(this.forecastData.forecast._id, {
        lockedTokens: this.lockedTokens,
        prediction: this.forecastPrediction
      });

      this.current = 3;
    },
    onShow: function onShow() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var modal, $app, prediction;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                modal = _this.$refs.modal;
                $app = _this.$root.$el;


                $app.parentNode.appendChild(modal.$el);

                _this.isLoading = true;

                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__services__["a" /* default */].Forecasts.getForecastPrediction(_this.forecastData.forecast._id);

              case 6:
                prediction = _context.sent;


                if (prediction !== null) {
                  _this.prediction = prediction;
                  _this.current = 4;
                } else {
                  _this.current = 1;
                }

                _this.isLoading = false;

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),

/***/ "dpC9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "step-finish-message",
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])('forecast', {
    setLockedTokens: 'setLockedTokens',
    setAcceptedRules: 'setAcceptedRules'
  }), {
    close: function close() {
      this.$emit('closeModal');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('forecast', {
    lockedTokens: 'lockedTokens',
    acceptedRules: 'acceptedRules',
    forecastData: 'forecastModalData'
  }), {
    asset: function asset() {
      return this.forecastData !== null ? this.forecastData.asset : null;
    }
  })
});

/***/ }),

/***/ "eDAf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-layout"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eEWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "basicLayout",
  watch: {
    $route: function $route() {
      this.closeMobileMenu();
    }
  },
  methods: {
    changeState: function changeState(state) {
      this.menuState = state;
    },
    toggleMobileMenu: function toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu: function closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  },
  data: function data() {
    return {
      menuState: 'open',
      mobileMenuOpen: false
    };
  }
});

/***/ }),

/***/ "eK9d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-card",class:{ 'smallcard': _vm.coin.small, 'active': _vm.coin.active }},[_c('div',{staticClass:"blue-line"}),_vm._v(" "),_c('div',{staticClass:"first-box",on:{"click":function($event){return _vm.expandCoin(_vm.coin)}}},[_c('div',{staticClass:"tc-info"},[_c('div',{staticClass:"ci-logo"},[_c('img',{class:{ 'gray': _vm.amount == 0 },attrs:{"src":_vm.coin.logoPath}})]),_vm._v(" "),_c('div',{staticClass:"ci-name"},[_c('div',{staticClass:"ci-name-full"},[_vm._v(_vm._s(_vm.coin.name))]),_vm._v(" "),_c('div',{staticClass:"ci-name-small"},[_vm._v(_vm._s(_vm.coin.symbol))])])]),_vm._v(" "),_c('div',{staticClass:"tc-price"},[_c('div',{staticClass:"tc-price-full"},[_vm._v(_vm._s(_vm.currentPrice)+" USD")]),_vm._v(" "),_c('div',{staticClass:"tc-price-small"},[_vm._v("Rate")])])]),_vm._v(" "),_c('div',{staticClass:"tc-select"},[_c('div',{staticClass:"amount-select"},[_c('div',{staticClass:"range-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],class:{active: _vm.amount > 0},attrs:{"type":"range","name":"range","min":"0","max":_vm.getMaxForTier(),"step":"1"},domProps:{"value":(_vm.amount)},on:{"change":function($event){return _vm.checkActiveAmount(_vm.coin)},"__r":function($event){_vm.amount=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"slide",style:({ width: _vm.slideWidth })})])])]),_vm._v(" "),_c('div',{staticClass:"tc-btns"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],staticClass:"tc-amount",class:{ active: _vm.amount > 0 },attrs:{"type":"text","value":"0"},domProps:{"value":(_vm.amount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.amount=$event.target.value},function($event){_vm.amount = $event.target.value != '' ? $event.target.value : 0}],"click":function($event){return _vm.checkActiveAmount(_vm.coin)}}}),_vm._v(" "),_c('div',{staticClass:"fg-amount-name"},[_vm._v("USD")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.amount > 0)?_c('div',{staticClass:"result-volume"},[_vm._v("\n          ~ "+_vm._s(_vm.computeResult.toFixed(4))+" "),_c('b',[_vm._v(_vm._s(_vm.coin.symbol))])]):_vm._e()])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/payment"}},[_c('div',{staticClass:"tc-btn",class:{'buy-btn-choosen': _vm.amount > 0 },on:{"click":function($event){return _vm.buyOrder(_vm.coin)}}},[_vm._v("Buy")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ejEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buyList_vue__ = __webpack_require__("Neyk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da351cc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_buyList_vue__ = __webpack_require__("JpXe");
function injectStyle (ssrContext) {
  __webpack_require__("ZjWu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da351cc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buyList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da351cc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_buyList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eluC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMEM0LjAzMiAwIDAgNC4wMzIgMCA5QzAgMTMuOTY4IDQuMDMyIDE4IDkgMThDMTMuOTY4IDE4IDE4IDEzLjk2OCAxOCA5QzE4IDQuMDMyIDEzLjk2OCAwIDkgMFpNOSAyLjdDMTAuNDk0IDIuNyAxMS43IDMuOTA2IDExLjcgNS40QzExLjcgNi44OTQgMTAuNDk0IDguMSA5IDguMUM3LjUwNiA4LjEgNi4zIDYuODk0IDYuMyA1LjRDNi4zIDMuOTA2IDcuNTA2IDIuNyA5IDIuN1pNOSAxNS40OEM2Ljc1IDE1LjQ4IDQuNzYxIDE0LjMyOCAzLjYgMTIuNTgyQzMuNjI3IDEwLjc5MSA3LjIgOS44MSA5IDkuODFDMTAuNzkxIDkuODEgMTQuMzczIDEwLjc5MSAxNC40IDEyLjU4MkMxMy4yMzkgMTQuMzI4IDExLjI1IDE1LjQ4IDkgMTUuNDhaIiBmaWxsPSIjRTRFQ0YzIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "f87H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fBtB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forecast-step"},[_c('b-row',{staticClass:"e-lock-tokens"},[_c('b-col',{attrs:{"cols":"4"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-center mb-3 mt-2 eh-text-small eh-text-gray-dark"},[_c('span',[_c('i',{staticClass:"far fa-credit-card mr-1"}),_vm._v("Max. 15,000 EMiX")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Balance: "),_c('a',{staticClass:"font-weight-bold pl-1",attrs:{"href":"#"},on:{"click":_vm.onBalanceClick}},[_vm._v(_vm._s(_vm.balance)+" EMiX")])])]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"number","min":"0","max":_vm.balance},model:{value:(_vm.tokens),callback:function ($$v) {_vm.tokens=$$v},expression:"tokens"}}),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center mt-3 eh-text-small eh-text-gray-dark"},[_c('span',{staticClass:"text-uppercase font-weight-bold"},[_c('i',{staticClass:"fas fa-lock mr-1"}),_vm._v("Locked for 1 week")])]),_vm._v(" "),_c('e-hint',{staticClass:"lock-tokens-hint",attrs:{"title":"Notice"}},[_vm._v("Please be informed that the tokens you choose to lock will be locked for a 1 Week (AKA 7 Days) After one week you'r token will return to you ewallet and after that you'll be inform if you were rewarded on you moderation or not.")])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"7","offset":"1"}},[_c('div',{staticClass:"modal-block-title"},[_vm._v("Read and Accept the rules2")]),_vm._v(" "),_c('div',{staticClass:"rules"},[_c('div',{staticClass:"rules-wrapper"},[_c('p',[_vm._v("Ten years ago a crack commando until was sent to prison by a military count for a crime they didn't commit. These men promptly escaped from a maximum security stockade to the Los Angeles underground. Today, still wanted by the goverment, they survive as soldiers of fortune. If you have a problem and no one else can help, and if you can find them, maybe you can hire the A-team. Ten years ago a crack commando until was sent to prison by a military count for a crime they didn't commit.")]),_vm._v(" "),_c('p',[_vm._v("These men promptly escaped from a maximum security stockade to the Los Angeles underground. Today, still wanted by the goverment, they survive as soldiers of fortune. If you have a problem and no one else can help, and if you can find them, maybe you can hire the A-team.")]),_vm._v(" "),_c('p',[_vm._v("Ten years ago a crack commando until was sent to prison by a military count for a crime they didn't commit. These men promptly escaped from a maximum security stockade to the Los Angeles underground. Today, still wanted by the goverment, they survive as soldiers of fortune. If you have a problem and no one else can help, and if you can find them, maybe you can hire the A-team.")])])]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"mt-4 legacy-checkbox",attrs:{"value":true,"unchecked-value":false},model:{value:(_vm.rules),callback:function ($$v) {_vm.rules=$$v},expression:"rules"}},[_vm._v("\n        I accept the rules\n      ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('e-button',{attrs:{"type":"outlined","color":"gray"},on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('div',{staticClass:"d-flex ml-auto"},[_c('e-button',{staticStyle:{"margin-right":"20px"},attrs:{"type":"outlined"},on:{"click":_vm.preview}},[_vm._v("Back")]),_vm._v(" "),_c('e-button',{attrs:{"disabled":_vm.isDisabledNext},on:{"click":_vm.next}},[_vm._v("Submit Forecast")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fMnW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");


var state = {
  isShowForecastModal: false,
  forecastModalData: null,
  forecastPrediction: null,
  lockedTokens: 0,
  acceptedRules: false
};

// getters
var getters = {
  isShowForecastModal: function isShowForecastModal(state) {
    return state.isShowForecastModal;
  },
  forecastModalData: function forecastModalData(state) {
    return state.forecastModalData;
  },
  lockedTokens: function lockedTokens(state) {
    return state.lockedTokens;
  },
  acceptedRules: function acceptedRules(state) {
    return state.acceptedRules;
  },
  forecastPrediction: function forecastPrediction(state) {
    return state.forecastPrediction;
  }
};

// actions
var actions = {};

// mutations
var mutations = {
  setShowForecastModal: function setShowForecastModal(state, status) {
    state.isShowForecastModal = status;
  },
  setForecastModalData: function setForecastModalData(state, data) {
    state.forecastModalData = data;
  },
  setPrediction: function setPrediction(state, prediction) {
    state.forecastPrediction = prediction;
  },
  setLockedTokens: function setLockedTokens(state, tokens) {
    state.lockedTokens = tokens;
  },
  setAcceptedRules: function setAcceptedRules(state, rules) {
    state.acceptedRules = rules;
  },
  clearForecastModalData: function clearForecastModalData(state) {
    state.forecastModalData = null;
    state.forecastPrediction = null;
    state.lockedTokens = 0;
    state.acceptedRules = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "ftRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_http__ = __webpack_require__("vHCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__("QmSG");









var orderUri = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].services.order;
var ratingUri = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].services.rating;

var Orders = function () {
  function Orders() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Orders);

    this.useMock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["b" /* useMock */])('orders');
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Orders, [{
    key: 'fetchOrders',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.useMock) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_helpers__["c" /* sleep */])(200);

                          case 2:
                            _context.t0 = resolve;
                            _context.next = 5;
                            return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "96Vk"));

                          case 5:
                            _context.t1 = _context.sent;
                            (0, _context.t0)(_context.t1);

                          case 7:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchOrders() {
        return _ref.apply(this, arguments);
      }

      return fetchOrders;
    }()
  }, {
    key: 'getOrdersList',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(filter) {
        var params, _ref4, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {};

                params.limit = filter.limit || 25;
                params.page = filter.page || 1;

                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(ratingUri + '/api/v1/user/orders/list', { params: params });

              case 5:
                _ref4 = _context3.sent;
                data = _ref4.data;
                return _context3.abrupt('return', data.data);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getOrdersList(_x2) {
        return _ref3.apply(this, arguments);
      }

      return getOrdersList;
    }()
  }, {
    key: 'createOrder',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(order) {
        var _this2 = this;

        var orderData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                orderData = {
                  amount: order.coin.amount,
                  currencyToBuy: order.coin.symbol.toUpperCase(),
                  moneyCurrency: order.currency
                };
                return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve) {
                    var _ref7, data;

                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].post(orderUri + '/api/v1/orders/', orderData);

                          case 2:
                            _ref7 = _context4.sent;
                            data = _ref7.data;

                            resolve(data);

                          case 5:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this2);
                  }));

                  return function (_x4) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createOrder(_x3) {
        return _ref5.apply(this, arguments);
      }

      return createOrder;
    }()
  }, {
    key: 'paymentInfo',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(orderId) {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
                  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(resolve) {
                    var _ref10, data;

                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_6__plugins_http__["a" /* default */].get(orderUri + '/api/v1/orders/' + orderId + '/paymentinfo');

                          case 2:
                            _ref10 = _context6.sent;
                            data = _ref10.data;

                            resolve(data);

                          case 5:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this3);
                  }));

                  return function (_x6) {
                    return _ref9.apply(this, arguments);
                  };
                }()));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function paymentInfo(_x5) {
        return _ref8.apply(this, arguments);
      }

      return paymentInfo;
    }()
  }]);

  return Orders;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Orders());

/***/ }),

/***/ "fuTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ClearLayout"
});

/***/ }),

/***/ "g3M4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gZor":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_store__ = __webpack_require__("EBaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array__ = __webpack_require__("p5eA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_object_hash__ = __webpack_require__("eZXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_object_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_object_hash__);









var state = {
  assets: {},
  assetsIds: [],
  assetsAliases: {},
  criteria: {},
  criteriaIds: [],
  sectors: {},
  sectorsIds: [],
  filtersHash: {}
};

// getters
var getters = {
  asset: function asset(state) {
    return function (aliasOrId) {
      return state.assets[aliasOrId] || state.assets[state.assetsAliases[aliasOrId]];
    };
  },
  assetsByFilter: function assetsByFilter(state) {
    return function (filter) {
      var filterHash = __WEBPACK_IMPORTED_MODULE_7_object_hash___default()(filter);

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.assets).filter(function (key) {
        return state.filtersHash[filterHash].includes(key);
      }).reduce(function (obj, key) {
        obj[key] = state.assets[key];
        return obj;
      }, {});
    };
  },
  getByIds: function getByIds(state, getters) {
    return function (ids) {
      return state.assets.filter(function (a) {
        return ids.includes(a.id);
      });
    };
  },
  getById: function getById(state, getters) {
    return function (id) {
      return state.assets.find(function (a) {
        return a.id === id;
      });
    };
  },
  getAll: function getAll(state, getters) {
    return state.assets;
  },
  criterion: function criterion(state) {
    return function (id) {
      return state.criteria[id];
    };
  },
  criteria: function criteria(state) {
    return state.criteria;
  },
  sector: function sector(state) {
    return function (id) {
      return state.sectors[id];
    };
  }
};

// actions
var actions = {
  fetchAsset: function fetchAsset(_ref, aliasOrId) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch,
        rootGetters = _ref.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('fefe fetchAsset', state);

              if (!(state.assets[aliasOrId] || state.assets[state.assetsAliases[aliasOrId]])) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:

              dispatch('wait/start', 'assets.fetchAsset', { root: true });
              dispatch('wait/start', "assets." + aliasOrId + ".fetch", { root: true });
              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */].Assets.fetchAsset(aliasOrId);

            case 7:
              data = _context.sent;
              _context.next = 10;
              return dispatch('pushAsset', data);

            case 10:
              dispatch('wait/end', "assets." + aliasOrId + ".fetch", { root: true });
              dispatch('wait/end', 'assets.fetchAsset', { root: true });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  fetchAssets: function fetchAssets(_ref2, ids) {
    var _this2 = this;

    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch,
        rootGetters = _ref2.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              ids = _.isArray(ids) ? ids : [ids];

              if (!(_.difference(ids, state.assetsIds).length > 0)) {
                _context2.next = 9;
                break;
              }

              dispatch('wait/start', 'assets.fetchAssets', { root: true });
              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */].Assets.fetchAssets(_.difference(ids, state.assetsIds));

            case 5:
              data = _context2.sent;
              _context2.next = 8;
              return dispatch('pushAssets', data);

            case 8:
              dispatch('wait/end', 'assets.fetchAssets', { root: true });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  fetchAssetsByFilter: function fetchAssetsByFilter(_ref3, filter) {
    var _this3 = this;

    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch,
        rootGetters = _ref3.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var filterHash, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              filterHash = __WEBPACK_IMPORTED_MODULE_7_object_hash___default()(filter);

              if (state.filtersHash[filterHash]) {
                _context3.next = 11;
                break;
              }

              dispatch('wait/start', 'assets.fetchAssets', { root: true });
              _context3.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */].Assets.fetchAssetsByFilter(filter);

            case 5:
              data = _context3.sent;
              _context3.next = 8;
              return dispatch('saveFilter', {
                data: data,
                hash: filterHash,
                cb: function cb(data) {
                  return data.map(function (a) {
                    return a.id;
                  });
                }
              });

            case 8:
              _context3.next = 10;
              return dispatch('pushAssets', data);

            case 10:
              dispatch('wait/end', 'assets.fetchAssets', { root: true });

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  pushAssets: function pushAssets(_ref4, assets) {
    var _this4 = this;

    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["a" /* asyncForEach */])(assets, function () {
                var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(a) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          return _context4.abrupt("return", dispatch('pushAsset', a));

                        case 1:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this4);
                }));

                return function (_x) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this4);
    }))();
  },
  pushAsset: function pushAsset(_ref6, asset) {
    var _this5 = this;

    var commit = _ref6.commit,
        state = _ref6.state,
        dispatch = _ref6.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var prepareAsset, _splitIdsCollection, sectorsIds, sectorsObjects, _splitIdsCollection2, criteriaIds, criteriaObjects, assembledCriteria;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!state.assets[asset.id]) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return");

            case 2:
              prepareAsset = asset;
              _splitIdsCollection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_store__["a" /* splitIdsCollection */])(prepareAsset.sectors), sectorsIds = _splitIdsCollection.ids, sectorsObjects = _splitIdsCollection.objects;
              _splitIdsCollection2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_store__["a" /* splitIdsCollection */])(prepareAsset.criteria.map(function (c) {
                return c.criterion;
              })), criteriaIds = _splitIdsCollection2.ids, criteriaObjects = _splitIdsCollection2.objects;
              _context6.next = 7;
              return dispatch('pushSectors', sectorsObjects);

            case 7:
              _context6.next = 9;
              return dispatch('pushCriteria', criteriaObjects);

            case 9:

              // assemble true collection of criteria with popularity property
              assembledCriteria = {};


              prepareAsset.criteria.forEach(function (c) {
                if (criteriaIds.includes(c.criterion)) {
                  assembledCriteria[c.criterion] = c;
                } else if (criteriaObjects.includes(c.criterion)) {
                  assembledCriteria[c.criterion.id] = {
                    criterion: c.criterion.id,
                    popularity: c.popularity
                  };
                }
              });

              prepareAsset.sectors = sectorsIds.concat(sectorsObjects.map(function (s) {
                return s.id;
              }));

              // console.log(prepareAsset.sectors);

              prepareAsset.criteria = assembledCriteria;

              commit('addAsset', { id: prepareAsset.id, asset: prepareAsset });

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this5);
    }))();
  },
  fetchAssetsCriteria: function fetchAssetsCriteria(_ref7, assets) {
    var _this6 = this;

    var commit = _ref7.commit,
        state = _ref7.state,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var _ref8;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return dispatch('fetchCriteria', (_ref8 = _).uniq.apply(_ref8, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(assets.map(function (a) {
                return _.toArray(_.mapValues(a.criteria, function (c) {
                  return c.criterion;
                }));
              }))));

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this6);
    }))();
  },
  fetchAssetCriteria: function fetchAssetCriteria(_ref9, asset) {
    var _this7 = this;

    var commit = _ref9.commit,
        state = _ref9.state,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return dispatch('fetchCriteria', _.toArray(_.mapValues(asset.criteria, function (c) {
                return c.criterion;
              })));

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this7);
    }))();
  },
  searchCriteria: function searchCriteria(_ref10, search) {
    var _this8 = this;

    var commit = _ref10.commit,
        state = _ref10.state,
        dispatch = _ref10.dispatch,
        rootGetters = _ref10.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var criteria;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!(search === '')) {
                _context9.next = 2;
                break;
              }

              return _context9.abrupt("return");

            case 2:

              dispatch('wait/start', 'assets.searchCriteria', { root: true });
              _context9.next = 5;
              return __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */].Assets.searchCriteria(search, rootGetters['auth/token']);

            case 5:
              criteria = _context9.sent;
              _context9.next = 8;
              return dispatch('pushCriteria', criteria);

            case 8:

              // dispatch('saveFilter', {
              //   data: criteria,
              //   hash: searchHash,
              // });

              dispatch('wait/end', 'assets.searchCriteria', { root: true });

            case 9:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this8);
    }))();
  },
  fetchCriteria: function fetchCriteria(_ref11, ids) {
    var _this9 = this;

    var commit = _ref11.commit,
        state = _ref11.state,
        dispatch = _ref11.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["a" /* asyncForEach */])(ids, function () {
                var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10(id) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          _context10.next = 2;
                          return dispatch('fetchCriterion', id);

                        case 2:
                          return _context10.abrupt("return", _context10.sent);

                        case 3:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10, _this9);
                }));

                return function (_x2) {
                  return _ref12.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this9);
    }))();
  },
  fetchCriterion: function fetchCriterion(_ref13, id) {
    var _this10 = this;

    var commit = _ref13.commit,
        state = _ref13.state,
        dispatch = _ref13.dispatch,
        rootGetters = _ref13.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (state.criteria[id]) {
                _context12.next = 6;
                break;
              }

              _context12.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */].Assets.fetchCriterion(id, rootGetters['auth/token']);

            case 3:
              data = _context12.sent;
              _context12.next = 6;
              return dispatch('pushCriterion', data);

            case 6:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this10);
    }))();
  },
  fetchSectors: function fetchSectors(_ref14, ids) {
    var _this11 = this;

    var commit = _ref14.commit,
        state = _ref14.state,
        dispatch = _ref14.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              dispatch('wait/start', 'assets.fetchSectors', { root: true });
              _context14.next = 3;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["a" /* asyncForEach */])(ids, function () {
                var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13(id) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          _context13.next = 2;
                          return dispatch('fetchSector', id);

                        case 2:
                          return _context13.abrupt("return", _context13.sent);

                        case 3:
                        case "end":
                          return _context13.stop();
                      }
                    }
                  }, _callee13, _this11);
                }));

                return function (_x3) {
                  return _ref15.apply(this, arguments);
                };
              }());

            case 3:
              dispatch('wait/end', 'assets.fetchSectors', { root: true });

            case 4:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, _this11);
    }))();
  },
  fetchSector: function fetchSector(_ref16, id) {
    var _this12 = this;

    var commit = _ref16.commit,
        state = _ref16.state,
        dispatch = _ref16.dispatch,
        rootGetters = _ref16.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__services__["a" /* default */].Assets.fetchSector(id, rootGetters['auth/token']);

            case 2:
              data = _context15.sent;

              dispatch('pushSector', data);

              return _context15.abrupt("return", data);

            case 5:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, _this12);
    }))();
  },
  pushCriteria: function pushCriteria(_ref17, criteria) {
    var _this13 = this;

    var commit = _ref17.commit,
        state = _ref17.state,
        dispatch = _ref17.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["a" /* asyncForEach */])(criteria, function () {
                var _ref18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16(a) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
                    while (1) {
                      switch (_context16.prev = _context16.next) {
                        case 0:
                          _context16.next = 2;
                          return dispatch('pushCriterion', a);

                        case 2:
                          return _context16.abrupt("return", _context16.sent);

                        case 3:
                        case "end":
                          return _context16.stop();
                      }
                    }
                  }, _callee16, _this13);
                }));

                return function (_x4) {
                  return _ref18.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, _this13);
    }))();
  },
  pushCriterion: function pushCriterion(_ref19, criterion) {
    var _this14 = this;

    var commit = _ref19.commit,
        state = _ref19.state,
        dispatch = _ref19.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (!state.criteria[criterion.id]) {
                commit('addCriterion', { id: criterion.id, criterion: criterion });
              }

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, _this14);
    }))();
  },
  pushSectors: function pushSectors(_ref20, sectors) {
    var _this15 = this;

    var commit = _ref20.commit,
        state = _ref20.state,
        dispatch = _ref20.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["a" /* asyncForEach */])(sectors, function (a) {
                return dispatch('pushSector', a);
              });

            case 2:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, _this15);
    }))();
  },
  pushSector: function pushSector(_ref21, sector) {
    var _this16 = this;

    var commit = _ref21.commit,
        state = _ref21.state,
        dispatch = _ref21.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              if (!state.sectors[sector.id]) {
                commit('addSector', { id: sector.id, sector: sector });
              }

            case 1:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, _this16);
    }))();
  },
  saveFilter: function saveFilter(_ref22, _ref23) {
    var _this17 = this;

    var commit = _ref22.commit,
        state = _ref22.state,
        dispatch = _ref22.dispatch;
    var data = _ref23.data,
        hash = _ref23.hash,
        _ref23$cb = _ref23.cb,
        cb = _ref23$cb === undefined ? null : _ref23$cb;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              commit('addFilter', { id: hash, data: typeof cb === 'function' ? cb(data) : {} });

            case 1:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, _this17);
    }))();
  }
};

// mutations
var mutations = {
  addCriterion: function addCriterion(state, _ref24) {
    var id = _ref24.id,
        criterion = _ref24.criterion;

    state.criteria[id] = criterion;
  },
  addSector: function addSector(state, _ref25) {
    var id = _ref25.id,
        sector = _ref25.sector;

    state.sectors[id] = sector;
  },
  addAsset: function addAsset(state, _ref26) {
    var id = _ref26.id,
        asset = _ref26.asset;

    state.assets[id] = asset;
    if (asset.alias) {
      state.assetsAliases[asset.alias] = id;
    }
  },
  addFilter: function addFilter(state, _ref27) {
    var id = _ref27.id,
        data = _ref27.data;

    state.filtersHash[id] = data;
  },
  addCriterionToAsset: function addCriterionToAsset(state, _ref28) {
    var assetId = _ref28.assetId,
        criterionId = _ref28.criterionId;

    console.log(assetId);
    console.log(state.assets[assetId]);
    state.assets[assetId].criteria[criterionId] = {
      criterion: criterionId,
      popularity: 0
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "goVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "step-create-forecast",
  components: {},
  filters: {
    formatForecastDate: function formatForecastDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD MMM. YYYY');
    },
    formatPrice: function formatPrice(price) {
      price = parseFloat(price);
      if (price <= 10) {
        return price.toFixed(6);
      } else if (price <= 50) {
        return price.toFixed(4);
      }

      return price.toFixed(2);
    }
  },
  data: function data() {
    return {
      valuePercent: 0,
      valueAbs: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])('forecast', {
    setPrediction: 'setPrediction'
  }), {
    nextPage: function nextPage(type) {
      this.$emit('nextPage', type);
    },
    onPercentChange: function onPercentChange(v) {
      this.valueAbs = (this.asset.price.value / 100 * parseFloat(this.valuePercent) + this.asset.price.value).toFixed(4);
    },
    onAbsChange: function onAbsChange(v) {
      this.valuePercent = (parseFloat(this.valueAbs) * 100 / this.asset.price.value - 100).toFixed(2);
    },
    cancel: function cancel() {
      this.$emit('closeModal');
    },
    next: function next() {
      this.setPrediction({
        absolute: this.valueAbs,
        percent: this.valuePercent,
        change: this.changeValue
      });

      this.$emit('nextPage');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('forecast', {
    forecastData: 'forecastModalData'
  }), {
    asset: function asset() {
      return this.forecastData !== null ? this.forecastData.asset : null;
    },
    changeValue: function changeValue() {
      if (parseFloat(this.valueAbs) === 0) {
        return 0 .toFixed(4);
      }

      return (parseFloat(this.valueAbs) - parseFloat(this.asset.price.value)).toFixed(4);
    },
    isDisabledNext: function isDisabledNext() {
      return +this.valuePercent === 0;
    }
  }),
  mounted: function mounted() {
    // this.fetchCoins();
  }
});

/***/ }),

/***/ "gqU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:['vue-star-rating-star', {'vue-star-rating-star-rotate': _vm.shouldAnimate}],attrs:{"height":_vm.starSize,"width":_vm.starSize,"viewBox":_vm.viewBox},on:{"mousemove":_vm.mouseMoving,"click":_vm.selected,"touchstart":_vm.touchStart,"touchend":_vm.touchEnd}},[_c('linearGradient',{attrs:{"id":_vm.grad,"x1":"0","x2":"100%","y1":"0","y2":"0"}},[_c('stop',{attrs:{"offset":_vm.starFill,"stop-color":_vm.rtl ? _vm.getColor(_vm.inactiveColor) : _vm.getColor(_vm.activeColor),"stop-opacity":_vm.rtl ? _vm.getOpacity(_vm.inactiveColor) : _vm.getOpacity(_vm.activeColor)}}),_vm._v(" "),_c('stop',{attrs:{"offset":_vm.starFill,"stop-color":_vm.rtl ? _vm.getColor(_vm.activeColor) : _vm.getColor(_vm.inactiveColor),"stop-opacity":_vm.rtl ? _vm.getOpacity(_vm.activeColor) : _vm.getOpacity(_vm.inactiveColor)}})],1),_vm._v(" "),_c('filter',{attrs:{"id":_vm.glowId,"height":"130%","width":"130%","filterUnits":"userSpaceOnUse"}},[_c('feGaussianBlur',{attrs:{"stdDeviation":_vm.glow,"result":"coloredBlur"}}),_vm._v(" "),_c('feMerge',[_c('feMergeNode',{attrs:{"in":"coloredBlur"}}),_vm._v(" "),_c('feMergeNode',{attrs:{"in":"SourceGraphic"}})],1)],1),_vm._v(" "),(_vm.glowColor && _vm.glow > 0)?_c('polygon',{directives:[{name:"show",rawName:"v-show",value:(_vm.fill > 1),expression:"fill > 1"}],attrs:{"points":_vm.starPointsToString,"fill":_vm.gradId,"stroke":_vm.glowColor,"filter":'url(#' + _vm.glowId + ')',"stroke-width":_vm.border}}):_vm._e(),_vm._v(" "),_c('polygon',{attrs:{"points":_vm.starPointsToString,"fill":_vm.gradId,"stroke":_vm.getBorderColor,"stroke-width":_vm.border,"stroke-linejoin":_vm.strokeLinejoin}}),_vm._v(" "),_c('polygon',{attrs:{"points":_vm.starPointsToString,"fill":_vm.gradId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gxY3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h694":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hHqd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__("tqXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardHeader__ = __webpack_require__("njrz");



/* harmony default export */ __webpack_exports__["a"] = ({ Card: __WEBPACK_IMPORTED_MODULE_0__card__["a" /* default */], CardHeader: __WEBPACK_IMPORTED_MODULE_1__cardHeader__["a" /* default */] });

/***/ }),

/***/ "hOIL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hYU/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Temporarily disabled during legacy build migration.
// import markdownEditor from 'vue-simplemde/src/markdown-editor'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-rate-evaluation",
  // components: {
  //   markdownEditor,
  // },
  props: {
    criterionId: String
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('rate', {
    getCriterionEvaluation: 'getCriterionEvaluation',
    getCriterionJustification: 'getCriterionJustification',
    averageEvaluation: 'getAverageEvaluation'
  }), {
    justification: {
      get: function get() {
        return this.getCriterionJustification(this.criterionId);
      },
      set: function set(value) {
        this.changeJustification({
          id: this.criterionId,
          justification: value
        });
      }
    }
  }),
  data: function data() {
    return {
      mdConfig: {
        toolbar: ["bold", "italic", "heading", "|", "heading-1", "heading-2", "heading-3", "|", "quote", "code", "|", "unordered-list", "ordered-list", "table", "|", "preview"]
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('rate', {
    changeEvaluation: 'changeEvaluation',
    changeJustification: 'changeJustification'
  }), {
    onChangeEval: function onChangeEval(evaluation) {
      this.changeEvaluation({
        id: this.criterionId,
        evaluation: evaluation
      });
    }
  })
});

/***/ }),

/***/ "hdIc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-card__header-append"},[_c('b-dropdown',{ref:"dropdown",staticClass:"e-dropdown e-card__dropdown",attrs:{"right":"","toggle-class":"e-card__dropdown-toggle e-topbar__dropdown-toggle","menu-class":"e-dropdown__menu e-dropdown__menu--right e-card__dropdown-menu"}},[_c('b-dropdown-item',{staticClass:"e-dropdown__item"},[_vm._v("Explore")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"e-dropdown__item",on:{"click":_vm.moveElement}},[_vm._v("Move")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"e-dropdown__item"},[_vm._v("Delete")]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"e-dropdown__item"},[_vm._v("Share")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hf0W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hi96":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hm1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topbar_vue__ = __webpack_require__("HolZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b5c676_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topbar_vue__ = __webpack_require__("Ofui");
function injectStyle (ssrContext) {
  __webpack_require__("HZmZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26b5c676"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b5c676_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hqb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header__ = __webpack_require__("c5w6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stepPaymentMethod_vue__ = __webpack_require__("utaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stepWallet_vue__ = __webpack_require__("K7k7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stepWiretransfer_vue__ = __webpack_require__("TzeR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stepSentMoney_vue__ = __webpack_require__("4oBp");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-buy-crypto",
  components: { EmBuyCryptoHeader: __WEBPACK_IMPORTED_MODULE_2__header__["a" /* default */], StepPaymentMethod: __WEBPACK_IMPORTED_MODULE_4__stepPaymentMethod_vue__["a" /* default */], StepWallet: __WEBPACK_IMPORTED_MODULE_5__stepWallet_vue__["a" /* default */], StepWiretransfer: __WEBPACK_IMPORTED_MODULE_6__stepWiretransfer_vue__["a" /* default */], StepSentMoney: __WEBPACK_IMPORTED_MODULE_7__stepSentMoney_vue__["a" /* default */] },
  data: function data() {
    return {
      current: 1,
      isFinished: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])("settings", ["paymentState"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('orders', {
    'isShowBuyModal': 'isShowBuyModal',
    orderData: 'buyModalData'
  }), {
    asset: function asset() {
      return this.orderData !== null ? this.orderData.asset : null;
    },
    currency: function currency() {
      return this.orderData.currency;
    },
    amount: function amount() {
      return parseFloat(this.orderData.amount);
    },
    volume: function volume() {
      return this.amount / this.asset.price.value;
    },
    steps: function steps() {
      return [{
        label: 'Choose Payment Method',
        number: 1
      }, {
        label: 'Wallet',
        number: 2
      }, {
        label: 'Payment',
        number: 3
      }, {
        label: 'Take ' + this.asset.name,
        number: 4
      }];
    },

    show: {
      get: function get() {
        return this.isShowBuyModal;
      },
      set: function set(v) {
        this.setShowBuyModal(v);
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])('orders', ['setShowBuyModal']), {
    close: function close() {
      this.show = false;
    },
    onShow: function onShow() {
      this.current = 1;
      this.isFinished = false;
      var modal = this.$refs.modal;
      var $app = this.$root.$el;

      $app.parentNode.appendChild(modal.$el);
    }
  })
});

/***/ }),

/***/ "hsIk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu-header"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iCs3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('keep-alive',[_c('draggable',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide),expression:"hide"}],ref:"drag",staticClass:"row e-draggable",class:{'e-draggable--active': _vm.canDrag},attrs:{"move":_vm.move,"options":_vm.options},model:{value:(_vm.components),callback:function ($$v) {_vm.components=$$v},expression:"components"}},_vm._l((_vm.components),function(component,i){return _c(component.component,{key:component.id,tag:"component",staticClass:"e-draggable__item",class:{'e-draggable__target': _vm.dragId === component.id},attrs:{"size":component.size},on:{"toggleDrag":function () { return _vm.toggleDrag(component.id); }}})}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iOlq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");




var state = {
  coins: []
};

// getters
var getters = {
  coins: function coins(state, getters, root) {
    return state.coins;
  }
};

// actions
var actions = {
  fetchCoins: function fetchCoins(_ref) {
    // const data = await Services.Coins.fetchCoins();
    // let coins = data.default.map(e => { e.small = true; return e; })
    // commit('updateCoins', coins);

    var _this = this;

    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  smallAllCoins: function smallAllCoins(_ref2, coin) {
    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;

    commit('smallerCoins', coin);
  }
};

// mutations
var mutations = {
  updateCoins: function updateCoins(state, data) {
    state.coins = [].concat(data);
  },
  smallerCoins: function smallerCoins(state, coin) {
    state.coins.forEach(function (c) {
      if (c != coin) c.small = true;else c.small = !c.small;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "iSCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_star_rating_vue__ = __webpack_require__("5tLd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a685cc30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_star_rating_vue__ = __webpack_require__("xHgi");
function injectStyle (ssrContext) {
  __webpack_require__("hOIL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a685cc30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_star_rating_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a685cc30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_star_rating_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ig+Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"payment-step"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"modal-block-title"},[_vm._v("Enter your "+_vm._s(this.orderData.asset.name)+" wallet ID")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('e-input',{attrs:{"type":"text","floating":"","label":"Wallet"},model:{value:(_vm.wallet),callback:function ($$v) {_vm.wallet=$$v},expression:"wallet"}}),_vm._v(" "),_c('e-hint',{attrs:{"title":"Notice"}},[_vm._v("We will send you the coins to the address you enter here. Make sure you enter a VALID Bitcoin wallet or your coins may be lost. You will need to reconfirm your Wallet ID later.")]),_vm._v(" "),_c('e-button',{staticStyle:{"margin-top":"20px","margin-left":"auto"},attrs:{"disabled":_vm.isWalidAddress},on:{"click":_vm.nextPage}},[_vm._v("Use this Wallet ID")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ijvn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguODc5NzcgMC4wMDA4MTc5MzNDMy45MDk1OCAwLjA2NzM0MDIgLTAuMDY1MzE3NiA0LjE1MDgzIDAuMDAwODEzMzQ0IDkuMTIxMjFDMC4wNjczMzU2IDE0LjA4OTQgNC4xNTA0MyAxOC4wNjU1IDkuMTIwNDMgMTcuOTk5NEMxNC4wODk2IDE3LjkzMjUgMTguMDY1MyAxMy44NDkgMTcuOTk5MiA4Ljg3ODk5QzE3LjkzMjcgMy45MTAzNyAxMy44NDk0IC0wLjA2NTUwODYgOC44Nzk3NyAwLjAwMDgxNzkzM1pNOC44NTMxNiAxNC40Nzg0TDguODAzNDcgMTQuNDc3NkM4LjAzODA3IDE0LjQ1NDkgNy40OTg0NiAxMy44OTExIDcuNTIwMTcgMTMuMTM3QzcuNTQxNSAxMi4zOTU5IDguMDk0MjIgMTEuODU3OCA4LjgzNDM4IDExLjg1NzhMOC44Nzg3OSAxMS44NTg2QzkuNjY1NTIgMTEuODgxOSAxMC4xOTkxIDEyLjQ0MDEgMTAuMTc3IDEzLjIxNTlDMTAuMTU1IDEzLjk1OTEgOS42MTA5MyAxNC40Nzg0IDguODUzMTYgMTQuNDc4NFpNMTIuMDcyNiA4LjA4ODU1QzExLjg5MjYgOC4zNDQyNyAxMS40OTY4IDguNjYxODIgMTAuOTk4MSA5LjA1MDM5TDEwLjQ0ODkgOS40Mjk1NkMxMC4xNDc0IDkuNjYzOTUgOS45NjU0NSA5Ljg4NDQ2IDkuODk3MTcgMTAuMTAxNEM5Ljg0MzM2IDEwLjI3MjIgOS44MTY5NSAxMC4zMTc0IDkuODEyMjYgMTAuNjY0OUw5LjgxMTQ3IDEwLjc1MzJINy43MTQ0Nkw3LjcyMDUyIDEwLjU3NTdDNy43NDYxNSA5Ljg0NjMgNy43NjQxNSA5LjQxNzI0IDguMDY2NDQgOS4wNjI3MUM4LjU0MDcgOC41MDU4OCA5LjU4Njg2IDcuODMyMjUgOS42MzEyOCA3LjgwMzY4QzkuNzgxMTUgNy42OTA3OSA5LjkwNzU0IDcuNTYyMjQgMTAuMDAxNiA3LjQyNDg5QzEwLjIyMTggNy4xMjE0NCAxMC4zMTkyIDYuODgyNTQgMTAuMzE5MiA2LjY0Nzc2QzEwLjMxOTIgNi4zMjIgMTAuMjIyNSA2LjAyMDY5IDEwLjAzMTQgNS43NTI0NUM5Ljg0NzY3IDUuNDkzNiA5LjQ5ODYyIDUuMzYyNTEgOC45OTM4NCA1LjM2MjUxQzguNDkzMTYgNS4zNjI1MSA4LjE1MDM3IDUuNTIxMzggNy45NDUzMyA1Ljg0NzM0QzcuNzM0NDEgNi4xODI0OSA3LjYyNzc4IDYuNTM0NDggNy42Mjc3OCA2Ljg5NDA5VjYuOTgzNUg1LjQ2NTYyTDUuNDY5NTMgNi44OTAxN0M1LjUyNTI5IDUuNTY1NzkgNS45OTc5OSA0LjYxMjE4IDYuODczOTMgNC4wNTU3NEM3LjQyNDMgMy43MDE0MSA4LjEwOTA5IDMuNTIxOCA4LjkwODE0IDMuNTIxOEM5Ljk1NDEgMy41MjE4IDEwLjgzNzEgMy43NzU5NSAxMS41MzIyIDQuMjc3MjJDMTIuMjM2NiA0Ljc4NTE0IDEyLjU5MzkgNS41NDU4NCAxMi41OTM5IDYuNTM4MTlDMTIuNTkzOSA3LjA5MzI2IDEyLjQxODYgNy42MTQ2OCAxMi4wNzI2IDguMDg4NTVaIiBmaWxsPSIjRTRFQ0YzIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "itHa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-steps"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('ul',{staticClass:"e-breadcrumb"},_vm._l((_vm.steps),function(step,i){return _c('li',{key:i,staticClass:"e-breadcrumb__item",class:{'e-breadcrumb--active': step.number < _vm.current, 'e-breadcrumb--current': step.number === _vm.current}},[_c('span',[_vm._v(_vm._s(step.label))])])}),0)])],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iuW+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_steps_vue__ = __webpack_require__("PyWm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e3e8e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_steps_vue__ = __webpack_require__("itHa");
function injectStyle (ssrContext) {
  __webpack_require__("VLrv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69e3e8e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e3e8e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ivRg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__("c/9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_http__ = __webpack_require__("vHCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("QmSG");








var uri = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].services.rating;

var Forecasts = function () {
  function Forecasts() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Forecasts);

    this.useMock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["b" /* useMock */])('assets');
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Forecasts, [{
    key: "fetchForecasts",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filter) {
        var params, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {};


                params.limit = filter.limit || 25;
                params.page = filter.page || 1;
                params.sort = filter.sort || '';
                params.type = filter.type || 'all';

                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].get(uri + "/api/v1/forecasts/list", { params: params });

              case 7:
                _ref2 = _context.sent;
                data = _ref2.data;
                return _context.abrupt("return", data.data);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchForecasts(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchForecasts;
    }()
  }, {
    key: "sendPrediction",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id, data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].post(uri + "/api/v1/forecasts/" + id + "/prediction", data);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendPrediction(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return sendPrediction;
    }()
  }, {
    key: "getForecastPrediction",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var _ref5, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].get(uri + "/api/v1/forecasts/" + id + "/prediction");

              case 2:
                _ref5 = _context3.sent;
                data = _ref5.data;
                return _context3.abrupt("return", data.data);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getForecastPrediction(_x4) {
        return _ref4.apply(this, arguments);
      }

      return getForecastPrediction;
    }()
  }, {
    key: "getForecastsList",
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(filter) {
        var params, _ref7, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {};

                params.limit = filter.limit || 25;
                params.page = filter.page || 1;

                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].get(uri + "/api/v1/user/forecasts/list", { params: params });

              case 5:
                _ref7 = _context4.sent;
                data = _ref7.data;
                return _context4.abrupt("return", data.data);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getForecastsList(_x5) {
        return _ref6.apply(this, arguments);
      }

      return getForecastsList;
    }()
  }]);

  return Forecasts;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Forecasts());

/***/ }),

/***/ "j1/8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jNXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assetCard__ = __webpack_require__("KnVC");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__assetCard__["a" /* default */]);

/***/ }),

/***/ "jVvO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiNFNEVDRjMiIGQ9Ik0xNC40MjggNS40MWgtLjI2OUMxMy40MTYgMi4yNDkgMTAuODg5IDAgNy45OTcgMGMtMi44NzUgMC01LjQgMi4yNDktNi4xNTQgNS40MTFoLS4yNzFDLjcwNSA1LjQxMSAwIDYuMjIxIDAgNy4yMTZ2Mi4wMjhjMCAuOTk1LjcwNSAxLjgwNSAxLjU3MiAxLjgwNWguMTk1Yy4yNTIgMi4yNzMgMS45NDcgNC4wMzcgMy45OTMgNC4wMzdoLjM3NmMuMTk5LjUzNy42NjMuOTE0IDEuMjAyLjkxNGgxLjMyNGMuNzIgMCAxLjMwNi0uNjczIDEuMzA2LTEuNSAwLS44MjgtLjU4Ni0xLjUtMS4zMDYtMS41SDcuMzM4Yy0uNTQgMC0xLjAwMy4zNzctMS4yMDIuOTEzSDUuNzZjLTEuNjU2IDAtMy4wMDQtMS41NDgtMy4wMDQtMy40NXYtNC40Yy41MjgtMi44MzcgMi43MjQtNC44OSA1LjI0MS00Ljg5IDIuNTM0IDAgNC43MzMgMi4wNTIgNS4yNDcgNC44ODh2NC40MDFjMCAuMzI0LjIyOS41ODYuNTEuNTg2aC42NzRjLjg2NyAwIDEuNTcyLS44MSAxLjU3Mi0xLjgwNVY3LjIxNmMwLS45OTYtLjcwNS0xLjgwNS0xLjU3Mi0xLjgwNXptLTcuMDkgOC43NjJoMS4zMjRjLjE1NyAwIC4yODUuMTQ3LjI4NS4zMjggMCAuMTgtLjEyOC4zMjgtLjI4NS4zMjhINy4zMzhjLS4xNTcgMC0uMjg1LS4xNDctLjI4NS0uMzI4IDAtLjE4MS4xMjgtLjMyOC4yODUtLjMyOHpNMS4wMjEgOS4yNDRWNy4yMTZjMC0uMzQ5LjI0Ny0uNjMyLjU1LS42MzJoLjE2NHYzLjI5MmgtLjE2M2MtLjMwNCAwLS41NTEtLjI4My0uNTUxLS42MzJ6bTEzLjk1OCAwYzAgLjM0OC0uMjQ3LjYzMi0uNTUuNjMyaC0uMTY0VjYuNTgzaC4xNjNjLjMwNCAwIC41NTEuMjg0LjU1MS42MzN2Mi4wMjd6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "jb7y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-list"},[_c('transition-group',{attrs:{"name":"fade","appear":""}},_vm._l((_vm.items),function(item){return _c('div',{key:("s" + (item.id)),staticClass:"activity-item"},[_c('div',{staticClass:"activity-image"},[_c('img',{attrs:{"src":item.image}})]),_vm._v(" "),_c('div',{staticClass:"activity-content"},[_c('h3',[_vm._v(_vm._s(item.message))]),_vm._v(" "),(item.hint)?_c('div',{staticClass:"activity-hint",domProps:{"innerHTML":_vm._s(item.hint)}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formattedDate(item.date)))])])])}),0),_vm._v(" "),(_vm.items.length < 4)?_c('div',{staticClass:"empty-content",style:(_vm.computedStyle)},[_c('div',{staticClass:"header"},[_vm._v("\n      Participates more - Get more\n    ")]),_vm._v(" "),_c('p',[_vm._v("Perform actions on the platform and get rewarded.")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jh3x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jyjQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-card-header",
  methods: {
    moveElement: function moveElement() {
      this.$emit('move');
    }
  }
});

/***/ }),

/***/ "kHJ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepCreateForecast_vue__ = __webpack_require__("goVC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296ce318_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepCreateForecast_vue__ = __webpack_require__("Lzff");
function injectStyle (ssrContext) {
  __webpack_require__("h694")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepCreateForecast_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296ce318_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepCreateForecast_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kLh0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_finish_vue__ = __webpack_require__("ysFa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09422ee1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_finish_vue__ = __webpack_require__("TIZb");
function injectStyle (ssrContext) {
  __webpack_require__("miYH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09422ee1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_finish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09422ee1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_finish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kPMY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_assets__ = __webpack_require__("SjBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookies_js__ = __webpack_require__("wFBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cookies_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-modal-asset-header",
  props: {
    asset: Object,
    hint: Object,
    meta: Array,
    type: String
  },
  data: function data() {
    return {
      isHintVisible: false
    };
  },

  methods: {
    hideHint: function hideHint() {
      this.isHintVisible = false;
      __WEBPACK_IMPORTED_MODULE_1_cookies_js___default.a.set("hintDisabled_" + this.type, true);
    }
  },
  computed: {
    assetEmixtier: function assetEmixtier() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_assets__["a" /* convertRateToEmixtier */])(this.asset.rate);
    }
  },
  created: function created() {
    var hintDisabled = __WEBPACK_IMPORTED_MODULE_1_cookies_js___default.a.get("hintDisabled_" + this.type);
    this.isHintVisible = !hintDisabled;
  }
});

/***/ }),

/***/ "khtj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forecast_vue__ = __webpack_require__("djKh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd4d2dc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forecast_vue__ = __webpack_require__("LmS/");
function injectStyle (ssrContext) {
  __webpack_require__("9kTw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd4d2dc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forecast_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd4d2dc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forecast_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kr3L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_store__ = __webpack_require__("EBaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__("p5eA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_object_hash__ = __webpack_require__("eZXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_object_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_object_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");








var state = {
  moderation: {},
  moderationGroup: {}
};

// getters
var getters = {
  moderation: function moderation(state) {
    return function (id) {
      return state.moderation[id];
    };
  },
  moderationGroupByAsset: function moderationGroupByAsset(state) {
    return function (assetId) {
      return _.find(state.moderationGroup, function (g) {
        return g.asset === assetId;
      });
    };
  }
};

// actions
var actions = {
  fetchModerationItem: function fetchModerationItem(_ref, moderationId) {
    var _this = this;

    var dispatch = _ref.dispatch,
        commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.moderation[moderationId]) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:

              dispatch('wait/start', "moderation." + moderationId + ".fetch", { root: true });

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].Moderation.fetchModerationItem(moderationId);

            case 5:
              data = _context.sent;
              _context.next = 8;
              return dispatch('pushModeration', data);

            case 8:

              dispatch('wait/end', "moderation." + moderationId + ".fetch", { root: true });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  fetchModerationGroupByAsset: function fetchModerationGroupByAsset(_ref2, assetId) {
    var _this2 = this;

    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch,
        rootGetters = _ref2.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_.find(state.moderationGroup, function (m) {
                return m.asset === assetId;
              })) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].Auth.fetchModerationGroup(assetId, rootGetters['auth/token']);

            case 4:
              data = _context2.sent;
              _context2.next = 7;
              return dispatch('pushModerationGroup', data);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  fetchModerationGroupByFilter: function fetchModerationGroupByFilter(_ref3, filter) {
    var _this3 = this;

    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch,
        rootGetters = _ref3.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].Moderation.fetchModerationGroupsByFilter(filter);

            case 2:
              data = _context3.sent;
              _context3.next = 5;
              return dispatch('pushModerationGroup', data);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  pushModerationGroup: function pushModerationGroup(_ref4, group) {
    var _this4 = this;

    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch,
        rootGetters = _ref4.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _splitIdsCollection, moderationIds, moderationObjects;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!state.moderationGroup[group.id]) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              _splitIdsCollection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* splitIdsCollection */])(group.moderation), moderationIds = _splitIdsCollection.ids, moderationObjects = _splitIdsCollection.objects;
              _context4.next = 5;
              return dispatch('pushModeration', moderationObjects);

            case 5:

              group.moderation = moderationIds.concat(moderationObjects.map(function (m) {
                return m.id;
              }));

              commit('addModerationGroup', { id: group.id, group: group });

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  pushModeration: function pushModeration(_ref5, moderation) {
    var _this5 = this;

    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch,
        rootGetters = _ref5.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              moderation = _.isArray(moderation) ? moderation : [moderation];

              moderation.forEach(function (m) {
                if (!state.moderation[m.id]) {
                  commit('addModeration', { id: m.id, moderation: m });
                }
              });

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
};

// mutations
var mutations = {
  updateModerationEval: function updateModerationEval(state, _ref6) {
    var id = _ref6.id,
        evaluate = _ref6.evaluate;

    console.log(id, evaluate);
    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(state.moderation[id], 'evaluate', evaluate);

    // state.moderation[id].evaluation = evaluation;
  },
  addModeration: function addModeration(state, _ref7) {
    var id = _ref7.id,
        moderation = _ref7.moderation;

    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(state.moderation, id, moderation);
    // state.moderation[id] = moderation;
  },
  addModerationGroup: function addModerationGroup(state, _ref8) {
    var id = _ref8.id,
        group = _ref8.group;

    state.moderationGroup[id] = group;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "l3K8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lf14":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menuHeader_vue__ = __webpack_require__("9CXc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de6f3518_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menuHeader_vue__ = __webpack_require__("hsIk");
function injectStyle (ssrContext) {
  __webpack_require__("jh3x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de6f3518"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menuHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de6f3518_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menuHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ljbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepLockTokens_vue__ = __webpack_require__("p31G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_550eb8b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepLockTokens_vue__ = __webpack_require__("fBtB");
function injectStyle (ssrContext) {
  __webpack_require__("DhXM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepLockTokens_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_550eb8b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepLockTokens_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m+09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chat_vue__ = __webpack_require__("YdSO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28dc2e22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chat_vue__ = __webpack_require__("XEzv");
function injectStyle (ssrContext) {
  __webpack_require__("RcyS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28dc2e22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28dc2e22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mb2O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_performance_vue__ = __webpack_require__("mbri");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30793836_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_performance_vue__ = __webpack_require__("MEQn");
function injectStyle (ssrContext) {
  __webpack_require__("Mijz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30793836"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_performance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30793836_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_performance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mbri":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__elements_card_card__ = __webpack_require__("tqXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_lineChart_lineChart__ = __webpack_require__("7rHV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_dynamicSize__ = __webpack_require__("KOBJ");
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ec-performance",
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_dynamicSize__["a" /* default */]],
  components: { EbLineChart: __WEBPACK_IMPORTED_MODULE_1__widgets_lineChart_lineChart__["a" /* default */], ECard: __WEBPACK_IMPORTED_MODULE_0__elements_card_card__["a" /* default */] }
});

/***/ }),

/***/ "miYH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mtPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rate__ = __webpack_require__("wm9K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__moderate__ = __webpack_require__("PV91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kyc__ = __webpack_require__("sqmj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buyCrypto__ = __webpack_require__("p8tu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header__ = __webpack_require__("r6Mc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__averageScore__ = __webpack_require__("G2NB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forecast__ = __webpack_require__("46VR");








/* harmony default export */ __webpack_exports__["a"] = ({
  EmRate: __WEBPACK_IMPORTED_MODULE_0__rate__["a" /* default */],
  EmModerate: __WEBPACK_IMPORTED_MODULE_1__moderate__["a" /* default */],
  EmHeader: __WEBPACK_IMPORTED_MODULE_4__header__["a" /* default */],
  EmAssetAverageScore: __WEBPACK_IMPORTED_MODULE_5__averageScore__["a" /* default */],
  EmKYC: __WEBPACK_IMPORTED_MODULE_2__kyc__["a" /* default */],
  EmBuyCrypto: __WEBPACK_IMPORTED_MODULE_3__buyCrypto__["a" /* default */],
  EmForecast: __WEBPACK_IMPORTED_MODULE_6__forecast__["a" /* default */]
});

/***/ }),

/***/ "muIl":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuOTMzNDkgOS4wMDk3N0gwLjQ4MjY2MUMwLjIxNjA4NyA5LjAwOTc3IDAgOS4yMjYxMiAwIDkuNDkzMDNWMTcuNTE2M0MwIDE3Ljc4MzIgMC4yMTYwODcgMTcuOTk5NSAwLjQ4MjY2MSAxNy45OTk1SDMuOTMzNDlDNC4yMDAwNiAxNy45OTk1IDQuNDE2MTUgMTcuNzgzMiA0LjQxNjE1IDE3LjUxNjNWOS40OTMwM0M0LjQxNjE1IDkuMjI2MTcgNC4yMDAwNiA5LjAwOTc3IDMuOTMzNDkgOS4wMDk3N1oiIGZpbGw9IiNFNEVDRjMiLz4KPHBhdGggZD0iTTkuNzI1NDggMEg2LjI3NDY1QzYuMDA4MDggMCA1Ljc5MTk5IDAuMjE2MzU4IDUuNzkxOTkgMC40ODMyNjZWMTcuNTE2N0M1Ljc5MTk5IDE3Ljc4MzUgNi4wMDgwOCAxOCA2LjI3NDY1IDE4SDkuNzI1NDhDOS45OTIwNiAxOCAxMC4yMDgxIDE3Ljc4MzUgMTAuMjA4MSAxNy41MTY3VjAuNDgzMjY2QzEwLjIwODEgMC4yMTYzNTggOS45OTIxIDAgOS43MjU0OCAwWiIgZmlsbD0iI0U0RUNGMyIvPgo8cGF0aCBkPSJNMTUuNTE3NSA1LjU3MDMxSDEyLjA2NjZDMTEuODAwMSA1LjU3MDMxIDExLjU4NCA1Ljc4NjY3IDExLjU4NCA2LjA1MzU4VjE3LjUxN0MxMS41ODQgMTcuNzgzOCAxMS44MDAxIDE4LjAwMDMgMTIuMDY2NiAxOC4wMDAzSDE1LjUxNzVDMTUuNzg0IDE4LjAwMDMgMTYuMDAwMSAxNy43ODM4IDE2LjAwMDEgMTcuNTE3VjYuMDUzNThDMTYuMDAwMSA1Ljc4NjY3IDE1Ljc4NDEgNS41NzAzMSAxNS41MTc1IDUuNTcwMzFaIiBmaWxsPSIjRTRFQ0YzIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "nO1W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ngrN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-xl-row flex-column"},[_c('div',{staticClass:"e-card__content d-none d-xl-flex"},[_c('b-table',{staticClass:"e-table e-table--filter--gray-scale",attrs:{"hover":"","outlined":"","fields":_vm.lineTableFields,"items":_vm.tableItems},on:{"row-clicked":_vm.onRowClicked},scopedSlots:_vm._u([{key:"coin",fn:function(data){return [_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"e-avatar size-30 mr-4"},[_c('img',{attrs:{"src":__webpack_require__("UEml")}})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('b',[_vm._v(_vm._s(data.item.asset))]),_vm._v(" "),_c('small',{staticClass:"eh-secondary-text"},[_vm._v("BTC")])])])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"e-card__content d-flex d-xl-none align-items-center"},[_c('b-btn',{staticClass:"e-btn e-btn--size--small e-btn--outlined e-btn--color--blue-light",class:{'e-btn--type--select': _vm.chartVisible},on:{"click":function($event){_vm.chartVisible = !_vm.chartVisible}}},[_vm._v("\n      "+_vm._s(_vm.chartVisible ? 'Show coins' : 'Apply')+"\n    ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.chartVisible),expression:"!chartVisible"}],staticClass:"eh-secondary-text ml-auto"},[_vm._v("Selected "+_vm._s(_vm.selectedItems.length)+" of "+_vm._s(this.maxSelected))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.chartVisible),expression:"chartVisible"}],staticClass:"e-scroll e-scroll--x"},[_c('div',{staticClass:"e-scroll__wrapper"},_vm._l((_vm.selectedItemsObject),function(item,key){return _c('b-btn',{key:key,staticClass:"e-btn e-btn--outlined e-btn--size--small e-btn--fill font-weight-bold",class:[("e-btn--color--" + (item.__color))],on:{"click":function($event){return _vm.onRowClicked(item, item.index)}}},[_vm._v("\n          "+_vm._s(item.asset)+" "),_c('span',{staticClass:"close"})])}),1)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowChart),expression:"isShowChart"}],staticClass:"line-chart"},[_c('transition-group',{attrs:{"name":"fade","mode":"out-in"}},[_c('highcharts',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItems.length > 0),expression:"selectedItems.length > 0"}],key:"chart",ref:"chart",staticClass:"line-chart__container",attrs:{"options":_vm.chartOptions}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItems.length <= 0),expression:"selectedItems.length <= 0"}],key:"empty",staticClass:"line-chart__empty"},[_c('p',[_vm._v("Please, select data")])])],1)],1),_vm._v(" "),(!_vm.isShowChart)?_c('div',{staticClass:"e-card__content e-line-chart-list d-flex d-xl-none row"},_vm._l((_vm.tableItems),function(item,key){return _c('div',{staticClass:"col-6 col-sm-4"},[_c('eb-line-chart-list-item',{attrs:{"item":item},on:{"click":function($event){return _vm.onRowClicked(item, key)}}})],1)}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "njrz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardHeader_vue__ = __webpack_require__("jyjQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c083f534_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardHeader_vue__ = __webpack_require__("hdIc");
function injectStyle (ssrContext) {
  __webpack_require__("+vqq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c083f534"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c083f534_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nkPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-card',{class:_vm.sizeClasses,on:{"toggleDrag":function($event){return _vm.$emit('toggleDrag')}}},[_c('b-tab',{staticClass:"e-card__content",attrs:{"title":"Forecast"}},[_c('b-table',{staticClass:"e-table e-table--filter--gray-scale",attrs:{"hover":"","outlined":"","fields":_vm.forecastTableFields,"items":_vm.forecastTableItems},scopedSlots:_vm._u([{key:"HEAD_forecasted",fn:function(data){return [_vm._v("\n        Forecast crowd / "),_c('b',[_vm._v("Your")])]}},{key:"HEAD_accuracy",fn:function(data){return [_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(data.label))])]}},{key:"index",fn:function(data){return [_vm._v("\n        "+_vm._s(data.index + 1)+"\n      ")]}},{key:"preview",fn:function(data){return [_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"e-avatar size-30 mr-4"},[_c('img',{attrs:{"src":__webpack_require__("UEml")}})]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('b',[_vm._v("Bitcoin")]),_vm._v(" "),_c('small',{staticClass:"eh-secondary-text"},[_vm._v("BTC")])])])]}},{key:"forecasted",fn:function(data){return [_vm._v("\n        "+_vm._s(data.item.crowd)+" / "),_c('b',[_vm._v(_vm._s(data.item.your))])]}},{key:"accuracy",fn:function(data){return [_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(data.value))])]}},{key:"actions",fn:function(data){return [_vm._v("\n        ...\n      ")]}}])})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Rate"}}),_vm._v(" "),_c('b-tab',{attrs:{"title":"Portfolio"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o/rg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oM57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}]},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oZ5M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oaKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_http__ = __webpack_require__("vHCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("QmSG");








var uri = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */].services.rating;

var Moderation = function () {
  function Moderation() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Moderation);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Moderation, [{
    key: 'fetchCurrentModerationGroup',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(assetId) {
        var _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('ACC', uri + '/api/v1/moderation/current/' + assetId);
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].get(uri + '/api/v1/moderation/current/' + assetId);

              case 3:
                _ref2 = _context.sent;
                data = _ref2.data;
                return _context.abrupt('return', data.data);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchCurrentModerationGroup(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchCurrentModerationGroup;
    }()
  }, {
    key: 'fetchModerationItem',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(itemId) {
        var _ref4, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].get(uri + '/api/v1/moderation/item/' + itemId);

              case 2:
                _ref4 = _context2.sent;
                data = _ref4.data;
                return _context2.abrupt('return', data.data);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchModerationItem(_x2) {
        return _ref3.apply(this, arguments);
      }

      return fetchModerationItem;
    }()
  }, {
    key: 'fetchNextModeration',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(payload) {
        var _ref6, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].post(uri + '/api/v1/moderation/confirm', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload));

              case 2:
                _ref6 = _context3.sent;
                data = _ref6.data;
                return _context3.abrupt('return', data.data);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchNextModeration(_x3) {
        return _ref5.apply(this, arguments);
      }

      return fetchNextModeration;
    }()
  }, {
    key: 'fetchModerationGroupByFilter',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var params, _ref8, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {};


                if (filter.state) {
                  params.state = filter.state;
                }

                if (filter.assetId) {
                  params.assetId = filter.assetId;
                }

                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].get(uri + '/api/v1/moderation/list', { params: params });

              case 5:
                _ref8 = _context4.sent;
                data = _ref8.data;
                return _context4.abrupt('return', data.data.items);

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchModerationGroupByFilter() {
        return _ref7.apply(this, arguments);
      }

      return fetchModerationGroupByFilter;
    }()
  }, {
    key: 'moderationIsAvailable',
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(assetId) {
        var _ref10, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].get(uri + '/api/v1/moderation/available/' + assetId);

              case 2:
                _ref10 = _context5.sent;
                data = _ref10.data;
                return _context5.abrupt('return', data.data);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function moderationIsAvailable(_x5) {
        return _ref9.apply(this, arguments);
      }

      return moderationIsAvailable;
    }()
  }, {
    key: 'createModeration',
    value: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(payload) {
        var _ref12, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].post(uri + '/api/v1/moderation', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload));

              case 2:
                _ref12 = _context6.sent;
                data = _ref12.data;
                return _context6.abrupt('return', data.data);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createModeration(_x6) {
        return _ref11.apply(this, arguments);
      }

      return createModeration;
    }()
  }, {
    key: 'getModerationsList',
    value: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(filter) {
        var params, _ref14, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                params = {};

                params.limit = filter.limit || 25;
                params.page = filter.page || 1;

                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__plugins_http__["a" /* default */].get(uri + '/api/v1/moderation/list', { params: params });

              case 5:
                _ref14 = _context7.sent;
                data = _ref14.data;
                return _context7.abrupt('return', data.data);

              case 8:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getModerationsList(_x7) {
        return _ref13.apply(this, arguments);
      }

      return getModerationsList;
    }()
  }]);

  return Moderation;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Moderation());

/***/ }),

/***/ "p31G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "step-lock-tokens",
  components: {},
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])('forecast', {
    setLockedTokens: 'setLockedTokens',
    setAcceptedRules: 'setAcceptedRules'
  }), {
    onBalanceClick: function onBalanceClick() {
      this.tokens = this.balance > this.maxLockTokens ? this.maxLockTokens : this.balance;
    },
    cancel: function cancel() {
      this.$emit('closeModal');
    },
    next: function next() {
      this.$emit('nextPage');
    },
    preview: function preview() {
      this.$emit('previewPage');
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('forecast', {
    lockedTokens: 'lockedTokens',
    acceptedRules: 'acceptedRules'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', {
    balance: 'balance'
  }), {
    tokens: {
      get: function get() {
        return this.lockedTokens;
      },
      set: function set(v) {
        this.setLockedTokens(parseFloat(v));
      }
    },
    rules: {
      get: function get() {
        return this.acceptedRules;
      },
      set: function set(v) {
        this.setAcceptedRules(v);
      }
    },
    isDisabledNext: function isDisabledNext() {
      return this.tokens === 0 || this.acceptedRules === false;
    }
  }),
  mounted: function mounted() {
    // this.fetchCoins();
  }
});

/***/ }),

/***/ "p4KC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myAssets_vue__ = __webpack_require__("uHI7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06869692_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myAssets_vue__ = __webpack_require__("CEt7");
function injectStyle (ssrContext) {
  __webpack_require__("o/rg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06869692"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myAssets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06869692_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myAssets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p5eA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncForEach; });
/* unused harmony export asyncMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



var asyncForEach = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(array, callback) {
    var index;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            index = 0;

          case 1:
            if (!(index < array.length)) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return callback(array[index], index, array);

          case 4:
            index++;
            _context.next = 1;
            break;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function asyncForEach(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var asyncMap = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(array, callback) {
    var results;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            results = array.map(callback);
            return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(results));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function asyncMap(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ "p8tu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buy__ = __webpack_require__("cUJM");


/* harmony default export */ __webpack_exports__["a"] = ({
  BuyModal: __WEBPACK_IMPORTED_MODULE_0__buy__["a" /* default */]
});

/***/ }),

/***/ "pqK0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hint__ = __webpack_require__("TKeN");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__hint__["a" /* default */]);

/***/ }),

/***/ "psvm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chat__ = __webpack_require__("Obzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lineChart__ = __webpack_require__("NS6T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__myAssets__ = __webpack_require__("W/5l");




/* harmony default export */ __webpack_exports__["a"] = ({
  EbChat: __WEBPACK_IMPORTED_MODULE_0__chat__["a" /* default */],
  EbLineChart: __WEBPACK_IMPORTED_MODULE_1__lineChart__["a" /* default */],
  EbMyAssets: __WEBPACK_IMPORTED_MODULE_2__myAssets__["a" /* default */]
});

/***/ }),

/***/ "q0g7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "eb-line-chart-list-item",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  watch: {
    item: {
      handler: function handler(current, preview) {
        this.element = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(current, true);
      },

      deep: true
    }
  },
  data: function data() {
    return {
      element: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(this.$props.item, true)
    };
  },

  methods: {
    onClick: function onClick() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ "qfd7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forecast-step"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"success-message"},[_c('h3',[_vm._v("Your prediction has been successfully saved.")]),_vm._v(" "),_c('div',{staticClass:"img-container",staticStyle:{"margin":"20px auto"}},[_c('svg',{staticStyle:{"fill":"#0672f3"},attrs:{"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 465.2 465.2","xml:space":"preserve"}},[_c('g',[_c('g',{attrs:{"id":"Layer_2_16_"}},[_c('g',[_c('path',{attrs:{"d":"M279.591,423.714c-3.836,0.956-7.747,1.805-11.629,2.52c-10.148,1.887-16.857,11.647-14.98,21.804\n                    c0.927,4.997,3.765,9.159,7.618,11.876c3.971,2.795,9.025,4.057,14.175,3.099c4.623-0.858,9.282-1.867,13.854-3.008\n                    c10.021-2.494,16.126-12.646,13.626-22.662C299.761,427.318,289.618,421.218,279.591,423.714z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M417.887,173.047c1.31,3.948,3.811,7.171,6.97,9.398c4.684,3.299,10.813,4.409,16.662,2.475\n                    c9.806-3.256,15.119-13.83,11.875-23.631c-1.478-4.468-3.118-8.95-4.865-13.314c-3.836-9.59-14.714-14.259-24.309-10.423\n                    c-9.585,3.834-14.256,14.715-10.417,24.308C415.271,165.528,416.646,169.293,417.887,173.047z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M340.36,397.013c-3.299,2.178-6.704,4.286-10.134,6.261c-8.949,5.162-12.014,16.601-6.854,25.546\n                    c1.401,2.433,3.267,4.422,5.416,5.942c5.769,4.059,13.604,4.667,20.127,0.909c4.078-2.352,8.133-4.854,12.062-7.452\n                    c8.614-5.691,10.985-17.294,5.291-25.912C360.575,393.686,348.977,391.318,340.36,397.013z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M465.022,225.279c-0.407-10.322-9.101-18.356-19.426-17.953c-10.312,0.407-18.352,9.104-17.947,19.422\n                    c0.155,3.945,0.195,7.949,0.104,11.89c-0.145,6.473,3.021,12.243,7.941,15.711c2.931,2.064,6.488,3.313,10.345,3.401\n                    c10.322,0.229,18.876-7.958,19.105-18.285C465.247,234.756,465.208,229.985,465.022,225.279z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M414.835,347.816c-8.277-6.21-19.987-4.524-26.186,3.738c-2.374,3.164-4.874,6.289-7.434,9.298\n                    c-6.69,7.86-5.745,19.666,2.115,26.361c0.448,0.38,0.901,0.729,1.371,1.057c7.814,5.509,18.674,4.243,24.992-3.171\n                    c3.057-3.59,6.037-7.323,8.874-11.102C424.767,365.735,423.089,354.017,414.835,347.816z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M442.325,280.213c-9.855-3.09-20.35,2.396-23.438,12.251c-1.182,3.765-2.492,7.548-3.906,11.253\n                    c-3.105,8.156-0.13,17.13,6.69,21.939c1.251,0.879,2.629,1.624,4.126,2.19c9.649,3.682,20.454-1.159,24.132-10.812\n                    c1.679-4.405,3.237-8.906,4.646-13.382C457.66,293.795,452.178,283.303,442.325,280.213z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M197.999,426.402c-16.72-3.002-32.759-8.114-47.968-15.244c-0.18-0.094-0.341-0.201-0.53-0.287\n                    c-3.584-1.687-7.162-3.494-10.63-5.382c-0.012-0.014-0.034-0.023-0.053-0.031c-6.363-3.504-12.573-7.381-18.606-11.628\n                    C32.24,331.86,11.088,209.872,73.062,121.901c13.476-19.122,29.784-35.075,47.965-47.719c0.224-0.156,0.448-0.311,0.67-0.468\n                    c64.067-44.144,151.06-47.119,219.089-1.757l-14.611,21.111c-4.062,5.876-1.563,10.158,5.548,9.518l63.467-5.682\n                    c7.12-0.64,11.378-6.799,9.463-13.675L387.61,21.823c-1.908-6.884-6.793-7.708-10.859-1.833l-14.645,21.161\n                    C312.182,7.638,252.303-5.141,192.87,5.165c-5.986,1.036-11.888,2.304-17.709,3.78c-0.045,0.008-0.081,0.013-0.117,0.021\n                    c-0.225,0.055-0.453,0.128-0.672,0.189C123.122,22.316,78.407,52.207,46.5,94.855c-0.269,0.319-0.546,0.631-0.8,0.978\n                    c-1.061,1.429-2.114,2.891-3.145,4.353c-1.686,2.396-3.348,4.852-4.938,7.308c-0.199,0.296-0.351,0.597-0.525,0.896\n                    C10.762,149.191-1.938,196.361,0.24,244.383c0.005,0.158-0.004,0.317,0,0.479c0.211,4.691,0.583,9.447,1.088,14.129\n                    c0.027,0.302,0.094,0.588,0.145,0.89c0.522,4.708,1.177,9.427,1.998,14.145c8.344,48.138,31.052,91.455,65.079,125.16\n                    c0.079,0.079,0.161,0.165,0.241,0.247c0.028,0.031,0.059,0.047,0.086,0.076c9.142,9.017,19.086,17.357,29.793,24.898\n                    c28.02,19.744,59.221,32.795,92.729,38.808c10.167,1.827,19.879-4.941,21.703-15.103\n                    C214.925,437.943,208.163,428.223,197.999,426.402z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M221.124,83.198c-8.363,0-15.137,6.78-15.137,15.131v150.747l137.87,71.271c2.219,1.149,4.595,1.69,6.933,1.69\n                    c5.476,0,10.765-2.982,13.454-8.185c3.835-7.426,0.933-16.549-6.493-20.384l-121.507-62.818V98.329\n                    C236.243,89.978,229.477,83.198,221.124,83.198z"}})])])])])]),_vm._v(" "),_c('p',[_vm._v("After the end of the forecast, you will receive a reward and you will be able to see how accurately you made the forecast.")])])])],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"d-flex ml-auto"},[_c('e-button',{on:{"click":_vm.close}},[_vm._v("OK")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qvWD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r+CK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menuItem__ = __webpack_require__("U+ZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__("GO4B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subMenuItem__ = __webpack_require__("dX5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__menuHeader__ = __webpack_require__("lf14");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_assest__ = __webpack_require__("2ZPF");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-sidebar",
  components: { EMenuHeader: __WEBPACK_IMPORTED_MODULE_4__menuHeader__["a" /* default */], ESubmenuItem: __WEBPACK_IMPORTED_MODULE_3__subMenuItem__["a" /* default */], EMenu: __WEBPACK_IMPORTED_MODULE_2__menu__["a" /* default */], EMenuItem: __WEBPACK_IMPORTED_MODULE_1__menuItem__["a" /* default */] },
  props: {
    state: {
      type: String,
      validator: function validator(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_assest__["a" /* oneOf */])(value, ['close', 'open']);
      },

      default: 'open'
    },
    mobileOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateViewport: function updateViewport() {
      this.isMobile = window.innerWidth <= 767;
    },
    toggleMenu: function toggleMenu() {
      if (this.isMobile) {
        this.closeMobile();
        return;
      }

      this.isOpen = !this.isOpen;
      this.$emit("changeState", this.isOpen ? 'open' : 'close');
      // this.$root.$emit('ex::sidebar::toggleMenu', this.isOpen);
    },
    closeMobile: function closeMobile() {
      if (this.isMobile && this.mobileOpen) {
        this.$emit("closeMobile");
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["e" /* mapState */])('settings', ['pageTitle']), {
    classes: function classes() {
      return {
        'is-close': !this.isOpen && !this.isMobile,
        'is-mobile': this.isMobile,
        'is-mobile-open': this.mobileOpen
      };
    }
  }),
  watch: {
    $route: function $route() {
      this.closeMobile();
    }
  },
  beforeMount: function beforeMount() {
    if (this.state === 'close') {
      this.isOpen = false;
    }
  },
  mounted: function mounted() {
    this.updateViewport();
    window.addEventListener('resize', this.updateViewport);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport);
  },
  data: function data() {
    return {
      isOpen: true,
      isMobile: false
    };
  }
});

/***/ }),

/***/ "r6Mc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("kPMY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa301c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("AbjV");
function injectStyle (ssrContext) {
  __webpack_require__("6MG3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fa301c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa301c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r7bF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asset)?_c('div',{staticClass:"buy-crypto-header"},[_c('b-row',[_c('div',{staticClass:"col-4 buy-info"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.asset.logoPath}}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h2',[_vm._v(_vm._s(_vm.asset.name))]),_vm._v(" "),_c('small',[_vm._v("("+_vm._s(_vm.asset.symbol)+")")])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"from"},[_c('div',{staticClass:"title"},[_vm._v("Total sum")]),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm.amount.toFixed(2))+" "+_vm._s(_vm.currency))])])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('div',{staticClass:"arrow"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 492.004 492.004"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 492.004 492.004","xml:space":"preserve"}},[_c('g',[_c('g',[_c('path',{attrs:{"fill":"#0e3d60","d":"M484.14,226.886L306.46,49.202c-5.072-5.072-11.832-7.856-19.04-7.856c-7.216,0-13.972,2.788-19.044,7.856l-16.132,16.136\n                c-5.068,5.064-7.86,11.828-7.86,19.04c0,7.208,2.792,14.2,7.86,19.264L355.9,207.526H26.58C11.732,207.526,0,219.15,0,234.002\n                v22.812c0,14.852,11.732,27.648,26.58,27.648h330.496L252.248,388.926c-5.068,5.072-7.86,11.652-7.86,18.864\n                c0,7.204,2.792,13.88,7.86,18.948l16.132,16.084c5.072,5.072,11.828,7.836,19.044,7.836c7.208,0,13.968-2.8,19.04-7.872\n                l177.68-177.68c5.084-5.088,7.88-11.88,7.86-19.1C492.02,238.762,489.228,231.966,484.14,226.886z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"to"},[_c('div',{staticClass:"title"},[_vm._v("Take Amount")]),_vm._v(" "),_c('div',{staticClass:"price"},[_vm._v(_vm._s(_vm.volume.toFixed(6))+" "+_vm._s(_vm.asset.symbol))])])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rLRw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets__ = __webpack_require__("ASOe");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__assets__["a" /* default */]);

/***/ }),

/***/ "rPjM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rikD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rq66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.layout)?_c(_vm.layout,{tag:"component"}):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"modal",attrs:{"modal-class":"e-modal e-first-use-modal","hide-footer":true,"hide-header":true,"centered":""},on:{"show":_vm.onShow},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{staticClass:"modal-content-container"},[_c('h3',[_vm._v("Congratulations!")]),_vm._v(" "),_c('div',{staticClass:"img-container"},[_c('svg',{attrs:{"height":"511pt","viewBox":"1 -26 511.99975 511","width":"511pt","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"#D2E3FB"}},[_c('path',{attrs:{"d":"m493.714844 97.953125c-11.792969-11.792969-27.46875-18.285156-44.148438-18.285156-16.675781 0-32.351562 6.492187-44.144531 18.285156l-211.023437 211.023437-87.851563-87.851562c-11.789063-11.789062-27.46875-18.285156-44.144531-18.285156-16.675782 0-32.351563 6.496094-44.144532 18.285156-24.34375 24.34375-24.34375 63.949219 0 88.292969l131.996094 131.996093c11.789063 11.792969 27.46875 18.285157 44.144532 18.285157 16.675781 0 32.355468-6.492188 44.144531-18.285157l255.171875-255.167968c11.789062-11.792969 18.285156-27.472656 18.285156-44.148438 0-16.675781-6.496094-32.355468-18.285156-44.144531zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m230.011719 131.226562c-12.875-4.8125-24.320313-12.175781-34.039063-21.90625-9.699218-9.691406-17.0625-21.136718-21.878906-34.027343-2.226562-5.953125-7.914062-9.902344-14.273438-9.902344-6.359374 0-12.050781 3.949219-14.277343 9.90625-4.8125 12.882813-12.175781 24.332031-21.890625 34.035156-9.707032 9.714844-21.15625 17.082031-34.035156 21.890625-5.957032 2.226563-9.910157 7.917969-9.90625 14.28125 0 6.363282 3.957031 12.054688 9.917968 14.277344 12.847656 4.785156 24.296875 12.148438 34.03125 21.878906 9.710938 9.714844 17.078125 21.164063 21.882813 34.03125 2.226562 5.957032 7.917969 9.90625 14.277343 9.90625 6.359376 0 12.046876-3.949218 14.273438-9.90625 9.671875-25.882812 30.054688-46.261718 55.914062-55.917968 5.957032-2.222657 9.90625-7.914063 9.910157-14.273438 0-6.355469-3.949219-12.046875-9.90625-14.273438zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m353.347656 52.5625c-9.703125-3.625-18.328125-9.175781-25.65625-16.511719-7.3125-7.304687-12.859375-15.933593-16.492187-25.644531-2.222657-5.957031-7.914063-9.90625-14.273438-9.90625s-12.046875 3.949219-14.273437 9.902344c-3.632813 9.714844-9.179688 18.34375-16.503906 25.660156-7.316407 7.324219-15.949219 12.875-25.652344 16.5-5.960938 2.226562-9.910156 7.917969-9.910156 14.28125.003906 6.363281 3.960937 12.054688 9.921874 14.273438 9.679688 3.605468 18.308594 9.15625 25.644532 16.492187 7.324218 7.320313 12.875 15.953125 16.5 25.652344 2.222656 5.957031 7.914062 9.902343 14.273437 9.902343s12.046875-3.945312 14.273438-9.902343c7.292969-19.511719 22.652343-34.871094 42.144531-42.148438 5.957031-2.222656 9.90625-7.914062 9.910156-14.273437 0-6.359375-3.949218-12.050782-9.90625-14.277344zm0 0"}})]),_vm._v(" "),_c('path',{attrs:{"d":"m449.566406 79.667969c-16.675781 0-32.351562 6.492187-44.144531 18.285156l-149.4375 149.4375v176.585937l237.730469-237.734374c11.789062-11.789063 18.285156-27.46875 18.285156-44.144532 0-16.675781-6.496094-32.355468-18.285156-44.148437-11.792969-11.789063-27.46875-18.28125-44.148438-18.28125zm0 0","fill":"#93BFF6"}}),_vm._v(" "),_c('path',{attrs:{"d":"m230.011719 131.226562c-12.875-4.8125-24.320313-12.175781-34.039063-21.90625-9.699218-9.691406-17.0625-21.136718-21.878906-34.027343-2.226562-5.953125-7.914062-9.902344-14.273438-9.902344-.003906 0-.003906 0-.007812 0v160.203125h.007812c6.359376 0 12.046876-3.945312 14.273438-9.902344 9.671875-25.882812 30.054688-46.265625 55.914062-55.917968 5.957032-2.222657 9.90625-7.914063 9.910157-14.273438 0-6.355469-3.949219-12.046875-9.90625-14.273438zm0 0","fill":"#93BFF6"}}),_vm._v(" "),_c('path',{attrs:{"d":"m353.347656 52.5625c-9.703125-3.625-18.328125-9.175781-25.65625-16.511719-7.3125-7.304687-12.859375-15.933593-16.492187-25.644531-2.222657-5.957031-7.914063-9.90625-14.273438-9.90625-.003906 0-.003906 0-.003906 0v132.664062h.003906c6.359375 0 12.046875-3.945312 14.273438-9.902343 7.292969-19.511719 22.652343-34.871094 42.144531-42.148438 5.957031-2.222656 9.90625-7.914062 9.910156-14.273437 0-6.359375-3.949218-12.050782-9.90625-14.277344zm0 0","fill":"#93BFF6"}})])]),_vm._v(" "),_c('p',[_vm._v("We are glad to see you on our platform. As a gift, we give you "),_c('b',[_vm._v("10,000 EMiX")]),_vm._v(" so that you can look at all aspects of the platform and choose a role for yourself.")]),_vm._v(" "),_c('p',[_vm._v("You want to take an introductory tour of the site?")])]),_vm._v(" "),_c('div',{staticClass:"modal-divider"}),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('e-button',{attrs:{"type":"outlined"},on:{"click":function($event){return _vm.closeModal(false)}}},[_vm._v("No")]),_vm._v(" "),_c('e-button',{on:{"click":function($event){return _vm.closeModal(true)}}},[_vm._v("I got it")])],1)]),_vm._v(" "),_c('v-tour',{attrs:{"name":"firstTour","steps":_vm.steps}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('em-kyc')],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('em-buy-crypto')],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('em-forecast')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s5DG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_draggable_vue__ = __webpack_require__("DcsS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_986c8228_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_draggable_vue__ = __webpack_require__("iCs3");
function injectStyle (ssrContext) {
  __webpack_require__("g3M4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_draggable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_986c8228_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_draggable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s7Lj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-rate-step-select-criteria",
  props: {
    assetId: String,
    modalId: String
  },
  data: function data() {
    return {
      asset: null,
      search: null,
      searchFn: _.debounce(this.searchCriteria, 150)
    };
  },

  watch: {
    assetId: {
      handler: function handler(current) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.asset = _this.getAsset(current);

                  if (_this.asset) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt('return');

                case 3:
                  _context.next = 5;
                  return _this.fetchAssetCriteria([_this.asset]);

                case 5:
                  _this.changeTitle();

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      },

      immediate: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('assets', {
    fetchAssetCriteria: 'fetchAssetsCriteria',
    searchCriteria: 'searchCriteria',
    pushCriterion: 'pushCriterion'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('rate', {
    toggleCriterion: 'toggleCriterion',
    resetCriteria: 'resetCriteria'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])('assets', {
    addCriterionToAsset: 'addCriterionToAsset'
  }), {
    changeSearch: function changeSearch(search) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.searchFn(search);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    newCriterion: function newCriterion() {
      var newId = 'new_' + new Date().getTime();
      this.pushCriterion({ id: newId, title: this.search });
      this.addCriterionToAsset({ assetId: this.assetId, criterionId: newId });
      this.search = '';
    },
    onNextClick: function onNextClick() {
      this.$emit('nextStep');
    },
    formattedCriterionTitle: function formattedCriterionTitle(id) {
      var criterion = this.getCriterion(id);
      var title = criterion && criterion.title ? criterion.title : '';

      if (!this.search) {
        return title;
      }

      var start = title.toLowerCase().indexOf(this.search.toLowerCase());
      var end = start + this.search.length;
      return title.slice(0, start) + '<b>' + title.slice(start, end) + '</b>' + title.slice(end, title.length);
    },
    changeTitle: function changeTitle() {
      this.$emit('changeTitle', 'Set a criteria for ' + this.asset.name);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('rate', ['isSelectedCriterion']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('rate', ['getCurrentCreateRateCriteria']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('assets', {
    getAsset: 'asset',
    getCriterion: 'criterion',
    getCriteria: 'criteria'
  }), {
    nextBtnDisabled: function nextBtnDisabled() {
      return !(this.getCurrentCreateRateCriteria.length > 0);
    },
    filteredCriteria: function filteredCriteria() {
      var _this3 = this;

      if (!this.asset) {
        return [];
      }

      if (!this.search) {
        var assetCriteria = _.sortBy(_.toArray(this.asset.criteria), 'popularity').map(function (c) {
          return _this3.getCriterion(c.criterion);
        }).filter(Boolean);
        var selectedCriteriaIds = this.getCurrentCreateRateCriteria;

        selectedCriteriaIds.forEach(function (c) {
          var criterion = _this3.getCriterion(c);

          if (criterion && !assetCriteria.find(function (ac) {
            return ac.id === c;
          })) {
            assetCriteria.push(criterion);
          }
        });

        return assetCriteria;
      }

      return _.sortBy(_.toArray(_.mapValues(this.getCriteria)), 'popularity').filter(function (c) {
        if (!c || !c.title) {
          return false;
        }

        return c.title.toLowerCase().indexOf(_this3.search.toLowerCase()) !== -1;
      });
    }
  })
});

/***/ }),

/***/ "sZL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-buy-crypto-header",
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('orders', {
    orderData: 'buyModalData'
  }), {
    asset: function asset() {
      return this.orderData !== null ? this.orderData.asset : null;
    },
    currency: function currency() {
      return this.orderData.currency;
    },
    amount: function amount() {
      return parseFloat(this.orderData.amount);
    },
    volume: function volume() {
      return this.amount / this.asset.price.value;
    }
  }),
  methods: {}
});

/***/ }),

/***/ "sfUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_activity_vue__ = __webpack_require__("V7/o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f690d6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_activity_vue__ = __webpack_require__("jb7y");
function injectStyle (ssrContext) {
  __webpack_require__("t11M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f690d6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_activity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f690d6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_activity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "shPy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sm9Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgOC44ODg4OUg3LjExMTExVjBIMFY4Ljg4ODg5Wk0wIDE2SDcuMTExMTFWMTAuNjY2N0gwVjE2Wk04Ljg4ODg5IDE2SDE2VjcuMTExMTFIOC44ODg4OVYxNlpNOC44ODg4OSAwVjUuMzMzMzNIMTZWMEg4Ljg4ODg5WiIgZmlsbD0iI0U0RUNGMyIvPgo8L3N2Zz4K"

/***/ }),

/***/ "sqmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_kyc_component_js__ = __webpack_require__("cFPW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bdf1b82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_kyc_component_html__ = __webpack_require__("KAhp");
function injectStyle (ssrContext) {
  __webpack_require__("/5nz")
  __webpack_require__("btDd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_kyc_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bdf1b82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_kyc_component_html__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t11M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tTnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_step_vue__ = __webpack_require__("4bkE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51620208_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_step_vue__ = __webpack_require__("oM57");
function injectStyle (ssrContext) {
  __webpack_require__("LJeQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51620208"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_step_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51620208_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_step_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ta6T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chat__ = __webpack_require__("d4YC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__message__ = __webpack_require__("6JhI");



/* harmony default export */ __webpack_exports__["a"] = ({ Message: __WEBPACK_IMPORTED_MODULE_1__message__["a" /* default */], Chat: __WEBPACK_IMPORTED_MODULE_0__chat__["a" /* default */] });

/***/ }),

/***/ "tqXy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__ = __webpack_require__("b/x4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1dcf272_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__ = __webpack_require__("3ssj");
function injectStyle (ssrContext) {
  __webpack_require__("b8yz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c1dcf272"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1dcf272_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tqch":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjgiIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCA0IDgiPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTS4xNDQgNC4zOTZsMy4wMTcgMy40NGEuNDUuNDUgMCAwIDAgLjY5NSAwIC42MTcuNjE3IDAgMCAwIDAtLjc5MkwxLjE4NiA0IDMuODU2Ljk1NmEuNjE3LjYxNyAwIDAgMCAwLS43OTIuNDUuNDUgMCAwIDAtLjY5NSAwTC4xNDQgMy42MDRBLjYuNiAwIDAgMCAwIDRhLjYuNiAwIDAgMCAuMTQ0LjM5NnoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "uA6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chat__ = __webpack_require__("vLiE");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__chat__["a" /* default */]);

/***/ }),

/***/ "uB6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classes,attrs:{"type":_vm.htmlType,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uH6x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-menu-item',{staticClass:"e-sub-menu e-menu__sub-menu",class:_vm.menuItemClasses,attrs:{"uppercase":_vm.uppercase,"badge":_vm.badge,"icon":_vm.icon,"label":_vm.label,"link-class":_vm.linkClass},on:{"click":_vm.onClickItem}},[_c('template',{slot:"link-prepend"},[_vm._t("link-prepend",function(){return [(_vm.icon)?_c('img',{staticClass:"e-menu__prepend",attrs:{"src":_vm.getImg}}):_vm._e()]})],2),_vm._v(" "),_c('template',{slot:"link-append"},[_c('div',{staticClass:"e-sub-menu__toggle"}),_vm._v(" "),_vm._t("link-append")],2),_vm._v(" "),_c('template',{slot:"append"},[_c('e-menu',{staticClass:"e-sub-menu__list"},[_vm._t("default")],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uHI7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_assetCard__ = __webpack_require__("jNXZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "eb-my-assets",
  components: { EAssetCard: __WEBPACK_IMPORTED_MODULE_2__elements_assetCard__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['myAssets']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('assets', {
    getAsset: 'asset'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('assets', ['fetchAssets'])),
  watch: {
    myAssets: {
      handler: function handler(current) {
        console.log(current);
        this.fetchAssets(current);
      },

      immediate: true
    }
  },
  data: function data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable: true
          // }
        } }
    };
  }
});

/***/ }),

/***/ "urWd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forecast-step"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"success-message"},[_c('h3',[_vm._v("You already have a prediction for this event.")]),_vm._v(" "),_c('div',{staticClass:"img-container",staticStyle:{"margin":"20px auto"}},[_c('svg',{staticStyle:{"fill":"#0672f3"},attrs:{"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 465.2 465.2","xml:space":"preserve"}},[_c('g',[_c('g',{attrs:{"id":"Layer_2_16_"}},[_c('g',[_c('path',{attrs:{"d":"M279.591,423.714c-3.836,0.956-7.747,1.805-11.629,2.52c-10.148,1.887-16.857,11.647-14.98,21.804\n                    c0.927,4.997,3.765,9.159,7.618,11.876c3.971,2.795,9.025,4.057,14.175,3.099c4.623-0.858,9.282-1.867,13.854-3.008\n                    c10.021-2.494,16.126-12.646,13.626-22.662C299.761,427.318,289.618,421.218,279.591,423.714z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M417.887,173.047c1.31,3.948,3.811,7.171,6.97,9.398c4.684,3.299,10.813,4.409,16.662,2.475\n                    c9.806-3.256,15.119-13.83,11.875-23.631c-1.478-4.468-3.118-8.95-4.865-13.314c-3.836-9.59-14.714-14.259-24.309-10.423\n                    c-9.585,3.834-14.256,14.715-10.417,24.308C415.271,165.528,416.646,169.293,417.887,173.047z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M340.36,397.013c-3.299,2.178-6.704,4.286-10.134,6.261c-8.949,5.162-12.014,16.601-6.854,25.546\n                    c1.401,2.433,3.267,4.422,5.416,5.942c5.769,4.059,13.604,4.667,20.127,0.909c4.078-2.352,8.133-4.854,12.062-7.452\n                    c8.614-5.691,10.985-17.294,5.291-25.912C360.575,393.686,348.977,391.318,340.36,397.013z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M465.022,225.279c-0.407-10.322-9.101-18.356-19.426-17.953c-10.312,0.407-18.352,9.104-17.947,19.422\n                    c0.155,3.945,0.195,7.949,0.104,11.89c-0.145,6.473,3.021,12.243,7.941,15.711c2.931,2.064,6.488,3.313,10.345,3.401\n                    c10.322,0.229,18.876-7.958,19.105-18.285C465.247,234.756,465.208,229.985,465.022,225.279z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M414.835,347.816c-8.277-6.21-19.987-4.524-26.186,3.738c-2.374,3.164-4.874,6.289-7.434,9.298\n                    c-6.69,7.86-5.745,19.666,2.115,26.361c0.448,0.38,0.901,0.729,1.371,1.057c7.814,5.509,18.674,4.243,24.992-3.171\n                    c3.057-3.59,6.037-7.323,8.874-11.102C424.767,365.735,423.089,354.017,414.835,347.816z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M442.325,280.213c-9.855-3.09-20.35,2.396-23.438,12.251c-1.182,3.765-2.492,7.548-3.906,11.253\n                    c-3.105,8.156-0.13,17.13,6.69,21.939c1.251,0.879,2.629,1.624,4.126,2.19c9.649,3.682,20.454-1.159,24.132-10.812\n                    c1.679-4.405,3.237-8.906,4.646-13.382C457.66,293.795,452.178,283.303,442.325,280.213z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M197.999,426.402c-16.72-3.002-32.759-8.114-47.968-15.244c-0.18-0.094-0.341-0.201-0.53-0.287\n                    c-3.584-1.687-7.162-3.494-10.63-5.382c-0.012-0.014-0.034-0.023-0.053-0.031c-6.363-3.504-12.573-7.381-18.606-11.628\n                    C32.24,331.86,11.088,209.872,73.062,121.901c13.476-19.122,29.784-35.075,47.965-47.719c0.224-0.156,0.448-0.311,0.67-0.468\n                    c64.067-44.144,151.06-47.119,219.089-1.757l-14.611,21.111c-4.062,5.876-1.563,10.158,5.548,9.518l63.467-5.682\n                    c7.12-0.64,11.378-6.799,9.463-13.675L387.61,21.823c-1.908-6.884-6.793-7.708-10.859-1.833l-14.645,21.161\n                    C312.182,7.638,252.303-5.141,192.87,5.165c-5.986,1.036-11.888,2.304-17.709,3.78c-0.045,0.008-0.081,0.013-0.117,0.021\n                    c-0.225,0.055-0.453,0.128-0.672,0.189C123.122,22.316,78.407,52.207,46.5,94.855c-0.269,0.319-0.546,0.631-0.8,0.978\n                    c-1.061,1.429-2.114,2.891-3.145,4.353c-1.686,2.396-3.348,4.852-4.938,7.308c-0.199,0.296-0.351,0.597-0.525,0.896\n                    C10.762,149.191-1.938,196.361,0.24,244.383c0.005,0.158-0.004,0.317,0,0.479c0.211,4.691,0.583,9.447,1.088,14.129\n                    c0.027,0.302,0.094,0.588,0.145,0.89c0.522,4.708,1.177,9.427,1.998,14.145c8.344,48.138,31.052,91.455,65.079,125.16\n                    c0.079,0.079,0.161,0.165,0.241,0.247c0.028,0.031,0.059,0.047,0.086,0.076c9.142,9.017,19.086,17.357,29.793,24.898\n                    c28.02,19.744,59.221,32.795,92.729,38.808c10.167,1.827,19.879-4.941,21.703-15.103\n                    C214.925,437.943,208.163,428.223,197.999,426.402z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M221.124,83.198c-8.363,0-15.137,6.78-15.137,15.131v150.747l137.87,71.271c2.219,1.149,4.595,1.69,6.933,1.69\n                    c5.476,0,10.765-2.982,13.454-8.185c3.835-7.426,0.933-16.549-6.493-20.384l-121.507-62.818V98.329\n                    C236.243,89.978,229.477,83.198,221.124,83.198z"}})])])])])]),_vm._v(" "),_c('p',[_vm._v("We remind you that you have locked "),_c('b',[_vm._v(_vm._s(_vm.prediction.lockedTokens))]),_vm._v(" tokens for the price of "),_c('b',[_vm._v("$"+_vm._s(_vm._f("formatPrice")(_vm.prediction.prediction)))])])])])],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"d-flex ml-auto"},[_c('e-button',{on:{"click":_vm.close}},[_vm._v("OK")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "utaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepPaymentMethod_vue__ = __webpack_require__("O6tT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0757fdfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepPaymentMethod_vue__ = __webpack_require__("R06g");
function injectStyle (ssrContext) {
  __webpack_require__("4U4o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stepPaymentMethod_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0757fdfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stepPaymentMethod_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vHCd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookies_js__ = __webpack_require__("wFBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cookies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cookies_js__);



var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();

http.interceptors.request.use(function (config) {
  if (__WEBPACK_IMPORTED_MODULE_1_cookies_js___default.a.get("accessToken")) {
    config.headers.Authorization = __WEBPACK_IMPORTED_MODULE_1_cookies_js___default.a.get("accessToken");
  }

  return config;
});

/* harmony default export */ __webpack_exports__["a"] = (http);

/***/ }),

/***/ "vLiE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chat_vue__ = __webpack_require__("PPHu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa7f6b52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chat_vue__ = __webpack_require__("4icS");
function injectStyle (ssrContext) {
  __webpack_require__("Gwys")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa7f6b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa7f6b52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vMY6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"e-hint"},[_c('b',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vZaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listItem__ = __webpack_require__("5Y0+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var MAX_SELECTED_ITEMS = 3;

var COLORS = {
  red: '#ff5656',
  // cyan: '#00c2ff',
  'blue-dark': '#1354aa',
  orange: '#ffab48'
};

// colors: ['#0e3d60', '#0e4b6e', '#0e648c', '#116091', '#1472ad', '#1490cb'],


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "eb-line-chart",
  components: { EbLineChartListItem: __WEBPACK_IMPORTED_MODULE_3__listItem__["a" /* default */] },
  props: {
    maxSelected: {
      type: Number,
      default: MAX_SELECTED_ITEMS
    }
  },
  computed: {
    isShowChart: function isShowChart() {
      return this.chartVisible;
    },
    selectedItemsObject: function selectedItemsObject() {
      var _this = this;

      return this.selectedItems.map(function (index) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          index: index
        }, _this.tableItems[index]);
      });
    },
    chartOptions: function chartOptions() {
      var _this2 = this;

      return {
        chart: {
          type: 'line',
          scrollablePlotArea: {
            minWidth: 700,
            scrollPositionX: -1
          },
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        tooltip: {
          shared: true
        },
        xAxis: {
          gridLineWidth: 0,
          lineWidth: 0,
          tickWidth: 0,
          categories: ['13.07', '14.07', '15.07', '16.07', '17.07', '18.07', '19.07', '20.07', '21.07', '22.07', '23.07', '24.07', '25.07', '26.07', '27.07'],
          tickmarkPlacement: 'on',
          title: {
            text: ''
          }
        },
        yAxis: {
          gridLineWidth: 0,
          title: {
            text: ''
          }
        },
        colors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(COLORS),
        plotOptions: {
          series: {
            dataLabels: {
              enabled: false
            }
          }
        },
        series: this.rawItems.map(function (item) {
          return _this2.prepareSeries({ name: item.name, data: item.data });
        })
      };
    }
  },
  methods: {
    // TODO rebase to mixin
    getFreeColor: function getFreeColor() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(COLORS, function (hex, color) {
        return !_this3.usedColors.includes(color);
      });
    },
    lockColor: function lockColor(color) {
      this.usedColors.push(color);
    },
    unlockColor: function unlockColor(color) {
      this.usedColors.splice(this.usedColors.indexOf(color), 1);
    },
    onRowClicked: function onRowClicked(item, index) {
      var items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(this.selectedItems, true);
      if (items.includes(index)) {
        items.splice(this.selectedItems.indexOf(index), 1);
        this.selectedItems = items;
      } else {
        if (items.length < this.maxSelected) {
          items.push(index);
          this.selectedItems = items;
        }
      }
    },


    // Chart functions
    prepareSeries: function prepareSeries(_ref) {
      var name = _ref.name,
          data = _ref.data;

      return {
        name: name,
        marker: {
          enabled: false
        },
        data: data,
        visible: false,
        type: "spline"
      };
    },
    showSeries: function showSeries(index) {
      var _this4 = this;

      this.$nextTick(function () {
        var color = COLORS[_this4.tableItems[index].__color];
        var chart = _this4.$refs.chart.chart;
        var series = chart.series[index];

        // chart.legend.colorizeItem(series, series.visible);
        series.color = color;
        series.graph.attr({
          stroke: color
        });

        series.show();
      });
    },
    hideSeries: function hideSeries(index) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$refs.chart.chart.series[index].hide();
      });
    }
  },
  watch: {
    selectedItems: {
      handler: function handler(current, preview) {
        var _this6 = this;

        // Looked at new active series
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.difference(current, preview || []).forEach(function (i) {
          var color = _this6.getFreeColor();
          _this6.tableItems[i]._rowVariant = 'row-active table-row-active--color--' + color;
          _this6.tableItems[i].__color = color;
          _this6.lockColor(color);
          _this6.showSeries(i);
        });

        // Looked at deactivated series
        if (preview) {
          __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.difference(preview, current).forEach(function (i) {
            _this6.tableItems[i]._rowVariant = null;
            _this6.unlockColor(_this6.tableItems[i].__color);
            _this6.tableItems[i].__color = null;
            _this6.hideSeries(i);
          });
        }
      },

      immediate: true
    }
  },
  data: function data() {
    var items = [{
      asset: 'Bitcoin',
      isActive: false,
      data: [3.9, 4.2, 5.7, 8.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 6.6, 4.8, 3, 5, 6, 7, 8]
    }, {
      asset: 'Ethereum',
      isActive: false,
      data: [2.9, 4.2, 7.7, 1.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 10.6, 4.8, 3, 5, 8, 7, 8]
    }, {
      asset: 'Neo',
      isActive: false,
      data: [3.9, 2, 5.0, 8.5, 41.9, 15.2, 17.0, 16.6, 15.2, 10.3, 6.6, 4.8, 3, 5, 6, 7, 8]
    }, {
      asset: 'Stratis',
      isActive: false,
      data: [5.9, 10, 5.7, 8.5, 11.7, 13, 11.0, 16.2, 14.8, 10.3, 6.6, 2.8, 3, 5, 10, 7, 8]
    }];

    return {
      resizeListener: null,
      chartVisible: true,
      usedColors: [],
      lineTableFields: [{
        label: 'Show',
        key: 'coin'
      }],
      rawItems: items,
      tableItems: items.map(function (i) {
        return {
          asset: i.asset,
          _rowVariant: null
        };
      }),
      selectedItems: [2, 3]
    };
  },
  created: function created() {
    var _this7 = this;

    this.resizeListener = window.addEventListener('resize', function () {
      _this7.chartVisible = true;
    });
  },
  destroyed: function destroyed() {
    removeEventListener({}, this.resizeListener);
  }
});

/***/ }),

/***/ "vbUp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vwpd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__("wSK1");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__badge__["a" /* default */]);

/***/ }),

/***/ "wE/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-card',{class:_vm.sizeClasses,on:{"toggleDrag":function($event){return _vm.$emit('toggleDrag')}}},[_c('b-tab',{attrs:{"title":"Pie Chart","active":""}},[_c('highcharts',{ref:"piChart",staticClass:"pie-chart-container",attrs:{"options":_vm.options}}),_vm._v(" "),_c('div',{staticClass:"e-card__content pt-0 d-none d-xl-flex flex-column"},[_c('hr',{staticClass:"e-divider"}),_vm._v(" "),_c('p',{staticClass:"text-center eh-secondary-text pb-3 pt-2"},[_vm._v("Last Achievements:")]),_vm._v(" "),_c('ul',{staticClass:"ee-list eh-primary-text"},[_c('li',[_c('p',{staticClass:"mr-4"},[_vm._v("Sigma Forecasting:")]),_c('p',{staticClass:"ml-auto"},[_vm._v("+ 75 CP")])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"mr-4"},[_vm._v("Moderating Litecoin:")]),_c('p',{staticClass:"ml-auto"},[_vm._v("+ 50 CP")])])])]),_vm._v(" "),_c('div',{staticClass:"e-card__content d-sm-flex d-xl-none align-items-center justify-content-center"},[_c('b-btn',{ref:"popoverInfoBtn1",staticClass:"e-btn e-btn--outlined e-btn--color--gray-dark e-btn--size--small"},[_vm._v("Learn More")]),_vm._v(" "),_c('b-popover',{staticClass:"e-popover",attrs:{"target":function () { return this$1.$refs.popoverInfoBtn1; },"placement":"top","triggers":"hover focus"}},[_c('p',{staticClass:"text-center eh-secondary-text pb-3"},[_vm._v("Last Achievements:")]),_vm._v(" "),_c('ul',{staticClass:"ee-list eh-primary-text"},[_c('li',[_c('p',{staticClass:"mr-4"},[_vm._v("Sigma Forecasting:")]),_c('p',{staticClass:"ml-auto"},[_vm._v("+ 75 CP")])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"mr-4"},[_vm._v("Moderating Litecoin:")]),_c('p',{staticClass:"ml-auto"},[_vm._v("+ 50 CP")])])])])],1)],1),_vm._v(" "),_c('b-tab',{staticClass:"e-card__content",attrs:{"title":"Table"}},[_c('div',{staticClass:"d-flex align-items-center"},[_c('p',{staticClass:"eh-secondary-text"},[_vm._v("Contribution Pts.")]),_vm._v(" "),_c('span',{staticClass:"ml-auto eh-accent-text"},[_vm._v("2 380")])]),_vm._v(" "),_c('hr',{staticClass:"e-divider"}),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('ul',{staticClass:"e-currency-table-list"},[_c('li',{staticClass:"e-currency-table-list__item"},[_c('div',{staticClass:"e-avatar size-10 bg-info"}),_vm._v(" "),_c('span',{staticClass:"e-currency-table-list__currency"},[_vm._v("BTC")]),_vm._v(" "),_c('span',{staticClass:"e-currency-table-list__value eh-secondary-text"},[_vm._v("36%")])]),_vm._v(" "),_c('li',{staticClass:"e-currency-table-list__item"},[_c('div',{staticClass:"e-avatar size-10 bg-warning"}),_vm._v(" "),_c('span',{staticClass:"e-currency-table-list__currency"},[_vm._v("ETH")]),_vm._v(" "),_c('span',{staticClass:"e-currency-table-list__value eh-secondary-text"},[_vm._v("40%")])]),_vm._v(" "),_c('li',{staticClass:"e-currency-table-list__item"},[_c('div',{staticClass:"e-avatar size-10 bg-success"}),_vm._v(" "),_c('span',{staticClass:"e-currency-table-list__currency"},[_vm._v("LTC")]),_vm._v(" "),_c('span',{staticClass:"e-currency-table-list__value eh-secondary-text"},[_vm._v("4%")])]),_vm._v(" "),_c('li',{staticClass:"e-currency-table-list__item"},[_c('div',{staticClass:"e-avatar size-10 bg-primary"}),_vm._v(" "),_c('span',{staticClass:"e-currency-table-list__currency"},[_vm._v("EMiX")]),_vm._v(" "),_c('span',{staticClass:"e-currency-table-list__value eh-secondary-text"},[_vm._v("28%")])]),_vm._v(" "),_c('li',{staticClass:"e-currency-table-list__item"},[_c('div',{staticClass:"e-avatar size-10 bg-danger"}),_vm._v(" "),_c('span',{staticClass:"e-currency-table-list__currency"},[_vm._v("Other")]),_vm._v(" "),_c('span',{staticClass:"e-currency-table-list__value eh-secondary-text"},[_vm._v("2%")])])])]),_vm._v(" "),_c('hr',{staticClass:"e-divider"}),_vm._v(" "),_c('div',{staticClass:"d-none d-xl-flex flex-column"},[_c('p',{staticClass:"text-center eh-secondary-text pb-3 pt-2"},[_vm._v("Last Achievements:")]),_vm._v(" "),_c('ul',{staticClass:"ee-list eh-primary-text"},[_c('li',[_c('p',{staticClass:"mr-4"},[_vm._v("Sigma Forecasting:")]),_c('p',{staticClass:"ml-auto"},[_vm._v("+ 75 CP")])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"mr-4"},[_vm._v("Moderating Litecoin:")]),_c('p',{staticClass:"ml-auto"},[_vm._v("+ 50 CP")])])])]),_vm._v(" "),_c('div',{staticClass:"e-card__content d-sm-flex d-xl-none align-items-center justify-content-center pt-2 pb-0"},[_c('b-btn',{ref:"popoverInfoBtn2",staticClass:"e-btn e-btn--outlined e-btn--color--gray-dark e-btn--size--small"},[_vm._v("Learn More")]),_vm._v(" "),_c('b-popover',{staticClass:"e-popover",attrs:{"target":function () { return this$1.$refs.popoverInfoBtn2; },"placement":"top","triggers":"hover focus"}},[_c('p',{staticClass:"text-center eh-secondary-text pb-3"},[_vm._v("Last Achievements:")]),_vm._v(" "),_c('ul',{staticClass:"ee-list eh-primary-text"},[_c('li',[_c('p',{staticClass:"mr-4"},[_vm._v("Sigma Forecasting:")]),_c('p',{staticClass:"ml-auto"},[_vm._v("+ 75 CP")])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"mr-4"},[_vm._v("Moderating Litecoin:")]),_c('p',{staticClass:"ml-auto"},[_vm._v("+ 50 CP")])])])])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wSK1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badge_vue__ = __webpack_require__("KExZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b1ac1b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_badge_vue__ = __webpack_require__("ybsL");
function injectStyle (ssrContext) {
  __webpack_require__("NXt2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77b1ac1b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b1ac1b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_badge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wWok":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_assets__ = __webpack_require__("SjBe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-moderate",
  props: {
    alias: String
  },

  data: function data() {
    return {
      isShow: true
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('assets', {
    fetchAsset: 'fetchAsset'
  }), {
    onClose: function onClose() {
      this.$router.go(-1);
    }
  }),

  watch: {
    alias: {
      handler: function handler(current) {
        this.fetchAsset(current);
      },

      immediate: true
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('assets', {
    getAsset: 'asset'
  }), {
    asset: function asset() {
      return this.getAsset(this.alias);
    },
    hint: function hint() {
      return {
        title: 'How the Criteria Works',
        text: 'To ensure fair and reliable ratings, each asset is evaluated using a defined set of criteria. Moderators review submitted ratings and confirm that they follow the guidelines and reflect accurate information about the asset. The moderation process checks rating accuracy, consistency with the criteria, and whether the submission contains spam or manipulation. By participating in moderation you help maintain the integrity and trust of the rating system.',
        buttonText: 'Got It'
      };
    },
    assetMeta: function assetMeta() {
      return [{
        title: 'Emixtier',
        value: this.asset.rate === 0 ? 'N/A' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_assets__["a" /* convertRateToEmixtier */])(this.asset.rate)
      }, {
        title: 'Total Score',
        value: this.asset.rate === 0 ? 'N/A' : this.asset.rate.toFixed(1)
      }, {
        title: 'Raters',
        value: this.asset.totalRaters
      }, {
        title: 'Moderators',
        value: this.asset.totalModeration
      }];
    }
  }),

  mounted: function mounted() {
    var modal = this.$refs.modal;
    var $app = this.$root.$el;

    $app.parentNode.appendChild(modal.$el);
  }
});

/***/ }),

/***/ "wkPx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "e-menu",
	methods: {}
});

/***/ }),

/***/ "wm9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rate__ = __webpack_require__("QO7f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectCriteria__ = __webpack_require__("7iwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__write__ = __webpack_require__("YFh7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__evaluation__ = __webpack_require__("R3zG");





/* harmony default export */ __webpack_exports__["a"] = ({
  Rate: __WEBPACK_IMPORTED_MODULE_0__rate__["default"], SelectCriteria: __WEBPACK_IMPORTED_MODULE_1__selectCriteria__["a" /* default */], Write: __WEBPACK_IMPORTED_MODULE_2__write__["a" /* default */], Evaluation: __WEBPACK_IMPORTED_MODULE_3__evaluation__["a" /* default */]
});

/***/ }),

/***/ "wphm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_assest__ = __webpack_require__("2ZPF");

//
//
//
//
//
//
//
//
//
//



var prefixCls = 'e-button';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-button",
  props: {
    type: {
      validator: function validator(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assest__["a" /* oneOf */])(value, ['default', 'link', 'outlined']);
      },

      default: 'default'
    },
    color: {
      type: String,
      default: 'blue-light'
    },
    size: {
      validator: function validator(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assest__["a" /* oneOf */])(value, ['small', 'smaller', 'large', 'default']);
      },

      default: 'default'
    },
    disabled: Boolean,
    htmlType: {
      default: 'button',
      validator: function validator(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_assest__["a" /* oneOf */])(value, ['button', 'submit', 'reset']);
      }
    },
    long: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      return ["" + prefixCls, prefixCls + "-color-" + this.color, (_ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + "-" + this.type, this.type !== 'default'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + "-" + this.size, this.size !== 'default'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + "-long", this.long), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + "-shadow", this.shadow), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + "-shadowless", this.shadow === false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, prefixCls + "-disabled", this.disabled), _ref)];
    }
  },
  methods: {
    handleClick: function handleClick(event) {
      this.$emit('click', event);
    }
  }
});

/***/ }),

/***/ "x25R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_events_vue__ = __webpack_require__("Wmd3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5480ec0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_events_vue__ = __webpack_require__("nkPA");
function injectStyle (ssrContext) {
  __webpack_require__("ZQmX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c5480ec0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5480ec0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_events_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xD3O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue__ = __webpack_require__("6q2E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2979e76a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__ = __webpack_require__("HRjB");
function injectStyle (ssrContext) {
  __webpack_require__("IvEH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2979e76a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2979e76a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xHgi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['vue-star-rating', {'vue-star-rating-rtl': _vm.rtl}, {'vue-star-rating-inline': _vm.inline}]},[_c('div',{staticClass:"sr-only"},[_vm._t("screen-reader",function(){return [_c('span',[_vm._v("Rated "+_vm._s(_vm.selectedRating)+" stars out of "+_vm._s(_vm.maxRating))])]},{"rating":_vm.selectedRating,"stars":_vm.maxRating})],2),_vm._v(" "),_c('div',{staticClass:"vue-star-rating",on:{"mouseleave":_vm.resetRating}},[_vm._l((_vm.maxRating),function(n){return _c('span',{key:n,class:[{'vue-star-rating-pointer': !_vm.readOnly}, 'vue-star-rating-star'],style:({'margin-right': _vm.margin + 'px'})},[_c('star',{attrs:{"fill":_vm.fillLevel[n - 1],"size":_vm.starSize,"points":_vm.starPoints,"star-id":n,"step":_vm.step,"active-color":_vm.currentActiveColor,"inactive-color":_vm.inactiveColor,"border-color":_vm.borderColor,"active-border-color":_vm.currentActiveBorderColor,"border-width":_vm.borderWidth,"rounded-corners":_vm.roundedCorners,"rtl":_vm.rtl,"glow":_vm.glow,"glow-color":_vm.glowColor,"animate":_vm.animate},on:{"star-selected":function($event){return _vm.setRating($event, true)},"star-mouse-move":_vm.setRating}})],1)}),_vm._v(" "),(_vm.showRating)?_c('span',{class:['vue-star-rating-rating-text', _vm.textClass]},[_vm._v(" "+_vm._s(_vm.formattedRating))]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cookies_js__ = __webpack_require__("wFBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cookies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_cookies_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Load layout components dynamically.
var requireContext = __webpack_require__("SSdR");

var layouts = requireContext.keys().map(function (file) {
  return [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)];
}).reduce(function (components, _ref) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      name = _ref2[0],
      component = _ref2[1];

  components[name] = component.default || component;
  return components;
}, {});

/* harmony default export */ __webpack_exports__["a"] = ({
  el: '#app',

  data: function data() {
    return {
      layout: null,
      defaultLayout: 'basic',
      isTour: false,
      steps: [{
        target: '[data-v-step="1"]', // We're using document.querySelector() under the hood
        content: 'Your current balance is shown here.'
      }, {
        target: '[data-v-step="2"]',
        content: '<p>All your actions on the platform will be shown here as notifications.</p><p>Looks like you already have the first alert, look it up!</p>'
      }, {
        target: '[data-v-step="3"]',
        content: 'There will be assets you subscribed to. This is easy to do, just click on the "Subscribe" button at the top right when viewing the asset.',
        params: {
          placement: 'top'
        }
      }, {
        target: '[data-v-step="4"]',
        content: 'Here is a list of assets for quick access to them. On top of the tabs you can switch the type of assets.',
        params: {
          placement: 'top'
        }
      }, {
        target: '[data-v-step="5"]',
        content: 'In order to leave a rating, you just need to click on this button. Do this as you become familiar with the platform.',
        params: {
          placement: 'top'
        }
      }, {
        target: '[data-v-step="6"]',
        content: 'Or you can be a moderator. To leave the asset on any asset, click on this button.',
        params: {
          placement: 'top'
        }
      }, {
        target: '[data-v-step="7"]',
        content: 'Here you can quickly buy shares or tokens of any asset available on Economix',
        params: {
          placement: 'top'
        }
      }, {
        target: '[data-v-step="8"]',
        content: 'Just do not forget that for the purchase of large amounts, you need to go through the KYC procedure. Here you can see the current status and update the information in time.',
        params: {
          placement: 'top'
        }
      }]
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])('auth', ['setToken', 'setRefreshToken', 'setExpiresToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('auth', ['updateRefreshTimer', 'updateAuthSession', 'changeFirstUse']), {
    setLayout: function setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout;
      }

      this.layout = layouts[layout];
    },
    closeModal: function closeModal(isTour) {
      this.$refs.modal.hide();
      this.isTour = isTour;

      if (isTour) {
        this.$tours['firstTour'].start();
      }
    },
    onShow: function onShow() {
      var modal = this.$refs.modal;
      var $app = this.$root.$el;

      $app.parentNode.appendChild(modal.$el);
    }
  }),

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', {
    isFirstUse: 'isFirstUse'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('settings', {
    'isShowKyc': 'isShowKyc'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('orders', {
    'isShowBuyCrypto': 'isShowBuyCrypto'
  }), {

    showModal: {
      get: function get() {
        return this.isFirstUse;
      },
      set: function set(v) {
        this.changeFirstUse(v);
      }
    }
  }),

  watch: {
    isFirstUse: function isFirstUse(v) {
      console.log(v);
    }
  },

  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var accessToken, refreshToken, expiresIn;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              accessToken = __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.get('accessToken');
              refreshToken = __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.get('refreshToken');
              expiresIn = __WEBPACK_IMPORTED_MODULE_4_cookies_js___default.a.get('expiresToken');


              _this.setToken(accessToken || null);
              _this.setRefreshToken(refreshToken || null);
              _this.setExpiresToken(expiresIn || null);

              // if(accessToken) {
              //   if(expiresIn * 1000 - Date.now() <= 2000) {
              //     await this.updateAuthSession();
              //   }
              //   this.updateRefreshTimer();
              // }

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "xnnc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "e-lock-tokens",
  props: ['value'],
  data: function data() {
    return {
      maxLockTokens: 15000
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', {
    balance: 'balance'
  }), {
    lockValue: {
      get: function get() {
        return this.value.locked;
      },
      set: function set(v) {
        this.$emit('input', { locked: parseFloat(v), rules: this.value.rules });
      }
    },
    acceptRules: {
      get: function get() {
        return this.value.rules;
      },
      set: function set(v) {
        this.$emit('input', { locked: this.value.locked, rules: v });
      }
    }
  }),
  methods: {
    onBalanceClick: function onBalanceClick() {
      if (!this.value.disabled) {
        console.log(this.balance);
        this.lockValue = this.balance > this.maxLockTokens ? this.maxLockTokens : this.balance;
      }
    }
  },
  mounted: function mounted() {
    console.log(this.value);
  }
});

/***/ }),

/***/ "xqBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kyc__ = __webpack_require__("xv9Q");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__kyc__["a" /* default */]);

/***/ }),

/***/ "xryl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"id":_vm.id,"size":"xl","modal-class":"e-modal e-create-rate","hide-footer":true,"centered":""},on:{"hide":_vm.onClose},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[(!_vm.$wait.is(("assets." + _vm.alias + ".fetch")))?[_c('template',{slot:"modal-header"},[_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])]),_vm._v(" "),(_vm.asset)?[_c('div',{staticClass:"modal-content-container"},[_c('em-modal-asset-header',{attrs:{"asset":_vm.asset,"hint":_vm.hint,"meta":_vm.assetMeta,"type":"rate"}})],1),_vm._v(" "),_c('div',{staticClass:"modal-divider"}),_vm._v(" "),(!_vm.rateExist)?[_c(_vm.stepObject.component,_vm._b({tag:"component",on:{"changeTitle":function (t) { return _vm.title = t; },"nextStep":function () { return _vm.currentStep++; },"previewStep":function () { return _vm.currentStep--; },"closeModal":function () { return this$1.$refs.modal.hide(); },"changeStep":_vm.changeStep}},'component',_vm.componentProps,false))]:[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"modal-content-container"},[_c('div',{staticClass:"success-message",staticStyle:{"position":"relative","margin":"0","padding-top":"0"}},[_c('h3',[_vm._v("You have a current rate.")]),_vm._v(" "),_c('div',{staticClass:"img-container",staticStyle:{"margin":"20px auto"}},[_c('svg',{staticStyle:{"fill":"#0672f3"},attrs:{"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 465.2 465.2","xml:space":"preserve"}},[_c('g',[_c('g',{attrs:{"id":"Layer_2_16_"}},[_c('g',[_c('path',{attrs:{"d":"M279.591,423.714c-3.836,0.956-7.747,1.805-11.629,2.52c-10.148,1.887-16.857,11.647-14.98,21.804\n                          c0.927,4.997,3.765,9.159,7.618,11.876c3.971,2.795,9.025,4.057,14.175,3.099c4.623-0.858,9.282-1.867,13.854-3.008\n                          c10.021-2.494,16.126-12.646,13.626-22.662C299.761,427.318,289.618,421.218,279.591,423.714z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M417.887,173.047c1.31,3.948,3.811,7.171,6.97,9.398c4.684,3.299,10.813,4.409,16.662,2.475\n                          c9.806-3.256,15.119-13.83,11.875-23.631c-1.478-4.468-3.118-8.95-4.865-13.314c-3.836-9.59-14.714-14.259-24.309-10.423\n                          c-9.585,3.834-14.256,14.715-10.417,24.308C415.271,165.528,416.646,169.293,417.887,173.047z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M340.36,397.013c-3.299,2.178-6.704,4.286-10.134,6.261c-8.949,5.162-12.014,16.601-6.854,25.546\n                          c1.401,2.433,3.267,4.422,5.416,5.942c5.769,4.059,13.604,4.667,20.127,0.909c4.078-2.352,8.133-4.854,12.062-7.452\n                          c8.614-5.691,10.985-17.294,5.291-25.912C360.575,393.686,348.977,391.318,340.36,397.013z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M465.022,225.279c-0.407-10.322-9.101-18.356-19.426-17.953c-10.312,0.407-18.352,9.104-17.947,19.422\n                          c0.155,3.945,0.195,7.949,0.104,11.89c-0.145,6.473,3.021,12.243,7.941,15.711c2.931,2.064,6.488,3.313,10.345,3.401\n                          c10.322,0.229,18.876-7.958,19.105-18.285C465.247,234.756,465.208,229.985,465.022,225.279z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M414.835,347.816c-8.277-6.21-19.987-4.524-26.186,3.738c-2.374,3.164-4.874,6.289-7.434,9.298\n                          c-6.69,7.86-5.745,19.666,2.115,26.361c0.448,0.38,0.901,0.729,1.371,1.057c7.814,5.509,18.674,4.243,24.992-3.171\n                          c3.057-3.59,6.037-7.323,8.874-11.102C424.767,365.735,423.089,354.017,414.835,347.816z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M442.325,280.213c-9.855-3.09-20.35,2.396-23.438,12.251c-1.182,3.765-2.492,7.548-3.906,11.253\n                          c-3.105,8.156-0.13,17.13,6.69,21.939c1.251,0.879,2.629,1.624,4.126,2.19c9.649,3.682,20.454-1.159,24.132-10.812\n                          c1.679-4.405,3.237-8.906,4.646-13.382C457.66,293.795,452.178,283.303,442.325,280.213z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M197.999,426.402c-16.72-3.002-32.759-8.114-47.968-15.244c-0.18-0.094-0.341-0.201-0.53-0.287\n                          c-3.584-1.687-7.162-3.494-10.63-5.382c-0.012-0.014-0.034-0.023-0.053-0.031c-6.363-3.504-12.573-7.381-18.606-11.628\n                          C32.24,331.86,11.088,209.872,73.062,121.901c13.476-19.122,29.784-35.075,47.965-47.719c0.224-0.156,0.448-0.311,0.67-0.468\n                          c64.067-44.144,151.06-47.119,219.089-1.757l-14.611,21.111c-4.062,5.876-1.563,10.158,5.548,9.518l63.467-5.682\n                          c7.12-0.64,11.378-6.799,9.463-13.675L387.61,21.823c-1.908-6.884-6.793-7.708-10.859-1.833l-14.645,21.161\n                          C312.182,7.638,252.303-5.141,192.87,5.165c-5.986,1.036-11.888,2.304-17.709,3.78c-0.045,0.008-0.081,0.013-0.117,0.021\n                          c-0.225,0.055-0.453,0.128-0.672,0.189C123.122,22.316,78.407,52.207,46.5,94.855c-0.269,0.319-0.546,0.631-0.8,0.978\n                          c-1.061,1.429-2.114,2.891-3.145,4.353c-1.686,2.396-3.348,4.852-4.938,7.308c-0.199,0.296-0.351,0.597-0.525,0.896\n                          C10.762,149.191-1.938,196.361,0.24,244.383c0.005,0.158-0.004,0.317,0,0.479c0.211,4.691,0.583,9.447,1.088,14.129\n                          c0.027,0.302,0.094,0.588,0.145,0.89c0.522,4.708,1.177,9.427,1.998,14.145c8.344,48.138,31.052,91.455,65.079,125.16\n                          c0.079,0.079,0.161,0.165,0.241,0.247c0.028,0.031,0.059,0.047,0.086,0.076c9.142,9.017,19.086,17.357,29.793,24.898\n                          c28.02,19.744,59.221,32.795,92.729,38.808c10.167,1.827,19.879-4.941,21.703-15.103\n                          C214.925,437.943,208.163,428.223,197.999,426.402z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M221.124,83.198c-8.363,0-15.137,6.78-15.137,15.131v150.747l137.87,71.271c2.219,1.149,4.595,1.69,6.933,1.69\n                          c5.476,0,10.765-2.982,13.454-8.185c3.835-7.426,0.933-16.549-6.493-20.384l-121.507-62.818V98.329\n                          C236.243,89.978,229.477,83.198,221.124,83.198z"}})])])])])]),_vm._v(" "),_c('p',[_vm._v("In order to create a new rate for this asset, you need to wait another "),_c('b',[_vm._v("30 days.")])]),_vm._v(" "),_c('p',[_vm._v("We remind you that the average value that you set is equal to "),_c('b',[_vm._v(_vm._s(_vm.hasRate.averageRate.toFixed(1)))]),_vm._v(", and the number of tokens that you have frozen - "),_c('b',[_vm._v(_vm._s(_vm.hasRate.lockedTokens)+" EMiX")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"d-flex ml-auto"},[_c('e-button',{on:{"click":function () { return this$1.$refs.modal.hide(); }}},[_vm._v("OK")])],1)])]]:_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xt5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asset)?_c('div',{staticClass:"e-asset-header forecast-modal-header"},[_c('b-row',[_c('div',{staticClass:"col-2 asset-info"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.asset.logoPath}}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h2',[_vm._v(_vm._s(_vm.asset.name))]),_vm._v(" "),_c('small',[_vm._v("("+_vm._s(_vm.asset.symbol)+")")])])]),_vm._v(" "),_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.isHintVisible && _vm.hint)?_c('b-col',{key:"hint"},[_c('e-hint',{attrs:{"title":_vm.hint.title || ''}},[_vm._v(_vm._s(_vm.hint.text || ''))]),_vm._v(" "),_c('e-button',{staticClass:"px-3 mt-2",attrs:{"color":"gray","type":"outlined","size":"smaller"},on:{"click":_vm.hideHint}},[_vm._v(_vm._s(_vm.hint.buttonText))])],1):_c('b-col',{key:"asset-data",attrs:{"cols":"10"}},[_c('div',{staticClass:"asset-meta"},[_c('div',{staticClass:"item",class:_vm.coloredClass},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.forecastData.asset.change24.toFixed(2)))]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Change in %")])]),_vm._v(" "),_c('div',{staticClass:"item",class:_vm.coloredClass},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.evalPrice)))]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n              Evaluated Price\n              "),_c('svg',{staticStyle:{"enable-background":"new 0 0 40 40"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 40 40","xml:space":"preserve"}},[_c('path',{staticClass:"st0",attrs:{"d":"M36.9,0H12.2c-0.8,0-1.6,0.3-2.2,0.9C9.5,1.5,9.2,2.2,9.2,3.1c0,0.8,0.3,1.6,0.9,2.2l8.5,8.5L0.5,31.8\n                C0.2,32.1,0,32.5,0,32.9c0,0.4,0.2,0.8,0.5,1.1L6,39.5C6.3,39.8,6.7,40,7.1,40c0.4,0,0.8-0.2,1.1-0.5l18.1-18.1l8.5,8.5\n                c0.6,0.6,1.3,0.9,2.2,0.9c0.8,0,1.6-0.3,2.2-0.9c0.6-0.6,0.9-1.3,0.9-2.2V3.1c0-0.8-0.3-1.6-0.9-2.2C38.5,0.3,37.8,0,36.9,0z"}})])])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("formatForecastDate")(_vm.forecastData.forecast.forecastDate)))]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Forecast Date")])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.forecastData.forecast.oracle))]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("Type of Oracle")])])])])],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xv9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kyc_vue__ = __webpack_require__("6qc/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da1a5d6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kyc_vue__ = __webpack_require__("QERB");
function injectStyle (ssrContext) {
  __webpack_require__("vbUp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da1a5d6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kyc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da1a5d6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kyc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y6H5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu__ = __webpack_require__("GO4B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menuItem__ = __webpack_require__("U+ZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sidebar__ = __webpack_require__("TdRy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subMenuItem__ = __webpack_require__("dX5N");





/* harmony default export */ __webpack_exports__["a"] = ({
  Menu: __WEBPACK_IMPORTED_MODULE_0__menu__["a" /* default */],
  MenuItem: __WEBPACK_IMPORTED_MODULE_1__menuItem__["a" /* default */],
  Sidebar: __WEBPACK_IMPORTED_MODULE_2__sidebar__["a" /* default */],
  SubMenuItem: __WEBPACK_IMPORTED_MODULE_3__subMenuItem__["a" /* default */]
});

/***/ }),

/***/ "ybsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classes},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ysFa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__averageScore__ = __webpack_require__("G2NB");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Temporarily disabled during legacy build migration.
// import markdownEditor from 'vue-simplemde/src/markdown-editor'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "em-rate-finish",
  components: { EmAssetAverageScore: __WEBPACK_IMPORTED_MODULE_2__averageScore__["a" /* default */] },
  props: {
    criteria: Array
  },
  methods: {
    onEditClick: function onEditClick(num) {
      this.$emit('editCriterion', ++num);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('rate', {
    criterionEval: 'getCriterionEvaluation',
    criterionJustification: 'getCriterionJustification',
    averageEvaluation: 'getAverageEvaluation'
  }))
});

/***/ }),

/***/ "zXyP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var AlphaColor = function () {
  function AlphaColor(color) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AlphaColor);

    this.color = color;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AlphaColor, [{
    key: 'parseAlphaColor',
    value: function parseAlphaColor() {
      if (/^rgba\((\d{1,3}%?\s*,\s*){3}(\d*(?:\.\d+)?)\)$/.test(this.color)) {
        return this.parseRgba();
      }

      if (/^hsla\(\d+\s*,\s*([\d.]+%\s*,\s*){2}(\d*(?:\.\d+)?)\)$/.test(this.color)) {
        return this.parseHsla();
      }

      if (/^#([0-9A-Fa-f]{4}|[0-9A-Fa-f]{8})$/.test(this.color)) {
        return this.parseAlphaHex();
      }

      if (/^transparent$/.test(this.color)) {
        return this.parseTransparent();
      }

      return {
        color: this.color,
        opacity: '1'
      };
    }
  }, {
    key: 'parseRgba',
    value: function parseRgba() {
      return {
        color: this.color.replace(/,(?!.*,).*(?=\))|a/g, ''),
        opacity: this.color.match(/\.\d+|[01](?=\))/)[0]
      };
    }
  }, {
    key: 'parseHsla',
    value: function parseHsla() {
      return {
        color: this.color.replace(/,(?!.*,).*(?=\))|a/g, ''),
        opacity: this.color.match(/\.\d+|[01](?=\))/)[0]
      };
    }
  }, {
    key: 'parseAlphaHex',
    value: function parseAlphaHex() {
      return {
        color: this.color.length === 5 ? this.color.substring(0, 4) : this.color.substring(0, 7),
        opacity: this.color.length === 5 ? (parseInt(this.color.substring(4, 5) + this.color.substring(4, 5), 16) / 255).toFixed(2) : (parseInt(this.color.substring(7, 9), 16) / 255).toFixed(2)
      };
    }
  }, {
    key: 'parseTransparent',
    value: function parseTransparent() {
      return {
        color: '#fff',
        opacity: 0
      };
    }
  }]);

  return AlphaColor;
}();

/* harmony default export */ __webpack_exports__["a"] = (AlphaColor);

/***/ }),

/***/ "zhIy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assetsList_vue__ = __webpack_require__("E9JO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4541e00b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assetsList_vue__ = __webpack_require__("POuU");
function injectStyle (ssrContext) {
  __webpack_require__("l3K8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4541e00b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assetsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4541e00b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assetsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zrHh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AlphaColor__ = __webpack_require__("zXyP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Star',
  props: {
    fill: { type: Number, default: 0 },
    points: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    size: { type: Number, default: 50 },
    starId: { type: Number, required: true },
    activeColor: { type: String, required: true },
    inactiveColor: { type: String, required: true },
    borderColor: { type: String, default: '#000' },
    activeBorderColor: { type: String, default: '#000' },
    borderWidth: { type: Number, default: 0 },
    roundedCorners: { type: Boolean, default: false },
    rtl: { type: Boolean, default: false },
    glow: { type: Number, default: 0 },
    glowColor: { type: String, default: null, required: false },
    animate: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      starPoints: [19.8, 2.2, 6.6, 43.56, 39.6, 17.16, 0, 17.16, 33, 43.56],
      grad: '',
      glowId: '',
      isStarActive: true
    };
  },

  computed: {
    starPointsToString: function starPointsToString() {
      return this.starPoints.join(',');
    },
    gradId: function gradId() {
      return 'url(#' + this.grad + ')';
    },
    starSize: function starSize() {
      var size = this.roundedCorners && this.borderWidth <= 0 ? parseInt(this.size) - parseInt(this.border) : this.size;
      return parseInt(size) + parseInt(this.border);
    },
    starFill: function starFill() {
      return this.rtl ? 100 - this.fill + '%' : this.fill + '%';
    },
    border: function border() {
      return this.roundedCorners && this.borderWidth <= 0 ? 6 : this.borderWidth;
    },
    getBorderColor: function getBorderColor() {
      if (this.roundedCorners && this.borderWidth <= 0) {
        return this.fill <= 0 ? this.inactiveColor : this.activeColor;
      }

      return this.fill <= 0 ? this.borderColor : this.activeBorderColor;
    },
    maxSize: function maxSize() {
      return this.starPoints.reduce(function (a, b) {
        return Math.max(a, b);
      });
    },
    viewBox: function viewBox() {
      return '0 0 ' + this.maxSize + ' ' + this.maxSize;
    },
    shouldAnimate: function shouldAnimate() {
      return this.animate && this.isStarActive;
    },
    strokeLinejoin: function strokeLinejoin() {
      return this.roundedCorners ? 'round' : 'miter';
    }
  },
  created: function created() {
    this.starPoints = this.points.length ? this.points : this.starPoints;
    this.calculatePoints();
    this.grad = this.getRandomId();
    this.glowId = this.getRandomId();
  },

  methods: {
    mouseMoving: function mouseMoving(event) {
      if (event.touchAction !== 'undefined') {
        this.$emit('star-mouse-move', {
          event: event,
          position: this.getPosition(event),
          id: this.starId
        });
      }
    },
    touchStart: function touchStart() {
      var _this = this;

      this.$nextTick(function () {
        _this.isStarActive = true;
      });
    },
    touchEnd: function touchEnd() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.isStarActive = false;
      });
    },
    getPosition: function getPosition(event) {
      var starWidth = 92 / 100 * this.size;
      var offset = this.rtl ? Math.min(event.offsetX, 45) : Math.max(event.offsetX, 1);
      var position = Math.round(100 / starWidth * offset);
      return Math.min(position, 100);
    },
    selected: function selected(event) {
      this.$emit('star-selected', {
        id: this.starId,
        position: this.getPosition(event)
      });
    },
    getRandomId: function getRandomId() {
      return Math.random().toString(36).substring(7);
    },
    calculatePoints: function calculatePoints() {
      var _this3 = this;

      this.starPoints = this.starPoints.map(function (point, i) {
        var offset = i % 2 === 0 ? _this3.border * 1.5 : 0;
        return _this3.size / _this3.maxSize * point + offset;
      });
    },
    getColor: function getColor(color) {
      return new __WEBPACK_IMPORTED_MODULE_0__AlphaColor__["a" /* default */](color).parseAlphaColor().color;
    },
    getOpacity: function getOpacity(color) {
      return new __WEBPACK_IMPORTED_MODULE_0__AlphaColor__["a" /* default */](color).parseAlphaColor().opacity;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.af92591439c997d1a98e.js